
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("es1Wq", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "NinChangeboardingAdminModal", () => $a2ea3ad8c5daa7b8$export$7d37935f329cddd4);
$parcel$export(module.exports, "Global", () => $a2ea3ad8c5daa7b8$export$98f03c5d19621d70);
$parcel$export(module.exports, "default", () => $a2ea3ad8c5daa7b8$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $48fa3 = parcelRequire("48fa3");

var $2ijRB = parcelRequire("2ijRB");

var $5KRxh = parcelRequire("5KRxh");

var $guiFP = parcelRequire("guiFP");

var $edvkU = parcelRequire("edvkU");

var $1ybV0 = parcelRequire("1ybV0");

var $bAQOb = parcelRequire("bAQOb");

var $5TVuZ = parcelRequire("5TVuZ");

var $kxeVc = parcelRequire("kxeVc");

var $cFeqe = parcelRequire("cFeqe");

var $6TR1R = parcelRequire("6TR1R");

var $kHLMD = parcelRequire("kHLMD");

var $j1Y2B = parcelRequire("j1Y2B");
var $f562T = parcelRequire("f562T");

var $g6gqP = parcelRequire("g6gqP");

var $j7vwS = parcelRequire("j7vwS");

var $fU0TK = parcelRequire("fU0TK");

var $1oCC5 = parcelRequire("1oCC5");

var $bsgBu = parcelRequire("bsgBu");

var $9GDXZ = parcelRequire("9GDXZ");

var $3HCkE = parcelRequire("3HCkE");

var $ellXt = parcelRequire("ellXt");

var $28VqH = parcelRequire("28VqH");

var $jM9bW = parcelRequire("jM9bW");

var $gYdvA = parcelRequire("gYdvA");

var $ab6rA = parcelRequire("ab6rA");
var $c7H0g = parcelRequire("c7H0g");
var $4xHig = parcelRequire("4xHig");

const $a2ea3ad8c5daa7b8$var$useIsModernGlobalIssueCreatePreferred = ()=>(0, $3HCkE.useResource)((0, $ellXt.gicOptInStatusResources)).data?.gicOptInStatus?.isEnabled ?? false;
const $a2ea3ad8c5daa7b8$var$LegacyComponents = ()=>{
    const baseUrl = '';
    const locale = (0, $4xHig.useLocale)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j7vwS.default), {
        baseUrl: baseUrl,
        locale: locale
    }));
};
const $a2ea3ad8c5daa7b8$var$ProjectCreateDrawerComponent = ()=>{
    const appEditions = (0, $ab6rA.useAppEditions)();
    const isAdmin = (0, $c7H0g.useIsAdmin)();
    const baseUrl = '';
    const locale = (0, $4xHig.useLocale)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9GDXZ.default), {
        baseUrl: baseUrl,
        isAdmin: isAdmin,
        isOnboarding: false,
        locale: locale,
        appEditions: appEditions
    });
};
const $a2ea3ad8c5daa7b8$var$ModernGlobalIssueCreate = (0, $2ijRB.default)(()=>(0, $1ybV0.ff)('project.config.pce.modern.global-issue-create') && $a2ea3ad8c5daa7b8$var$useIsModernGlobalIssueCreatePreferred(), ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gYdvA.AsyncEnforceStorageLimitsModal), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kHLMD.AsyncIssueCreateModal), null), (0, $1ybV0.ff)('project.config.pce.modern.global-issue-create.trigger') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fU0TK.default), null) : null), ()=>null);
const $a2ea3ad8c5daa7b8$var$IssueArchiveModal = (0, $bAQOb.componentWithFF)('issue-unarchival_wdpb9', (0, $6TR1R.default), ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null));
const $a2ea3ad8c5daa7b8$var$ModernIssueTransition = (0, $bAQOb.componentWithFF)('render-modern-issue-transition_cxt0z', (0, $g6gqP.AsyncIssueTransitionModal), ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null));
const $a2ea3ad8c5daa7b8$export$7d37935f329cddd4 = ()=>{
    const isAdmin = (0, $c7H0g.useIsAdmin)();
    const [userFirstModalVisit, setUserFirstModalVisit] = (0, $eUqFw.useState)(false);
    const fireErrorAnalyticWhenFetchHasSeenNinChangeboardingAdminModalUnsuccessful = (0, $eUqFw.useCallback)((cause)=>{
        const err = new Error('Fetch has seen NIN changeboarding admin modal was not successful', {
            cause: cause
        });
        (0, $guiFP.default)({
            meta: {
                id: 'adminModal',
                packageName: 'jiraSharedLayout',
                teamName: 'magma'
            },
            sendToPrivacyUnsafeSplunk: true,
            error: err
        });
    }, []);
    (0, $eUqFw.useEffect)(()=>{
        async function checkUserFirstModalVisit() {
            try {
                const hasSeenNinChangeboardingAdminModal = await (0, $f562T.default)();
                setUserFirstModalVisit(!hasSeenNinChangeboardingAdminModal);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (err) {
                fireErrorAnalyticWhenFetchHasSeenNinChangeboardingAdminModalUnsuccessful(err);
            }
        }
        isAdmin === true && checkUserFirstModalVisit();
    }, [
        fireErrorAnalyticWhenFetchHasSeenNinChangeboardingAdminModalUnsuccessful,
        setUserFirstModalVisit,
        isAdmin
    ]);
    return isAdmin === true && userFirstModalVisit ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j1Y2B.AsyncNinChangeboardingAdminModal), null) : null;
};
const $a2ea3ad8c5daa7b8$export$98f03c5d19621d70 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $edvkU.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kxeVc.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5TVuZ.AsyncFeedbackCollectorRenderer), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a2ea3ad8c5daa7b8$var$LegacyComponents, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1oCC5.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bsgBu.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cFeqe.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a2ea3ad8c5daa7b8$var$ProjectCreateDrawerComponent, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a2ea3ad8c5daa7b8$var$IssueArchiveModal, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a2ea3ad8c5daa7b8$var$ModernGlobalIssueCreate, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a2ea3ad8c5daa7b8$var$ModernIssueTransition, null), (0, $1ybV0.ff)('nin.global-scope_aqec8') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a2ea3ad8c5daa7b8$export$7d37935f329cddd4, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $28VqH.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        "data-testid": (0, $2ac6e3dbd6c2a0c4$export$bfef7353718d9887)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $48fa3.AsyncJiraCommandPalette), null)), (0, $1ybV0.ff)('jira-dark-theme-beta-benefits-modal') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5KRxh.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jM9bW.FlagIssueWithCommentModal), null));
var $a2ea3ad8c5daa7b8$export$2e2bcd8739ae039 = $a2ea3ad8c5daa7b8$export$98f03c5d19621d70;

});
parcelRegister("48fa3", function(module, exports) {

$parcel$export(module.exports, "AsyncJiraCommandPalette", () => $d33264548b6e9769$export$bc973e46f49f4513);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $npEL5 = parcelRequire("npEL5");
var $gCtL7 = parcelRequire("gCtL7");

var $6BN8F = parcelRequire("6BN8F");

var $9aFSa = parcelRequire("9aFSa");

var $gGtKh = parcelRequire("gGtKh");

var $epT40 = parcelRequire("epT40");

var $jK1pm = parcelRequire("jK1pm");

var $4Ds3l = parcelRequire("4Ds3l");

/* istanbul ignore next */ // eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $d33264548b6e9769$var$JiraCommandPaletteLazy = (0, $7rh0R.lazy)(()=>(parcelRequire("ae7ia")).then((module)=>module.CommandPaletteIntegration), {
    moduleId: "./src/packages/compal/command-palette-jira-integration/src/ui/index.tsx"
});
const $d33264548b6e9769$var$InternalAsyncCommandPalette = (props)=>{
    const [initialised, setInitialised] = (0, $eUqFw.useState)(false);
    const [{ isOpen: isOpen }] = (0, $gCtL7.useCommandPaletteIsOpen)();
    const { keyMap: commandPaletteKeyMap } = (0, $6BN8F.useCommandPaletteShortcut)();
    const [{ hasLoaded: hasLoaded }] = (0, $epT40.default)();
    (0, $eUqFw.useEffect)(()=>{
        if (!initialised && (isOpen || hasLoaded)) setInitialised(true);
    }, [
        initialised,
        isOpen,
        hasLoaded
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jK1pm.default), {
        name: "command-palette"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9aFSa.default), {
        keyMap: commandPaletteKeyMap
    }), initialised && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "jira-command-palette",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d33264548b6e9769$var$JiraCommandPaletteLazy, props)));
};
const $d33264548b6e9769$export$bc973e46f49f4513 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Ds3l.JiraCommandPaletteErrorBoundary), {
        id: "jira-command-palette-integration-async"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $npEL5.CommandPaletteWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d33264548b6e9769$var$InternalAsyncCommandPalette, props)));

});
parcelRegister("npEL5", function(module, exports) {

$parcel$export(module.exports, "CommandPaletteWrapper", () => $6e51acd077a5d53e$export$c6aee8a02c2936db);

var $eUqFw = parcelRequire("eUqFw");

var $8WuJm = parcelRequire("8WuJm");

var $gCtL7 = parcelRequire("gCtL7");
const $6e51acd077a5d53e$export$c6aee8a02c2936db = ({ children: children })=>{
    const [analyticsAttributes] = (0, $gCtL7.useCommandPaletteAnalyticsAttributes)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceName: "commandPalette",
        sourceType: (0, $41ea3621645e2acc$export$1171103ea9083ffa),
        attributes: analyticsAttributes
    }, children);
};

});
// SCREENS
const $41ea3621645e2acc$export$f636b5b56f1d624a = 'Screen';
const $41ea3621645e2acc$export$9d2de6eebf7462b5 = 'Drawer';
const $41ea3621645e2acc$export$1171103ea9083ffa = 'Modal';
const $41ea3621645e2acc$export$cae2783c9279926 = 'InlineDialog';
const $41ea3621645e2acc$export$d1123261ca8831d2 = 'Dropdown';
const $41ea3621645e2acc$export$238d30785c4bca84 = 'Banner';
const $41ea3621645e2acc$export$a1562d08625f5d7e = 'UI';
const $41ea3621645e2acc$export$947dac6c72b26f81 = 'TRACK';
const $41ea3621645e2acc$export$f1d537d508d2945a = 'SCREEN';
const $41ea3621645e2acc$export$12346a674644c156 = 'OPERATIONAL';

parcelRegister("gCtL7", function(module, exports) {

$parcel$export(module.exports, "useCommandPalette", () => $9139bfe8dcd2ea64$export$6b58f9610017fbb7);
$parcel$export(module.exports, "useActionsCommandPalette", () => $9139bfe8dcd2ea64$export$72aa7bc7c6a83c36);
$parcel$export(module.exports, "useCommandPaletteAnalyticsAttributes", () => $9139bfe8dcd2ea64$export$1f90c8f89f98110e);
$parcel$export(module.exports, "useCommandPaletteIsOpen", () => $9139bfe8dcd2ea64$export$cc979be9b69236df);
$parcel$export(module.exports, "useCommandPaletteIsLoaded", () => $9139bfe8dcd2ea64$export$af8fd8cd4b048315);
$parcel$export(module.exports, "useCommandPaletteSessionId", () => $9139bfe8dcd2ea64$export$7422170a403e909);
$parcel$export(module.exports, "useCommandPaletteExpandedCommand", () => $9139bfe8dcd2ea64$export$282aa48e4a3afada);
$parcel$export(module.exports, "useCommandPaletteSearch", () => $9139bfe8dcd2ea64$export$96819dfb22ad05d3);
$parcel$export(module.exports, "useCommandPaletteRegistryCurrentAttribution", () => $9139bfe8dcd2ea64$export$f893891deedab3c6);
$parcel$export(module.exports, "useCommandPaletteUsePerformModeState", () => $9139bfe8dcd2ea64$export$bbc05723eb144e03);

var $eUqFw = parcelRequire("eUqFw");

var $ggKAj = parcelRequire("ggKAj");
var $bj4JM = parcelRequire("bj4JM");
var $a61MH = parcelRequire("a61MH");

var $1ybV0 = parcelRequire("1ybV0");

var $8FbYY = parcelRequire("8FbYY");

var $li0m0 = parcelRequire("li0m0");
const $9139bfe8dcd2ea64$var$initialState = {
    commandPaletteSessionId: '',
    isOpen: false,
    isLoaded: false,
    search: '',
    activeIndex: 0,
    isSearchFieldFocused: false,
    commands: [],
    parentCommand: [],
    sections: [],
    isDisabled: false,
    registry: {},
    activeRegistry: {
        commandRegistry: {},
        registryIds: []
    },
    onClosePendingCommandAction: undefined,
    isLoadChildrenError: false
};
const $9139bfe8dcd2ea64$var$store = (0, $a61MH.createStore)({
    initialState: $9139bfe8dcd2ea64$var$initialState,
    actions: $li0m0.actions,
    name: 'commandPalette'
});
const $9139bfe8dcd2ea64$export$6b58f9610017fbb7 = (0, $ggKAj.createHook)($9139bfe8dcd2ea64$var$store);
const $9139bfe8dcd2ea64$export$72aa7bc7c6a83c36 = (0, $ggKAj.createActionsHook)($9139bfe8dcd2ea64$var$store);
const $9139bfe8dcd2ea64$export$e144a44b650635f4 = (ComponentToRender)=>(props)=>{
        const commandPalette = $9139bfe8dcd2ea64$export$6b58f9610017fbb7();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ComponentToRender, {
            ...props,
            commandPalette: commandPalette
        });
    };
const $9139bfe8dcd2ea64$export$56f06313122d0aac = ({ search: search, commandPaletteSessionId: commandPaletteSessionId, expandedCommand: expandedCommand, registry: registry, activeRegistry: activeRegistry })=>({
        wordCount: (0, $8FbYY.getWordCount)(search),
        queryLength: search.length,
        queryHash: (0, $8FbYY.getQueryHash)(search),
        commandPaletteSessionId: commandPaletteSessionId,
        cpMenu: expandedCommand?.id || 'rootMenu',
        ...(0, $8FbYY.getExpandedCommandRegistryAnalytics)(registry, activeRegistry, expandedCommand?.id) || {},
        activeRegistryIds: activeRegistry.registryIds,
        activeRegistryIdsLength: activeRegistry.registryIds.length,
        activeRegistryCommandsLength: Object.keys(activeRegistry.commandRegistry).length,
        ...(0, $1ybV0.ff)('compal.search-algorithm-analytics') ? {
            relevancyModel: 'v2-string-similarity'
        } : {}
    });
const $9139bfe8dcd2ea64$export$1f90c8f89f98110e = (0, $ggKAj.createHook)($9139bfe8dcd2ea64$var$store, {
    selector: $9139bfe8dcd2ea64$export$56f06313122d0aac
});
const $9139bfe8dcd2ea64$export$cc979be9b69236df = (0, $ggKAj.createHook)($9139bfe8dcd2ea64$var$store, {
    selector: ({ isOpen: isOpen })=>({
            isOpen: isOpen
        })
});
const $9139bfe8dcd2ea64$export$af8fd8cd4b048315 = (0, $ggKAj.createHook)($9139bfe8dcd2ea64$var$store, {
    selector: ({ isLoaded: isLoaded })=>({
            isLoaded: isLoaded
        })
});
const $9139bfe8dcd2ea64$export$4372697329bd9cbe = (0, $ggKAj.createHook)($9139bfe8dcd2ea64$var$store, {
    selector: ({ isDisabled: isDisabled })=>({
            isDisabled: isDisabled
        })
});
const $9139bfe8dcd2ea64$export$7422170a403e909 = (0, $ggKAj.createHook)($9139bfe8dcd2ea64$var$store, {
    selector: ({ commandPaletteSessionId: commandPaletteSessionId })=>({
            commandPaletteSessionId: commandPaletteSessionId
        })
});
const $9139bfe8dcd2ea64$export$282aa48e4a3afada = (0, $ggKAj.createHook)($9139bfe8dcd2ea64$var$store, {
    selector: ({ expandedCommand: expandedCommand, isOpen: isOpen })=>({
            expandedCommand: expandedCommand,
            isOpen: isOpen
        })
});
const $9139bfe8dcd2ea64$export$96819dfb22ad05d3 = (0, $ggKAj.createHook)($9139bfe8dcd2ea64$var$store, {
    selector: ({ search: search })=>({
            search: search
        })
});
const $9139bfe8dcd2ea64$export$a40e8ae3e53feab0 = (0, $bj4JM.createSelector)(({ registry: registry, activeRegistry: activeRegistry, expandedCommand: expandedCommand })=>({
        registry: registry,
        activeRegistry: activeRegistry,
        expandedCommand: expandedCommand
    }), ()=>undefined, ({ registry: registry, activeRegistry: activeRegistry, expandedCommand: expandedCommand })=>{
    if (!expandedCommand) return undefined;
    const registryData = (0, $8FbYY.getRegistryData)(registry, activeRegistry, expandedCommand.id);
    return {
        registryData: registryData,
        analyticsAttributes: registryData
    };
});
const $9139bfe8dcd2ea64$export$f893891deedab3c6 = (0, $ggKAj.createHook)($9139bfe8dcd2ea64$var$store, {
    selector: $9139bfe8dcd2ea64$export$a40e8ae3e53feab0
});
const $9139bfe8dcd2ea64$export$bbc05723eb144e03 = (0, $ggKAj.createHook)($9139bfe8dcd2ea64$var$store, {
    selector: ({ commands: commands, search: search, expandedCommand: expandedCommand, childResult: childResult, registry: registry, activeRegistry: activeRegistry })=>({
            commands: commands,
            search: search,
            expandedCommand: expandedCommand,
            childResult: childResult,
            registry: registry,
            activeRegistry: activeRegistry
        })
});

});
parcelRegister("8FbYY", function(module, exports) {

$parcel$export(module.exports, "getRegistryData", () => $faf99007a5829b26$export$6a1ed481c04a3ae6);
$parcel$export(module.exports, "getExpandedCommandRegistryAnalytics", () => $faf99007a5829b26$export$eb055284806da6e5);
$parcel$export(module.exports, "getShortcutSpecialCharacters", () => $faf99007a5829b26$export$e6994b845b967732);
$parcel$export(module.exports, "removeShortcutSpecialCharacters", () => $faf99007a5829b26$export$cd2a5827eae5f4cf);
$parcel$export(module.exports, "mergeSections", () => $faf99007a5829b26$export$389b0273703d5c48);
$parcel$export(module.exports, "mergeChildResults", () => $faf99007a5829b26$export$60a91e1b94ab4fef);
$parcel$export(module.exports, "getAnalyticsAttributesFromState", () => $faf99007a5829b26$export$4023cd53e5e5fcb8);
$parcel$export(module.exports, "isSecondaryTrigger", () => $faf99007a5829b26$export$daa5beabdf8d9fc3);
$parcel$export(module.exports, "hasChildren", () => $faf99007a5829b26$export$bd5ff50f0e53d41c);
$parcel$export(module.exports, "getAnalyticsAttributesFromResult", () => $faf99007a5829b26$export$bc9cd28438b3ea4b);
$parcel$export(module.exports, "getQueryHash", () => $faf99007a5829b26$export$fa1c95a5ffa92036);
$parcel$export(module.exports, "getWordCount", () => $faf99007a5829b26$export$dba3e2bcdbd49da4);
$parcel$export(module.exports, "getCommandAction", () => $faf99007a5829b26$export$fb6dafa07e60c21a);
$parcel$export(module.exports, "hasAction", () => $faf99007a5829b26$export$e217e69099d082f5);
$parcel$export(module.exports, "useSetTimeoutAutoClear", () => $faf99007a5829b26$export$c3d20e8c1e93a572);

var $eUqFw = parcelRequire("eUqFw");

var $3IRl5 = parcelRequire("3IRl5");

var $igOBb = parcelRequire("igOBb");

var $1ybV0 = parcelRequire("1ybV0");

var $ftpwV = parcelRequire("ftpwV");

var $6jiFZ = parcelRequire("6jiFZ");
const $faf99007a5829b26$export$6a1ed481c04a3ae6 = (registry, activeRegistry, commandId)=>{
    if (!commandId) return undefined;
    const activeCommandRegistryData = activeRegistry?.commandRegistry?.[commandId];
    const registryData = activeCommandRegistryData?.registryId ? registry[activeCommandRegistryData?.registryId] : undefined;
    return registryData;
};
const $faf99007a5829b26$export$eb055284806da6e5 = (registry, activeRegistry, commandId)=>$faf99007a5829b26$export$6a1ed481c04a3ae6(registry, activeRegistry, commandId);
const $faf99007a5829b26$export$8af60a6897157f84 = (registry, activeRegistry, parentCommands)=>{
    const parentCommandIds = parentCommands?.map((command)=>command.id);
    while(parentCommandIds?.length){
        const nextParentCommandId = parentCommandIds?.pop();
        const registryData = $faf99007a5829b26$export$6a1ed481c04a3ae6(registry, activeRegistry, nextParentCommandId);
        if (registryData) return registryData;
    }
    return undefined;
};
const $faf99007a5829b26$export$e6994b845b967732 = ()=>[
        {
            char: ' ',
            replacement: (0, $ftpwV.SHORTCUT_ELEMENT_TYPES).THEN
        },
        {
            char: '+',
            replacement: (0, $ftpwV.SHORTCUT_ELEMENT_TYPES).PLUS
        },
        {
            char: '|',
            replacement: (0, $ftpwV.SHORTCUT_ELEMENT_TYPES).OR
        }
    ];
const $faf99007a5829b26$export$cd2a5827eae5f4cf = (shortcut)=>{
    const specialChars = $faf99007a5829b26$export$e6994b845b967732();
    let strippedShortcut = shortcut;
    specialChars.forEach(({ char: char })=>{
        strippedShortcut = strippedShortcut.split(char).join('');
    });
    return strippedShortcut.toLowerCase();
};
const $faf99007a5829b26$export$389b0273703d5c48 = (sections)=>sections.reduce((acc, curr)=>{
        Object.entries(curr).forEach(([key, entry])=>{
            acc[key] = entry;
        });
        return acc;
    }, {});
const $faf99007a5829b26$export$60a91e1b94ab4fef = (childResults)=>{
    const commands = [];
    const sections = [];
    childResults.forEach((childResult)=>{
        commands.push(...childResult.commands);
        if (childResult.sections) sections.push(childResult.sections);
    });
    return {
        commands: commands,
        sections: $faf99007a5829b26$export$389b0273703d5c48(sections)
    };
};
const $faf99007a5829b26$export$ae8f55d2b67cb8d6 = (text, commonWordsToBeRemoved)=>{
    const commonWords = commonWordsToBeRemoved.toLowerCase().replace(/\s{2,}/g, ' ').trim().split(' ');
    const regexString = commonWords.map((word)=>`\\b${word}\\b`).join('|');
    const regex = new RegExp(regexString, 'g');
    return text.replace(/[.,]/g, '') // remove dot and comma
    .replace(regex, '') // remove common words
    .replace(/\s{2,}/g, ' ') // remove double spaces
    .trim();
};
const $faf99007a5829b26$export$4023cd53e5e5fcb8 = (state, command, method = 'undefined', wasSecondaryTriggered, attributes)=>{
    const analyticsAttributes = {
        commandPaletteId: command.id,
        commandPaletteSessionId: state.commandPaletteSessionId,
        searchTaken: !!state.search,
        method: method,
        cpMenu: 'rootMenu',
        action: command.id,
        actionCategory: 'none',
        wasSecondaryTriggered: wasSecondaryTriggered,
        ...(0, $1ybV0.ff)('fix-register-searchable-command-with-registryid') && $faf99007a5829b26$export$8af60a6897157f84(state.registry, state.activeRegistry, command.parentCommands),
        ...$faf99007a5829b26$export$6a1ed481c04a3ae6(state.registry, state.activeRegistry, command.id) || {},
        ...$faf99007a5829b26$export$eb055284806da6e5(state.registry, state.activeRegistry, state.expandedCommand?.id) || {},
        ...attributes,
        ...!!command.analytics && command.analytics
    };
    if (state.expandedCommand?.analytics) analyticsAttributes.cpMenu = state.expandedCommand.analytics.action;
    else if (state.expandedCommand?.id) analyticsAttributes.cpMenu = state.expandedCommand.id;
    const sections = state.expandedCommand && state.childResult?.sections ? $faf99007a5829b26$export$389b0273703d5c48([
        ...state.sections,
        state.childResult?.sections
    ]) : $faf99007a5829b26$export$389b0273703d5c48(state.sections);
    const rootCommand = state.parentCommand?.[0] || state.expandedCommand || command;
    const rootSection = rootCommand.section ? sections?.[rootCommand.section] : undefined;
    analyticsAttributes.actionCategory = rootSection?.actionCategory || rootCommand?.section || rootCommand?.analytics?.actionCategory || // Fallback to the original command section
    (command?.section ? sections?.[command?.section]?.actionCategory || command?.section : undefined) || analyticsAttributes.actionCategory;
    return analyticsAttributes;
};
const $faf99007a5829b26$export$daa5beabdf8d9fc3 = (event)=>(0, $igOBb.isMacOs)() ? event.metaKey : event.ctrlKey;
const $faf99007a5829b26$export$bd5ff50f0e53d41c = (command)=>{
    if (command?.wasSecondaryTriggered) {
        if (command?.secondaryAction?.type) {
            const hasSecondaryChildren = (0, $6jiFZ.COMMAND_WITH_CHILDREN).some((commandType)=>commandType === command?.secondaryAction?.type);
            return hasSecondaryChildren;
        }
        // secondary action not defined - fallback to primary
        return (0, $6jiFZ.COMMAND_WITH_CHILDREN).some((commandType)=>commandType === command?.primaryAction?.type);
    }
    return (0, $6jiFZ.COMMAND_WITH_CHILDREN).some((commandType)=>commandType === command?.primaryAction?.type);
};
const $faf99007a5829b26$export$bc9cd28438b3ea4b = (result)=>{
    if (result) return {
        globalIndex: result.index,
        sectionIndex: result.sectionIndex,
        indexWithinSection: result.indexWithinSection,
        sectionId: result.sectionId
    };
    return {};
};
const $faf99007a5829b26$export$fa1c95a5ffa92036 = (str)=>(0, $3IRl5.createHash)().update(str).digest('hex');
const $faf99007a5829b26$export$dba3e2bcdbd49da4 = (str)=>str.length > 0 ? str.split(/\s+/).length : 0;
const $faf99007a5829b26$export$fb6dafa07e60c21a = (command, wasSecondaryTriggered)=>{
    if (!command) return null;
    const { secondaryAction: secondaryAction, primaryAction: primaryAction } = command;
    if (!primaryAction) return null;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const commandAction = wasSecondaryTriggered && secondaryAction ? secondaryAction : primaryAction;
    return {
        ...commandAction
    };
};
const $faf99007a5829b26$export$e217e69099d082f5 = (command)=>Boolean(command.primaryAction || command.secondaryAction);
const $faf99007a5829b26$export$c3d20e8c1e93a572 = ()=>{
    const timeoutRef = (0, $eUqFw.useRef)();
    (0, $eUqFw.useEffect)(()=>()=>{
            if (timeoutRef.current) clearTimeout(timeoutRef.current);
        }, []);
    const setTimeoutAutoClear = (...args)=>{
        if (timeoutRef.current) clearTimeout(timeoutRef.current);
        timeoutRef.current = setTimeout(...args);
    };
    return {
        setTimeoutAutoClear: setTimeoutAutoClear
    };
};

});
parcelRegister("igOBb", function(module, exports) {

$parcel$export(module.exports, "isMacOs", () => $a127768fd887ea5b$export$c5e71f489eb3970b);
$parcel$export(module.exports, "getShortcutModifierKey", () => $a127768fd887ea5b$export$fe66dae91c68619b);
const $a127768fd887ea5b$export$c5e71f489eb3970b = ()=>/Mac/i.test(window?.navigator?.platform);
const $a127768fd887ea5b$export$fe66dae91c68619b = ()=>$a127768fd887ea5b$export$c5e71f489eb3970b() ? 'meta' : 'ctrl';

});

parcelRegister("ftpwV", function(module, exports) {

$parcel$export(module.exports, "UI_EVENT_TYPE", () => $48b165edb54974f4$export$a1562d08625f5d7e);
$parcel$export(module.exports, "TRACK_EVENT_TYPE", () => $48b165edb54974f4$export$947dac6c72b26f81);
$parcel$export(module.exports, "SHORTCUT_ELEMENT_TYPES", () => $48b165edb54974f4$export$1ee9d153576afd13);
// EVENT TYPES
const $48b165edb54974f4$export$a1562d08625f5d7e = 'UI';
const $48b165edb54974f4$export$947dac6c72b26f81 = 'TRACK';
const $48b165edb54974f4$export$f1d537d508d2945a = 'SCREEN';
const $48b165edb54974f4$export$12346a674644c156 = 'OPERATIONAL';
var $48b165edb54974f4$export$1ee9d153576afd13;
(function(SHORTCUT_ELEMENT_TYPES) {
    SHORTCUT_ELEMENT_TYPES["THEN"] = "then";
    SHORTCUT_ELEMENT_TYPES["OR"] = "or";
    SHORTCUT_ELEMENT_TYPES["PLUS"] = "plus";
    SHORTCUT_ELEMENT_TYPES["KEY"] = "key";
})($48b165edb54974f4$export$1ee9d153576afd13 || ($48b165edb54974f4$export$1ee9d153576afd13 = {}));

});

parcelRegister("6jiFZ", function(module, exports) {

$parcel$export(module.exports, "CommandActionType", () => $5c36304d2fa4b1a2$export$f041b1b117ab382f);
$parcel$export(module.exports, "COMMAND_WITH_CHILDREN", () => $5c36304d2fa4b1a2$export$904b2a0e38a1bef3);
var $5c36304d2fa4b1a2$export$f041b1b117ab382f;
(function(CommandActionType) {
    /** Performs action when user clicks or presses Enter in the command. Command Palette closes while performing the action */ CommandActionType["PERFORM"] = "perform";
    /** Loads a sub list of commands  */ CommandActionType["COMMAND_LIST"] = "command-list";
})($5c36304d2fa4b1a2$export$f041b1b117ab382f || ($5c36304d2fa4b1a2$export$f041b1b117ab382f = {}));
const $5c36304d2fa4b1a2$export$3e448fd53031e13c = Object.values($5c36304d2fa4b1a2$export$f041b1b117ab382f);
const $5c36304d2fa4b1a2$export$904b2a0e38a1bef3 = [
    "command-list"
];

});


parcelRegister("li0m0", function(module, exports) {

$parcel$export(module.exports, "actions", () => $476b965ceb7c28b6$export$e324594224ef24da);

var $MdoH4 = parcelRequire("MdoH4");

var $hompL = parcelRequire("hompL");

var $igOBb = parcelRequire("igOBb");

var $guiFP = parcelRequire("guiFP");

var $1ybV0 = parcelRequire("1ybV0");

var $9lcOH = parcelRequire("9lcOH");

var $duQ8C = parcelRequire("duQ8C");

var $ftpwV = parcelRequire("ftpwV");

var $6jiFZ = parcelRequire("6jiFZ");

var $8FbYY = parcelRequire("8FbYY");

var $gklnd = parcelRequire("gklnd");

var $2fkzb = parcelRequire("2fkzb");
const $476b965ceb7c28b6$var$rootCommands = {
    parentCommand: [],
    expandedCommand: undefined,
    childCommands: undefined,
    childResult: undefined
};
const $476b965ceb7c28b6$var$open = ()=>({ setState: setState, getState: getState })=>{
        if (getState().isDisabled) return;
        setState({
            commandPaletteSessionId: (0, (/*@__PURE__*/$parcel$interopDefault($hompL))).v4(),
            isOpen: true,
            activeIndex: 0,
            search: ''
        });
    };
const $476b965ceb7c28b6$var$close = ()=>({ setState: setState })=>{
        setState({
            isOpen: false,
            commandPaletteSessionId: '',
            search: '',
            ...$476b965ceb7c28b6$var$rootCommands
        });
    };
const $476b965ceb7c28b6$var$toggle = ()=>({ setState: setState, getState: getState })=>{
        const isOpen = !getState().isOpen;
        setState({
            isOpen: isOpen,
            activeIndex: 0,
            search: '',
            commandPaletteSessionId: isOpen ? (0, (/*@__PURE__*/$parcel$interopDefault($hompL))).v4() : '',
            ...!isOpen ? $476b965ceb7c28b6$var$rootCommands : {}
        });
    };
const $476b965ceb7c28b6$var$addCommands = (commands)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        const newCommands = currentState.commands.concat(commands);
        const newState = {
            commands: newCommands
        };
        if (currentState.expandedCommand) {
            const matchedExpandedCommand = commands.filter((command)=>command.id === currentState.expandedCommand?.id);
            if (matchedExpandedCommand.length === 1) {
                const [updatedExpandedCommand] = matchedExpandedCommand;
                newState.expandedCommand = updatedExpandedCommand;
            }
        }
        setState(newState);
    };
const $476b965ceb7c28b6$var$removeCommands = (commands)=>({ setState: setState, getState: getState })=>{
        const newCommands = getState().commands.filter((command)=>!commands.includes(command));
        setState({
            commands: newCommands
        });
    };
const $476b965ceb7c28b6$var$removeCommandsById = (commandIds)=>({ setState: setState, getState: getState })=>{
        const newCommands = getState().commands.filter((command)=>!commandIds.includes(command.id));
        setState({
            commands: newCommands
        });
    };
const $476b965ceb7c28b6$var$handleSearch = (search)=>({ setState: setState })=>{
        setState({
            search: search,
            activeIndex: 0
        });
    };
const $476b965ceb7c28b6$var$goBackLevel = (goToRoot, analytics)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        if (!currentState.expandedCommand) return;
        const newState = {
            search: '',
            activeIndex: 0,
            childResult: undefined,
            forceSearchFocus: true
        };
        if (currentState.parentCommand.length && !goToRoot) {
            newState.expandedCommand = currentState.parentCommand[currentState.parentCommand.length - 1];
            newState.parentCommand = currentState.parentCommand.slice(0, currentState.parentCommand.length - 1);
            if (newState.expandedCommand?.primaryAction?.type === (0, $6jiFZ.CommandActionType).COMMAND_LIST && newState.expandedCommand?.primaryAction?.commands) newState.childResult = {
                commands: newState.expandedCommand?.primaryAction?.commands,
                sections: newState.expandedCommand?.primaryAction?.sections
            };
        } else {
            newState.loadingList = false;
            newState.parentCommand = [];
            newState.expandedCommand = undefined;
            newState.childResult = undefined;
        }
        if ((0, $1ybV0.ff)('compal-refactor-analytics') && currentState?.onAnalytics && analytics?.createAnalyticsEvent) currentState.onAnalytics(analytics.createAnalyticsEvent({
            action: 'navigation',
            actionSubject: 'commandPalette'
        }), (0, $ftpwV.TRACK_EVENT_TYPE), {
            attributes: {
                cpMenu: currentState.expandedCommand?.id || 'rootMenu',
                searchSessionId: currentState.commandPaletteSessionId,
                action: goToRoot ? 'backToRoot' : 'backToParent',
                actionCategory: 'back',
                method: analytics?.method
            }
        });
        else if (!(0, $1ybV0.ff)('compal-refactor-analytics') && analytics?.onAnalyticsOld && analytics?.createAnalyticsEvent) analytics.onAnalyticsOld(analytics.createAnalyticsEvent({
            action: 'navigation',
            actionSubject: 'commandPalette'
        }), (0, $ftpwV.TRACK_EVENT_TYPE), {
            cpMenu: currentState.expandedCommand?.id || 'rootMenu',
            searchSessionId: currentState.commandPaletteSessionId,
            action: goToRoot ? 'backToRoot' : 'backToParent',
            actionCategory: 'back',
            method: analytics?.method
        });
        setState(newState);
    };
// Once search input is focused, forceSearchFocus can go back to false
const $476b965ceb7c28b6$var$forceFocusSearch = (forceSearchFocus = false)=>({ setState: setState })=>{
        setState({
            forceSearchFocus: forceSearchFocus
        });
    };
const $476b965ceb7c28b6$var$setActiveIndex = (index)=>({ setState: setState, getState: getState })=>{
        const { isSearchFieldFocused: isSearchFieldFocused } = getState();
        setState({
            activeIndex: index,
            ...!isSearchFieldFocused ? {
                forceSearchFocus: true
            } : {}
        });
    };
const $476b965ceb7c28b6$var$getAnalyticsAttributes = (command, method, wasSecondaryTriggered = false, attributes = {})=>({ getState: getState })=>(0, $8FbYY.getAnalyticsAttributesFromState)(getState(), command, method, wasSecondaryTriggered, attributes);
const $476b965ceb7c28b6$var$performDialogCloseCommand = ()=>({ setState: setState, getState: getState })=>{
        // Timeout applied to ensure that this happens after react-focus-lock is shut down
        // react-focus-lock also has a timeout before it stops listening for focus events
        // tl;dr If you don't add this timeout, cypress gets sad (and probably some actual users too but I've never repro'd it manually)
        setTimeout(()=>{
            const { onClosePendingCommandAction: onClosePendingCommandAction } = getState();
            if (onClosePendingCommandAction !== undefined) {
                try {
                    (0, $duQ8C.default)('command-palette-executed');
                    onClosePendingCommandAction.perform();
                } catch (err) {
                    const error = err instanceof Error ? err : new Error('Command palette perform error');
                    (0, $guiFP.default)({
                        error: error,
                        meta: {
                            id: 'compal.performDialogCloseCommand',
                            packageName: 'jiraCommandPalette',
                            teamName: typeof onClosePendingCommandAction?.analyticsArgs?.teamName === 'string' ? onClosePendingCommandAction?.analyticsArgs.teamName : 'deliveroo'
                        },
                        attributes: onClosePendingCommandAction.analyticsArgs
                    });
                    (0, $9lcOH.setInteractionError)('command-palette-executed', {
                        errorMessage: error.message,
                        name: 'performDialogCloseCommandPerformError'
                    });
                }
                setState({
                    onClosePendingCommandAction: undefined
                });
            }
        }, 0);
    };
const $476b965ceb7c28b6$var$executeCommand = (command, analytics, wasSecondaryTriggered = false)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        const newState = {
            ...!(0, $gklnd.getActiveCommandList)(command, wasSecondaryTriggered)?.keepSearch && {
                search: ''
            },
            activeIndex: 0
        };
        const analyticsAttributes = (0, $8FbYY.getAnalyticsAttributesFromState)(currentState, command, analytics?.method || 'undefined', wasSecondaryTriggered, analytics?.attributes);
        const currentCommandAction = (0, $8FbYY.getCommandAction)(command, wasSecondaryTriggered);
        if (!currentCommandAction) return;
        if ((0, $1ybV0.ff)('compal-refactor-analytics') && currentState?.onAnalytics && analytics?.createAnalyticsEvent) {
            const analyticsEvent = analytics.createAnalyticsEvent({
                action: 'navigation',
                actionSubject: 'commandPalette'
            });
            currentState.onAnalytics(analyticsEvent, (0, $ftpwV.TRACK_EVENT_TYPE), {
                attributes: analyticsAttributes
            });
        } else if (!(0, $1ybV0.ff)('compal-refactor-analytics') && analytics?.onAnalyticsOld && analytics?.createAnalyticsEvent) {
            const analyticsEvent = analytics.createAnalyticsEvent({
                action: 'navigation',
                actionSubject: 'commandPalette'
            });
            analytics.onAnalyticsOld(analyticsEvent, (0, $ftpwV.TRACK_EVENT_TYPE), {
                ...analyticsAttributes
            });
        }
        const shouldLoadChildren = (0, $8FbYY.hasChildren)({
            ...command,
            wasSecondaryTriggered: wasSecondaryTriggered
        });
        const shouldExecutePerform = currentCommandAction?.type === (0, $6jiFZ.CommandActionType).PERFORM;
        if (shouldLoadChildren) {
            (0, $duQ8C.default)('command-palette-load-child-command-list');
            if (currentState.expandedCommand) newState.parentCommand = [
                ...currentState.parentCommand,
                currentState.expandedCommand
            ];
            newState.expandedCommand = {
                ...command,
                wasSecondaryTriggered: wasSecondaryTriggered
            };
            newState.childResult = undefined;
            newState.forceSearchFocus = true;
            if ((0, $2fkzb.isSearchableChildrenAction)(currentCommandAction)) {
                newState.childResult = {
                    commands: currentCommandAction.commands,
                    sections: currentCommandAction.sections
                };
                if (command.parentCommands?.length) newState.parentCommand = [
                    ...newState.parentCommand || [],
                    ...command.parentCommands
                ];
            } else newState.childResult = undefined;
            setState(newState);
            if ((0, $1ybV0.ff)('compal-issue-actions-very-high-priority_f5w5r')) {
                if (currentCommandAction.type === (0, $6jiFZ.CommandActionType).COMMAND_LIST && currentCommandAction.onClick) currentCommandAction.onClick();
            }
        } else if (shouldExecutePerform) {
            if (!currentCommandAction.preventModalClose) {
                newState.commandPaletteSessionId = '';
                newState.isOpen = false;
                newState.expandedCommand = undefined;
                newState.parentCommand = [];
                newState.childResult = undefined;
                setState(newState);
                if ((0, $1ybV0.ff)('compal-refactor-analytics') && currentState.onAnalytics && analytics?.createAnalyticsEvent) {
                    const closeAnalyticsEvent = analytics.createAnalyticsEvent({
                        action: 'closed',
                        actionSubject: 'commandPalette'
                    });
                    currentState.onAnalytics(closeAnalyticsEvent, (0, $ftpwV.UI_EVENT_TYPE), {
                        attributes: analyticsAttributes
                    });
                } else if (!(0, $1ybV0.ff)('compal-refactor-analytics') && analytics?.onAnalyticsOld && analytics?.createAnalyticsEvent) {
                    const closeAnalyticsEvent = analytics.createAnalyticsEvent({
                        action: 'closed',
                        actionSubject: 'commandPalette'
                    });
                    analytics.onAnalyticsOld(closeAnalyticsEvent, (0, $ftpwV.UI_EVENT_TYPE), analyticsAttributes);
                }
            }
            if ((0, $1ybV0.ff)('compal-refactor-analytics') && wasSecondaryTriggered && currentState.onAnalytics && analytics?.createAnalyticsEvent) {
                const closeAnalyticsEvent = analytics.createAnalyticsEvent({
                    action: 'secondaryAction',
                    actionSubject: 'commandPalette'
                });
                currentState.onAnalytics(closeAnalyticsEvent, (0, $ftpwV.TRACK_EVENT_TYPE), {
                    attributes: {
                        ...analyticsAttributes,
                        keyPressed: (0, $igOBb.isMacOs)() ? 'cmdEnter' : 'ctrlEnter',
                        ...currentCommandAction.analyticsArgs
                    }
                });
            } else if (!(0, $1ybV0.ff)('compal-refactor-analytics') && wasSecondaryTriggered && analytics?.onAnalyticsOld && analytics?.createAnalyticsEvent) {
                const closeAnalyticsEvent = analytics.createAnalyticsEvent({
                    action: 'secondaryAction',
                    actionSubject: 'commandPalette'
                });
                analytics.onAnalyticsOld(closeAnalyticsEvent, (0, $ftpwV.TRACK_EVENT_TYPE), {
                    ...analyticsAttributes,
                    keyPressed: (0, $igOBb.isMacOs)() ? 'cmdEnter' : 'ctrlEnter',
                    ...currentCommandAction.analyticsArgs
                });
            }
            // If not closing dialog, execute immediately, otherwise cue for after dialog is closed
            if (currentCommandAction.preventModalClose) try {
                (0, $duQ8C.default)('command-palette-executed');
                currentCommandAction.perform();
            } catch (err) {
                const error = err instanceof Error ? err : new Error('Command palette perform error');
                (0, $guiFP.default)({
                    error: error,
                    meta: {
                        id: 'compal.executeCommand',
                        packageName: 'jiraCommandPalette',
                        teamName: typeof analytics?.attributes?.teamName === 'string' ? analytics?.attributes.teamName : 'deliveroo'
                    },
                    attributes: analytics?.attributes
                });
                (0, $9lcOH.setInteractionError)('command-palette-executed', {
                    errorMessage: error.message,
                    name: 'executeCommandPerformError'
                });
            }
            else setState({
                onClosePendingCommandAction: {
                    ...currentCommandAction,
                    analyticsArgs: analytics?.attributes
                }
            });
        }
    };
const $476b965ceb7c28b6$var$setChildCommands = (childResult)=>({ setState: setState })=>{
        setState({
            childResult: childResult
        });
    };
const $476b965ceb7c28b6$var$setLoadingList = (loadingList)=>({ setState: setState })=>{
        setState({
            loadingList: loadingList
        });
    };
const $476b965ceb7c28b6$var$setFocusInput = (isSearchFieldFocused)=>({ setState: setState })=>setState({
            isSearchFieldFocused: isSearchFieldFocused
        });
const $476b965ceb7c28b6$var$registerSections = (newSections)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        const sections = currentState.sections.slice(0);
        sections.push(newSections);
        setState({
            sections: sections
        });
    };
const $476b965ceb7c28b6$var$unregisterSections = (newSections)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        const sections = currentState.sections.filter((section)=>section !== newSections);
        setState({
            sections: sections
        });
    };
const $476b965ceb7c28b6$var$markAsLoaded = ()=>({ setState: setState })=>{
        setState({
            isLoaded: true
        });
    };
const $476b965ceb7c28b6$var$setIsDisabled = (isDisabled)=>({ setState: setState })=>{
        setState({
            isDisabled: isDisabled,
            ...isDisabled ? {
                isOpen: false
            } : {}
        });
    };
const $476b965ceb7c28b6$var$setRegistry = (registry)=>({ setState: setState })=>{
        setState({
            registry: registry
        });
    };
const $476b965ceb7c28b6$var$updateActiveRegistry = (registryId, commands)=>({ setState: setState, getState: getState })=>{
        const currentActiveRegistry = getState().activeRegistry;
        const activeRegistry = {
            commandRegistry: {
                ...currentActiveRegistry.commandRegistry,
                ...commands.reduce((acc, command)=>{
                    acc[command.id] = {
                        registryId: registryId
                    };
                    return acc;
                }, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                {})
            },
            registryIds: (0, (/*@__PURE__*/$parcel$interopDefault($MdoH4)))([
                ...currentActiveRegistry.registryIds,
                registryId
            ])
        };
        setState({
            activeRegistry: activeRegistry
        });
    };
const $476b965ceb7c28b6$var$removeFromActiveRegistry = (registryId, commands)=>({ setState: setState, getState: getState })=>{
        const currentActiveRegistry = getState().activeRegistry;
        const commandRegistry = {
            ...currentActiveRegistry.commandRegistry
        };
        commands.forEach((command)=>{
            delete commandRegistry[command.id];
        });
        setState({
            activeRegistry: {
                commandRegistry: commandRegistry,
                registryIds: currentActiveRegistry.registryIds.filter((id)=>id !== registryId)
            }
        });
    };
const $476b965ceb7c28b6$var$setAnalytics = (onAnalytics, onErrorAnalytics)=>({ setState: setState })=>{
        setState({
            onAnalytics: onAnalytics,
            onErrorAnalytics: onErrorAnalytics
        });
    };
const $476b965ceb7c28b6$var$setFallbackOverride = (fallbackOverride)=>({ setState: setState })=>{
        setState({
            fallbackOverride: fallbackOverride
        });
    };
const $476b965ceb7c28b6$export$e324594224ef24da = {
    open: $476b965ceb7c28b6$var$open,
    toggle: $476b965ceb7c28b6$var$toggle,
    close: $476b965ceb7c28b6$var$close,
    addCommands: $476b965ceb7c28b6$var$addCommands,
    removeCommands: $476b965ceb7c28b6$var$removeCommands,
    handleSearch: $476b965ceb7c28b6$var$handleSearch,
    forceFocusSearch: $476b965ceb7c28b6$var$forceFocusSearch,
    setActiveIndex: $476b965ceb7c28b6$var$setActiveIndex,
    executeCommand: $476b965ceb7c28b6$var$executeCommand,
    goBackLevel: $476b965ceb7c28b6$var$goBackLevel,
    setChildCommands: $476b965ceb7c28b6$var$setChildCommands,
    setLoadingList: $476b965ceb7c28b6$var$setLoadingList,
    setFocusInput: $476b965ceb7c28b6$var$setFocusInput,
    registerSections: $476b965ceb7c28b6$var$registerSections,
    unregisterSections: $476b965ceb7c28b6$var$unregisterSections,
    markAsLoaded: $476b965ceb7c28b6$var$markAsLoaded,
    getAnalyticsAttributes: $476b965ceb7c28b6$var$getAnalyticsAttributes,
    setIsDisabled: $476b965ceb7c28b6$var$setIsDisabled,
    setRegistry: $476b965ceb7c28b6$var$setRegistry,
    updateActiveRegistry: $476b965ceb7c28b6$var$updateActiveRegistry,
    removeCommandsById: $476b965ceb7c28b6$var$removeCommandsById,
    removeFromActiveRegistry: $476b965ceb7c28b6$var$removeFromActiveRegistry,
    performDialogCloseCommand: $476b965ceb7c28b6$var$performDialogCloseCommand,
    setAnalytics: $476b965ceb7c28b6$var$setAnalytics,
    setFallbackOverride: $476b965ceb7c28b6$var$setFallbackOverride
};

});
parcelRegister("gklnd", function(module, exports) {

$parcel$export(module.exports, "getActiveCommandList", () => $b93b5138b1f374a6$export$639b7f41b0b47a01);

var $6jiFZ = parcelRequire("6jiFZ");
const $b93b5138b1f374a6$export$639b7f41b0b47a01 = (expandedCommand, wasSecondaryTriggered)=>{
    if (wasSecondaryTriggered && expandedCommand?.secondaryAction?.type === (0, $6jiFZ.CommandActionType).COMMAND_LIST) return expandedCommand.secondaryAction;
    if (!wasSecondaryTriggered && expandedCommand?.primaryAction?.type === (0, $6jiFZ.CommandActionType).COMMAND_LIST) return expandedCommand.primaryAction;
    return null;
};

});

parcelRegister("2fkzb", function(module, exports) {

$parcel$export(module.exports, "isSearchableChildrenAction", () => $20c016b992336e05$export$d75616d77443fe4e);

var $6jiFZ = parcelRequire("6jiFZ");
const $20c016b992336e05$export$d75616d77443fe4e = (action)=>action?.type === (0, $6jiFZ.CommandActionType).COMMAND_LIST && action.commands !== undefined;

});




parcelRegister("6BN8F", function(module, exports) {

$parcel$export(module.exports, "useCommandPaletteShortcut", () => $939f0895d88815ff$export$819c83c949ab2a6b);

var $gCtL7 = parcelRequire("gCtL7");

var $igOBb = parcelRequire("igOBb");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $duQ8C = parcelRequire("duQ8C");

var $9zALC = parcelRequire("9zALC");
const $939f0895d88815ff$export$819c83c949ab2a6b = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [{ isLoaded: isLoaded }, { open: open }] = (0, $gCtL7.useCommandPaletteIsLoaded)();
    return {
        keyMap: {
            [`${(0, $igOBb.getShortcutModifierKey)()}+k`]: {
                callback: (ev)=>{
                    (0, $duQ8C.default)('command-palette-opened');
                    (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent((0, $9zALC.COMMAND_PALETTE_PRESSED_ANALYTICS)), (0, $9zALC.COMMAND_PALETTE_ID), {
                        key: 'k',
                        isLoaded: isLoaded
                    });
                    ev?.preventDefault();
                    open();
                }
            }
        }
    };
};

});
parcelRegister("9zALC", function(module, exports) {

$parcel$export(module.exports, "COMMAND_PALETTE_SECTIONS", () => $8bee8fa7684ab6e5$export$16b06d29ef8f802b);
$parcel$export(module.exports, "COMMAND_PALETTE_ISSUE_ACTIONS", () => $8bee8fa7684ab6e5$export$156ebd2354e25466);
$parcel$export(module.exports, "COMMAND_PALETTE_PRESSED_ANALYTICS", () => $8bee8fa7684ab6e5$export$7fe859528e87e623);
$parcel$export(module.exports, "COMMAND_PALETTE_ID", () => $8bee8fa7684ab6e5$export$9f646ab88e1d2b14);
$parcel$export(module.exports, "COMMAND_PALETTE_SECTIONS_PRIORITY", () => $8bee8fa7684ab6e5$export$abf26cc5daebd2c8);
$parcel$export(module.exports, "COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY", () => $8bee8fa7684ab6e5$export$12514ca8899b0521);
$parcel$export(module.exports, "COMMAND_PALETTE_ATLASSIAN_ADMIN_PRIORITY", () => $8bee8fa7684ab6e5$export$5fa0bcf59f933c21);
$parcel$export(module.exports, "COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY", () => $8bee8fa7684ab6e5$export$7d9743be0b7d862f);
$parcel$export(module.exports, "COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY", () => $8bee8fa7684ab6e5$export$b4e1633c86db2b70);
$parcel$export(module.exports, "COMMAND_PALETTE_HELP_PRIORITY", () => $8bee8fa7684ab6e5$export$5e5a87aac5d9771f);
// TODO: go/restrict-enums
// eslint-disable-next-line no-restricted-syntax
var $8bee8fa7684ab6e5$export$16b06d29ef8f802b;
(function(COMMAND_PALETTE_SECTIONS) {
    COMMAND_PALETTE_SECTIONS["quickSearch"] = "quick-search";
    COMMAND_PALETTE_SECTIONS["projectNavigation"] = "project-navigation";
    COMMAND_PALETTE_SECTIONS["siteNavigation"] = "site-navigation";
    COMMAND_PALETTE_SECTIONS["help"] = "help";
    COMMAND_PALETTE_SECTIONS["quickActions"] = "quick-actions";
    COMMAND_PALETTE_SECTIONS["personalSettings"] = "personal-settings";
    COMMAND_PALETTE_SECTIONS["jiraSettings"] = "jira-settings";
    COMMAND_PALETTE_SECTIONS["atlassianAdmin"] = "atlassian-admin";
})($8bee8fa7684ab6e5$export$16b06d29ef8f802b || ($8bee8fa7684ab6e5$export$16b06d29ef8f802b = {}));
const $8bee8fa7684ab6e5$export$156ebd2354e25466 = 'issueActions';
const $8bee8fa7684ab6e5$export$7fe859528e87e623 = {
    action: 'pressed',
    actionSubject: 'commandPaletteKeyboardShortcut'
};
const $8bee8fa7684ab6e5$export$9f646ab88e1d2b14 = 'commandPalette';
var $8bee8fa7684ab6e5$export$abf26cc5daebd2c8;
(function(COMMAND_PALETTE_SECTIONS_PRIORITY) {
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["quickSearch"] = 0] = "quickSearch";
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["issueActions"] = 1] = "issueActions";
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["projectNavigation"] = 2] = "projectNavigation";
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["quickActions"] = 3] = "quickActions";
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["siteNavigation"] = 4] = "siteNavigation";
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["atlassianAdmin"] = 5] = "atlassianAdmin";
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["jiraSettings"] = 6] = "jiraSettings";
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["personalSettings"] = 7] = "personalSettings";
    COMMAND_PALETTE_SECTIONS_PRIORITY[COMMAND_PALETTE_SECTIONS_PRIORITY["help"] = 8] = "help";
})($8bee8fa7684ab6e5$export$abf26cc5daebd2c8 || ($8bee8fa7684ab6e5$export$abf26cc5daebd2c8 = {}));
var $8bee8fa7684ab6e5$export$12514ca8899b0521;
(function(COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY) {
    COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY[COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY["goToBacklog"] = 0] = "goToBacklog";
    COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY[COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY["goToBoard"] = 1] = "goToBoard";
    COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY[COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY["goToReports"] = 2] = "goToReports";
    COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY[COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY["goToTimeline"] = 3] = "goToTimeline";
    COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY[COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY["goToIssues"] = 4] = "goToIssues";
})($8bee8fa7684ab6e5$export$12514ca8899b0521 || ($8bee8fa7684ab6e5$export$12514ca8899b0521 = {}));
var $8bee8fa7684ab6e5$export$5fa0bcf59f933c21;
(function(COMMAND_PALETTE_ATLASSIAN_ADMIN_PRIORITY) {
    COMMAND_PALETTE_ATLASSIAN_ADMIN_PRIORITY[COMMAND_PALETTE_ATLASSIAN_ADMIN_PRIORITY["userManagement"] = 0] = "userManagement";
    COMMAND_PALETTE_ATLASSIAN_ADMIN_PRIORITY[COMMAND_PALETTE_ATLASSIAN_ADMIN_PRIORITY["billing"] = 1] = "billing";
})($8bee8fa7684ab6e5$export$5fa0bcf59f933c21 || ($8bee8fa7684ab6e5$export$5fa0bcf59f933c21 = {}));
var $8bee8fa7684ab6e5$export$7d9743be0b7d862f;
(function(COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY) {
    COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY[COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY["switchToDarkTheme"] = 0] = "switchToDarkTheme";
    COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY[COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY["switchToLightTheme"] = 1] = "switchToLightTheme";
    COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY[COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY["switchToSystemTheme"] = 2] = "switchToSystemTheme";
    COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY[COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY["goToPersonalSettings"] = 3] = "goToPersonalSettings";
    COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY[COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY["goToAccountSettings"] = 4] = "goToAccountSettings";
})($8bee8fa7684ab6e5$export$7d9743be0b7d862f || ($8bee8fa7684ab6e5$export$7d9743be0b7d862f = {}));
var $8bee8fa7684ab6e5$export$b4e1633c86db2b70;
(function(COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY) {
    COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY[COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY["viewAllIssues"] = 0] = "viewAllIssues";
    COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY[COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY["goToProjects"] = 1] = "goToProjects";
    COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY[COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY["goToBoards"] = 2] = "goToBoards";
    COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY[COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY["goToFilters"] = 3] = "goToFilters";
    COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY[COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY["goToDashboards"] = 4] = "goToDashboards";
    COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY[COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY["goToPlans"] = 5] = "goToPlans";
})($8bee8fa7684ab6e5$export$b4e1633c86db2b70 || ($8bee8fa7684ab6e5$export$b4e1633c86db2b70 = {}));
var $8bee8fa7684ab6e5$export$5e5a87aac5d9771f;
(function(COMMAND_PALETTE_HELP_PRIORITY) {
    COMMAND_PALETTE_HELP_PRIORITY[COMMAND_PALETTE_HELP_PRIORITY["getHelp"] = 0] = "getHelp";
    COMMAND_PALETTE_HELP_PRIORITY[COMMAND_PALETTE_HELP_PRIORITY["viewKeyboardShortcuts"] = 1] = "viewKeyboardShortcuts";
})($8bee8fa7684ab6e5$export$5e5a87aac5d9771f || ($8bee8fa7684ab6e5$export$5e5a87aac5d9771f = {}));

});


parcelRegister("9aFSa", function(module, exports) {

$parcel$export(module.exports, "default", () => $80173688b586a9b5$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7Q1yP = parcelRequire("7Q1yP");

var $cIhGE = parcelRequire("cIhGE");

var $haeC1 = parcelRequire("haeC1");

var $fVFUy = parcelRequire("fVFUy");

var $kGQen = parcelRequire("kGQen");

var $h80SI = parcelRequire("h80SI");
let $80173688b586a9b5$var$shortcutsCount = 0;
let $80173688b586a9b5$var$subscription = null;
const $80173688b586a9b5$var$ShortcutsSubscriber = ({ keyMap: keyMap, label: label, location: location })=>{
    const parentRegistry = (0, $eUqFw.useContext)((0, $kGQen.ShortcutRegistryContext)) || (0, $fVFUy.rootRegistry);
    const addKeyMap = (0, $eUqFw.useCallback)(()=>parentRegistry.addKeyMap(()=>({
                keyMap: (0, $h80SI.bindKeyMapWithErrorHandling)(keyMap, location),
                label: label
            })), [
        label,
        parentRegistry,
        keyMap,
        location
    ]);
    (0, $eUqFw.useEffect)(()=>{
        $80173688b586a9b5$var$shortcutsCount += 1;
        const removeKeyMap = addKeyMap();
        return ()=>{
            removeKeyMap();
            $80173688b586a9b5$var$shortcutsCount -= 1;
            if ($80173688b586a9b5$var$subscription && $80173688b586a9b5$var$shortcutsCount === 0) {
                $80173688b586a9b5$var$subscription.unsubscribe();
                $80173688b586a9b5$var$subscription = null;
            }
        };
    }, [
        addKeyMap
    ]);
    (0, $eUqFw.useEffect)(()=>{
        $80173688b586a9b5$var$subscription = $80173688b586a9b5$var$subscription || // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        (0, $cIhGE.default)().subscribe((0, $haeC1.default));
    }, [
        parentRegistry,
        keyMap
    ]);
    return null;
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$80173688b586a9b5$export$2e2bcd8739ae039 = ({ useKeyboardShortcutsToggle: useKeyboardShortcutsToggle = (0, $7Q1yP.useKeyboardShortcutsToggle), ...props })=>{
    const [{ isEnabled: isEnabled }] = useKeyboardShortcutsToggle();
    return isEnabled && true ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($80173688b586a9b5$var$ShortcutsSubscriber, props) : null;
};

});
parcelRegister("7Q1yP", function(module, exports) {

$parcel$export(module.exports, "useKeyboardShortcutsToggle", () => $e8e091cfd61e9197$export$a33a81f1fc5458ad);

var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");
var $dYfll = parcelRequire("dYfll");

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");

var $6rW04 = parcelRequire("6rW04");

var $jMP2a = parcelRequire("jMP2a");
const $e8e091cfd61e9197$var$URL_FRAGMENT = '/rest/internal/latest/user/preferences/keyboardShortcuts?turn=';
const $e8e091cfd61e9197$export$b62f67be35e65859 = (baseUrl, analyticsEvent)=>async ({ setState: setState, getState: getState })=>{
        const currentState = getState().isEnabled;
        const status = currentState ? 'off' : 'on';
        const url = `${$e8e091cfd61e9197$var$URL_FRAGMENT}${status}`;
        try {
            await (0, $lRmyA.performPutRequest)(url);
            setState({
                isEnabled: !currentState,
                error: null
            });
            (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'keyboardShortcutsToggle', {
                isEnabled: !currentState
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            setState({
                error: err
            });
            (0, $guiFP.default)({
                meta: {
                    id: 'keyboardShortcutToggleFailure',
                    // eslint-disable-next-line jira/js/package-name-enforcer-for-error-analytics
                    packageName: 'jiraCommonLegacyDoNotAddAnythingNew'
                },
                error: err
            });
        }
    };
const $e8e091cfd61e9197$var$Store = (0, $a61MH.createStore)({
    initialState: {
        isEnabled: !((0, $6rW04.default)('ajs-keyboard-shortcuts-enabled') === 'false'),
        error: null
    },
    actions: {
        // @ts-expect-error - TS2322 - Type '(baseUrl: string, analyticsEvent: UIAnalyticsEventInterface) => ({ setState, getState }: StoreActionApi<State>) => Promise<void>' is not assignable to type 'ActionThunk<{ isEnabled: boolean; error: null; }, { toggle: (baseUrl: string, analyticsEvent: UIAnalyticsEventInterface) => ({ setState, getState }: StoreActionApi<State>) => Promise<void>; }>'.
        toggle: $e8e091cfd61e9197$export$b62f67be35e65859
    }
});
const $e8e091cfd61e9197$export$a33a81f1fc5458ad = (0, $ggKAj.createHook)($e8e091cfd61e9197$var$Store);
const $e8e091cfd61e9197$export$a0308f0e05568f25 = (0, $dYfll.createSubscriber)($e8e091cfd61e9197$var$Store);

});

parcelRegister("cIhGE", function(module, exports) {

$parcel$export(module.exports, "default", () => $61e80b5974f2eb64$export$2e2bcd8739ae039);
$parcel$export(module.exports, "flush", () => $61e80b5974f2eb64$export$4909b86c8034bf73);
/**
 * An observable that emits key sequences as a string representation
 *
 * Examples:
 *
 * g i
 * shift+enter
 */ 
var $3JafE = parcelRequire("3JafE");

var $70s4u = parcelRequire("70s4u");
parcelRequire("fRdoC");
parcelRequire("5dKXv");
parcelRequire("8OtG5");
parcelRequire("fWv6o");
parcelRequire("flmol");
parcelRequire("7Rus6");
parcelRequire("azOPD");
parcelRequire("1d9Hc");

var $1YqdI = parcelRequire("1YqdI");
const $61e80b5974f2eb64$var$ignoredKeys = {
    Control: true,
    Meta: true,
    Shift: true,
    Alt: true,
    AltGraph: true,
    CapsLock: true,
    Fn: true,
    FnLock: true,
    Hyper: true,
    NumLock: true,
    OS: true,
    ScrollLock: true,
    Super: true,
    Symbol: true,
    SymbolLock: true
};
/**
 * Skipping few input types to allow keydown event propagation to it's parent element
 * inputMode - react-select or select or combo
 * type - skipping these inputtypes (checkbox, radio) to support shortcuts like
 *        e(EPIC panel) or v(VERSION panel) or n(board card selection) in board and backlog
 * This condition added as a part of https://a11y.atlassian.net/browse/JCA11Y-1317
 */ const $61e80b5974f2eb64$var$isNonTextInput = ({ inputMode: inputMode = '', type: type })=>inputMode === 'none' || type === 'checkbox';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $61e80b5974f2eb64$var$isEditable = (node)=>node.nodeName === 'INPUT' && !$61e80b5974f2eb64$var$isNonTextInput(node) || node.nodeName === 'TEXTAREA' || node.isContentEditable === true;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $61e80b5974f2eb64$var$isRelevantKeyEvent = (e)=>typeof e.key === 'string' && // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'any' can't be used to index type '{ readonly Control: true; readonly Meta: true; readonly Shift: true; readonly Alt: true; readonly AltGraph: true; readonly CapsLock: true; readonly Fn: true; readonly FnLock: true; readonly Hyper: true; ... 5 more ...; readonly SymbolLock: true; }'.
    (e.key === 'Escape' || !$61e80b5974f2eb64$var$isEditable(e.target) && !$61e80b5974f2eb64$var$ignoredKeys[e.key]);
const $61e80b5974f2eb64$export$25d1b8252b4c49b7 = ()=>{
    const elBlankets = document.querySelectorAll('.aui-blanket');
    if (elBlankets.length === 0) // no aui-blanket in DOM, so it means it's closed
    return true;
    const isAllHidden = Array.from(elBlankets || []).every((el)=>{
        if (el.getAttribute('aria-hidden') === 'true' || // when `el.getAttribute('hidden')` returns an empty string, it means the element has the `hidden` attribute and it's invisible.
        el.getAttribute('hidden') !== null) return true;
        return false;
    });
    return isAllHidden;
};
let $61e80b5974f2eb64$var$key$;
const $61e80b5974f2eb64$var$flush$ = new (0, $70s4u.Subject)();
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$61e80b5974f2eb64$export$2e2bcd8739ae039 = ()=>{
    if (!$61e80b5974f2eb64$var$key$) {
        $61e80b5974f2eb64$var$key$ = (0, $3JafE.Observable).fromEvent(document, 'keydown').filter($61e80b5974f2eb64$var$isRelevantKeyEvent).filter($61e80b5974f2eb64$export$25d1b8252b4c49b7).map((0, $1YqdI.toKeyWithModifiers));
        const sequence$ = $61e80b5974f2eb64$var$key$.scan((seq, key)=>{
            if (!key || !seq) return undefined;
            return {
                sequence: `${String(seq.sequence)} ${String(key.sequence)}`,
                e: key.e
            };
        });
        $61e80b5974f2eb64$var$key$ = $61e80b5974f2eb64$var$key$.debounceTime(1000).startWith(null).merge($61e80b5974f2eb64$var$flush$).switchMapTo(sequence$);
    }
    return $61e80b5974f2eb64$var$key$;
};
const $61e80b5974f2eb64$export$4909b86c8034bf73 = ()=>{
    $61e80b5974f2eb64$var$flush$.next();
};

});
parcelRegister("1YqdI", function(module, exports) {

$parcel$export(module.exports, "toKeyWithModifiers", () => $1b99fa3356e664b3$export$8cf0d2c3d060a0c2);
$parcel$export(module.exports, "isValidShortcut", () => $1b99fa3356e664b3$export$8e231506c5580162);
$parcel$export(module.exports, "isShortcutCollision", () => $1b99fa3356e664b3$export$4add9e50cb49d130);
/**
 * Converts a KeyboardEvent to a normalised string representation of
 * modifiers and key.
 *
 * Ordering of modifier keys is taken from Apple's guidelines:
 * https://developer.apple.com/macos/human-interface-guidelines/input-and-output/keyboard/
 *
 * Example representation of ArrowUp key with all modifiers present:
 * ctrl+shift+meta+arrowup
 *
 * Character keys never include the 'shift' modifier,.
 * as it changes the character itself.
 * Examples:
 *  - instead of 'shift+a' the normal form is 'A'
 *  - instead of 'shift+/' the normal form is '?'
 *
 * The 'alt' modifier is NOT supported at all due to inconsistent behaviour
 * across platforms. On Mac, it changes the character input, e.g.
 * 'alt+z' is 'Ω' - which becomes the `event.key`. To properly support
 * this, a reverse-mapping of all these characters needs to be added.
 * Alternatively, `String.fromCharCode(event.which)` can be used, but
 * 1. This is a deprecated property
 * 2. The char code is still for the modified character for some keys on Mac
 *    (e.g. The char code for 'alt+/' is '¿')
 */ // Special keys such as 'Escape', 'ArrowUp' or ' '
const $1b99fa3356e664b3$var$isNonCharacterKey = (e)=>e.key.length > 1 || e.key === ' ';
const $1b99fa3356e664b3$var$modifiers = [
    {
        name: 'ctrl',
        // @ts-expect-error - TS7006 - Parameter 'e' implicitly has an 'any' type.
        test: (e)=>e.ctrlKey
    },
    {
        name: 'shift',
        // @ts-expect-error - TS7006 - Parameter 'e' implicitly has an 'any' type.
        test: (e)=>e.shiftKey && $1b99fa3356e664b3$var$isNonCharacterKey(e)
    },
    {
        // Command key on MacOS, Windows key on Windows
        name: 'meta',
        // @ts-expect-error - TS7006 - Parameter 'e' implicitly has an 'any' type.
        test: (e)=>e.metaKey || e.getModifierState && e.getModifierState('OS')
    }
];
const $1b99fa3356e664b3$var$toKey = (e)=>{
    if ($1b99fa3356e664b3$var$isNonCharacterKey(e)) return e.key.toLowerCase();
    // Ignore accidental CapsLock
    return e.shiftKey ? e.key.toUpperCase() : e.key.toLowerCase();
};
const $1b99fa3356e664b3$export$8cf0d2c3d060a0c2 = (e)=>{
    if (!e || !e.key) // There are still browsers out there that do not support e.key;
    // Just today (Oct 2018) I have observed Chrome 47 in Sentry, but it started supporting e.key since 51.
    // So instead of crashing the page with TypeError let's not detect keyboard shortcuts.
    return {
        sequence: '',
        e: e
    };
    return {
        sequence: $1b99fa3356e664b3$var$modifiers.filter((modifier)=>modifier.test(e)).map((modifier)=>modifier.name).concat($1b99fa3356e664b3$var$toKey(e)).join('+'),
        e: e
    };
};
/*
 *  Selected special key values disjunction for regex. All lowercase, ordered alphabethically.
 *  See https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/key/Key_Values.
 */ const $1b99fa3356e664b3$var$orSpecialChars = ' |arrowdown|arrowleft|arrowright|arrowup|backspace|clear|delete|end|enter|escape|home|insert|pagedown|pageup|pause|printscreen|tab';
/*
 * This string when used as a regular expression:
 * 1. Allows lowercase only with a single exception (see 3)
 * 2. Allows optional ctrl, shift, meta followed by "+" in that specific order in the beginning
 * 3. Allows any printable character (may be uppercase letter) or a special key value
 * 4. If shift modifier is used it can only be followed by a special char
 * 5. Is based on toKeyWithModifiers, uses orSpecialChars whitelist for shift chars
 * 6. Does not capture redundant groups
 */ const $1b99fa3356e664b3$var$singleShortcutEntry = `(ctrl\\+)?(shift\\+(?=(?:(?:meta\\+)?(?:${$1b99fa3356e664b3$var$orSpecialChars}))))?(meta\\+)?(${$1b99fa3356e664b3$var$orSpecialChars}|[!-~])`;
/*
 * Any number of singleShortcutEntry separated by a single space
 * We are not specifying "g" flag, so it's fine to reuse the same regex object.
 */ const $1b99fa3356e664b3$var$shortcutRegex = RegExp(`^${$1b99fa3356e664b3$var$singleShortcutEntry}( ${$1b99fa3356e664b3$var$singleShortcutEntry})*$`);
const $1b99fa3356e664b3$export$8e231506c5580162 = (shortcut)=>$1b99fa3356e664b3$var$shortcutRegex.test(shortcut);
const $1b99fa3356e664b3$export$4add9e50cb49d130 = (leftShortcut, rightShortcut)=>{
    if (!leftShortcut || !rightShortcut) return leftShortcut === rightShortcut;
    if (rightShortcut === leftShortcut) return true;
    if (leftShortcut.indexOf(rightShortcut) === 0) return leftShortcut[rightShortcut.length] === ' ';
    if (rightShortcut.indexOf(leftShortcut) === 0) return rightShortcut[leftShortcut.length] === ' ';
    return false;
};

});


parcelRegister("haeC1", function(module, exports) {

$parcel$export(module.exports, "default", () => $44bf9c8ab51bd76c$export$2e2bcd8739ae039);

var $cIhGE = parcelRequire("cIhGE");

var $fVFUy = parcelRequire("fVFUy");
const $44bf9c8ab51bd76c$var$matches = (prefix)=>(definedSequence)=>definedSequence.startsWith(`${prefix} `);
var /**
 * Manages key sequence inputs to execute predefined actions or clear unmatched sequences. This function ensures efficient handling of user inputs by checking against existing sequences and preparing for potential future matches.
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$44bf9c8ab51bd76c$export$2e2bcd8739ae039 = (keySequence)=>{
    const { sequence: sequence, e: e } = keySequence || {};
    const activeKeyMap = (0, $fVFUy.rootRegistry).getActiveKeyMap();
    if (sequence !== undefined && activeKeyMap[sequence]) {
        activeKeyMap[sequence].callback(e);
        (0, $cIhGE.flush)();
    } else {
        // Are there any sequences that might be activated with more key presses?
        const isFutureMatchPossible = sequence !== undefined && Object.keys(activeKeyMap).some($44bf9c8ab51bd76c$var$matches(sequence));
        if (!isFutureMatchPossible) (0, $cIhGE.flush)();
    }
};

});
parcelRegister("fVFUy", function(module, exports) {

$parcel$export(module.exports, "ShortcutRegistry", () => $3843ad0413ec519e$export$ca1c75b575abf5ff);
$parcel$export(module.exports, "rootRegistry", () => $3843ad0413ec519e$export$1dd4c61d1ce1fa15);
/* eslint-disable jira/js/no-reduce-accumulator-spread */ /**
 * A tree-like registry of shortcuts, with a default, root registry.
 */ 
var $fUTZC = parcelRequire("fUTZC");

var $6G5mG = parcelRequire("6G5mG");

var $ldoFd = parcelRequire("ldoFd");

var $bFXjh = parcelRequire("bFXjh");

var $1YqdI = parcelRequire("1YqdI");
const $3843ad0413ec519e$var$validateKeyMaps = (keyMaps)=>{
    (0, (/*@__PURE__*/$parcel$interopDefault($fUTZC)))(keyMaps, (keyMap, keyMapIndex)=>{
        const shortcuts = Object.keys(keyMap);
        (0, (/*@__PURE__*/$parcel$interopDefault($fUTZC)))(shortcuts, (shortcut, shortcutIndex)=>{
            if (!(0, $1YqdI.isValidShortcut)(shortcut)) // eslint-disable-next-line no-console
            console.error(`"${shortcut}" is an incorrect shortcut. Please, update it according to a playbook entry on shortcuts.`);
            for(let indexForOtherKeymaps = keyMapIndex + 1; indexForOtherKeymaps < keyMaps.length; indexForOtherKeymaps += 1){
                const anotherKeyMap = keyMaps[indexForOtherKeymaps];
                (0, (/*@__PURE__*/$parcel$interopDefault($fUTZC)))(anotherKeyMap, (anotherAction, anotherShortcut)=>{
                    if ((0, $1YqdI.isShortcutCollision)(anotherShortcut, shortcut)) // If neither shortcut has a priority we have a conflict.. You should ideally
                    // put a priority on one of these conflicting shortcut configs so you definitively
                    // know which one should be active when there is a conflict.
                    {
                        if ((0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(keyMap[shortcut].priority) && (0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(anotherKeyMap[anotherShortcut].priority) || keyMap[shortcut].priority === anotherKeyMap[anotherShortcut].priority) // DO NOT LET THIS HAPPEN. ADD A PRIORITY!!!
                        // eslint-disable-next-line no-console
                        console.error(`"${shortcut}" has a collision with "${anotherShortcut}" shortcut from another keyMap.`);
                    }
                });
            }
            for(let indexToCompareSelf = shortcutIndex + 1; indexToCompareSelf < shortcuts.length; indexToCompareSelf += 1)if ((0, $1YqdI.isShortcutCollision)(shortcut, shortcuts[indexToCompareSelf])) // eslint-disable-next-line no-console
            console.error(`"${shortcut}" has a collision with "${shortcuts[indexToCompareSelf]}" shortcut from the same keyMap.`);
        });
    });
};
const $3843ad0413ec519e$var$mergeKeyMaps = (keyMapsToMerge)=>// Instead of doing the standard Object.assign({}, ...keyMapsToMerge)
    // we want to have a bit more control over what we can and can't override
    // through the use of the priority
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    keyMapsToMerge.reduce((prev, keyMap)=>({
            ...prev,
            // Add the keys that can be overridden
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            ...Object.keys(keyMap).reduce((newAccumulator, newKey)=>{
                if (!(0, (/*@__PURE__*/$parcel$interopDefault($6G5mG)))(prev, newKey) || (prev[newKey].priority ?? 0) < (keyMap[newKey].priority ?? 1 // Default behaviour is override
                )) return {
                    ...newAccumulator,
                    [newKey]: keyMap[newKey]
                };
                return newAccumulator;
            }, {})
        }), {});
class $3843ad0413ec519e$export$ca1c75b575abf5ff {
    addChildRegistry(child) {
        this.children.push(child);
        return ()=>{
            (0, (/*@__PURE__*/$parcel$interopDefault($bFXjh)))(this.children, child);
        };
    }
    addKeyMap(getKeyMap) {
        this.keyMapRetrievers.push(getKeyMap);
        return ()=>{
            (0, (/*@__PURE__*/$parcel$interopDefault($bFXjh)))(this.keyMapRetrievers, getKeyMap);
        };
    }
    getActiveKeyMap() {
        const keyMaps = this.children.length ? this.children.map((child)=>child.getActiveKeyMap()) : this.keyMapRetrievers.map((getKeyMap)=>getKeyMap().keyMap);
        return {
            ...$3843ad0413ec519e$var$mergeKeyMaps(keyMaps)
        };
    }
    getKeyMapInfo() {
        const info = this.children.length ? this.children.map((child)=>child.getKeyMapInfo()) : this.keyMapRetrievers.map((getInfo)=>getInfo());
        // @ts-expect-error - TS2769 - No overload matches this call.
        const flattenedInfo = [].concat(...info);
        return flattenedInfo;
    }
    constructor(){
        // go/jfe-eslint
        this.children = [];
        this.keyMapRetrievers = [];
    }
}
const $3843ad0413ec519e$export$1dd4c61d1ce1fa15 = new $3843ad0413ec519e$export$ca1c75b575abf5ff();

});
parcelRegister("bFXjh", function(module, exports) {

var $9eFtX = parcelRequire("9eFtX");

var $49axs = parcelRequire("49axs");
/**
 * Removes all given values from `array` using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
 * to remove elements from an array by predicate.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Array
 * @param {Array} array The array to modify.
 * @param {...*} [values] The values to remove.
 * @returns {Array} Returns `array`.
 * @example
 *
 * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
 *
 * _.pull(array, 'a', 'c');
 * console.log(array);
 * // => ['b', 'b']
 */ var $880187c06210b759$var$pull = $9eFtX($49axs);
module.exports = $880187c06210b759$var$pull;

});
parcelRegister("49axs", function(module, exports) {

var $3cvRc = parcelRequire("3cvRc");
/**
 * This method is like `_.pull` except that it accepts an array of values to remove.
 *
 * **Note:** Unlike `_.difference`, this method mutates `array`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to modify.
 * @param {Array} values The values to remove.
 * @returns {Array} Returns `array`.
 * @example
 *
 * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
 *
 * _.pullAll(array, ['a', 'c']);
 * console.log(array);
 * // => ['b', 'b']
 */ function $30502d761f1085cf$var$pullAll(array, values) {
    return array && array.length && values && values.length ? $3cvRc(array, values) : array;
}
module.exports = $30502d761f1085cf$var$pullAll;

});
parcelRegister("3cvRc", function(module, exports) {

var $kJvGp = parcelRequire("kJvGp");

var $jkhuN = parcelRequire("jkhuN");

var $2Rm6I = parcelRequire("2Rm6I");

var $74vSq = parcelRequire("74vSq");

var $b69Sx = parcelRequire("b69Sx");
/** Used for built-in method references. */ var $254b343f3ff82813$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $254b343f3ff82813$var$splice = $254b343f3ff82813$var$arrayProto.splice;
/**
 * The base implementation of `_.pullAllBy` without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to remove.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns `array`.
 */ function $254b343f3ff82813$var$basePullAll(array, values, iteratee, comparator) {
    var indexOf = comparator ? $2Rm6I : $jkhuN, index = -1, length = values.length, seen = array;
    if (array === values) values = $b69Sx(values);
    if (iteratee) seen = $kJvGp(array, $74vSq(iteratee));
    while(++index < length){
        var fromIndex = 0, value = values[index], computed = iteratee ? iteratee(value) : value;
        while((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1){
            if (seen !== array) $254b343f3ff82813$var$splice.call(seen, fromIndex, 1);
            $254b343f3ff82813$var$splice.call(array, fromIndex, 1);
        }
    }
    return array;
}
module.exports = $254b343f3ff82813$var$basePullAll;

});
parcelRegister("2Rm6I", function(module, exports) {
/**
 * This function is like `baseIndexOf` except that it accepts a comparator.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $2151ae143791d52b$var$baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1, length = array.length;
    while(++index < length){
        if (comparator(array[index], value)) return index;
    }
    return -1;
}
module.exports = $2151ae143791d52b$var$baseIndexOfWith;

});






parcelRegister("kGQen", function(module, exports) {

$parcel$export(module.exports, "ShortcutRegistryContext", () => $082205e2100625d8$export$ebbb59327adb551a);
$parcel$export(module.exports, "default", () => $082205e2100625d8$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $fVFUy = parcelRequire("fVFUy");
const $082205e2100625d8$export$ebbb59327adb551a = /*#__PURE__*/ (0, $eUqFw.createContext)((0, $fVFUy.rootRegistry));
const $082205e2100625d8$var$ShortcutScope = ({ children: children = null })=>{
    const registry = (0, $eUqFw.useMemo)(()=>new (0, $fVFUy.ShortcutRegistry)(), []);
    const parentRegistry = (0, $eUqFw.useContext)($082205e2100625d8$export$ebbb59327adb551a) || (0, $fVFUy.rootRegistry);
    (0, $eUqFw.useEffect)(()=>{
        // "This only happens ONCE.  But it happens AFTER the initial render."
        const removeRegistry = parentRegistry.addChildRegistry(registry);
        return removeRegistry;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($082205e2100625d8$export$ebbb59327adb551a.Provider, {
        value: registry
    }, children);
};
var $082205e2100625d8$export$2e2bcd8739ae039 = $082205e2100625d8$var$ShortcutScope;

});

parcelRegister("h80SI", function(module, exports) {

$parcel$export(module.exports, "bindKeyMapWithErrorHandling", () => $2297a6a3d8ab933d$export$77477772a9b904da);

var $gUUjF = parcelRequire("gUUjF");
const $2297a6a3d8ab933d$var$wrapCallbackWithErrorHandling = (key, callback, location = 'keyboard-shortcuts.common')=>(e)=>{
        try {
            callback(e);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $gUUjF.default).safeErrorWithoutCustomerData(location, `Error firing shortcut '${key}': ${error.message} (commandPaletteBlockNativeShortcutFF=true)`, error);
        }
    };
const $2297a6a3d8ab933d$export$77477772a9b904da = (keyMap, location)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    Object.keys(keyMap).reduce((map, key)=>({
            // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
            ...map,
            [key]: {
                ...keyMap[key],
                callback: $2297a6a3d8ab933d$var$wrapCallbackWithErrorHandling(key, keyMap[key].callback, location)
            }
        }), {});

});


parcelRegister("4Ds3l", function(module, exports) {

$parcel$export(module.exports, "JiraCommandPaletteErrorBoundary", () => $b6e51307db9d6484$export$4c089b36a27ad393);

var $eUqFw = parcelRequire("eUqFw");

var $gCtL7 = parcelRequire("gCtL7");

var $0cdA8 = parcelRequire("0cdA8");
const $b6e51307db9d6484$export$4c089b36a27ad393 = ({ id: id, children: children })=>{
    const [data] = (0, $gCtL7.useCommandPaletteRegistryCurrentAttribution)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: id,
        packageName: "jiraCommandPaletteIntegration",
        fallback: "unmount",
        teamName: data?.registryData?.teamName || 'deliveroo',
        attributes: data?.analyticsAttributes
    }, children);
};

});

parcelRegister("ae7ia", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('6Eyx8')
        ]);
        const value = parcelRequire('kxxIM');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("6Eyx8")
    ]).then(()=>parcelRequire('kxxIM'));
}

});


parcelRegister("2ijRB", function(module, exports) {

$parcel$export(module.exports, "default", () => $63c0d8b469289537$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
var /**
 * @deprecated this does not support useRef and is being moved into a new package.
 * Use @atlassian/jira-feature-flagging-utils and componentWithCondition instead.
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$63c0d8b469289537$export$2e2bcd8739ae039 = (conditionGetter, ComponentTrue, ComponentFalse)=>{
    const ComponentWithCondition = (props)=>// @ts-expect-error - TS2322 - Type 'P' is not assignable to type 'IntrinsicAttributes & PropsWithoutRef<P> & RefAttributes<any> & { children?: ReactNode; }'. | TS2322 - Type 'P' is not assignable to type 'IntrinsicAttributes & PropsWithoutRef<P> & RefAttributes<any> & { children?: ReactNode; }'.
        conditionGetter() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ComponentTrue, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ComponentFalse, props);
    if (conditionGetter.name !== '') ComponentWithCondition.displayName = `ComponentWithCondition[${conditionGetter.name}]`;
    // @ts-expect-error - TS2322 - Type '{ (props: P): JSX.Element; displayName: string; }' is not assignable to type 'AbstractComponent<P, any>'.
    return ComponentWithCondition;
};

});

parcelRegister("5KRxh", function(module, exports) {

$parcel$export(module.exports, "default", () => $4c068eb5fe033ea1$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $0cdA8 = parcelRequire("0cdA8");

var $gGtKh = parcelRequire("gGtKh");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $4c068eb5fe033ea1$var$LazyDarkThemeBenefitsModal = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("7lDux")), {
    ssr: false,
    moduleId: "./src/packages/theme/darktheme-benefits-modal/src/ui/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$4c068eb5fe033ea1$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "async.jira.dark-theme-benefits-modal",
        packageName: "jiraDarkthemeBenefitsModal"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "dark-theme-benefits-modal",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4c068eb5fe033ea1$var$LazyDarkThemeBenefitsModal, null)));

});
parcelRegister("7lDux", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('h2MrD'),
            load('bYT2S'),
            load('2eGAW')
        ]);
        const value = parcelRequire('luYsA');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("h2MrD"),
        load("bYT2S"),
        load("2eGAW")
    ]).then(()=>parcelRequire('luYsA'));
}

});


parcelRegister("edvkU", function(module, exports) {

$parcel$export(module.exports, "default", () => $360dd5bd4be3525d$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $26gAy = parcelRequire("26gAy");

var $dQZ5c = parcelRequire("dQZ5c");

var $br3MN = parcelRequire("br3MN");
function $360dd5bd4be3525d$export$2e2bcd8739ae039(_props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dQZ5c.FavouriteChangeConsumer), null, (favouriteChangeContext)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $26gAy.FavouriteAPISubscriber), null, (__, actions)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $br3MN.default), {
                items: favouriteChangeContext.items,
                changeFavourite: favouriteChangeContext.changeFavourite,
                // @ts-expect-error - TS2322 - Type 'BoundActions<State, Actions>' is not assignable to type 'Actions'.
                callbackRegistry: actions
            })));
}

});
parcelRegister("26gAy", function(module, exports) {

$parcel$export(module.exports, "FavouriteAPISubscriber", () => $c981a76f616b1beb$export$3c7280b9a668eeee);

var $heB5U = parcelRequire("heB5U");
var $dYfll = parcelRequire("dYfll");

var $crATJ = parcelRequire("crATJ");
const $c981a76f616b1beb$export$3c7280b9a668eeee = (0, $dYfll.createSubscriber)((0, $crATJ.default), {
    displayName: 'FavouriteAPISubscriber',
    selector: null
});
const $c981a76f616b1beb$export$a0c0b6db71e843eb = (0, $heB5U.createContainer)((0, $crATJ.default));

});
parcelRegister("crATJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $a1033ee86a70c5ad$export$2e2bcd8739ae039);

var $a61MH = parcelRequire("a61MH");

var $80FwA = parcelRequire("80FwA");
const $a1033ee86a70c5ad$var$initialState = {
    callbacks: new Set()
};
var $a1033ee86a70c5ad$export$2e2bcd8739ae039 = (0, $a61MH.createStore)({
    name: 'favourite-api-callbacks',
    initialState: $a1033ee86a70c5ad$var$initialState,
    actions: $80FwA.default
});

});
parcelRegister("80FwA", function(module, exports) {

$parcel$export(module.exports, "default", () => $175ee89eacc44e16$export$2e2bcd8739ae039);

var $kAdm2 = parcelRequire("kAdm2");
var $d4PbU = parcelRequire("d4PbU");
var $85FUs = parcelRequire("85FUs");
var $20oC5 = parcelRequire("20oC5");
const $175ee89eacc44e16$var$actions = {
    add: (cb)=>({ dispatch: dispatch })=>dispatch($kAdm2.default('callbacks', cb)),
    remove: (cb)=>({ dispatch: dispatch })=>dispatch($85FUs.default('callbacks', cb)),
    clear: ()=>({ dispatch: dispatch })=>dispatch($d4PbU.default('callbacks')),
    run: (...args)=>({ dispatch: dispatch })=>dispatch($20oC5.default('callbacks', ...args))
};
var $175ee89eacc44e16$export$2e2bcd8739ae039 = $175ee89eacc44e16$var$actions;

});



parcelRegister("br3MN", function(module, exports) {

$parcel$export(module.exports, "default", () => $90da6362f77c3705$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $ds5Im = parcelRequire("ds5Im");
class $90da6362f77c3705$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            items: {
                boards: {},
                filters: {},
                dashboards: {},
                issues: {},
                projects: {},
                queues: {}
            },
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            onAddClearImperativeApiCallback: ()=>{}
        };
    }
    constructor(){
        // @ts-expect-error - TS2554 - Expected 1-2 arguments, but got 0.
        super();
        // eslint-disable-next-line jira/wrm/no-load-bridge
        (0, $ds5Im.loadBridgeWeak)({
            name: 'jira/favouriteItems/bridge'
        }).then((bridge)=>{
            // @ts-expect-error - TS2571 - Object is of type 'unknown'.
            bridge(this.getImperativeAPI());
        });
    }
    shouldComponentUpdate(nextProps) {
        return this.props.items !== nextProps.items;
    }
    componentDidUpdate() {
        if (!this.props.items) return;
        this.props.callbackRegistry.run(this.props.items);
    }
    componentWillUnmount() {
        this.props.callbackRegistry.clear();
    }
    getImperativeAPI() {
        return {
            // Update a favourite in Jira-Frontend (from Monolith)
            changeFavourite: async (item)=>this.props.changeFavourite(item),
            // Register a callback that gets executed in Monolith when a value in Jira-Frontend gets changed
            registerFavouriteChangeCallback: (callback)=>this.props.callbackRegistry.add(callback),
            unregisterFavouriteChangeCallback: (callback)=>this.props.callbackRegistry.remove(callback)
        };
    }
    render() {
        return null;
    }
}

});


parcelRegister("5TVuZ", function(module, exports) {

$parcel$export(module.exports, "AsyncFeedbackCollectorRenderer", () => $d796dec04b05b0d3$export$af648acab555078b);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $0cdA8 = parcelRequire("0cdA8");

var $gGtKh = parcelRequire("gGtKh");

// Note `renderer` here means a small wrapper/boilerplate which is used
// to render AK Feedback Collector dialog later.
// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $d796dec04b05b0d3$var$LazyFeedbackCollectorRenderer = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("iMGzr")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/feedback-collector/src/ui/feedback-renderer/index.tsx"
});
const $d796dec04b05b0d3$export$af648acab555078b = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "asyncFeedbackCollector",
        packageName: "jiraFeedbackCollector",
        teamName: "magma"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "async-feedback-collector-renderer",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d796dec04b05b0d3$var$LazyFeedbackCollectorRenderer, null)));

});
parcelRegister("iMGzr", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('bVHL8');
        const value = parcelRequire('8BFqM');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("bVHL8").then(()=>parcelRequire('8BFqM'));
}

});


parcelRegister("kxeVc", function(module, exports) {

$parcel$export(module.exports, "default", () => $27c2b8fde788efdf$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $2BvS3 = parcelRequire("2BvS3");
var $4DtuZ = parcelRequire("4DtuZ");

var $guiFP = parcelRequire("guiFP");

var $4xHig = parcelRequire("4xHig");

var $16kIm = parcelRequire("16kIm");
var $drNtW = parcelRequire("drNtW");

var $8nwKa = parcelRequire("8nwKa");
const $27c2b8fde788efdf$var$LoadGICResources = ()=>{
    const locale = (0, $4xHig.useLocale)();
    const isModernPreferred = (0, $8nwKa.useIsModernGlobalIssueCreatePreferred)() && (0, $8nwKa.isModernGlobalIssueCreateEnabled)();
    (0, $eUqFw.useEffect)(()=>{
        if (__SPA__) // eslint-disable-next-line jira/wrm/no-load-bridge
        (isModernPreferred ? (0, $4DtuZ.waitForHeritage)() : (0, $2BvS3.loadBridge)({
            name: 'wrm/require'
        }))?.then(()=>(0, $16kIm.asyncWrmRequire)([
                'wrc!com.atlassian.jira.jira-quick-edit-plugin:quick-create-issue',
                'wrc!com.atlassian.plugins.browser.metrics.browser-metrics-plugin:api',
                'wrc!jira.create.issue',
                (0, $drNtW.default)(locale),
                'wrc!com.atlassian.jira.plugins.jira-dnd-attachment-plugin:shared-utility',
                'wrc!com.pyxis.greenhopper.jira:gh-issue-type-whitelist',
                'wrc!com.atlassian.jira.plugins.jira-wiki-editor:wiki-editor-resources-init',
                'wrc!com.pyxis.greenhopper.jira:gh-view-issue',
                'wrc!com.pyxis.greenhopper.jira:gh-custom-field-pickers',
                'wrc!com.atlassian.jira.jira-atlaskit-plugin:sidebar'
            ])).catch((error)=>{
            (0, $guiFP.default)({
                meta: {
                    id: 'LoadGICResources',
                    packageName: 'jiraGlobalIssueCreateResources',
                    teamName: 'gryffindor'
                },
                error: error
            });
        });
    }, [
        isModernPreferred,
        locale
    ]);
    return null;
};
var $27c2b8fde788efdf$export$2e2bcd8739ae039 = $27c2b8fde788efdf$var$LoadGICResources;

});
parcelRegister("4xHig", function(module, exports) {

$parcel$export(module.exports, "useLocale", () => $d8981c42d4d07028$export$43bb16f9c6d9e3f7);
$parcel$export(module.exports, "useNativeLocale", () => $d8981c42d4d07028$export$31652d9c30d7d3f3);

var $eUqFw = parcelRequire("eUqFw");

var $ao0hp = parcelRequire("ao0hp");

var $ao0hp = parcelRequire("ao0hp");

var $gd0Sp = parcelRequire("gd0Sp");
const $d8981c42d4d07028$export$43bb16f9c6d9e3f7 = ()=>{
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    return tenantContext && tenantContext.locale || (0, $ao0hp.defaultLocale);
};
const $d8981c42d4d07028$export$31652d9c30d7d3f3 = ()=>{
    const locale = $d8981c42d4d07028$export$43bb16f9c6d9e3f7();
    const standardizedLocale = (0, $eUqFw.useMemo)(()=>(0, $ao0hp.standardizeLocale)(locale), [
        locale
    ]);
    return standardizedLocale;
};

});

parcelRegister("drNtW", function(module, exports) {

$parcel$export(module.exports, "default", () => $bcc2e3f79d8a74bd$export$2e2bcd8739ae039);
/*
 * There are components in Issue and Service Desk that invoke legacy UI components. Some of these
 * components require Jira Calendar resources, but only two of the three required resources are
 * loaded implicitly. The third resource must be loaded dynamically because it depends on the
 * current user's locale.
 *
 * Here we generate the resource name for that calendar locale dependency, for loading through WRM.
 *
 * For more context in Jira, see:
 * - com.atlassian.jira.web.action.util.CalendarResourceIncluder
 * - jira-components/jira-webapp-resources/src/main/webapp/includes/lib/calendar
 * - system-webresources-plugin.xml
 */ const $bcc2e3f79d8a74bd$var$calendarLocaleMap = {
    cs_CZ: 'calendar-cs',
    da_DK: 'calendar-da',
    de_DE: 'calendar-de',
    en_GB: 'calendar-en',
    en_UK: 'calendar-en',
    en_ZZ: 'calendar-en',
    en_US: 'calendar-en',
    es_ES: 'calendar-es',
    et_EE: 'calendar-en',
    fi_FI: 'calendar-fi',
    fr_FR: 'calendar-fr',
    hu_HU: 'calendar-hu',
    is_IS: 'calendar-en',
    it_IT: 'calendar-it',
    ja_JP: 'calendar-jp',
    ko_KR: 'calendar-ko',
    nb_NO: 'calendar-no',
    nl_NL: 'calendar-nl',
    pl_PL: 'calendar-pl',
    pt_BR: 'calendar-pt',
    pt_PT: 'calendar-pt',
    ro_RO: 'calendar-ro',
    ru_RU: 'calendar-ru',
    sk_SK: 'calendar-sk',
    sv_SE: 'calendar-sv',
    tr_TR: 'calendar-tr',
    zh_CN: 'calendar-zh',
    zh_TW: 'calendar-zh'
};
const $bcc2e3f79d8a74bd$var$getCalendarResource = (locale)=>$bcc2e3f79d8a74bd$var$calendarLocaleMap[locale] || $bcc2e3f79d8a74bd$var$calendarLocaleMap.en_US;
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$bcc2e3f79d8a74bd$export$2e2bcd8739ae039 = (locale)=>`wrc!jira.webresources:${$bcc2e3f79d8a74bd$var$getCalendarResource(locale)}`;

});

parcelRegister("8nwKa", function(module, exports) {

$parcel$export(module.exports, "isModernGlobalIssueCreateEnabled", () => $1d52ed034cfda8bc$export$14b20d1740832b35);
$parcel$export(module.exports, "useIsModernGlobalIssueCreatePreferred", () => $1d52ed034cfda8bc$export$92258d85324089e5);

var $1ybV0 = parcelRequire("1ybV0");

var $3HCkE = parcelRequire("3HCkE");

var $ellXt = parcelRequire("ellXt");
const $1d52ed034cfda8bc$export$14b20d1740832b35 = ()=>(0, $1ybV0.ff)('project.config.pce.modern.global-issue-create', false);
const $1d52ed034cfda8bc$export$92258d85324089e5 = ()=>(0, $3HCkE.useResource)((0, $ellXt.gicOptInStatusResources)).data?.gicOptInStatus?.isEnabled ?? false;

});


parcelRegister("cFeqe", function(module, exports) {

$parcel$export(module.exports, "default", () => $b7eda2e6c171050c$export$2e2bcd8739ae039);

var $4KZl5 = parcelRequire("4KZl5");

var $iFLJg = parcelRequire("iFLJg");
var $b7eda2e6c171050c$export$2e2bcd8739ae039 = (0, $4KZl5.default);

});
parcelRegister("4KZl5", function(module, exports) {

$parcel$export(module.exports, "default", () => $a8eba76800edd3d8$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $WYb5n = parcelRequire("WYb5n");

var $ciZ8Y = parcelRequire("ciZ8Y");

var $gGtKh = parcelRequire("gGtKh");

var $9QFxq = parcelRequire("9QFxq");

var $hiBi9 = parcelRequire("hiBi9");

var $4QvG6 = parcelRequire("4QvG6");

const $a8eba76800edd3d8$export$448e48d8961c824c = (0, $7rh0R.lazy)(()=>(parcelRequire("cvw7i")), {
    moduleId: "./src/packages/invite-people-drawer/src/ui/content/index.tsx"
});
const $a8eba76800edd3d8$var$InvitePeopleDrawerInternal = ({ disableNoInviteError: disableNoInviteError })=>{
    const [{ isOpen: isOpen, inviteFlow: inviteFlow, continueUrl: continueUrl, inviteAssignModelContext: inviteAssignModelContext, invitePromptOnLinkInsertContext: invitePromptOnLinkInsertContext }, { closeDrawer: closeDrawer }] = (0, $hiBi9.useInvitePeopleDrawer)();
    if ((0, $9QFxq.isInviteOnLinkInsertV3Enabled)() && isOpen && invitePromptOnLinkInsertContext) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $WYb5n.InvitePeopleModalContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4QvG6.default), {
        ...invitePromptOnLinkInsertContext,
        onCancelHandler: closeDrawer
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7rh0R.LazyWait), {
        until: isOpen
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "invite-people-drawer",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a8eba76800edd3d8$export$448e48d8961c824c, {
        inviteFlow: inviteFlow,
        isOpen: isOpen,
        onClose: closeDrawer,
        continueUrl: continueUrl,
        inviteAssignModelContext: inviteAssignModelContext,
        disableNoInviteError: disableNoInviteError
    })));
};
$a8eba76800edd3d8$var$InvitePeopleDrawerInternal.displayName = 'InvitePeopleDrawerInternal';
const $a8eba76800edd3d8$var$InvitePeopleDrawerWithErrorBoundary = ({ disableNoInviteError: disableNoInviteError })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ciZ8Y.ErrorBoundary), {
        id: "invite-people-drawer",
        packageName: "jiraInvitePeopleDrawer"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a8eba76800edd3d8$var$InvitePeopleDrawerInternal, {
        disableNoInviteError: disableNoInviteError
    }));
var $a8eba76800edd3d8$export$2e2bcd8739ae039 = $a8eba76800edd3d8$var$InvitePeopleDrawerWithErrorBoundary;

});
parcelRegister("9QFxq", function(module, exports) {

$parcel$export(module.exports, "getSourceByInviteFlow", () => $2b0bde6b83f84248$export$c35cd18e9d0123e3);
$parcel$export(module.exports, "isInviteOnLinkInsertV3Enabled", () => $2b0bde6b83f84248$export$bbac70b4535f5e90);

var $79xbN = parcelRequire("79xbN");

var $1ybV0 = parcelRequire("1ybV0");
const $2b0bde6b83f84248$export$c35cd18e9d0123e3 = (inviteFlow)=>{
    let source = inviteFlow;
    if (inviteFlow === 'mention') source = 'mentionInEditor';
    else if (inviteFlow === 'assignee') source = 'assigneeField';
    return source;
};
const $2b0bde6b83f84248$export$bbac70b4535f5e90 = ()=>{
    if (!(0, $1ybV0.ff)('statsig-guard-invite-prompt-on-link-insert-v-3', false)) return false;
    const [expConfig] = (0, $79xbN.UNSAFE_noExposureExp)('invite_prompt_on_link_insert_v3');
    return expConfig.get('cohort', 'not-enrolled') === 'variation';
};

});

parcelRegister("hiBi9", function(module, exports) {

$parcel$export(module.exports, "shouldDisplayModal", () => $df085b8c8c8c9e63$export$32eec1126fb86cc9);
$parcel$export(module.exports, "useInvitePeopleDrawer", () => $df085b8c8c8c9e63$export$48fb2d80745c5e67);
$parcel$export(module.exports, "triggerOpenDrawer", () => $df085b8c8c8c9e63$export$b7dab610045052db);

var $heB5U = parcelRequire("heB5U");
var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");
var $dYfll = parcelRequire("dYfll");
var $gasA1 = parcelRequire("gasA1");

var $1Iui1 = parcelRequire("1Iui1");

var $cQrkf = parcelRequire("cQrkf");
const $df085b8c8c8c9e63$var$CONTROLLER_NAME = 'invite-people-drawer';
const $df085b8c8c8c9e63$var$initialState = {
    isOpen: false,
    inviteFlow: 'unknown',
    continueUrl: undefined
};
const $df085b8c8c8c9e63$export$1dbc37ce23aead84 = ({ inviteFromAssignModalCohort: inviteFromAssignModalCohort })=>{
    let resolvedCohort = {
        cohort: '',
        ineligibilityReasons: [
            ''
        ]
    };
    if (inviteFromAssignModalCohort === (0, $1Iui1.NOT_ENROLLED)) resolvedCohort = {
        cohort: (0, $1Iui1.NOT_ENROLLED),
        ineligibilityReasons: []
    };
    if (inviteFromAssignModalCohort === (0, $1Iui1.CONTROL)) resolvedCohort = {
        cohort: (0, $1Iui1.CONTROL),
        ineligibilityReasons: []
    };
    if (inviteFromAssignModalCohort === (0, $1Iui1.VARIATION)) resolvedCohort = {
        cohort: (0, $1Iui1.VARIATION),
        ineligibilityReasons: []
    };
    return resolvedCohort;
};
const $df085b8c8c8c9e63$export$32eec1126fb86cc9 = (inviteAssignModelContext)=>{
    if ($df085b8c8c8c9e63$export$1dbc37ce23aead84(inviteAssignModelContext).cohort === (0, $1Iui1.VARIATION)) return true;
    return false;
};
const $df085b8c8c8c9e63$var$Store = (0, $a61MH.createStore)({
    name: $df085b8c8c8c9e63$var$CONTROLLER_NAME,
    initialState: $df085b8c8c8c9e63$var$initialState,
    actions: {
        openDrawer: (createAnalyticsEvent, { inviteFlow: inviteFlow, analyticsSource: analyticsSource, continueUrl: continueUrl }, inviteAssignModelContext, invitePromptOnLinkInsertContext)=>({ setState: setState })=>{
                const displayModal = inviteAssignModelContext && $df085b8c8c8c9e63$export$32eec1126fb86cc9(inviteAssignModelContext);
                let processedInviteAssignModalContext;
                if (inviteAssignModelContext) {
                    processedInviteAssignModalContext = {
                        ...inviteAssignModelContext
                    };
                    const { cohort: resultCohort, ineligibilityReasons: ineligibilityReasons } = $df085b8c8c8c9e63$export$1dbc37ce23aead84(inviteAssignModelContext);
                    (0, $cQrkf.fireAddTeammatetoJiraAnalytics)(createAnalyticsEvent, resultCohort, analyticsSource);
                    (0, $cQrkf.fireInviteFromAssignModalExposedAnalytics)(createAnalyticsEvent, inviteAssignModelContext.inviteFromAssignModalCohort, resultCohort, ineligibilityReasons, analyticsSource);
                    processedInviteAssignModalContext.inviteFromAssignModalCohort = resultCohort;
                }
                if (displayModal) (0, $cQrkf.fireModalTriggeredAnalytics)(createAnalyticsEvent, inviteFlow, inviteAssignModelContext, analyticsSource);
                else (0, $cQrkf.fireDrawerTriggeredAnalytics)(createAnalyticsEvent, inviteFlow, analyticsSource);
                setState({
                    isOpen: true,
                    inviteFlow: inviteFlow,
                    continueUrl: continueUrl,
                    inviteAssignModelContext: processedInviteAssignModalContext,
                    invitePromptOnLinkInsertContext: invitePromptOnLinkInsertContext
                });
            },
        closeDrawer: ()=>({ setState: setState })=>setState($df085b8c8c8c9e63$var$initialState)
    }
});
const $df085b8c8c8c9e63$export$48fb2d80745c5e67 = (0, $ggKAj.createHook)($df085b8c8c8c9e63$var$Store);
const $df085b8c8c8c9e63$export$ac7fed664b4735b5 = (0, $heB5U.createContainer)($df085b8c8c8c9e63$var$Store, {
    onInit: ()=>({ setState: setState }, { isOpen: isOpen })=>{
            setState({
                isOpen: isOpen
            });
        }
});
const $df085b8c8c8c9e63$export$4358742cbaf4a6d4 = (0, $dYfll.createSubscriber)($df085b8c8c8c9e63$var$Store, {
    displayName: 'InvitePeopleDrawerSubscriber',
    selector: (state)=>state.isOpen
});
const $df085b8c8c8c9e63$export$b7dab610045052db = (createAnalyticsEvent, contextConfig, inviteAssignModelContext)=>{
    (0, $gasA1.defaultRegistry).getStore($df085b8c8c8c9e63$var$Store).actions.openDrawer(createAnalyticsEvent, contextConfig, inviteAssignModelContext);
};

});
parcelRegister("1Iui1", function(module, exports) {

$parcel$export(module.exports, "COHORT", () => $1524157debf2fd00$export$3d370c33621572df);
$parcel$export(module.exports, "NOT_ENROLLED", () => $1524157debf2fd00$export$5b7423264d48ab04);
$parcel$export(module.exports, "CONTROL", () => $1524157debf2fd00$export$43f367b3e957f219);
$parcel$export(module.exports, "EXPERIMENT", () => $1524157debf2fd00$export$9ba2bc3b1bdc1519);
$parcel$export(module.exports, "VARIATION", () => $1524157debf2fd00$export$fa04ad826acc90da);
$parcel$export(module.exports, "VAR1", () => $1524157debf2fd00$export$6486974e39493fa6);
$parcel$export(module.exports, "VAR2", () => $1524157debf2fd00$export$7d994996134ad562);

var $1ybV0 = parcelRequire("1ybV0");
const $1524157debf2fd00$export$3d370c33621572df = 'cohort';
const $1524157debf2fd00$export$5b7423264d48ab04 = 'not-enrolled';
const $1524157debf2fd00$export$43f367b3e957f219 = 'control';
const $1524157debf2fd00$export$9ba2bc3b1bdc1519 = 'experiment';
const $1524157debf2fd00$export$fa04ad826acc90da = 'variation';
const $1524157debf2fd00$export$6486974e39493fa6 = 'variation-1';
const $1524157debf2fd00$export$7d994996134ad562 = 'variation-2';
const $1524157debf2fd00$export$795e7d69b248dcd0 = 'variation-3';
const $1524157debf2fd00$export$c9c947c57470b787 = 'variation-4';
const $1524157debf2fd00$var$DEFAULT_VALID_EXPERIMENT_GROUPS = [
    $1524157debf2fd00$export$5b7423264d48ab04,
    $1524157debf2fd00$export$43f367b3e957f219,
    $1524157debf2fd00$export$9ba2bc3b1bdc1519,
    $1524157debf2fd00$export$fa04ad826acc90da,
    $1524157debf2fd00$export$6486974e39493fa6,
    $1524157debf2fd00$export$7d994996134ad562,
    $1524157debf2fd00$export$795e7d69b248dcd0,
    $1524157debf2fd00$export$c9c947c57470b787
];
var // Use optionalValidExperimentGroups to further restrict the list of cohorts
// eslint-disable-next-line jira/import/no-anonymous-default-export
$1524157debf2fd00$export$2e2bcd8739ae039 = (experimentFeatureFlag, validExperimentGroups = $1524157debf2fd00$var$DEFAULT_VALID_EXPERIMENT_GROUPS)=>(0, $1ybV0.getMultivariateFeatureFlag)(experimentFeatureFlag, $1524157debf2fd00$export$5b7423264d48ab04, validExperimentGroups);

});

parcelRegister("cQrkf", function(module, exports) {

$parcel$export(module.exports, "AnalyticsProvider", () => $de9a0e3d07ee4b39$export$1b581a2ec13e37f1);
$parcel$export(module.exports, "fireDrawerTriggeredAnalytics", () => $de9a0e3d07ee4b39$export$2e49c23c45194e1a);
$parcel$export(module.exports, "fireModalTriggeredAnalytics", () => $de9a0e3d07ee4b39$export$6815765da918b983);
$parcel$export(module.exports, "fireInviteFromAssignModalExposedAnalytics", () => $de9a0e3d07ee4b39$export$9a32ecb3d5c4df6b);
$parcel$export(module.exports, "fireAddTeammatetoJiraAnalytics", () => $de9a0e3d07ee4b39$export$21b810258e82d438);

var $eUqFw = parcelRequire("eUqFw");

var $jYVKV = parcelRequire("jYVKV");

var $1Iui1 = parcelRequire("1Iui1");

var $1ybV0 = parcelRequire("1ybV0");

var $jMP2a = parcelRequire("jMP2a");
var $iKlrz = parcelRequire("iKlrz");

var $3FyZ4 = parcelRequire("3FyZ4");

var $9QFxq = parcelRequire("9QFxq");
const $de9a0e3d07ee4b39$var$getInviteFromAssignCohort = ()=>(0, $1ybV0.getFeatureFlagValue)('invite.from.assign', (0, $1Iui1.NOT_ENROLLED));
const $de9a0e3d07ee4b39$var$useAnalyticsClient = ()=>{
    const analyticsWebClientRef = (0, $eUqFw.useRef)((0, $3FyZ4.getAnalyticsWebClientPromise)());
    return {
        sendEvent: (analyticsEvent)=>{
            analyticsWebClientRef.current.then((webClient)=>webClient.sendEvent((0, $iKlrz.getEvent)(analyticsEvent)));
        }
    };
};
const $de9a0e3d07ee4b39$export$1b581a2ec13e37f1 = ({ children: children })=>{
    const { sendEvent: sendEvent } = $de9a0e3d07ee4b39$var$useAnalyticsClient();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jYVKV.default), {
        channel: "peopleAndTeams",
        onEvent: sendEvent
    }, children);
};
const $de9a0e3d07ee4b39$var$sendAnalyticsClientUIEvent = async (createAnalyticsEvent, analyticsPayload)=>{
    if (createAnalyticsEvent) (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), // @ts-expect-error Argument of type '[string, string, Attributes | undefined]' is not assignable to parameter of type 'RestArguments'.
    `${analyticsPayload.actionSubject} ${analyticsPayload.action}`, analyticsPayload?.actionSubjectId || '', analyticsPayload.attributes);
    else {
        const webAnalyticsClient = await (0, $3FyZ4.getAnalyticsWebClientPromise)();
        const analyticsClient = webAnalyticsClient.getInstance();
        // SSR doesn't have an analytics client
        if (analyticsClient) analyticsClient.sendUIEvent(analyticsPayload);
    }
};
const $de9a0e3d07ee4b39$export$2e49c23c45194e1a = async (createAnalyticsEvent, inviteFlow, source)=>{
    const analyticsPayload = {
        action: 'triggered',
        actionSubject: 'drawer',
        actionSubjectId: 'invitePeopleDrawer',
        attributes: {
            source: (0, $9QFxq.getSourceByInviteFlow)(inviteFlow),
            inviteFromAssignCohort: $de9a0e3d07ee4b39$var$getInviteFromAssignCohort()
        },
        source: source != null && source !== '' ? source : 'unknown'
    };
    $de9a0e3d07ee4b39$var$sendAnalyticsClientUIEvent(createAnalyticsEvent, analyticsPayload);
};
const $de9a0e3d07ee4b39$export$6815765da918b983 = async (createAnalyticsEvent, inviteFlow, inviteAssignModelContext, source)=>{
    const analyticsPayload = {
        action: 'triggered',
        actionSubject: 'modal',
        actionSubjectId: 'invitePeopleModal',
        attributes: {
            source: (0, $9QFxq.getSourceByInviteFlow)(inviteFlow),
            inviteFromAssignCohort: $de9a0e3d07ee4b39$var$getInviteFromAssignCohort(),
            inviteFromAssignModalCohort: inviteAssignModelContext.inviteFromAssignModalCohort
        },
        source: source != null && source !== '' ? source : 'unknown'
    };
    $de9a0e3d07ee4b39$var$sendAnalyticsClientUIEvent(createAnalyticsEvent, analyticsPayload);
};
const $de9a0e3d07ee4b39$export$9a32ecb3d5c4df6b = async (createAnalyticsEvent, inviteFromAssignModalCohort, resultCohort, ineligibilityReasons, source)=>{
    const analyticsPayload = {
        action: 'exposed',
        actionSubject: 'feature',
        product: 'jira',
        attributes: {
            flagKey: 'invite.from.assign.modal',
            value: inviteFromAssignModalCohort,
            cohort: resultCohort,
            growthInitiative: 'virality',
            ineligibilityReasons: ineligibilityReasons
        },
        source: source != null && source !== '' ? source : 'unknown'
    };
    if (createAnalyticsEvent) (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), `${analyticsPayload.actionSubject} ${analyticsPayload.action}`, analyticsPayload.attributes);
    else {
        const webAnalyticsClient = await (0, $3FyZ4.getAnalyticsWebClientPromise)();
        const analyticsClient = webAnalyticsClient.getInstance();
        // SSR doesn't have an analytics client
        if (analyticsClient) analyticsClient.sendTrackEvent(analyticsPayload);
    }
};
const $de9a0e3d07ee4b39$export$21b810258e82d438 = async (createAnalyticsEvent, resultCohort, source)=>{
    const analyticsPayload = {
        action: 'clicked',
        actionSubject: 'addTeammatetoJira',
        product: 'jira',
        attributes: {
            inviteFromAssignModalCohort: resultCohort
        },
        source: source != null && source !== '' ? source : 'unknown'
    };
    $de9a0e3d07ee4b39$var$sendAnalyticsClientUIEvent(createAnalyticsEvent, analyticsPayload);
};

});


parcelRegister("4QvG6", function(module, exports) {

$parcel$export(module.exports, "default", () => $42d6336cd52f3c4a$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $fQNrS = parcelRequire("fQNrS");
const $42d6336cd52f3c4a$var$TriggerInvitePeopleModal = (context)=>{
    const { experimental_openModal: openInvitePeopleModal } = (0, $fQNrS.useInvitePeopleModal)({
        resourceAri: ''
    });
    (0, $eUqFw.useEffect)(()=>{
        openInvitePeopleModal({
            ...context,
            disableViralSettings: true,
            enableThirdParty: true
        });
    // useInvitePeopleModal always return a new function, and it caused an infinite loop
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        context
    ]);
    return null;
};
var $42d6336cd52f3c4a$export$2e2bcd8739ae039 = $42d6336cd52f3c4a$var$TriggerInvitePeopleModal;

});

parcelRegister("cvw7i", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('h2MrD'),
            load('bYT2S'),
            load('hPzOn'),
            load('k8102')
        ]);
        const value = parcelRequire('49Ug7');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("h2MrD"),
        load("bYT2S"),
        load("hPzOn"),
        load("k8102")
    ]).then(()=>parcelRequire('49Ug7'));
}

});


parcelRegister("iFLJg", function(module, exports) {

$parcel$export(module.exports, "stripUrlToIssueKey", () => $068703c2c99fc355$export$1f3c6284caef177b);
$parcel$export(module.exports, "useInvitePeopleFlags", () => $068703c2c99fc355$export$ab5fb7206b83c9ad);
$parcel$export(module.exports, "projectTypeToSubProduct", () => $068703c2c99fc355$export$3500077858760067);

var $eUqFw = parcelRequire("eUqFw");

var $k8Qyf = parcelRequire("k8Qyf");

var $3Y2Y8 = parcelRequire("3Y2Y8");

var $90ffs = parcelRequire("90ffs");

var $Gz4Lz = parcelRequire("Gz4Lz");

var $82rJa = parcelRequire("82rJa");
const $068703c2c99fc355$var$ISSUE_KEY_REGEXP = /(([A-Z][A-Z0-9]+)-([0-9]+))($|\?.*)/;
const $068703c2c99fc355$export$1f3c6284caef177b = (candidateUrl)=>{
    const match = candidateUrl.match($068703c2c99fc355$var$ISSUE_KEY_REGEXP);
    return match && match[1];
};
const $068703c2c99fc355$export$ab5fb7206b83c9ad = ()=>{
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagsService)();
    const addFlag = (0, $eUqFw.useCallback)(// @ts-expect-error - TS7031 - Binding element 'appearance' implicitly has an 'any' type.
    ({ appearance: appearance, ...flagProps })=>{
        let FlagComponent = (0, $90ffs.default);
        // eslint-disable-next-line default-case
        switch(appearance){
            case 'success':
            case 'normal':
                FlagComponent = (0, $Gz4Lz.default);
                break;
            case 'warning':
                FlagComponent = (0, $82rJa.default);
                break;
            case 'error':
                FlagComponent = (0, $3Y2Y8.default);
                break;
        }
        // @ts-expect-error Type error after Flag props have been fixed globally, to be fixed by owning team
        showFlag((serviceProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(FlagComponent, {
                ...flagProps,
                ...serviceProps
            }));
    }, [
        showFlag
    ]);
    return {
        addFlag: addFlag
    };
};
const $068703c2c99fc355$export$3500077858760067 = (projectType)=>{
    switch(projectType){
        case 'jira_software':
            return 'software';
        case 'jira_service_management':
            return 'servicedesk';
        case 'jira_work_management':
            return 'core';
        case 'jira_product_discovery':
            return 'product-discovery';
        default:
            return undefined;
    }
};

});
parcelRegister("3Y2Y8", function(module, exports) {

$parcel$export(module.exports, "default", () => $23cb4ade2efc0679$export$2e2bcd8739ae039);

var $kQ0RL = parcelRequire("kQ0RL");
var $23cb4ade2efc0679$export$2e2bcd8739ae039 = (0, $kQ0RL.ErrorFlag);

});
parcelRegister("kQ0RL", function(module, exports) {

$parcel$export(module.exports, "CommonFlag", () => $2ffdc518941fd08c$export$13d73238a031436b);
$parcel$export(module.exports, "ErrorFlag", () => $2ffdc518941fd08c$export$518ba8e0e60f145f);
$parcel$export(module.exports, "ErrorAutoDismissFlag", () => $2ffdc518941fd08c$export$3f75672bb90a4431);
$parcel$export(module.exports, "InfoFlag", () => $2ffdc518941fd08c$export$6a55b52e74c1e48e);
$parcel$export(module.exports, "SuccessAutoDismissFlag", () => $2ffdc518941fd08c$export$74a3c0748aa31355);
$parcel$export(module.exports, "SuccessFlag", () => $2ffdc518941fd08c$export$93bd4963a1d00fd5);
$parcel$export(module.exports, "WarningFlag", () => $2ffdc518941fd08c$export$23695d8281998f27);
$parcel$export(module.exports, "FlagGroup", () => $2ffdc518941fd08c$export$a2c3479950310d7d);
// eslint-disable-next-line jira/restricted/react-component-props

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $5L0Jp = parcelRequire("5L0Jp");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $2ffdc518941fd08c$var$ForPaintCommonFlag = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("aiVXY")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/common-flag-v2/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $2ffdc518941fd08c$var$AfterPaintCommonFlag = (0, $7rh0R.lazyAfterPaint)(// eslint-disable-next-line jira/import/webpack-magic-comment-entries
()=>(parcelRequire("aiVXY")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/common-flag-v2/index.tsx"
});
const $2ffdc518941fd08c$var$CommonFlagImpl = (props)=>__SPA__ ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$AfterPaintCommonFlag, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$ForPaintCommonFlag, props);

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $2ffdc518941fd08c$var$ForPaintFlagGroup = (0, $7rh0R.lazyForPaint)(// eslint-disable-next-line jira/import/webpack-magic-comment-entries
()=>(parcelRequire("Tabui")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/group-flag-v2/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $2ffdc518941fd08c$var$AfterPaintFlagGroup = (0, $7rh0R.lazyAfterPaint)(// eslint-disable-next-line jira/import/webpack-magic-comment-entries
()=>(parcelRequire("Tabui")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/group-flag-v2/index.tsx"
});
const $2ffdc518941fd08c$var$FlagGroupImpl = (props)=>__SPA__ ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$AfterPaintFlagGroup, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$ForPaintFlagGroup, props);
const $2ffdc518941fd08c$export$13d73238a031436b = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, props));
const $2ffdc518941fd08c$export$518ba8e0e60f145f = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, {
        flagType: "error",
        ...props
    }));
const $2ffdc518941fd08c$export$3f75672bb90a4431 = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, {
        flagType: "error",
        isAutoDismiss: true,
        ...props
    }));
const $2ffdc518941fd08c$export$6a55b52e74c1e48e = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, {
        flagType: "info",
        ...props
    }));
const $2ffdc518941fd08c$export$74a3c0748aa31355 = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, {
        flagType: "success",
        isAutoDismiss: true,
        ...props
    }));
const $2ffdc518941fd08c$export$93bd4963a1d00fd5 = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, {
        flagType: "success",
        ...props
    }));
const $2ffdc518941fd08c$export$23695d8281998f27 = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, {
        flagType: "warning",
        ...props
    }));
const $2ffdc518941fd08c$export$a2c3479950310d7d = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$FlagGroupImpl, props));

});
parcelRegister("aiVXY", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('2hmUs'),
            load('bCeK4'),
            load('cCYJs')
        ]);
        const value = parcelRequire('kbpOk');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("2hmUs"),
        load("bCeK4"),
        load("cCYJs")
    ]).then(()=>parcelRequire('kbpOk'));
}

});

parcelRegister("Tabui", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('hkLGi');
        const value = parcelRequire('jkRT2');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("hkLGi").then(()=>parcelRequire('jkRT2'));
}

});



parcelRegister("90ffs", function(module, exports) {

$parcel$export(module.exports, "default", () => $8b69c2b71403c7d4$export$2e2bcd8739ae039);

var $kQ0RL = parcelRequire("kQ0RL");
var $8b69c2b71403c7d4$export$2e2bcd8739ae039 = (0, $kQ0RL.InfoFlag);

});

parcelRegister("Gz4Lz", function(module, exports) {

$parcel$export(module.exports, "default", () => $1273ecbdbcfe24cd$export$2e2bcd8739ae039);

var $kQ0RL = parcelRequire("kQ0RL");
var $1273ecbdbcfe24cd$export$2e2bcd8739ae039 = (0, $kQ0RL.SuccessFlag);

});

parcelRegister("82rJa", function(module, exports) {

$parcel$export(module.exports, "default", () => $9c8bd85b08cb5610$export$2e2bcd8739ae039);

var $kQ0RL = parcelRequire("kQ0RL");
var $9c8bd85b08cb5610$export$2e2bcd8739ae039 = (0, $kQ0RL.WarningFlag);

});



parcelRegister("6TR1R", function(module, exports) {

$parcel$export(module.exports, "default", () => $059e4670d04af301$export$2e2bcd8739ae039);

var $3lEH1 = parcelRequire("3lEH1");

var $c1nhO = parcelRequire("c1nhO");
var $059e4670d04af301$export$2e2bcd8739ae039 = (0, $3lEH1.default);

});
parcelRegister("3lEH1", function(module, exports) {

$parcel$export(module.exports, "default", () => $56196a5cffdb2666$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $6j4bv = parcelRequire("6j4bv");

var $1HzcR = parcelRequire("1HzcR");

var $kdRsy = parcelRequire("kdRsy");
const $56196a5cffdb2666$var$runtimeProps = {};
const $56196a5cffdb2666$var$entryPointParams = {};
const $56196a5cffdb2666$var$AsyncArchiveIssueModal = ()=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $6j4bv.useEntryPoint)((0, $kdRsy.archiveModalEntryPoint), $56196a5cffdb2666$var$entryPointParams);
    (0, $eUqFw.useEffect)(()=>{
        entryPointActions.load();
        return ()=>{
            entryPointActions.unload();
        };
    }, [
        entryPointActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1HzcR.JiraEntryPointContainer), {
        id: "jira-issue-archival-modal",
        packageName: "jiraIssueArchiveModal",
        entryPointReferenceSubject: entryPointReferenceSubject,
        runtimeProps: $56196a5cffdb2666$var$runtimeProps
    });
};
var $56196a5cffdb2666$export$2e2bcd8739ae039 = $56196a5cffdb2666$var$AsyncArchiveIssueModal;

});
parcelRegister("kdRsy", function(module, exports) {

$parcel$export(module.exports, "archiveModalEntryPoint", () => $92b663e939c4181c$export$30191a6aa5a8420a);

var $1K77P = parcelRequire("1K77P");

var $7QhYz = parcelRequire("7QhYz");

const $92b663e939c4181c$export$30191a6aa5a8420a = (0, $7QhYz.createEntryPoint)({
    root: (0, $1K77P.JSResourceForInteraction)(()=>(parcelRequire("1ADuI")), {
        moduleId: "95ca667b"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("1ADuI", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('4oAJu')
        ]);
        const value = parcelRequire('1d6I0');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("4oAJu")
    ]).then(()=>parcelRequire('1d6I0'));
}

});



parcelRegister("c1nhO", function(module, exports) {

$parcel$export(module.exports, "ArchiveIssueModalStore", () => $75533eed75557d4a$export$c5cad849002b274b);
$parcel$export(module.exports, "useArchiveIssueModalActions", () => $75533eed75557d4a$export$b7e685898567f722);

var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");

var $3XTqs = parcelRequire("3XTqs");

var $lTatv = parcelRequire("lTatv");
const $75533eed75557d4a$export$c5cad849002b274b = (0, $a61MH.createStore)({
    initialState: $lTatv.initialState,
    actions: (0, $3XTqs.ArchiveIssueModalActions),
    name: 'archiveIssueModalStore'
});
const $75533eed75557d4a$export$b7e685898567f722 = (0, $ggKAj.createActionsHook)($75533eed75557d4a$export$c5cad849002b274b);

});
parcelRegister("3XTqs", function(module, exports) {

$parcel$export(module.exports, "ArchiveIssueModalActions", () => $870f3d628d60d18a$export$69579d834733fb34);
const $870f3d628d60d18a$export$69579d834733fb34 = {
    openArchiveIssueModal: ({ issueKey: issueKey, issueId: issueId, onIssueArchiveSuccess: onIssueArchiveSuccess, onCloseIssueViewModal: onCloseIssueViewModal })=>({ setState: setState })=>{
            setState({
                isArchiveIssueModalOpen: true,
                issueKey: issueKey,
                issueId: issueId,
                onIssueArchiveSuccess: onIssueArchiveSuccess,
                onCloseIssueViewModal: onCloseIssueViewModal
            });
        },
    closeArchiveIssueModal: ()=>({ setState: setState })=>{
            setState({
                isArchiveIssueModalOpen: false,
                issueKey: null,
                issueId: null,
                onIssueArchiveSuccess: null,
                onCloseIssueViewModal: null
            });
        }
};

});

parcelRegister("lTatv", function(module, exports) {

$parcel$export(module.exports, "initialState", () => $fb7fb4605c1c5da6$export$d4c72bab9d6cc13a);
const $fb7fb4605c1c5da6$export$d4c72bab9d6cc13a = {
    isArchiveIssueModalOpen: false,
    issueKey: null,
    issueId: null,
    onIssueArchiveSuccess: null,
    onCloseIssueViewModal: null
};

});



parcelRegister("kHLMD", function(module, exports) {

$parcel$export(module.exports, "AsyncIssueCreateModal", () => $74c60adcb99acbbe$export$2eb2fdb04fff9db3);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $0cdA8 = parcelRequire("0cdA8");


var $ctR9z = parcelRequire("ctR9z");

var $gGtKh = parcelRequire("gGtKh");

var $98Kfy = parcelRequire("98Kfy");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $74c60adcb99acbbe$var$IssueCreateModal = (0, $7rh0R.lazy)(()=>(parcelRequire("JgZkg")), {
    ssr: false,
    moduleId: "./src/packages/issue-create/issue-create-modal/src/index.tsx"
});
const $74c60adcb99acbbe$export$2eb2fdb04fff9db3 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "async.jira.issue-create-modal",
        packageName: "jiraIssueCreate",
        sendToPrivacyUnsafeSplunk: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "issue-create-modal",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($74c60adcb99acbbe$var$IssueCreateModal, null)));

});
parcelRegister("ctR9z", function(module, exports) {

$parcel$export(module.exports, "useTriggerIssueCreateModal", () => $bd445758cecbab8c$export$71e0eb7b8a91a156);
$parcel$export(module.exports, "withNewGICProvider", () => $bd445758cecbab8c$export$558a195c5bfe3787);

var $eUqFw = parcelRequire("eUqFw");

var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");
var $dYfll = parcelRequire("dYfll");

var $hompL = parcelRequire("hompL");

var $1ybV0 = parcelRequire("1ybV0");

var $dfh7z = parcelRequire("dfh7z");

var $dEMIg = parcelRequire("dEMIg");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $3HCkE = parcelRequire("3HCkE");

var $ellXt = parcelRequire("ellXt");


var $dgsxZ = parcelRequire("dgsxZ");
const $bd445758cecbab8c$export$d4c72bab9d6cc13a = {
    inProgressIssueID: undefined,
    isModalOpen: false,
    isSubsequentLoad: false,
    // isSubTaskCreationOpen is used for creating subtasks with new GIC
    isSubTaskCreationOpen: false,
    // isCreateLinkedIssue is used for creating linked issues with new GIC
    isCreateLinkedIssue: false,
    wasStateRestored: false,
    // payload can be used to control the initial values displayed in the GIC Modal
    payload: null,
    // id for the GIC Modal component
    id: 'create-issue-dialog',
    // title for the GIC modal
    title: null,
    // sectionMessage is used to show an info banner at the top of the GIC modal
    sectionMessage: null,
    // submitErrorMessage is used to show an error banner at the top of the GIC modal
    submitErrorMessage: undefined,
    // globalEventNamespaces is the list of event namespaces to which data of created issues will be published
    globalEventNamespaces: [
        (0, $dEMIg.GLOBAL_EVENT_NAMESPACE)
    ],
    // fieldsToAddInPublishedData: list of additioanl fields that should be appended in the data published for
    // created issues. By default we publish summary, status, assignee, duedate, project, issuetype & priority
    fieldsToAddInPublishedData: [],
    // Used on Create Incident from Alerts functionality. Only relevant for Opsgenie alert pages
    alertsToBeLinked: undefined,
    // if onIssueCreate is passed for every issue created in the session onIssueCreate is called with
    // the data of each issue created
    onIssueCreate: null,
    onClose: null,
    // only show required fields
    displayOnlyRequiredFields: false,
    // disables the success flag
    disableCreationSuccessFlag: false,
    // toggle the 'create another issue' checkbox
    displayCreateAnotherIssueToggle: true,
    // toggle display of site picker field.
    displaySitePicker: false,
    // do not allow user to change issue project
    disableProjectDropdown: false,
    // do not allow user to change issue type
    disableIssueTypeDropdown: false,
    // triggerPoinKey can be used to identify specific trigger point of new GIC
    triggerPointKey: (0, $33ffe55cb7bcdadc$export$8d987f6e80b74000),
    // context can be used to pass data like rank/board data which will be used as payload for issue creation
    context: undefined,
    // the view state for the minimizable modal
    minimizableModalView: 'modal',
    // the modal view maybe persistent depending on conditions, if this value is present, it may override the `minimizableModalView` during `openIssueCreateModal`.
    persistentModalView: undefined,
    // whether we should display mini modal by default for the first time. If this is true, it will override the view state to `mini` during `openIssueCreateModal`.
    shouldPushMiniModalDiscoverability: undefined,
    // whether we should display mini modal spotlight for the first time.
    shouldShowMiniModalSpotlight: undefined,
    // modal was attempted to be opened when already opened
    wasModalRetriggered: false,
    // if there is an existing gic open - we only apply the next state if they discard their current issue
    openIssueCreateModalNextState: {},
    // when an issue is discarded we will reinitialise the gic modal
    shouldInitFetchConfig: false,
    interactedWithModalChangerButtons: false,
    // open modal for the jql board trigger point
    isModalLoadInContext: false,
    // opt-out of the minimizable GIC modal
    disableMinimizableModal: false,
    // switch to control the hide and display of minimizable buttons
    displayMinimizableButtons: true,
    // switch to control the hide and display of header action container
    displayHeaderActionContainer: true,
    // do not override "use request type fields" toggle state
    overrideUseRequestTypeFieldsToggleState: undefined,
    /**
	 * this is for applying the container styles on the GIC containers except modal view
	 */ containerStyle: {},
    // this flag is for enable the minidesign for a trigger point without being in mini view
    isMiniDesignEnabled: false,
    // this flag is for the GIC multiple layout experiment by Makkuro
    isEnrolledAndTargetedForGicMultipleLayouts: false,
    // optional sessionId used for the current issue creation session
    sessionId: undefined,
    // optional component - when supplied, this wraps every field as children within the GIC modal
    FieldWrapperComponent: undefined,
    // Analytics property for board with custom filter and icc enabled
    isCustomBoardWithIcc: false
};
const $bd445758cecbab8c$export$e324594224ef24da = {
    restoreState: (stateToRestore)=>({ setState: setState, getState: getState })=>{
            const { isSubsequentLoad: isSubsequentLoad, isModalOpen: isModalOpen } = getState();
            if (!isModalOpen && stateToRestore.isModalOpen) (0, $dgsxZ.startGlobalIssueCreateMetrics)(isSubsequentLoad);
            setState(stateToRestore);
        },
    openIssueCreateModal: (nextState)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            if (currentState.isModalOpen) /* If there is an existing gic open then we will defer the state change to prevent
                       clashing with the issue in creation. */ setState({
                wasModalRetriggered: true,
                openIssueCreateModalNextState: nextState
            });
            else {
                (0, $dgsxZ.startGlobalIssueCreateMetrics)(currentState.isSubsequentLoad);
                const isDiscoverabilityPushEnabled = !currentState.isEnrolledAndTargetedForGicMultipleLayouts;
                const isDiscoPushTriggerPoint = isDiscoverabilityPushEnabled && (0, $dgsxZ.isPartOfDiscoverabilityTriggers)(nextState?.triggerPointKey);
                const nextModalView = isDiscoverabilityPushEnabled ? (0, $dgsxZ.getNextModalView)(isDiscoPushTriggerPoint, currentState.persistentModalView, $bd445758cecbab8c$export$d4c72bab9d6cc13a.minimizableModalView) : 'modal';
                setState({
                    ...$bd445758cecbab8c$export$d4c72bab9d6cc13a,
                    ...isDiscoverabilityPushEnabled && {
                        minimizableModalView: nextModalView,
                        persistentModalView: currentState.persistentModalView,
                        ...(0, $dgsxZ.discoverabilityPushModalViewOverride)(currentState.shouldPushMiniModalDiscoverability, isDiscoPushTriggerPoint, nextModalView)
                    },
                    inProgressIssueID: (0, (/*@__PURE__*/$parcel$interopDefault($hompL))).v4(),
                    isSubsequentLoad: currentState.isSubsequentLoad,
                    isModalOpen: true,
                    wasModalRetriggered: currentState.isModalOpen,
                    ...nextState
                });
            }
        },
    closeIssueCreateModal: (hasIssueCreated)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            const isDiscoverabilityPushEnabled = !currentState.isEnrolledAndTargetedForGicMultipleLayouts;
            const isValidDiscoPushTriggerPoint = isDiscoverabilityPushEnabled && (0, $dgsxZ.isPartOfDiscoverabilityTriggers)(currentState.triggerPointKey);
            const shouldUpdatePersistentModalView = isDiscoverabilityPushEnabled && hasIssueCreated && isValidDiscoPushTriggerPoint;
            const shouldPersistDiscoverabilityState = isDiscoverabilityPushEnabled && currentState.shouldPushMiniModalDiscoverability && !isValidDiscoPushTriggerPoint;
            setState({
                ...$bd445758cecbab8c$export$d4c72bab9d6cc13a,
                ...shouldPersistDiscoverabilityState && {
                    shouldPushMiniModalDiscoverability: true
                },
                ...isDiscoverabilityPushEnabled && {
                    persistentModalView: currentState.persistentModalView
                },
                ...shouldUpdatePersistentModalView && {
                    persistentModalView: currentState.minimizableModalView === 'mini' ? 'mini' : 'modal'
                },
                isModalOpen: false,
                isSubsequentLoad: true
            });
            (0, $dfh7z.CreateIssueUFOExperience).abort({
                metadata: {
                    wasStateRestored: getState().wasStateRestored
                }
            });
        },
    clearSectionMessage: ()=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            setState({
                ...currentState,
                sectionMessage: null
            });
        },
    setDisplayOnlyRequiredFields: (nextState)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            setState({
                ...currentState,
                displayOnlyRequiredFields: nextState
            });
        },
    setMinimizableModalView: (minimizableModalView)=>({ setState: setState })=>{
            setState({
                minimizableModalView: minimizableModalView,
                interactedWithModalChangerButtons: true
            });
        },
    resetWasModalRetriggered: (applyNextState = false)=>({ setState: setState, getState: getState })=>{
            if (applyNextState) {
                const currentState = getState();
                (0, $dgsxZ.startGlobalIssueCreateMetrics)(currentState.isSubsequentLoad);
                setState({
                    ...$bd445758cecbab8c$export$d4c72bab9d6cc13a,
                    ...!currentState.isEnrolledAndTargetedForGicMultipleLayouts && {
                        persistentModalView: currentState.persistentModalView
                    },
                    inProgressIssueID: currentState.inProgressIssueID,
                    isSubsequentLoad: currentState.isSubsequentLoad,
                    isModalOpen: true,
                    wasModalRetriggered: false,
                    minimizableModalView: 'modal',
                    openIssueCreateModalNextState: {},
                    shouldInitFetchConfig: true,
                    ...currentState.openIssueCreateModalNextState
                });
            } else setState({
                minimizableModalView: 'modal',
                wasModalRetriggered: false,
                openIssueCreateModalNextState: {}
            });
        },
    resetShouldInitFetchConfig: ()=>({ setState: setState })=>{
            setState({
                shouldInitFetchConfig: false
            });
        },
    setCallbackPayload: (callbackPayload)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            setState({
                callbackPayload: {
                    id: currentState.callbackPayload?.id ?? '',
                    data: callbackPayload
                }
            });
        },
    setShouldPushMiniModalDiscoverability: (shouldPushMiniModalDiscoverability)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            if (currentState.isEnrolledAndTargetedForGicMultipleLayouts) return;
            setState({
                shouldPushMiniModalDiscoverability: shouldPushMiniModalDiscoverability
            });
        },
    dismissModalSpotlight: ()=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            if (currentState.isEnrolledAndTargetedForGicMultipleLayouts) return;
            setState({
                shouldShowMiniModalSpotlight: false
            });
        },
    setPersistentModalView: (persistentModalView)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            if (currentState.isEnrolledAndTargetedForGicMultipleLayouts) return;
            setState({
                persistentModalView: persistentModalView
            });
        },
    removeAlertFromAlertsToBeLinked: (alertId)=>({ setState: setState, getState: getState })=>{
            if (!(0, $1ybV0.ff)('linked-alerts-in-gic_onvr6')) return;
            const currentState = getState();
            const alertsToBeLinked = currentState.alertsToBeLinked?.filter((entry)=>entry !== alertId);
            setState({
                alertsToBeLinked: alertsToBeLinked
            });
        },
    setSessionId: (sessionId)=>({ setState: setState })=>{
            setState({
                sessionId: sessionId
            });
        }
};
const $bd445758cecbab8c$var$store = (0, $a61MH.createStore)({
    name: 'issue-create.issue-create-form.use-trigger-issue-create-modal',
    initialState: $bd445758cecbab8c$export$d4c72bab9d6cc13a,
    actions: $bd445758cecbab8c$export$e324594224ef24da
});
const $bd445758cecbab8c$var$useTriggerIssueCreateModalState = (0, $ggKAj.createStateHook)($bd445758cecbab8c$var$store);
const $bd445758cecbab8c$var$useTriggerIssueCreateModalActions = (0, $ggKAj.createActionsHook)($bd445758cecbab8c$var$store);
const $bd445758cecbab8c$export$71e0eb7b8a91a156 = ()=>{
    const createState = $bd445758cecbab8c$var$useTriggerIssueCreateModalState();
    const createActions = $bd445758cecbab8c$var$useTriggerIssueCreateModalActions();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { openIssueCreateModal: openIssueCreateModal, ...otherActions } = createActions;
    const openIssueCreateModalWithAnalytics = (0, $eUqFw.useCallback)((nextState)=>{
        const analyticsEvent = createAnalyticsEvent({});
        const attributes = {
            gicViewState: nextState?.minimizableModalView,
            isSubtask: nextState?.isSubTaskCreationOpen,
            triggerPointKey: nextState?.triggerPointKey
        };
        (0, $jMP2a.fireTrackAnalyticsDeferred)(analyticsEvent, 'issueCreateModal triggered', attributes);
        openIssueCreateModal(nextState);
    }, [
        createAnalyticsEvent,
        openIssueCreateModal
    ]);
    return [
        createState,
        {
            ...otherActions,
            openIssueCreateModal: openIssueCreateModalWithAnalytics
        }
    ];
};
const $bd445758cecbab8c$export$47cf258b1046080b = ()=>{
    const { openIssueCreateModal: openIssueCreateModal } = $bd445758cecbab8c$var$useTriggerIssueCreateModalActions();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    return (0, $eUqFw.useCallback)((nextState)=>{
        const analyticsEvent = createAnalyticsEvent({});
        const attributes = {
            gicViewState: nextState?.minimizableModalView,
            isSubtask: nextState?.isSubTaskCreationOpen,
            triggerPointKey: nextState?.triggerPointKey
        };
        (0, $jMP2a.fireTrackAnalyticsDeferred)(analyticsEvent, 'issueCreateModal triggered', attributes);
        openIssueCreateModal(nextState);
    }, [
        createAnalyticsEvent,
        openIssueCreateModal
    ]);
};
const $bd445758cecbab8c$export$4c674fe824b8f278 = (0, $dYfll.createSubscriber)($bd445758cecbab8c$var$store);
function $bd445758cecbab8c$export$558a195c5bfe3787(WrappedComponent) {
    return (props)=>{
        const [, { openIssueCreateModal: openIssueCreateModal, closeIssueCreateModal: closeIssueCreateModal }] = $bd445758cecbab8c$export$71e0eb7b8a91a156();
        const { data: data } = (0, $3HCkE.useResource)((0, $ellXt.gicOptInStatusResources));
        const currentIssueCreateVisibility = data && data?.gicOptInStatus;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, {
            openIssueCreateModal: openIssueCreateModal,
            closeIssueCreateModal: closeIssueCreateModal,
            currentIssueCreateVisibility: currentIssueCreateVisibility?.isEnabled || false,
            ...props
        });
    };
}

});
parcelRegister("dfh7z", function(module, exports) {

$parcel$export(module.exports, "CreateIssueUFOExperience", () => $5fd686e53a19cbe0$export$cd75c112ac11a83b);
$parcel$export(module.exports, "StatusFieldLoad", () => $5fd686e53a19cbe0$export$e890e797a25e655c);
$parcel$export(module.exports, "GlobalIssueCreateModalSubmitUFOExperience", () => $5fd686e53a19cbe0$export$70208657c8d471a7);

var $12kyE = parcelRequire("12kyE");
var $kDfSL = parcelRequire("kDfSL");
const $5fd686e53a19cbe0$export$cd75c112ac11a83b = new (0, $kDfSL.UFOExperience)('global-issue-create.create-issue', {
    type: (0, $12kyE.ExperienceTypes).Experience,
    performanceType: (0, $12kyE.ExperiencePerformanceTypes).Custom,
    category: 'global-issue-create.create-issue'
});
const $5fd686e53a19cbe0$export$e890e797a25e655c = new (0, $kDfSL.UFOExperience)('global-issue-create.create-issue.status-field', {
    type: (0, $12kyE.ExperienceTypes).Load,
    performanceType: (0, $12kyE.ExperiencePerformanceTypes).PageSegmentLoad
});
const $5fd686e53a19cbe0$export$70208657c8d471a7 = new (0, $kDfSL.UFOExperience)('modern-global-issue-create.modal.issue-submit', {
    type: (0, $12kyE.ExperienceTypes).Experience,
    performanceType: (0, $12kyE.ExperiencePerformanceTypes).Custom,
    category: 'modern-global-issue-create.modal.issue-submit'
});

});

parcelRegister("dEMIg", function(module, exports) {

$parcel$export(module.exports, "REQUIRED", () => $dd9f36fe091541c8$export$b1c05b34d317c074);
$parcel$export(module.exports, "FORM_DROPZONE_CONTAINER_ID", () => $dd9f36fe091541c8$export$1a020bd73f33e5a);
$parcel$export(module.exports, "MINIMISED_DROPZONE_CONTAINER_ID", () => $dd9f36fe091541c8$export$9eadc594a5383580);
$parcel$export(module.exports, "LOG_WORK_TIME_SPENT_ERROR_KEY", () => $dd9f36fe091541c8$export$a1a7caa1e4a73c9f);
$parcel$export(module.exports, "LOG_WORK_TIME_REMAINING_ERROR_KEY", () => $dd9f36fe091541c8$export$cf70f9220e6a2f50);
$parcel$export(module.exports, "LOG_WORK_DATE_ERROR_KEY", () => $dd9f36fe091541c8$export$aac4661200ba4104);
$parcel$export(module.exports, "LOG_WORK_DESCRIPTION_ERROR_KEY", () => $dd9f36fe091541c8$export$a23c32d5cf54cba0);
$parcel$export(module.exports, "COMMON_LOG_WORK_ERROR_KEYS", () => $dd9f36fe091541c8$export$74ab3898ae683660);
$parcel$export(module.exports, "MULTI_INPUT_FIELDS_ERROR_KEYS", () => $dd9f36fe091541c8$export$983715bb9b0f9b2c);
$parcel$export(module.exports, "DEFAULT_SCROLL_OPTIONS", () => $dd9f36fe091541c8$export$40f6793dd75f4e52);
$parcel$export(module.exports, "UNSUPPORTED_FIELD_TYPES_IN_GIC", () => $dd9f36fe091541c8$export$3bf5bce483cc2c30);
$parcel$export(module.exports, "ISSUE_CREATE_TYPE", () => $dd9f36fe091541c8$export$30cc1fd33e7c7258);
$parcel$export(module.exports, "GLOBAL_EVENT_NAMESPACE", () => $dd9f36fe091541c8$export$8170252f0ea43511);

const $dd9f36fe091541c8$export$17bcab948893a9ba = 'worklog';
const $dd9f36fe091541c8$export$b1c05b34d317c074 = 'REQUIRED';
const $dd9f36fe091541c8$export$f10b32dfda12e96e = 'unknown';
const $dd9f36fe091541c8$export$e5e4b8c32e68dd0b = 'networkError';
const $dd9f36fe091541c8$export$2d06efb8146cd043 = 'graphQLError';
const $dd9f36fe091541c8$export$1a020bd73f33e5a = 'issue-create-modal-dropzone-container';
const $dd9f36fe091541c8$export$9eadc594a5383580 = 'minimised-issue-create-dropzone-container';
const $dd9f36fe091541c8$export$a1a7caa1e4a73c9f = 'worklog_timeLogged';
const $dd9f36fe091541c8$export$cf70f9220e6a2f50 = 'worklog_newEstimate';
const $dd9f36fe091541c8$export$aac4661200ba4104 = 'worklog_startDate';
const $dd9f36fe091541c8$export$a23c32d5cf54cba0 = 'worklog_description';
const $dd9f36fe091541c8$export$74ab3898ae683660 = [
    'worklog_adjustmentAmount',
    'worklog_adjustEstimate',
    'worklog_activate'
];
const $dd9f36fe091541c8$export$63fd567c1d0aca19 = [
    ...$dd9f36fe091541c8$export$74ab3898ae683660,
    $dd9f36fe091541c8$export$a1a7caa1e4a73c9f,
    $dd9f36fe091541c8$export$cf70f9220e6a2f50,
    $dd9f36fe091541c8$export$aac4661200ba4104,
    $dd9f36fe091541c8$export$a23c32d5cf54cba0
];
const $dd9f36fe091541c8$export$983715bb9b0f9b2c = {
    [$dd9f36fe091541c8$export$17bcab948893a9ba]: $dd9f36fe091541c8$export$63fd567c1d0aca19
};
const $dd9f36fe091541c8$export$40f6793dd75f4e52 = {
    behavior: 'auto',
    scrollMode: 'if-needed',
    block: 'start'
};
const $dd9f36fe091541c8$export$3bf5bce483cc2c30 = [
    'com.atlassian.servicedesk:sd-request-participants'
];
const $dd9f36fe091541c8$export$30cc1fd33e7c7258 = {
    linkedIssue: 'LINKED_ISSUE_CREATE',
    standard: 'STANDARD'
};
const $dd9f36fe091541c8$export$8170252f0ea43511 = 'QuickCreateIssue';

});
// error types
const $8b8bfa076f313cc4$export$6c8cb487d6ffc522 = 'QueryError';
const $8b8bfa076f313cc4$export$b171488d52070cb3 = 'JiraIssueFieldUnsupportedErrorExtension';
const $8b8bfa076f313cc4$export$14b50ab9fbf2d370 = 'JiraIssueFieldValueValidationErrorExtension';
const $8b8bfa076f313cc4$export$3d1cda9bd50505e8 = 'SERVICE_REQUEST';
const $8b8bfa076f313cc4$export$48c144830383423 = 'INCIDENT_MANAGEMENT';
const $8b8bfa076f313cc4$export$1ea6ead7bcee4494 = 'PROBLEM_MANAGEMENT';
const $8b8bfa076f313cc4$export$b92ccb6dc3cdb548 = 'CHANGE_MANAGEMENT';
const $8b8bfa076f313cc4$export$a4a741b969f6509c = 'POST_INCIDENT_REVIEW';
const $8b8bfa076f313cc4$export$81e62964cc725098 = 'DEVELOPER_ESCALATION';
const $8b8bfa076f313cc4$export$92ab80c1dc9baf44 = 'REQUEST_TYPE';
const $8b8bfa076f313cc4$export$ebb48b08205007c5 = 'ISSUE_TYPE';
const $8b8bfa076f313cc4$export$c835df30ebbd529d = 'UNASSIGNED_REQUEST_TYPE';


const $33ffe55cb7bcdadc$export$a05673a22505d5ee = 'forge-open-issue-create';
const $33ffe55cb7bcdadc$export$c78d329777576aa0 = 'global-create-button';
const $33ffe55cb7bcdadc$export$affdc3af7a9a4677 = 'keyboard-shortcut';
const $33ffe55cb7bcdadc$export$7e9cfd1f59e60910 = 'jsw-issue-view-create-issue-in-epic';
const $33ffe55cb7bcdadc$export$708499dcd016e5e9 = 'jsw-issue-view-create-subtask';
const $33ffe55cb7bcdadc$export$e1c8789144c4c810 = 'jsw-issue-view-ai-breakdown-child-issue';
const $33ffe55cb7bcdadc$export$c5afabb7a17e802 = 'jsw-issue-view-ai-breakdown-subtask';
const $33ffe55cb7bcdadc$export$2086a63173b79b56 = 'jsw-releases-create-issue';
const $33ffe55cb7bcdadc$export$fe1e5e4597147709 = 'jsw-roadmap-create-issue';
const $33ffe55cb7bcdadc$export$9bc326812a93707 = 'jsw-security-create-issue';
const $33ffe55cb7bcdadc$export$f352934e06f44599 = 'jsm-calendar-create-change-request';
const $33ffe55cb7bcdadc$export$6ae07c77acc64360 = 'jsm-create-incident-from-alert-detail';
const $33ffe55cb7bcdadc$export$b41d0684e4b6ab1 = 'jsm-create-incident-from-alert-list';
const $33ffe55cb7bcdadc$export$be9b2b1329ff7ec9 = 'jsm-empty-queue-create-request';
const $33ffe55cb7bcdadc$export$235b856f54db8916 = 'jwm-board-create-issue';
const $33ffe55cb7bcdadc$export$ebbb81a0a3406bcb = 'jwm-calendar-create-issue';
const $33ffe55cb7bcdadc$export$8e135b62470e5f9a = 'jwm-list-create-issue';
const $33ffe55cb7bcdadc$export$21ea58e7361c33ba = 'jwm-list-create-subtask';
const $33ffe55cb7bcdadc$export$d2cf44b8c67cca33 = 'jwm-timeline-create-issue';
const $33ffe55cb7bcdadc$export$894285d6d13375fd = 'jwm-timeline-create-subtask';
const $33ffe55cb7bcdadc$export$aa348159181703a0 = 'software-create-issue-dialog';
const $33ffe55cb7bcdadc$export$f90eec3841adf619 = 'create-linked-issue-issue-view';
const $33ffe55cb7bcdadc$export$718822a309bffada = 'create-linked-issue-command-palette';
const $33ffe55cb7bcdadc$export$2753dafac81e805c = 'service-desk-linked-issue-trigger';
const $33ffe55cb7bcdadc$export$7c4d5cc5711d9294 = 'jsw-incidents-create-jsm-pir-trigger';
const $33ffe55cb7bcdadc$export$6eb7318fea2f8ce0 = 'jsw-incidents-create-issue-trigger';
const $33ffe55cb7bcdadc$export$998dfc72404b9e14 = 'jpo-dialogs-jira-create-issue';
const $33ffe55cb7bcdadc$export$fc180a4b5785d2f4 = 'jsw-adapted-global-issue-create-trigger';
const $33ffe55cb7bcdadc$export$946ec0b21cb84fd0 = 'jsw-create-epic-issue';
const $33ffe55cb7bcdadc$export$dba86c91ec4fdbf0 = 'create-issue-backlog-trigger';
const $33ffe55cb7bcdadc$export$b5cdfd7f3bb79a7 = 'create-epic-issue-backlog-trigger';
const $33ffe55cb7bcdadc$export$a8199da3cfab0e8 = 'create-issue-in-epic-backlog-trigger';
const $33ffe55cb7bcdadc$export$5b97e2844e620e54 = 'create-issue-active-sprint-empty-view-trigger';
const $33ffe55cb7bcdadc$export$569f5ff8afa08896 = 'create-linked-issue-issue-navigator-trigger';
const $33ffe55cb7bcdadc$export$bafd52474e9ff4e = 'jwm-summary-create-first-issue-trigger';
const $33ffe55cb7bcdadc$export$87f86192eaf0fdf = 'create-subtask-issue-navigator-trigger';
const $33ffe55cb7bcdadc$export$b99842c2cf46f6be = 'create-subtask-new-issue-navigator-trigger';
const $33ffe55cb7bcdadc$export$1e467d0a3f53a410 = 'jwm-board-embed-issue-create';
const $33ffe55cb7bcdadc$export$8d987f6e80b74000 = 'trigger-point-key-not-defined';
const $33ffe55cb7bcdadc$export$867e9a641a3c1457 = 'jwm-list-embed-issue-create';
const $33ffe55cb7bcdadc$export$8de9fa43731c4b5b = 'issue-parent-switcher-field-create-issue';
const $33ffe55cb7bcdadc$export$87249ccbfd10fb78 = 'polaris-create-delivery-issue';
const $33ffe55cb7bcdadc$export$c0eeeb31d264de76 = 'home-page-default-open-gic';
const $33ffe55cb7bcdadc$export$f546e18e46478c84 = 'issue-create-embed-trigger';
const $33ffe55cb7bcdadc$export$1784e634ba79f1f9 = 'developer-escalations-issue-create-trigger';
const $33ffe55cb7bcdadc$export$145eb8935a34e85e = 'jwm-inline-create';
const $33ffe55cb7bcdadc$export$32648b574a536c8b = 'polaris-global-submit-idea-switch-project-trigger';

parcelRegister("dgsxZ", function(module, exports) {

$parcel$export(module.exports, "startGlobalIssueCreateMetrics", () => $b8d8e5356c7976a6$export$550b19803bc962ec);
$parcel$export(module.exports, "isPartOfDiscoverabilityTriggers", () => $b8d8e5356c7976a6$export$f6bc17a4d9120156);
$parcel$export(module.exports, "discoverabilityPushModalViewOverride", () => $b8d8e5356c7976a6$export$8d246e5e04f0b424);
$parcel$export(module.exports, "getNextModalView", () => $b8d8e5356c7976a6$export$720579602bb055a2);

var $dfh7z = parcelRequire("dfh7z");
var $fqKjL = parcelRequire("fqKjL");

var $hBkQt = parcelRequire("hBkQt");

var $duQ8C = parcelRequire("duQ8C");
const $b8d8e5356c7976a6$export$550b19803bc962ec = (isSubsequentLoad)=>{
    (0, $dfh7z.CreateIssueUFOExperience).start();
    const globalIssueCreateModalLoadMetric = isSubsequentLoad ? (0, $fqKjL.globalIssueCreateModalLoadSubsequent) : (0, $fqKjL.globalIssueCreateModalLoad);
    if (isSubsequentLoad) (0, $duQ8C.default)('global-issue.create-modal-subsequent');
    else (0, $duQ8C.default)('global-issue.create-modal');
    globalIssueCreateModalLoadMetric.start();
    (0, $hBkQt.startGlobalIssueCreateTTIWithAdjustments)();
};
const $b8d8e5356c7976a6$export$f6bc17a4d9120156 = (triggerPoint)=>{
    if (!triggerPoint) return false;
    const acceptedTriggerPoints = [
        'global-create-button',
        'keyboard-shortcut'
    ];
    return acceptedTriggerPoints.includes(triggerPoint);
};
const $b8d8e5356c7976a6$export$8d246e5e04f0b424 = (shouldPushDiscoverability, isTriggerAccepted, defaultView = 'modal')=>{
    if (!shouldPushDiscoverability) return undefined;
    return {
        minimizableModalView: isTriggerAccepted ? 'mini' : defaultView,
        shouldPushMiniModalDiscoverability: true,
        shouldShowMiniModalSpotlight: isTriggerAccepted
    };
};
const $b8d8e5356c7976a6$export$720579602bb055a2 = (isTriggerAccepted, persistentView, defaultView = 'modal')=>{
    if (isTriggerAccepted) return persistentView || defaultView;
    return defaultView;
};

});
parcelRegister("fqKjL", function(module, exports) {

$parcel$export(module.exports, "globalIssueCreateModalLoad", () => $de2993c8c3fea479$export$5a01a7fa84b239c8);
$parcel$export(module.exports, "globalIssueCreateModalLoadSubsequent", () => $de2993c8c3fea479$export$c50ad3c31b6fcfc6);
$parcel$export(module.exports, "successFlagDisplay", () => $de2993c8c3fea479$export$4b2382574525bb0f);
$parcel$export(module.exports, "successFlagAddToSprintAction", () => $de2993c8c3fea479$export$7839bdaa2f6a2385);
$parcel$export(module.exports, "successFlagClearFiltersAction", () => $de2993c8c3fea479$export$c1592e4d8d98963e);

var $lEpcX = parcelRequire("lEpcX");
const $de2993c8c3fea479$export$5a01a7fa84b239c8 = (0, $lEpcX.metrics).interaction({
    key: 'global-issue-create-modal'
});
const $de2993c8c3fea479$export$c50ad3c31b6fcfc6 = (0, $lEpcX.metrics).interaction({
    key: 'global-issue-create-modal-subsequent'
});
const $de2993c8c3fea479$export$4b2382574525bb0f = (0, $lEpcX.metrics).interaction({
    key: 'global-issue-create-dynamic-success-flag-display'
});
const $de2993c8c3fea479$export$7839bdaa2f6a2385 = (0, $lEpcX.metrics).interaction({
    key: 'global-issue-create-dynamic-success-flag-add-to-sprint-action'
});
const $de2993c8c3fea479$export$c1592e4d8d98963e = (0, $lEpcX.metrics).interaction({
    key: 'global-issue-create-dynamic-success-flag-clear-filters-action'
});

});

parcelRegister("hBkQt", function(module, exports) {

$parcel$export(module.exports, "globalIssueCreateTTIWithAdjustments", () => $362542d6dd943f24$export$9f3d6f17e1da7874);
$parcel$export(module.exports, "startGlobalIssueCreateTTIWithAdjustments", () => $362542d6dd943f24$export$457c9fb71ad5b3a9);
$parcel$export(module.exports, "markGicTti", () => $362542d6dd943f24$export$ef664dac649a716c);
$parcel$export(module.exports, "stopTTI", () => $362542d6dd943f24$export$30ca4c461fab486c);
$parcel$export(module.exports, "cancelTTI", () => $362542d6dd943f24$export$27f2445288b528c);
$parcel$export(module.exports, "markIframeLoad", () => $362542d6dd943f24$export$7a2709fc1e33401a);
$parcel$export(module.exports, "markFieldsRegistered", () => $362542d6dd943f24$export$cf3893335c93e33b);
$parcel$export(module.exports, "markOnInitResolved", () => $362542d6dd943f24$export$d86f4868694f2aa7);

var $lEpcX = parcelRequire("lEpcX");

var $gGRYc = parcelRequire("gGRYc");
const $362542d6dd943f24$export$9f3d6f17e1da7874 = (0, $lEpcX.metrics).interaction({
    key: 'global-issue-create-tti-with-adjustments',
    timings: [
        {
            key: 'gic-tti-delta',
            startMark: 'gic-tti'
        },
        {
            key: 'script-execution',
            startMark: 'iframe-load'
        },
        {
            key: 'loading-indicators-visibility',
            startMark: 'fields-registered'
        },
        {
            key: 'time-until-oninit-resolved',
            endMark: 'oninit-resolved'
        },
        {
            key: 'gic-all-fields-tti',
            endMark: 'gic-all-fields-loaded'
        }
    ],
    featureFlags: (0, $gGRYc.TTIFFs)
});
const $362542d6dd943f24$export$457c9fb71ad5b3a9 = ()=>{
    $362542d6dd943f24$export$9f3d6f17e1da7874.start();
};
const $362542d6dd943f24$export$ef664dac649a716c = ()=>$362542d6dd943f24$export$9f3d6f17e1da7874.mark('gic-tti');
const $362542d6dd943f24$export$30ca4c461fab486c = (customData)=>{
    $362542d6dd943f24$export$9f3d6f17e1da7874.stop({
        customData: customData
    });
};
const $362542d6dd943f24$export$27f2445288b528c = ()=>{
    $362542d6dd943f24$export$9f3d6f17e1da7874.cancel();
};
const $362542d6dd943f24$export$7a2709fc1e33401a = ()=>{
    $362542d6dd943f24$export$9f3d6f17e1da7874.mark('iframe-load');
};
const $362542d6dd943f24$export$cf3893335c93e33b = ()=>{
    $362542d6dd943f24$export$9f3d6f17e1da7874.mark('fields-registered');
};
const $362542d6dd943f24$export$d86f4868694f2aa7 = ()=>{
    $362542d6dd943f24$export$9f3d6f17e1da7874.mark('oninit-resolved');
};

});
parcelRegister("gGRYc", function(module, exports) {

$parcel$export(module.exports, "TTIFFs", () => $05ae9ccc47102fc0$export$c396ba1504d97f3f);
const $05ae9ccc47102fc0$export$c396ba1504d97f3f = [];

});




parcelRegister("98Kfy", function(module, exports) {

$parcel$export(module.exports, "useInitializePersistentIssueCreateModalView", () => $9b8038c58e37e9fd$export$9086117e14a55509);

var $eUqFw = parcelRequire("eUqFw");

var $7ZZxN = parcelRequire("7ZZxN");

var $ctR9z = parcelRequire("ctR9z");

var $bNe1g = parcelRequire("bNe1g");

var $aONhl = parcelRequire("aONhl");
const $9b8038c58e37e9fd$export$9086117e14a55509 = ()=>{
    const [{ shouldShowMiniModalSpotlight: shouldShowMiniModalSpotlight }, { setShouldPushMiniModalDiscoverability: setShouldPushMiniModalDiscoverability, setPersistentModalView: setPersistentModalView }] = (0, $ctR9z.useTriggerIssueCreateModal)();
    const { data: projectContext } = (0, $bNe1g.useProjectContext)();
    const hasUserSeenMiniModal = (0, $eUqFw.useRef)(false);
    const isJSM = projectContext?.projectType === (0, $7ZZxN.SERVICE_DESK_PROJECT);
    const { data: resource } = (0, $aONhl.usePersistentIssueCreateModalViewResource)();
    /**
	 * It only handles the initialization part as after the modal is opened the persistentModalView
	 * would be handled by the `actions` of `useTriggerIssueCreateModal`.
	 */ (0, $eUqFw.useEffect)(()=>{
        setPersistentModalView(resource?.view || 'modal');
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    /**
	 * JSM has opted out so we update the `shouldPushMiniModalDiscoverability` on every project change
	 * until the discoverability push has been done, meaning that the user has seen the mini modal being
	 * shown as the default modal.
	 *
	 * If the user has seen the mini modal from discoverability push (hasUserSeenMiniModal) or
	 * dismiss its nudge (isDiscoPushComplete), shouldPushMiniModalDiscoverability should never be true again.
	 */ (0, $eUqFw.useEffect)(()=>{
        if (resource?.isDiscoPushComplete || hasUserSeenMiniModal.current) setShouldPushMiniModalDiscoverability(false);
        else setShouldPushMiniModalDiscoverability(!isJSM);
    }, [
        resource?.isDiscoPushComplete,
        setShouldPushMiniModalDiscoverability,
        isJSM
    ]);
    /**
	 * `shouldShowMiniModalSpotlight` can be used to determine if user has seen the mini modal
	 * as it is only set `onModalOpen`, which means, if it is true, the modal is opened with mini view
	 * and the user will see it.
	 */ (0, $eUqFw.useEffect)(()=>{
        if (shouldShowMiniModalSpotlight && !hasUserSeenMiniModal.current) hasUserSeenMiniModal.current = true;
    }, [
        shouldShowMiniModalSpotlight
    ]);
    return null;
};

});
parcelRegister("aONhl", function(module, exports) {

$parcel$export(module.exports, "usePersistentIssueCreateModalViewResource", () => $9e2a84bf0e5d8f6a$export$20dbed3226e737bc);

var $eUqFw = parcelRequire("eUqFw");

var $guiFP = parcelRequire("guiFP");

var $3HCkE = parcelRequire("3HCkE");

var $cm5m0 = parcelRequire("cm5m0");


var $fKYF0 = parcelRequire("fKYF0");
const $9e2a84bf0e5d8f6a$export$20dbed3226e737bc = ()=>{
    const { data: data, update: update } = (0, $3HCkE.useResource)((0, $fKYF0.persistentIssueCreateModalViewResource));
    const updateView = (0, $eUqFw.useCallback)(async (view)=>{
        try {
            await (0, $cm5m0.userPreferenceAPI).set((0, $9cf0ecd2babadcc5$export$15187a597cef02df), view);
            update((state)=>({
                    ...state,
                    view: view
                }));
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $guiFP.default)({
                error: error,
                meta: {
                    id: 'persistentIssueCreateModalViewState',
                    packageName: 'jiraRouterResourcesPersistentIssueCreateModalView',
                    teamName: 'gryffindor'
                },
                sendToPrivacyUnsafeSplunk: true
            });
        }
    }, [
        update
    ]);
    const updateIsDiscoPushComplete = (0, $eUqFw.useCallback)(async (isDiscoPushComplete = true)=>{
        try {
            await (0, $cm5m0.userPreferenceAPI).set((0, $9cf0ecd2babadcc5$export$8977f91a75d8d265), isDiscoPushComplete);
            update((state)=>({
                    ...state,
                    isDiscoPushComplete: isDiscoPushComplete
                }));
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $guiFP.default)({
                error: error,
                meta: {
                    id: 'miniModalDiscoverabilityPushState',
                    packageName: 'jiraRouterResourcesPersistentIssueCreateModalView',
                    teamName: 'gryffindor'
                },
                sendToPrivacyUnsafeSplunk: true
            });
        }
    }, [
        update
    ]);
    return {
        data: data,
        updateView: updateView,
        updateIsDiscoPushComplete: updateIsDiscoPushComplete
    };
};

});
const $9cf0ecd2babadcc5$export$15187a597cef02df = 'jira.user.gic.persistent.modal.view.state';
const $9cf0ecd2babadcc5$export$8977f91a75d8d265 = 'jira.user.gic.mini.modal.discoverability';
const $9cf0ecd2babadcc5$export$f658cfd591eb583e = 'RESOURCE_PERSISTENT_ISSUE_CREATE_MODAL_VIEW';



parcelRegister("JgZkg", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('bf9ps'),
            load('kWrFZ'),
            load('2hmUs'),
            load('bCeK4'),
            load('h2MrD'),
            load('bYT2S'),
            load('hPzOn'),
            load('fvaxW')
        ]);
        const value = parcelRequire('YxYfk');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("bf9ps"),
        load("kWrFZ"),
        load("2hmUs"),
        load("bCeK4"),
        load("h2MrD"),
        load("bYT2S"),
        load("hPzOn"),
        load("fvaxW")
    ]).then(()=>parcelRequire('YxYfk'));
}

});


parcelRegister("j1Y2B", function(module, exports) {

$parcel$export(module.exports, "AsyncNinChangeboardingAdminModal", () => $452bc7b5857b5b77$export$840a496d334ea347);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $0cdA8 = parcelRequire("0cdA8");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $452bc7b5857b5b77$var$NinChangeboardingAdminModal = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("famLP")), {
    ssr: false,
    moduleId: "./src/packages/issue-navigator/changeboarding/src/ui/admin-modal/index.tsx"
});
const $452bc7b5857b5b77$export$840a496d334ea347 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        packageName: "jiraIssueNavigatorChangeboarding",
        id: "async-changeboarding-admin-modal",
        sendToPrivacyUnsafeSplunk: true,
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($452bc7b5857b5b77$var$NinChangeboardingAdminModal, null));

});
parcelRegister("famLP", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('h2MrD'),
            load('bYT2S'),
            load('8puTm')
        ]);
        const value = parcelRequire('hH6ud');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("h2MrD"),
        load("bYT2S"),
        load("8puTm")
    ]).then(()=>parcelRequire('hH6ud'));
}

});


parcelRegister("f562T", function(module, exports) {

$parcel$export(module.exports, "default", () => $da8633d11de6f13b$export$2e2bcd8739ae039);

var $lRmyA = parcelRequire("lRmyA");
const $da8633d11de6f13b$var$HAS_SEEN_NIN_CHANGEBOARDING_ADMIN_MODAL_QUERY = `
    query HasSeenNinChangeboardingAdminModalQuery {
        myPreferences(keys: [
            "jira.user.nin.changeboarding.admin-modal.viewed"
        ])
    }
`;
const $da8633d11de6f13b$var$fetchHasSeenNinChangeboardingAdminModal = async ()=>{
    const apiResult = await (0, $lRmyA.performPostRequest)('/rest/gira/1/', {
        body: JSON.stringify({
            query: $da8633d11de6f13b$var$HAS_SEEN_NIN_CHANGEBOARDING_ADMIN_MODAL_QUERY
        })
    });
    const userPreferenceValue = apiResult.data.myPreferences['jira.user.nin.changeboarding.admin-modal.viewed'];
    if (userPreferenceValue !== 'true' && userPreferenceValue !== 'false' && userPreferenceValue !== null) throw new RangeError('Unexpected user preference value');
    return userPreferenceValue === 'true';
};
var $da8633d11de6f13b$export$2e2bcd8739ae039 = $da8633d11de6f13b$var$fetchHasSeenNinChangeboardingAdminModal;

});

parcelRegister("g6gqP", function(module, exports) {

$parcel$export(module.exports, "AsyncIssueTransitionModal", () => $fd847ca1fe3f5e08$export$5156c94e3e50c841);

var $eUqFw = parcelRequire("eUqFw");

var $6j4bv = parcelRequire("6j4bv");

var $3q7Yq = parcelRequire("3q7Yq");

var $1ybV0 = parcelRequire("1ybV0");

var $1a3la = parcelRequire("1a3la");

var $huI7r = parcelRequire("huI7r");

var $dWLk9 = parcelRequire("dWLk9");

var $6DVVe = parcelRequire("6DVVe");

var $7DSZD = parcelRequire("7DSZD");
const $fd847ca1fe3f5e08$var$runtimeProps = {};
const $fd847ca1fe3f5e08$export$5156c94e3e50c841 = ()=>{
    const [{ isModalOpen: isModalOpen, payload: payload }] = (0, $1a3la.useTriggerIssueTransitionModal)();
    const { transitionId: transitionId, issueId: issueId, issueKey: issueKey } = payload;
    const siteContextARI = (0, $7DSZD.useSiteContextARI)();
    /**
	 * Creating ari's which may be incorrect.
	 * This is not used in the query apart from verifying issueId,
	 */ const cloudId = (0, $dWLk9.useCloudId)();
    const defautIssueAri = (0, $huI7r.createAri)({
        resourceOwner: 'jira',
        cloudId: cloudId,
        resourceType: 'issue',
        resourceId: ''
    });
    const updatedIssueAriId = issueId ?? defautIssueAri;
    /* End of code which should not be used for any other thing
	 */ const variables = (0, $eUqFw.useMemo)(()=>({
            transitionId: transitionId,
            issueId: updatedIssueAriId,
            issueKey: issueKey,
            cloudId: cloudId,
            contextId: siteContextARI,
            moveGicFieldToDecomp: (0, $1ybV0.ff)('modern-issue-transition-fields-rollout-batch-2_bremb'),
            shouldUseIssueKey: !issueId
        }), [
        transitionId,
        updatedIssueAriId,
        issueKey,
        cloudId,
        siteContextARI,
        issueId
    ]);
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $6j4bv.useEntryPoint)((0, $6DVVe.asyncIssueTransitionModal), variables);
    (0, $eUqFw.useEffect)(()=>{
        if (isModalOpen && transitionId && (issueKey || issueId)) entryPointActions.load();
        else entryPointActions.unload();
    }, [
        entryPointActions,
        isModalOpen,
        issueKey,
        issueId,
        transitionId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3q7Yq.ModalEntryPointContainer), {
        entryPointReferenceSubject: entryPointReferenceSubject,
        id: "async.jira.issue-transition-modal",
        packageName: "jiraIssueTransitionModal",
        teamName: "Gryffindor",
        runtimeProps: $fd847ca1fe3f5e08$var$runtimeProps,
        entryPointActions: entryPointActions,
        errorFallback: "flag"
    });
};

});
parcelRegister("3q7Yq", function(module, exports) {

$parcel$export(module.exports, "ModalEntryPointContainer", () => $79aee538140aeba6$export$4d67c6ee49f3d14d);

var $eUqFw = parcelRequire("eUqFw");

var $dxopF = parcelRequire("dxopF");

var $P6D7Q = parcelRequire("P6D7Q");

var $ioLN0 = parcelRequire("ioLN0");
const $79aee538140aeba6$export$4d67c6ee49f3d14d = ({ entryPointActions: { unload: unload }, entryPointReferenceSubject: entryPointReferenceSubject, errorFallback: errorFallback, runtimeProps: runtimeProps, ...containerProps })=>{
    const entryPointReference = (0, $P6D7Q.useEntryPointSubscription)(entryPointReferenceSubject);
    const props = (0, $eUqFw.useMemo)(()=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        ({
            ...runtimeProps,
            onClose () {
                runtimeProps.onClose?.();
                unload();
            }
        }), [
        runtimeProps,
        unload
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dxopF.default), null, entryPointReference && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ioLN0.InternalEntryPointContainer), {
        ...containerProps,
        entryPointReference: entryPointReference,
        errorFallback: errorFallback || 'flag',
        placeholderName: "modal-entry-point-container",
        runtimeProps: props
    }));
};

});

parcelRegister("1a3la", function(module, exports) {

$parcel$export(module.exports, "useOpenIssueTransitionModal", () => $2ec6874397d8d50c$export$736bd10472c63b49);
$parcel$export(module.exports, "useTriggerIssueTransitionModal", () => $2ec6874397d8d50c$export$95a1e9702d78f223);

var $eUqFw = parcelRequire("eUqFw");

var $6XOSh = parcelRequire("6XOSh");

var $b3pJg = parcelRequire("b3pJg");
const $2ec6874397d8d50c$export$736bd10472c63b49 = ()=>{
    const { openIssueTransitionModal: openIssueTransitionModalAction } = (0, $b3pJg.useTriggerIssueTransitionModalActions)();
    const { stateGet: { state: { isEnabled: isEnabled = true } = {} } = {} } = (0, $6XOSh.useIssueTransitionLabsOptIn)();
    return (0, $eUqFw.useCallback)((nextState)=>{
        openIssueTransitionModalAction(nextState, isEnabled);
    }, [
        isEnabled,
        openIssueTransitionModalAction
    ]);
};
const $2ec6874397d8d50c$export$95a1e9702d78f223 = ()=>{
    const state = (0, $b3pJg.useTriggerIssueTransitionModalState)();
    const actions = (0, $b3pJg.useTriggerIssueTransitionModalActions)();
    const openIssueTransitionModal = $2ec6874397d8d50c$export$736bd10472c63b49();
    return [
        state,
        {
            ...actions,
            openIssueTransitionModal: openIssueTransitionModal
        }
    ];
};
var $2ec6874397d8d50c$export$2e2bcd8739ae039 = $2ec6874397d8d50c$export$95a1e9702d78f223;

});
parcelRegister("b3pJg", function(module, exports) {

$parcel$export(module.exports, "TriggerIssueTransitionModalContainer", () => $04b7e125a8f2ae4a$export$8ad65e459a406a8a);
$parcel$export(module.exports, "useTriggerIssueTransitionModalActions", () => $04b7e125a8f2ae4a$export$68de001c738e4145);
$parcel$export(module.exports, "useTriggerIssueTransitionModalState", () => $04b7e125a8f2ae4a$export$d3aceeec551eaab5);

var $ggKAj = parcelRequire("ggKAj");
var $heB5U = parcelRequire("heB5U");
var $a61MH = parcelRequire("a61MH");

var $7iqKZ = parcelRequire("7iqKZ");

var $gtFcb = parcelRequire("gtFcb");
const $04b7e125a8f2ae4a$var$store = (0, $a61MH.createStore)({
    name: 'issue-transition.issue-transition-form.use-trigger-issue-transition-modal',
    initialState: $7iqKZ.initialState,
    actions: $gtFcb
});
const $04b7e125a8f2ae4a$export$8ad65e459a406a8a = (0, $heB5U.createContainer)($04b7e125a8f2ae4a$var$store);
const $04b7e125a8f2ae4a$export$68de001c738e4145 = (0, $ggKAj.createActionsHook)($04b7e125a8f2ae4a$var$store);
const $04b7e125a8f2ae4a$export$d3aceeec551eaab5 = (0, $ggKAj.createStateHook)($04b7e125a8f2ae4a$var$store);

});
parcelRegister("7iqKZ", function(module, exports) {

$parcel$export(module.exports, "initialState", () => $ab6f76333cdb27e5$export$d4c72bab9d6cc13a);

var $hompL = parcelRequire("hompL");

const $ab6f76333cdb27e5$export$d4c72bab9d6cc13a = {
    inProgressTransitionID: (0, (/*@__PURE__*/$parcel$interopDefault($hompL))).v4(),
    isModalOpen: false,
    isSubsequentLoad: false,
    payload: {
        issueId: '',
        issueKey: '',
        transitionId: ''
    },
    id: 'issue-transition-dialog',
    title: null,
    fetchedIssueId: '',
    triggerPointKey: (0, $fa834bef164496cf$export$8d987f6e80b74000),
    onDialogSuccess: null,
    onDialogCancel: null,
    onDialogError: null
};

});
const $fa834bef164496cf$export$ef94a84e2990361c = 'issue-transition-issue-view';
const $fa834bef164496cf$export$de11f84a7d32933b = 'issue-transition-board-card-transition';
const $fa834bef164496cf$export$6c46e4003e7b7e9c = 'issue-transition-advanced-roadmaps-jira-transition';
const $fa834bef164496cf$export$e77cd508fbc3b5ba = 'issue-transition-backlog-inline-transition';
const $fa834bef164496cf$export$4edf4c3eee5081f6 = 'issue-transition-issue-view-shortcut-dialog';
const $fa834bef164496cf$export$27b74e685c26e665 = 'issue-transition-command-palette-status-field-transition';
const $fa834bef164496cf$export$290710ac08f770c0 = 'issue-transition-issue-results-shortcut-transition';
const $fa834bef164496cf$export$ddade13ad1b89bf0 = 'issue-transition-status-field-trigger';
const $fa834bef164496cf$export$8d987f6e80b74000 = 'trigger-point-key-not-defined';
const $fa834bef164496cf$export$2bf0e335b815a90b = 'comment';
const $fa834bef164496cf$export$1b8cc53b37a62399 = 'worklog';
const $fa834bef164496cf$export$d624b8367eb730df = 'issuelinks';


parcelRegister("gtFcb", function(module, exports) {

$parcel$export(module.exports, "closeIssueTransitionModal", () => (parcelRequire("bh2xU")).default);
$parcel$export(module.exports, "openIssueTransitionModal", () => (parcelRequire("kO8vo")).default);
$parcel$export(module.exports, "restoreState", () => (parcelRequire("krvVA")).default);
$parcel$export(module.exports, "setFetchedIssueId", () => (parcelRequire("cqFa9")).default);

var $bh2xU = parcelRequire("bh2xU");

var $kO8vo = parcelRequire("kO8vo");

var $krvVA = parcelRequire("krvVA");

var $cqFa9 = parcelRequire("cqFa9");

});
parcelRegister("bh2xU", function(module, exports) {

$parcel$export(module.exports, "default", () => $c8733dbfae9aa86f$export$2e2bcd8739ae039);

var $7iqKZ = parcelRequire("7iqKZ");
const $c8733dbfae9aa86f$var$closeIssueTransitionModal = ()=>({ setState: setState })=>{
        setState({
            ...(0, $7iqKZ.initialState),
            isModalOpen: false,
            isSubsequentLoad: true
        });
    };
var $c8733dbfae9aa86f$export$2e2bcd8739ae039 = $c8733dbfae9aa86f$var$closeIssueTransitionModal;

});

parcelRegister("kO8vo", function(module, exports) {

$parcel$export(module.exports, "default", () => $f64237f09f9bb7e0$export$2e2bcd8739ae039);

var $jG2Eu = parcelRequire("jG2Eu");

var $fzLv5 = parcelRequire("fzLv5");

var $hvjqG = parcelRequire("hvjqG");

var $guiFP = parcelRequire("guiFP");

var $jRlXU = parcelRequire("jRlXU");

var $7ST5U = parcelRequire("7ST5U");
const $f64237f09f9bb7e0$var$openIssueTransitionModal = (nextState, preferNewIssueTransitionScreen = true)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        const { payload: { issueKey: issueKey = '', transitionId: transitionId = '' }, onDialogSuccess: onDialogSuccess, onDialogCancel: onDialogCancel, onDialogError: onDialogError, triggerPointKey: triggerPointKey } = nextState || {
            payload: {}
        };
        let transitionModalVersion = '';
        const isNewITSEnabled = (0, $7ST5U.isNewTransitionScreenEnabled)(preferNewIssueTransitionScreen, triggerPointKey);
        try {
            if (isNewITSEnabled) {
                transitionModalVersion = 'NEW';
                (0, $jRlXU.startIssueTransitionMetrics)(currentState.isSubsequentLoad);
                setState({
                    ...currentState,
                    isModalOpen: true,
                    // making fetchedIssueId as blank to ensure we donot end up using stale issueId
                    fetchedIssueId: '',
                    ...nextState
                });
            } else {
                transitionModalVersion = 'OLD';
                (0, $hvjqG.timeToRenderTransitionModal).start();
                new (0, $fzLv5.default)({
                    issueKey: issueKey,
                    transitionId: transitionId
                }).onDialogSuccess(onDialogSuccess || (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))).onDialogCancel(onDialogCancel || (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))).onDialogError(onDialogError || (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))).show();
            }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $guiFP.default)({
                meta: {
                    id: 'transitionIssueTrigger',
                    packageName: 'jiraIssueTransitionTrigger',
                    teamName: 'gryffindor'
                },
                error: error,
                attributes: {
                    transitionModalVersion: transitionModalVersion
                },
                sendToPrivacyUnsafeSplunk: true
            });
            throw error;
        }
    };
var $f64237f09f9bb7e0$export$2e2bcd8739ae039 = $f64237f09f9bb7e0$var$openIssueTransitionModal;

});
parcelRegister("fzLv5", function(module, exports) {

$parcel$export(module.exports, "default", () => $0f25a951ff2b0812$export$2e2bcd8739ae039);

var $jG2Eu = parcelRequire("jG2Eu");

var $2BvS3 = parcelRequire("2BvS3");

var $5zSUY = parcelRequire("5zSUY");

var $hvjqG = parcelRequire("hvjqG");
class $0f25a951ff2b0812$export$2e2bcd8739ae039 {
    constructor({ issueId: issueId, transitionId: transitionId, issueKey: issueKey, issueKeys: issueKeys }){
        this.onDialogSuccessCallback = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)));
        this.onDialogErrorCallback = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)));
        this.onDialogCancelCallback = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)));
        this.issueId = issueId;
        this.transitionId = transitionId;
        this.issueKey = issueKey;
        this.issueKeys = issueKeys;
    }
    static{
        this.onDialogContentReady = ()=>{
            // This event fired by a dialog before the dialog itself is rendered and visible to the user
            // That's why we need to postpone sending the response to the next moment after it became visible
            setTimeout(()=>{
                (0, $hvjqG.timeToRenderTransitionModal).stop();
            });
        };
    }
    onDialogSuccess(onDialogSuccessCallback) {
        this.onDialogSuccessCallback = onDialogSuccessCallback;
        return this;
    }
    onDialogError(onDialogErrorCallback) {
        this.onDialogErrorCallback = onDialogErrorCallback;
        return this;
    }
    onDialogCancel(onDialogCancelCallback) {
        this.onDialogCancelCallback = onDialogCancelCallback;
        return this;
    }
    getIssueParam() {
        if (this.issueId != null) return `id=${this.issueId}`;
        if (this.issueKey != null) return `key=${this.issueKey}`;
        return '';
    }
    getUrl() {
        const { issueKeys: issueKeys } = this;
        if (issueKeys != null) // key= is needed to be sent together with keys= because of legacy API
        return `/secure/BulkTransitionIssue!default.jspa?keys=${issueKeys.join(',')}&key=${issueKeys[0]}&action=${this.transitionId}&atl_token=${(0, $5zSUY.default)() || ''}&decorator=dialog&inline=true&returnUrl=`;
        return `/secure/WorkflowUIDispatcher.jspa?${this.getIssueParam()}&action=${this.transitionId}&atl_token=${(0, $5zSUY.default)() || ''}&returnUrl=`;
    }
    async show() {
        document.addEventListener('legacyJiraDialogContentReady', $0f25a951ff2b0812$export$2e2bcd8739ae039.onDialogContentReady);
        // eslint-disable-next-line jira/wrm/no-load-bridge
        const FormDialog = await (0, $2BvS3.loadBridge)({
            name: 'jira/dialog/form-dialog',
            wrmKeys: 'wrc!jira.webresources:dialogs'
        });
        // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        const dialog = new FormDialog({
            id: 'edit-issue-dialog',
            ajaxOptions: {
                url: this.getUrl(),
                dataType: 'json'
            },
            autoClose: true,
            widthClass: 'large',
            onDialogFinished: this.onDialogSuccessCallback,
            onUnSuccessfulSubmit: this.onDialogErrorCallback,
            shouldLoadHeritageFormDialogContext: true
        });
        const cancelNativeHandler = (event)=>{
            if (!(event instanceof CustomEvent)) return;
            const dialogElement = event.detail.popup;
            const { reason: reason } = event.detail;
            if (dialogElement.is(dialog.get$popup())) {
                if (reason === 'cancel' || reason === 'esc') this.onDialogCancelCallback(event, dialogElement, reason);
                document.removeEventListener('legacyJiraDialogBeforeHide', cancelNativeHandler);
                document.removeEventListener('legacyJiraDialogContentReady', $0f25a951ff2b0812$export$2e2bcd8739ae039.onDialogContentReady);
            }
        };
        document.addEventListener('legacyJiraDialogBeforeHide', cancelNativeHandler);
        dialog.show();
    }
}

});
parcelRegister("hvjqG", function(module, exports) {

$parcel$export(module.exports, "timeToRenderTransitionModal", () => $5364d9ea59150bac$export$9d20a86383e90d09);

var $lEpcX = parcelRequire("lEpcX");
const $5364d9ea59150bac$export$9d20a86383e90d09 = (0, $lEpcX.metrics).interaction({
    key: 'issue.time-to.render-issue-transition-screen',
    // @ts-expect-error - TS2741 - Property '[BMInteractionMetrics.response]' is missing in type '{ result: string; }' but required in type 'InteractionHistogramConfig'.
    histogram: {
        result: '500_1000_2500_4000_7000_10000'
    }
});

});


parcelRegister("jRlXU", function(module, exports) {

$parcel$export(module.exports, "startIssueTransitionMetrics", () => $bd86a98ef7e8a43a$export$3fc439100e136a52);

var $1ybV0 = parcelRequire("1ybV0");

var $3gb01 = parcelRequire("3gb01");
var $67xHO = parcelRequire("67xHO");

var $fy5vB = parcelRequire("fy5vB");

var $duQ8C = parcelRequire("duQ8C");
const $bd86a98ef7e8a43a$export$3fc439100e136a52 = (isSubsequentLoad)=>{
    (0, $3gb01.IssueTransitionLoadUFOExperience).start();
    const issueTransitionModalLoadMetric = isSubsequentLoad ? (0, $67xHO.issueTransittionModalLoadSubsequent) : (0, $67xHO.issueTransitionModalLoad);
    if (isSubsequentLoad) (0, $duQ8C.default)('issue-transition.transition-modal-subsequent');
    else (0, $duQ8C.default)('issue-transition.transition-modal');
    issueTransitionModalLoadMetric.start();
    if ((0, $1ybV0.ff)('ui-modifications-on-issue-transition-view_7z1g0')) (0, $fy5vB.startUimTTI)();
};

});
parcelRegister("3gb01", function(module, exports) {

$parcel$export(module.exports, "IssueTransitionLoadUFOExperience", () => $dda1b5d926efd158$export$8fb308d8abecd81a);
$parcel$export(module.exports, "IssueTransitionSubmitUFOExpereince", () => $dda1b5d926efd158$export$bd3bf8b90a131c50);

var $12kyE = parcelRequire("12kyE");
var $kDfSL = parcelRequire("kDfSL");
const $dda1b5d926efd158$export$8fb308d8abecd81a = new (0, $kDfSL.UFOExperience)('issue-transition-screen.transition-load', {
    type: (0, $12kyE.ExperienceTypes).Experience,
    performanceType: (0, $12kyE.ExperiencePerformanceTypes).Custom,
    category: 'issue-transition-screen.transition-load'
});
const $dda1b5d926efd158$export$bd3bf8b90a131c50 = new (0, $kDfSL.UFOExperience)('issue-transition-screen.transition-submit', {
    type: (0, $12kyE.ExperienceTypes).Experience,
    performanceType: (0, $12kyE.ExperiencePerformanceTypes).Custom,
    category: 'issue-transition-screen.transition-sumbit'
});

});

parcelRegister("67xHO", function(module, exports) {

$parcel$export(module.exports, "issueTransitionModalLoad", () => $cdba3bd366b58958$export$772fb4a8bd181fd6);
$parcel$export(module.exports, "issueTransittionModalLoadSubsequent", () => $cdba3bd366b58958$export$afa89f024c56a00a);

var $lEpcX = parcelRequire("lEpcX");
const $cdba3bd366b58958$export$772fb4a8bd181fd6 = (0, $lEpcX.metrics).interaction({
    key: 'issue-transition-modal'
});
const $cdba3bd366b58958$export$afa89f024c56a00a = (0, $lEpcX.metrics).interaction({
    key: 'issue-transition-modal-subsequent'
});

});

parcelRegister("fy5vB", function(module, exports) {

$parcel$export(module.exports, "startUimTTI", () => $cdecbdc0cabe0dc7$export$ae34c17d9cd2c876);
$parcel$export(module.exports, "markIssueTransitionLoaded", () => $cdecbdc0cabe0dc7$export$7cc1bb35860c7c25);
$parcel$export(module.exports, "stopTTI", () => $cdecbdc0cabe0dc7$export$30ca4c461fab486c);
$parcel$export(module.exports, "cancelTTI", () => $cdecbdc0cabe0dc7$export$27f2445288b528c);
$parcel$export(module.exports, "markIframeLoad", () => $cdecbdc0cabe0dc7$export$7a2709fc1e33401a);
$parcel$export(module.exports, "markFieldsRegistered", () => $cdecbdc0cabe0dc7$export$cf3893335c93e33b);
$parcel$export(module.exports, "markOnInitResolved", () => $cdecbdc0cabe0dc7$export$d86f4868694f2aa7);

var $lEpcX = parcelRequire("lEpcX");

var $gGRYc = parcelRequire("gGRYc");
const $cdecbdc0cabe0dc7$var$uimInIssueTransitionTTI = (0, $lEpcX.metrics).interaction({
    key: 'ui-modifications-in-issue-transition',
    timings: [
        {
            key: 'issue-transition-tti-delta',
            startMark: 'issue-transition-tti'
        },
        {
            key: 'script-execution',
            startMark: 'iframe-load'
        },
        {
            key: 'loading-indicators-visibility',
            startMark: 'fields-registered'
        },
        {
            key: 'time-until-oninit-resolved',
            endMark: 'oninit-resolved'
        }
    ],
    featureFlags: (0, $gGRYc.TTIFFs)
});
const $cdecbdc0cabe0dc7$export$ae34c17d9cd2c876 = ()=>{
    $cdecbdc0cabe0dc7$var$uimInIssueTransitionTTI.start();
};
const $cdecbdc0cabe0dc7$export$7cc1bb35860c7c25 = ()=>$cdecbdc0cabe0dc7$var$uimInIssueTransitionTTI.mark('issue-transition-tti');
const $cdecbdc0cabe0dc7$export$30ca4c461fab486c = (customData)=>{
    $cdecbdc0cabe0dc7$var$uimInIssueTransitionTTI.stop({
        customData: customData
    });
};
const $cdecbdc0cabe0dc7$export$27f2445288b528c = ()=>{
    $cdecbdc0cabe0dc7$var$uimInIssueTransitionTTI.cancel();
};
const $cdecbdc0cabe0dc7$export$7a2709fc1e33401a = ()=>{
    $cdecbdc0cabe0dc7$var$uimInIssueTransitionTTI.mark('iframe-load');
};
const $cdecbdc0cabe0dc7$export$cf3893335c93e33b = ()=>{
    $cdecbdc0cabe0dc7$var$uimInIssueTransitionTTI.mark('fields-registered');
};
const $cdecbdc0cabe0dc7$export$d86f4868694f2aa7 = ()=>{
    $cdecbdc0cabe0dc7$var$uimInIssueTransitionTTI.mark('oninit-resolved');
};

});


parcelRegister("7ST5U", function(module, exports) {

$parcel$export(module.exports, "isNewTransitionScreenEnabled", () => $23d7c4603c0324df$export$1f5b72e7dbe0548d);

var $1ybV0 = parcelRequire("1ybV0");
const $23d7c4603c0324df$export$3e9c47f2b27760a = (triggerPointKey)=>{
    const triggerPointsFlags = {
        'issue-transition-issue-view': (0, $1ybV0.ff)('issue-transition-issue-view_yq5a8'),
        'issue-transition-issue-view-shortcut-dialog': (0, $1ybV0.ff)('issue-transition-issue-view-shortcut_lv9l3'),
        'issue-transition-board-card-transition': (0, $1ybV0.ff)('issue-transition-board-card-transition_ciq82'),
        'issue-transition-advanced-roadmaps-jira-transition': (0, $1ybV0.ff)('issue-transition-advanced-roadmaps-jira-transition_b1gmi'),
        'issue-transition-command-palette-status-field-transition': (0, $1ybV0.ff)('issue-transition-command-palette-status-field-transition_ddmcl'),
        'issue-transition-issue-results-shortcut-transition': (0, $1ybV0.ff)('issue-transition-issue-results-shortcut-transition_9jznw'),
        'issue-transition-backlog-inline-transition': (0, $1ybV0.ff)('issue-transition-backlog-inline-transition_2mpzc'),
        'issue-transition-status-field-trigger': (0, $1ybV0.ff)('issue-transition-status-field-trigger_ygzr6'),
        'trigger-point-key-not-defined': (0, $1ybV0.ff)('trigger-point-key-not-defined_cixw0')
    };
    return triggerPointsFlags[triggerPointKey];
};
const $23d7c4603c0324df$export$1f5b72e7dbe0548d = (preferNewIssueTransitionScreen, triggerPointKey)=>{
    if (!(0, $1ybV0.ff)('render-modern-issue-transition_cxt0z')) return false;
    /* DEFAULT VALUE IS FALSE FOR ANY TRIGGER POINT NOT AVAILABLE IN THE MAP ABOVE
	 *  If trigger key is not present, then by default overall ITS will be false.
	 *  For any new trigger point, it must be necessary to list the trigger point in the map above.
	 *  When we cleanup FF for trigger points, then this should be also removed.
	 */ if (!triggerPointKey || !$23d7c4603c0324df$export$3e9c47f2b27760a(triggerPointKey)) return false;
    return preferNewIssueTransitionScreen || (0, $1ybV0.ff)('issue-transition-customisation-for-srb_0eyvc');
};

});


parcelRegister("krvVA", function(module, exports) {

$parcel$export(module.exports, "default", () => $a3e2db18eed05b7b$export$2e2bcd8739ae039);
const $a3e2db18eed05b7b$var$restoreState = (stateToRestore)=>({ setState: setState })=>{
        setState(stateToRestore);
    };
var $a3e2db18eed05b7b$export$2e2bcd8739ae039 = $a3e2db18eed05b7b$var$restoreState;

});

parcelRegister("cqFa9", function(module, exports) {

$parcel$export(module.exports, "default", () => $3e14702d6ab11f2a$export$2e2bcd8739ae039);
/**
 *
 * @deprecated since we should not be using this in the log run
 * we should not call this method any where and should clean this up as soon as GIC-JIS migration is done
 * @param issueId
 * @returns
 */ const $3e14702d6ab11f2a$var$setFetchedIssueId = (issueId)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        const { fetchedIssueId: fetchedIssueId } = currentState;
        if (issueId !== fetchedIssueId) setState({
            ...currentState,
            fetchedIssueId: issueId
        });
    };
var $3e14702d6ab11f2a$export$2e2bcd8739ae039 = $3e14702d6ab11f2a$var$setFetchedIssueId;

});




parcelRegister("6DVVe", function(module, exports) {

$parcel$export(module.exports, "asyncIssueTransitionModal", () => $e3a5a25a56001ff0$export$d06e6b324c2d867a);

var $ld2KQ = parcelRequire("ld2KQ");

var $1K77P = parcelRequire("1K77P");

var $7QhYz = parcelRequire("7QhYz");

const $e3a5a25a56001ff0$var$resource = (0, $1K77P.JSResourceForInteraction)(()=>(parcelRequire("bgPSy")), {
    moduleId: "ae3ffdfd"
});
const $e3a5a25a56001ff0$var$getPreloadProps = (variables)=>({
        queries: {
            issueTransitionInitialQueryRef: {
                parameters: (0, $ld2KQ.default),
                variables: variables,
                options: {
                    fetchPolicy: 'network-only'
                }
            }
        }
    });
const $e3a5a25a56001ff0$export$d06e6b324c2d867a = (0, $7QhYz.createEntryPoint)({
    root: $e3a5a25a56001ff0$var$resource,
    getPreloadProps: $e3a5a25a56001ff0$var$getPreloadProps
});

});
parcelRegister("ld2KQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $1cd02176ebf32d5d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5497ba802b9ee58e694b68fe30323ca3>>
 * @relayHash 6a00c1df44ed1ed8ed55a1cbe73bf142
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1e3c298136c6c01b050498f17e4f135d0f928cb7d8addca4b9a7e57c77ba2461
const $1cd02176ebf32d5d$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "1e3c298136c6c01b050498f17e4f135d0f928cb7d8addca4b9a7e57c77ba2461",
        "metadata": {},
        "name": "main_getIssueTransitionByIdRootQuery",
        "operationKind": "query",
        "text": null
    }
};
var $1cd02176ebf32d5d$export$2e2bcd8739ae039 = $1cd02176ebf32d5d$var$node;

});

parcelRegister("bgPSy", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('h2MrD'),
            load('bYT2S'),
            load('hPzOn'),
            load('31t5H')
        ]);
        const value = parcelRequire('dASO6');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("h2MrD"),
        load("bYT2S"),
        load("hPzOn"),
        load("31t5H")
    ]).then(()=>parcelRequire('dASO6'));
}

});


parcelRegister("7DSZD", function(module, exports) {

$parcel$export(module.exports, "useSiteContextARI", () => $6742605cdac7d518$export$66718c2aeae88580);

var $huI7r = parcelRequire("huI7r");

var $dWLk9 = parcelRequire("dWLk9");
const $6742605cdac7d518$export$66718c2aeae88580 = ()=>{
    const cloudId = (0, $dWLk9.useCloudId)();
    return (0, $huI7r.createAri)({
        resourceOwner: 'jira',
        resourceType: 'site',
        resourceId: cloudId
    });
};

});


parcelRegister("j7vwS", function(module, exports) {

$parcel$export(module.exports, "default", () => $87df48feda6429c4$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $ds5Im = parcelRequire("ds5Im");

var $gUUjF = parcelRequire("gUUjF");

var $6vrw7 = parcelRequire("6vrw7");

var $1Wh0A = parcelRequire("1Wh0A");

var $eV5V8 = parcelRequire("eV5V8");

var $cE0ag = parcelRequire("cE0ag");

var $5Ga7C = parcelRequire("5Ga7C");

var $cpzCu = parcelRequire("cpzCu");

var $gN8r4 = parcelRequire("gN8r4");

var $breL2 = parcelRequire("breL2");

var $5MKHW = parcelRequire("5MKHW");

var $4nWk4 = parcelRequire("4nWk4");
const $87df48feda6429c4$export$87d0ca22edb7493a = 'page-container.navigation.legacy-async-modals';
class $87df48feda6429c4$export$ca935a4305b90cfe extends (0, $eUqFw.Component) {
    constructor(props){
        super(props);
        this.state = {
            ModalComponent: undefined
        };
        const createHandler = (ModalComponent, method)=>(options)=>this.showModal(// @ts-expect-error - TS2322 - Type '{ baseUrl: string; onClose: () => void; onInitiateFailed?: (() => void) | undefined; onInitiateSuccess?: (() => void) | undefined; children?: ReactNode; } | { baseUrl: string; onClose: () => void; ... 6 more ...; isProjectSimplified: boolean; } | ... 5 more ... | { ...; }' is not assignable to type 'IntrinsicAttributes & CProps & { children?: ReactNode; }'.
                (modalProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ModalComponent, {
                        ...options,
                        ...modalProps
                    }), undefined, method);
        this.api = {
            showCreateDashboardModal: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
            showCopyDashboardModal: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
            showEditDashboardModal: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
            showEditFilterModal: createHandler((0, $gN8r4.default), 'showEditFilterModal'),
            showEditPriorityMappingModal: createHandler((0, $breL2.default), 'showEditPriorityMappingModal'),
            showHardDeleteProjectModal: createHandler((0, $5MKHW.default), 'showHardDeleteProjectModal'),
            showConfigureMailServerModal: createHandler((0, $eV5V8.default), 'showConfigureMailServerModal'),
            showSoftDeleteProjectModal: createHandler((0, $4nWk4.default), 'showSoftDeleteProjectModal'),
            showArchiveProjectModal: createHandler((0, $1Wh0A.default), 'showArchiveProjectModal'),
            showConnectIssueModal: createHandler((0, $cE0ag.default), 'showConnectIssueModal'),
            showCustomFieldContextDeleteModal: createHandler((0, $cpzCu.default), 'showCustomFieldContextDeleteModal'),
            showCreateDashboardGadgetModal: createHandler((0, $5Ga7C.default), 'showCreateDashboardGadgetModal')
        };
    }
    componentDidMount() {
        // eslint-disable-next-line jira/wrm/no-load-bridge
        (0, $ds5Im.loadBridgeWeak)({
            name: 'jira/async-modals/bridge'
        })// @ts-expect-error - TS2571 - Object is of type 'unknown'.
        .then((bridge)=>bridge(this.api)).catch((e)=>{
            (0, $gUUjF.default).safeErrorWithoutCustomerData($87df48feda6429c4$export$87d0ca22edb7493a, 'Cannot load the bridge', e);
        });
    }
    showModal(ModalComponent, mountingPromise, method) {
        (0, $gUUjF.default).safeInfoWithoutCustomerData($87df48feda6429c4$export$87d0ca22edb7493a, 'showModal', {
            method: method
        });
        if (this.state.ModalComponent) {
            (0, $gUUjF.default).safeErrorWithoutCustomerData($87df48feda6429c4$export$87d0ca22edb7493a, 'Tried to show the modal while another one is open');
            return undefined;
        }
        if (ModalComponent) {
            this.setState({
                ModalComponent: ModalComponent
            });
            return {
                close: ()=>this.closeModal(ModalComponent),
                mountingPromise: mountingPromise
            };
        }
        (0, $gUUjF.default).safeErrorWithoutCustomerData($87df48feda6429c4$export$87d0ca22edb7493a, 'Tried to show the modal which does not exist');
        return undefined;
    }
    closeModal(ModalComponent) {
        if (this.state.ModalComponent === ModalComponent) this.setState({
            ModalComponent: undefined
        });
        else (0, $gUUjF.default).safeErrorWithoutCustomerData($87df48feda6429c4$export$87d0ca22edb7493a, 'Tried to close the modal which is not open');
    }
    render() {
        const { ModalComponent: ModalComponent } = this.state;
        const { baseUrl: baseUrl } = this.props;
        if (!ModalComponent) return null;
        const onClose = ()=>this.closeModal(ModalComponent);
        // @ts-expect-error - TS2604 - JSX element type 'ModalComponent' does not have any construct or call signatures.
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ModalComponent, {
            baseUrl: (0, $6vrw7.toBaseUrl)(baseUrl),
            onClose: onClose
        });
    }
}
var $87df48feda6429c4$export$2e2bcd8739ae039 = $87df48feda6429c4$export$ca935a4305b90cfe;

});
parcelRegister("1Wh0A", function(module, exports) {

$parcel$export(module.exports, "default", () => $e8198c112abb7493$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $8WuJm = parcelRequire("8WuJm");

var $gXIPA = parcelRequire("gXIPA");

var $c7H0g = parcelRequire("c7H0g");
const $e8198c112abb7493$var$ArchiveProject = ({ baseUrl: baseUrl, onClose: onClose, projectName: projectName, projectId: projectId, projectType: projectType })=>{
    const isAdmin = (0, $c7H0g.useIsAdmin)();
    const onArchiveSuccess = ()=>{
        if (isAdmin) window.location.replace('/jira/settings/projects/manage');
        else window.location.replace('/jira/projects');
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceName: "EditProjectDetails",
        sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gXIPA.default), {
        isProjectSimplified: false,
        onClose: onClose,
        baseUrl: baseUrl,
        projectName: projectName,
        projectId: projectId,
        projectType: projectType,
        onArchiveSuccess: onArchiveSuccess,
        onArchiveSuccessFlagRestore: undefined
    }));
};
var $e8198c112abb7493$export$2e2bcd8739ae039 = $e8198c112abb7493$var$ArchiveProject;

});
parcelRegister("gXIPA", function(module, exports) {

$parcel$export(module.exports, "default", () => $a9a8f51b8296f27b$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $h97Af = parcelRequire("h97Af");

var $0cdA8 = parcelRequire("0cdA8");

var $gGtKh = parcelRequire("gGtKh");


// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $a9a8f51b8296f27b$var$LazyComponent = (0, $7rh0R.lazy)(()=>(parcelRequire("eALjN")), {
    moduleId: "./src/packages/project-pages/project-archive/project-archive-modal/src/index.tsx"
});
const $a9a8f51b8296f27b$var$Component = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        fallback: "flag",
        id: "bundle-async-project-archive-modal",
        packageName: "jira-project-archive-modal"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "project-archive-modal",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h97Af.default), {
            metricKey: (0, $4cc5e2d7e0bd05c3$export$37312a67c3e314c6)
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a9a8f51b8296f27b$var$LazyComponent, props)));
var $a9a8f51b8296f27b$export$2e2bcd8739ae039 = $a9a8f51b8296f27b$var$Component;

});
const $4cc5e2d7e0bd05c3$export$37312a67c3e314c6 = 'PROJECT_ARCHIVE_MODAL_LOAD_START_MARK_KEY';
const $4cc5e2d7e0bd05c3$export$515f0dec8945cffc = 'div[data-test-id="project-archive-modal.ui.archive-modal.modal-footer.close-button-wrapper"]';
const $4cc5e2d7e0bd05c3$export$a374d20c3b9d9d28 = 'div[data-test-id="project-archive-modal.ui.archive-modal.modal-footer.archive-button-wrapper"]';

parcelRegister("eALjN", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('hPzOn'),
            load('8cB4b')
        ]);
        const value = parcelRequire('jSgVy');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("hPzOn"),
        load("8cB4b")
    ]).then(()=>parcelRequire('jSgVy'));
}

});



parcelRegister("eV5V8", function(module, exports) {

$parcel$export(module.exports, "default", () => $95c61bf6b972ab31$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $4wTwC = parcelRequire("4wTwC");
const $95c61bf6b972ab31$var$ConfigureMailServerModal = (props)=>{
    const { onClose: onClose, action: action, id: id, name: name, authenticationType: authenticationType } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4wTwC.default), {
        onClose: onClose,
        action: action,
        id: id,
        name: name,
        authenticationType: authenticationType
    });
};
var $95c61bf6b972ab31$export$2e2bcd8739ae039 = $95c61bf6b972ab31$var$ConfigureMailServerModal;

});
parcelRegister("4wTwC", function(module, exports) {

$parcel$export(module.exports, "default", () => $ec167cf371bc7271$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $h97Af = parcelRequire("h97Af");

var $ciZ8Y = parcelRequire("ciZ8Y");

var $gGtKh = parcelRequire("gGtKh");

var $c1rN8 = parcelRequire("c1rN8");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $ec167cf371bc7271$var$AsyncLazyConfigureMailServerModal = (0, $7rh0R.lazy)(()=>(parcelRequire("fjtSP")), {
    moduleId: "./src/packages/admin-pages/incoming-mail/configure-mail-server-modal/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$ec167cf371bc7271$export$2e2bcd8739ae039 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ciZ8Y.ErrorBoundary), {
        id: "configure-mail-server-modal",
        packageName: "jira-configure-mail-server-modal"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "configure-mail-service-modal",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h97Af.default), {
            metricKey: (0, $c1rN8.LOAD_START_MARK_KEY)
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ec167cf371bc7271$var$AsyncLazyConfigureMailServerModal, props)));

});
parcelRegister("c1rN8", function(module, exports) {

$parcel$export(module.exports, "LOAD_START_MARK_KEY", () => $4485c25ee4295c2e$export$37312a67c3e314c6);
$parcel$export(module.exports, "OAUTH__UPDATE_SERVER_MODAL_ERROR_FLAG", () => $4485c25ee4295c2e$export$a792a4590d58b241);
$parcel$export(module.exports, "OAUTH_SAVE_AND_REAUTHORIZE_SERVER_MODAL_SUCCESS_FLAG", () => $4485c25ee4295c2e$export$5eac226c393e310c);
$parcel$export(module.exports, "OAUTH__SAVE_AND_REAUTHORIZE_SERVER_MODAL_ERROR_FLAG", () => $4485c25ee4295c2e$export$94d27d38e0820c0b);
$parcel$export(module.exports, "CUSTOM_SERVER_MODAL_SUCCESS_FLAG", () => $4485c25ee4295c2e$export$53e713d2a98cd747);
$parcel$export(module.exports, "CUSTOM_SERVER_MODAL_ERROR_FLAG", () => $4485c25ee4295c2e$export$a01d1307b4719d5f);
$parcel$export(module.exports, "ADD_MAIL_SERVER_MODAL", () => $4485c25ee4295c2e$export$3ca722c2d79959e0);
$parcel$export(module.exports, "EDIT_CUSTOM_MAIL_SERVER_MODAL", () => $4485c25ee4295c2e$export$7a0bad9b8f7f5f49);
$parcel$export(module.exports, "EDIT_OAUTH_MAIL_SERVER_MODAL", () => $4485c25ee4295c2e$export$76d6a02740ddbf15);
$parcel$export(module.exports, "ADD_CUSTOM_MAIL_SERVER_MODAL", () => $4485c25ee4295c2e$export$be66491207659cf9);
$parcel$export(module.exports, "DELETE_MAIL_SERVER_MODAL", () => $4485c25ee4295c2e$export$d3334283d631bf5e);
$parcel$export(module.exports, "SAVE_AND_REAUTHORIZE_MAIL_SERVER_MODAL", () => $4485c25ee4295c2e$export$2ff390148e621d72);
$parcel$export(module.exports, "BASIC_DETAILS_MAIL_SERVER_CANCEL_BTN", () => $4485c25ee4295c2e$export$43eff1520f004691);
$parcel$export(module.exports, "SAVE_AND_REAUTHORIZE_MAIL_SERVER_SUBMIT_BTN", () => $4485c25ee4295c2e$export$e7833cf4fbffefad);
$parcel$export(module.exports, "SAVE_AND_REAUTHORIZE_MAIL_SERVER_CANCEL_BTN", () => $4485c25ee4295c2e$export$2834c8c25257c0a);
$parcel$export(module.exports, "DELETE_SERVER_SUBMIT_BTN", () => $4485c25ee4295c2e$export$ee89d62be837cb5c);
$parcel$export(module.exports, "DELETE_SERVER_CANCEL_BTN", () => $4485c25ee4295c2e$export$9cf43e929a820b51);
$parcel$export(module.exports, "CUSTOM_DETAILS_MAIL_SERVER_SAVE_BTN", () => $4485c25ee4295c2e$export$a4061de68765281e);
$parcel$export(module.exports, "CUSTOM_DETAILS_MAIL_SERVER_CANCEL_BTN", () => $4485c25ee4295c2e$export$469099411a8b9fdd);
$parcel$export(module.exports, "GMAIL_SERVICE_KEY", () => $4485c25ee4295c2e$export$9d7fb5252c105003);
$parcel$export(module.exports, "MICROSOFT_SERVICE_KEY", () => $4485c25ee4295c2e$export$55b35aa2fcc524dc);
$parcel$export(module.exports, "getOAuth3LOProvider", () => $4485c25ee4295c2e$export$9624c6d13bd08f09);

var $9dp5m = parcelRequire("9dp5m");
const $4485c25ee4295c2e$export$37312a67c3e314c6 = 'PROJECT_CONFIGURE_MAIL_SERVER_MODAL_LOAD_START_MARK_KEY';
const $4485c25ee4295c2e$export$3815f759c8f9f402 = 'configure-mailserver-modal.ui.delete-mailserver-modal.modal-footer.close-button';
const $4485c25ee4295c2e$export$1400140e7b94f1ed = 'configure-mailserver-modal.ui.delete-mailserver-modal.modal-footer.delete-button';
const $4485c25ee4295c2e$export$1af8dc0354a1479f = 'configure-mailserver-modal.ui.delete-mailserver-modal.flags.delete-success';
const $4485c25ee4295c2e$export$ac16863eedc66f9f = 'configure-mailserver-modal.ui.delete-mailserver-modal.flags.delete-failure';
const $4485c25ee4295c2e$export$d0d1473e2a42510a = 'configure-mail-server-modal.ui.update-oauth-mailserver-modal.modal-footer.save-button';
const $4485c25ee4295c2e$export$c37cb144eea8a3ce = 'configure-mail-server-modal.ui.update-oauth-mailserver-modal.modal-footer.cancel-button';
const $4485c25ee4295c2e$export$683f70b363b05e3e = 'configure-mail-server-modal.ui.update-oauth-mailserver-modal.modal-footer.reauthorize-button';
const $4485c25ee4295c2e$export$3defe4940c34ee3 = 'configure-mailserver-modal.ui.basic-mailserver-modal.flags.create-success';
const $4485c25ee4295c2e$export$7fa7e2bb6a222bc5 = 'configure-mailserver-modal.ui.basic-details-modal.flags.create-failure';
const $4485c25ee4295c2e$export$c38df6eb22bb00d = 'configure-mailserver-modal.ui.update-oauth-mailserver-modal.flags.create-success';
const $4485c25ee4295c2e$export$a792a4590d58b241 = 'configure-mailserver-modal.ui.update-oauth-mailserver-modal.flags.create-failure';
const $4485c25ee4295c2e$export$5eac226c393e310c = 'configure-mailserver-modal.ui.update-oauth-save-and-reauthorize-mailserver-modal.flags.create-success';
const $4485c25ee4295c2e$export$94d27d38e0820c0b = 'configure-mailserver-modal.ui.update-oauth-save-and-reauthorize-mailserver-modal.flags.create-failure';
const $4485c25ee4295c2e$export$369a8649a5caab53 = 'configure-mail-server-modal.ui.custom-mailserver-modal.modal-footer.submit';
const $4485c25ee4295c2e$export$53e713d2a98cd747 = 'configure-mailserver-modal.ui.basic-mailserver-modal.flags.create-success';
const $4485c25ee4295c2e$export$a01d1307b4719d5f = 'configure-mailserver-modal.ui.basic-mailserver-modal.flags.create-failure';
const $4485c25ee4295c2e$export$ee0a64a1db75f705 = 'configure-mailserver-modal.ui.update-oauth-mailserver-modal.save-and-reauthorize-modal.modal-footer.save-and-reauthorize-button';
const $4485c25ee4295c2e$export$f268a53528f3c559 = 'configure-mailserver-modal.ui.update-oauth-mailserver-modal.save-and-reauthorize-modal.modal-footer.close-button';
const $4485c25ee4295c2e$export$22ea0ea53d2d0fa4 = 'configure-mail-server-modal.custom-mailserver-modal.inline-error';
const $4485c25ee4295c2e$export$97537b5daf429030 = 'editMailServer';
const $4485c25ee4295c2e$export$3ca722c2d79959e0 = 'addMailServer';
const $4485c25ee4295c2e$export$7a0bad9b8f7f5f49 = 'editCustomMailServer';
const $4485c25ee4295c2e$export$76d6a02740ddbf15 = 'editOAUTHMailServer';
const $4485c25ee4295c2e$export$be66491207659cf9 = 'addCustomMailServer';
const $4485c25ee4295c2e$export$d3334283d631bf5e = 'deleteMailServer';
const $4485c25ee4295c2e$export$2ff390148e621d72 = 'saveChanges';
const $4485c25ee4295c2e$export$2a4b9cb1acf6eecb = 'saveMailServerButton';
const $4485c25ee4295c2e$export$43eff1520f004691 = 'cancelSaveMailServerButton';
const $4485c25ee4295c2e$export$e7833cf4fbffefad = 'saveMailServerButton';
const $4485c25ee4295c2e$export$2834c8c25257c0a = 'cancelSaveMailServerButton';
const $4485c25ee4295c2e$export$ee89d62be837cb5c = 'confirmDeleteMailServerButton';
const $4485c25ee4295c2e$export$9cf43e929a820b51 = 'cancelDeleteMailServerButton';
const $4485c25ee4295c2e$export$a4061de68765281e = 'saveCustomMailServerButton';
const $4485c25ee4295c2e$export$469099411a8b9fdd = 'cancelSaveCustomMailServerButton';
const $4485c25ee4295c2e$export$9d7fb5252c105003 = 'jira-email-service-gmail';
const $4485c25ee4295c2e$export$55b35aa2fcc524dc = 'jira-email-service-microsoft';
const $4485c25ee4295c2e$export$9624c6d13bd08f09 = ()=>({
        [$4485c25ee4295c2e$export$55b35aa2fcc524dc]: {
            prod: {
                containerId: 'c16a389e-0776-44b3-9528-19c82119a022',
                threeLOUrl: `https://${(0, $9dp5m.getATLContextDomain)('id')}/outboundAuth/v2/start`
            },
            staging: {
                containerId: 'f4b08e22-5fdf-43c0-b33b-5178bbae4caf',
                threeLOUrl: `https://${(0, $9dp5m.getATLContextDomain)('id', [
                    'stg',
                    'commercial'
                ])}/outboundAuth/v2/start`
            },
            dev: {
                containerId: 'f4b08e22-5fdf-43c0-b33b-5178bbae4caf',
                threeLOUrl: `https://${(0, $9dp5m.getATLContextDomain)('id', [
                    'stg',
                    'commercial'
                ])}/outboundAuth/v2/start`
            },
            local: {
                containerId: 'f4b08e22-5fdf-43c0-b33b-5178bbae4caf',
                threeLOUrl: `https://${(0, $9dp5m.getATLContextDomain)('id', [
                    'dev',
                    'commercial'
                ])}/outboundAuth/v2/start`
            }
        },
        [$4485c25ee4295c2e$export$9d7fb5252c105003]: {
            prod: {
                containerId: 'c16a389e-0776-44b3-9528-19c82119a022',
                threeLOUrl: `https://${(0, $9dp5m.getATLContextDomain)('id')}/outboundAuth/v2/start`
            },
            staging: {
                containerId: 'f4b08e22-5fdf-43c0-b33b-5178bbae4caf',
                threeLOUrl: `https://${(0, $9dp5m.getATLContextDomain)('id', [
                    'stg',
                    'commercial'
                ])}/outboundAuth/v2/start`
            },
            dev: {
                containerId: 'f4b08e22-5fdf-43c0-b33b-5178bbae4caf',
                threeLOUrl: `https://${(0, $9dp5m.getATLContextDomain)('id', [
                    'stg',
                    'commercial'
                ])}/outboundAuth/v2/start`
            },
            local: {
                containerId: 'f4b08e22-5fdf-43c0-b33b-5178bbae4caf',
                threeLOUrl: `https://${(0, $9dp5m.getATLContextDomain)('id', [
                    'dev',
                    'commercial'
                ])}/outboundAuth/v2/start`
            }
        }
    });

});

parcelRegister("fjtSP", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('bI9wb');
        const value = parcelRequire('7i2Ra');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("bI9wb").then(()=>parcelRequire('7i2Ra'));
}

});



parcelRegister("cE0ag", function(module, exports) {

$parcel$export(module.exports, "default", () => $3b76ce909a1d7c9d$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $cmF2U = parcelRequire("cmF2U");

var $2f095 = parcelRequire("2f095");
const $3b76ce909a1d7c9d$var$ConnectIssueModal = ({ issueKey: issueKey, onClose: onClose, onCancel: onCancel, onError: onError })=>{
    const onCloseCallback = (0, $eUqFw.useCallback)((props)=>{
        onClose();
        // onCancel might not be defined
        // onCancel might throw an error
        onCancel?.(props);
    }, [
        onCancel,
        onClose
    ]);
    (0, $2f095.useNavigationEffect)(()=>{
        // execute in timeout in order to not let error from onCancel trigger ErrorBoundary
        setTimeout(()=>onCloseCallback(issueKey));
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cmF2U.AsyncConnectModal), {
        issueKey: issueKey,
        onClose: onCloseCallback,
        onError: onError
    });
};
var $3b76ce909a1d7c9d$export$2e2bcd8739ae039 = $3b76ce909a1d7c9d$var$ConnectIssueModal;

});
parcelRegister("cmF2U", function(module, exports) {

$parcel$export(module.exports, "AsyncConnectModal", () => $75c20f87f82d5082$export$114a56bd5931fa2a);
// eslint-disable-next-line jira/restricted/react-component-props

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $gGtKh = parcelRequire("gGtKh");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $75c20f87f82d5082$var$ConnectModal = (0, $7rh0R.lazy)(()=>(parcelRequire("dqH9L")).then(({ ConnectIssueModal: ConnectIssueModal })=>ConnectIssueModal), {
    moduleId: "./src/packages/issue/connect-modal/src/index.tsx"
});
const $75c20f87f82d5082$export$114a56bd5931fa2a = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "connect-issue-modal",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($75c20f87f82d5082$var$ConnectModal, props));

});
parcelRegister("dqH9L", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('bf9ps'),
            load('kWrFZ'),
            load('dsiAd'),
            load('2hmUs'),
            load('bCeK4'),
            load('hPzOn'),
            load('h2MrD'),
            load('bYT2S'),
            load('fOReF')
        ]);
        const value = parcelRequire('hZioB');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("bf9ps"),
        load("kWrFZ"),
        load("dsiAd"),
        load("2hmUs"),
        load("bCeK4"),
        load("hPzOn"),
        load("h2MrD"),
        load("bYT2S"),
        load("fOReF")
    ]).then(()=>parcelRequire('hZioB'));
}

});


parcelRegister("2f095", function(module, exports) {

$parcel$export(module.exports, "useNavigationEffect", () => $073ebefbc226c81a$export$619befab0baf5dd8);

var $eUqFw = parcelRequire("eUqFw");

var $hzcvF = parcelRequire("hzcvF");

var $kJlBc = parcelRequire("kJlBc");
const $073ebefbc226c81a$var$useRouteLocation = (0, $kJlBc.createRouterSelector)(// there are two possible options to use
// `pathname+search` or just `key`
// not using key as it will be updated on hash updates
// subject to change
({ location: location })=>`${location.pathname}?${location.search}`);
const $073ebefbc226c81a$export$619befab0baf5dd8 = (callback)=>{
    const locationKey = $073ebefbc226c81a$var$useRouteLocation();
    const callbackRef = (0, $eUqFw.useRef)(callback);
    callbackRef.current = callback;
    const previousLocationKey = (0, $hzcvF.usePreviousWithInitial)(locationKey);
    // possible improvement: capture and rethrow error in timeout
    // this is not "synchronization" - this is "reaction" similar to "onClick" because it reacts to "onClick" made in different place
    // error throw from useEffect will trigger ErrorBoundary, but error from onClick will not
    // we might need to synchronize their behaviors aka "useSafeEffect" or "useEventEffect"
    (0, $eUqFw.useEffect)(()=>{
        if (previousLocationKey !== locationKey) callbackRef.current();
    }, [
        previousLocationKey,
        locationKey
    ]);
};

});


parcelRegister("5Ga7C", function(module, exports) {

$parcel$export(module.exports, "default", () => $11f948954008d01a$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $cW9Ib = parcelRequire("cW9Ib");

var $kJlBc = parcelRequire("kJlBc");
const $11f948954008d01a$var$CreateDashboardGadgetModal = ({ onClose: onClose, baseUrl: _, onInitiateFailed: __, onInitiateSuccess: ___, ...filterIdOrJql })=>{
    const { push: push } = (0, $kJlBc.useRouterActions)();
    const onSuccess = (dashboardId)=>{
        onClose();
        push(`/jira/dashboards/${dashboardId}/edit`);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cW9Ib.default), {
        onSuccess: onSuccess,
        onCancel: onClose,
        ...filterIdOrJql
    });
};
var $11f948954008d01a$export$2e2bcd8739ae039 = $11f948954008d01a$var$CreateDashboardGadgetModal;

});
parcelRegister("cW9Ib", function(module, exports) {

$parcel$export(module.exports, "default", () => $27fe59e7f6258763$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $51vNN = parcelRequire("51vNN");

var $0cdA8 = parcelRequire("0cdA8");

var $gGtKh = parcelRequire("gGtKh");

// We can't migrate this modal to entrypoints yet because entrypoints currently do not support rendering modals
// in legacy pages
// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $27fe59e7f6258763$var$LazyCreateDashboardGadgetModal = (0, $7rh0R.lazy)(()=>(parcelRequire("2bJZd")), {
    moduleId: "./src/packages/global-pages/dashboard/create-dashboard-gadget-modal/src/main.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$27fe59e7f6258763$export$2e2bcd8739ae039 = ({ onFailed: onFailed = ()=>undefined, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "AsyncCreateDashboardGadgetModal",
        packageName: "jiraDashboardCreateDashboardGadgetModal",
        fallback: "flag",
        onError: onFailed
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "async-create-dashboard-gadget-modal",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $51vNN.default), {
            isTinted: true
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($27fe59e7f6258763$var$LazyCreateDashboardGadgetModal, props)));

});
parcelRegister("2bJZd", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('hPzOn'),
            load('2hmUs'),
            load('bCeK4'),
            load('iz42u')
        ]);
        const value = parcelRequire('lCKfi');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("hPzOn"),
        load("2hmUs"),
        load("bCeK4"),
        load("iz42u")
    ]).then(()=>parcelRequire('lCKfi'));
}

});



parcelRegister("cpzCu", function(module, exports) {

$parcel$export(module.exports, "default", () => $bcebe7a8a3645650$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $hzeYR = parcelRequire("hzeYR");

var $8WuJm = parcelRequire("8WuJm");
const $bcebe7a8a3645650$var$AsyncCustomFieldContextDelete = ({ baseUrl: baseUrl, onClose: onClose, customFieldId: customFieldId, fieldConfigSchemeId: fieldConfigSchemeId, ContextualAnalyticsData: // @ts-expect-error - TS2339 - Property 'ContextualAnalyticsData' does not exist on type 'Props'.
ContextualAnalyticsData = (0, $8WuJm.ContextualAnalyticsData), AsyncCustomFieldContextDeleteModal: // @ts-expect-error - TS2339 - Property 'AsyncCustomFieldContextDeleteModal' does not exist on type 'Props'.
AsyncCustomFieldContextDeleteModal = (0, $hzeYR.default) })=>{
    const onContextDeleteSuccess = ()=>{
        onClose();
        window.location.reload();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ContextualAnalyticsData, {
        sourceName: "CustomFieldContextDetails",
        sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(AsyncCustomFieldContextDeleteModal, {
        baseUrl: baseUrl,
        customFieldId: customFieldId,
        fieldConfigSchemeId: fieldConfigSchemeId,
        onDeleteSuccess: onContextDeleteSuccess,
        onDeleteFailure: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
        onClose: onClose
    }));
};
var $bcebe7a8a3645650$export$2e2bcd8739ae039 = $bcebe7a8a3645650$var$AsyncCustomFieldContextDelete;

});
parcelRegister("hzeYR", function(module, exports) {

$parcel$export(module.exports, "default", () => $cee51467007e720b$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $h97Af = parcelRequire("h97Af");

var $0cdA8 = parcelRequire("0cdA8");

var $fee69 = parcelRequire("fee69");

var $gGtKh = parcelRequire("gGtKh");

const $cee51467007e720b$var$ErrorComponent = ({ error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fee69.ErrorFlagRenderer), {
        id: "bundle-async-custom-field-context-delete-modal",
        error: error
    });

const $cee51467007e720b$var$preloadComponent = ()=>(parcelRequire("fL4aX"));
// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $cee51467007e720b$var$LazyFieldContextDeleteModal = (0, $7rh0R.lazy)(()=>$cee51467007e720b$var$preloadComponent(), {});
function $cee51467007e720b$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "asyncFieldContextDeleteModal",
        packageName: "jiraCustomFieldContextDeleteModal",
        teamName: "morphinecake",
        fallback: $cee51467007e720b$var$ErrorComponent,
        sendToPrivacyUnsafeSplunk: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "field-context-delete-modal",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h97Af.default), {
            metricKey: (0, $219e044e3bc24c7e$export$37312a67c3e314c6)
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cee51467007e720b$var$LazyFieldContextDeleteModal, props)));
}

});
const $219e044e3bc24c7e$export$37312a67c3e314c6 = 'CUSTOM_FIELD_CONTEXT_DELETE_MODAL_LOAD_START_MARK_KEY';
const $219e044e3bc24c7e$export$8264b60fc1e46b36 = 'custom-field-context-delete-modal.ui.actions.cancel-button-wrapper';
const $219e044e3bc24c7e$export$c760e119f8a25963 = 'custom-field-context-delete-modal.ui.actions.delete-button-wrapper';

parcelRegister("fL4aX", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('ccytT');
        const value = parcelRequire('ioqYg');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("ccytT").then(()=>parcelRequire('ioqYg'));
}

});



parcelRegister("gN8r4", function(module, exports) {

$parcel$export(module.exports, "default", () => $ff912401aa8a9b36$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $7OUSe = parcelRequire("7OUSe");
const $ff912401aa8a9b36$var$EditFilter = ({ sharePermissions: sharePermissions, editPermissions: editPermissions, id: id, name: name, description: description, baseUrl: baseUrl, onClose: onClose })=>{
    const onSuccess = ()=>{
        onClose();
        window.location.reload();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7OUSe.default), {
        id: id,
        sharePermissions: sharePermissions,
        editPermissions: editPermissions,
        name: name,
        description: description,
        baseUrl: baseUrl,
        onInitiateSuccess: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
        onCancel: onClose,
        onEdited: onSuccess
    });
};
var $ff912401aa8a9b36$export$2e2bcd8739ae039 = $ff912401aa8a9b36$var$EditFilter;

});
parcelRegister("7OUSe", function(module, exports) {

$parcel$export(module.exports, "default", () => $e7084006fcf294e2$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react-component-props

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $gGtKh = parcelRequire("gGtKh");

const $e7084006fcf294e2$var$RLLAsyncEditFilterModal = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("vQ0bH")), {
    moduleId: "./src/packages/global-pages/directories/filters-directory-v2/edit-filters-modal/src/index.tsx"
});
const $e7084006fcf294e2$var$RLLAsyncEditFilterModalContainer = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "edit-filter-modal",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e7084006fcf294e2$var$RLLAsyncEditFilterModal, props));
var $e7084006fcf294e2$export$2e2bcd8739ae039 = $e7084006fcf294e2$var$RLLAsyncEditFilterModalContainer;

});
parcelRegister("vQ0bH", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('dsiAd'),
            load('hPzOn'),
            load('h2MrD'),
            load('bYT2S'),
            load('iCegE')
        ]);
        const value = parcelRequire('25GDZ');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("dsiAd"),
        load("hPzOn"),
        load("h2MrD"),
        load("bYT2S"),
        load("iCegE")
    ]).then(()=>parcelRequire('25GDZ'));
}

});



parcelRegister("breL2", function(module, exports) {

$parcel$export(module.exports, "default", () => $7fa7748151451e43$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $2jhmq = parcelRequire("2jhmq");
const $7fa7748151451e43$var$EditPriorityMapping = ({ cloudId: cloudId, onClose: onClose, priorities: priorities, defaultPriorityId: defaultPriorityId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2jhmq.AsyncEditPriorityMappingModal), {
        cloudId: cloudId,
        onClose: onClose,
        jiraPriorities: priorities,
        defaultJiraPriorityId: defaultPriorityId
    });
var $7fa7748151451e43$export$2e2bcd8739ae039 = $7fa7748151451e43$var$EditPriorityMapping;

});
parcelRegister("2jhmq", function(module, exports) {

$parcel$export(module.exports, "AsyncEditPriorityMappingModal", () => $489fb0de5294d661$export$209a6ab110d0e343);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $gGtKh = parcelRequire("gGtKh");

const $489fb0de5294d661$var$EditPriorityMappingModal = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("gKdVc")).then((module)=>module.EditPriorityMappingModalApp), {
    moduleId: "./src/packages/servicedesk/incident-management/edit-priority-mapping-modal/src/index.tsx"
});
const $489fb0de5294d661$export$209a6ab110d0e343 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "edit-priority-mapping-modal",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($489fb0de5294d661$var$EditPriorityMappingModal, props));

});
parcelRegister("gKdVc", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('2hmUs'),
            load('bCeK4'),
            load('hPzOn'),
            load('UUqzq')
        ]);
        const value = parcelRequire('8Ipqg');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("2hmUs"),
        load("bCeK4"),
        load("hPzOn"),
        load("UUqzq")
    ]).then(()=>parcelRequire('8Ipqg'));
}

});



parcelRegister("5MKHW", function(module, exports) {

$parcel$export(module.exports, "default", () => $daccb7dba647e6cb$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $8WuJm = parcelRequire("8WuJm");

var $aLVzQ = parcelRequire("aLVzQ");
const $daccb7dba647e6cb$var$AsyncHardDeleteProject = ({ baseUrl: baseUrl, onClose: onClose, projectName: projectName, projectId: projectId, projectType: projectType, isProjectSimplified: isProjectSimplified, ContextualAnalyticsData: // @ts-expect-error - TS2339 - Property 'ContextualAnalyticsData' does not exist on type 'Props'.
ContextualAnalyticsData = (0, $8WuJm.ContextualAnalyticsData), AsyncHardDeleteProjectModal: // @ts-expect-error - TS2339 - Property 'AsyncHardDeleteProjectModal' does not exist on type 'Props'.
AsyncHardDeleteProjectModal = (0, $aLVzQ.default) })=>{
    const onProjectActionSuccess = ()=>{
        onClose();
        window.location.replace(`${baseUrl}/jira/your-work`);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ContextualAnalyticsData, {
        sourceName: "EditProjectDetails",
        sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(AsyncHardDeleteProjectModal, {
        onClose: onClose,
        baseUrl: baseUrl,
        projectName: projectName,
        projectType: projectType,
        projectId: projectId,
        isProjectSimplified: isProjectSimplified,
        onProjectDeleteSuccess: onProjectActionSuccess,
        onProjectDeleteFailure: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
    }));
};
var $daccb7dba647e6cb$export$2e2bcd8739ae039 = $daccb7dba647e6cb$var$AsyncHardDeleteProject;

});
parcelRegister("aLVzQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $01e58783968b453b$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $h97Af = parcelRequire("h97Af");

var $0cdA8 = parcelRequire("0cdA8");

var $gGtKh = parcelRequire("gGtKh");


// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $01e58783968b453b$var$LazyComponent = (0, $7rh0R.lazy)(()=>(parcelRequire("aGiSe")), {
    moduleId: "./src/packages/project-pages/project-restore/project-permanent-delete-modal/src/index.tsx"
});
const $01e58783968b453b$var$Component = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        fallback: "flag",
        id: "bundle-async-project-permanent-delete-modal",
        packageName: "jira-project-permanent-delete-modal"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "project-permanent-delete-modal",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h97Af.default), {
            metricKey: (0, $507e10f94149943e$export$37312a67c3e314c6)
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($01e58783968b453b$var$LazyComponent, props)));
var $01e58783968b453b$export$2e2bcd8739ae039 = $01e58783968b453b$var$Component;

});
const $507e10f94149943e$export$37312a67c3e314c6 = 'PROJECT_PERMANENT_DELETE_MODAL_LOAD_START_MARK_KEY';

parcelRegister("aGiSe", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('hPzOn'),
            load('dsiAd'),
            load('k5i7W')
        ]);
        const value = parcelRequire('42UYU');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("hPzOn"),
        load("dsiAd"),
        load("k5i7W")
    ]).then(()=>parcelRequire('42UYU'));
}

});



parcelRegister("4nWk4", function(module, exports) {

$parcel$export(module.exports, "default", () => $2684325460266d5f$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $8WuJm = parcelRequire("8WuJm");

var $2nKQI = parcelRequire("2nKQI");

var $c7H0g = parcelRequire("c7H0g");
const $2684325460266d5f$var$AsyncSoftDeleteProject = ({ baseUrl: baseUrl, onClose: onClose, projectName: projectName, projectId: projectId, projectType: projectType, isProjectSimplified: isProjectSimplified })=>{
    const isAdmin = (0, $c7H0g.useIsAdmin)();
    const onDeleteProjectSuccess = ()=>{
        onClose();
        if (isAdmin) window.location.replace('/jira/settings/projects/manage');
        else window.location.replace('/jira/projects');
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceName: "EditProjectDetails",
        sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2nKQI.default), {
        onClose: onClose,
        baseUrl: baseUrl,
        projectName: projectName,
        projectType: projectType,
        projectId: projectId,
        isProjectSimplified: isProjectSimplified,
        onDeleteProjectSuccess: onDeleteProjectSuccess,
        onDeleteProjectFailure: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
        onDeleteSuccessFlagRestore: undefined
    }));
};
var $2684325460266d5f$export$2e2bcd8739ae039 = $2684325460266d5f$var$AsyncSoftDeleteProject;

});
parcelRegister("2nKQI", function(module, exports) {

$parcel$export(module.exports, "default", () => $88369e2b2439803c$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $h97Af = parcelRequire("h97Af");

var $0cdA8 = parcelRequire("0cdA8");

var $gGtKh = parcelRequire("gGtKh");


// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $88369e2b2439803c$var$LazyComponent = (0, $7rh0R.lazy)(()=>(parcelRequire("jFokq")), {
    moduleId: "./src/packages/project-pages/project-restore/project-soft-delete-modal/src/index.tsx"
});
const $88369e2b2439803c$var$Component = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        fallback: "flag",
        id: "bundle-async-project-soft-delete-modal-errors",
        packageName: "jira-project-soft-delete-modal"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "project-soft-delete-modal",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h97Af.default), {
            metricKey: (0, $6013c7debe0a67fc$export$37312a67c3e314c6)
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($88369e2b2439803c$var$LazyComponent, props)));
var $88369e2b2439803c$export$2e2bcd8739ae039 = $88369e2b2439803c$var$Component;

});
const $6013c7debe0a67fc$export$37312a67c3e314c6 = 'PROJECT_SOFT_DELETE_MODAL_LOAD_START_MARK_KEY';

parcelRegister("jFokq", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('dsiAd'),
            load('hPzOn'),
            load('8wKid')
        ]);
        const value = parcelRequire('9kxHQ');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("dsiAd"),
        load("hPzOn"),
        load("8wKid")
    ]).then(()=>parcelRequire('9kxHQ'));
}

});




parcelRegister("fU0TK", function(module, exports) {

$parcel$export(module.exports, "default", () => $11a0e42ee8132009$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $ciZ8Y = parcelRequire("ciZ8Y");

var $gGtKh = parcelRequire("gGtKh");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $11a0e42ee8132009$var$NewIssueCreateTrigger = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("54D6s")), {
    ssr: false,
    moduleId: "./src/packages/issue-create/new-issue-create-trigger/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$11a0e42ee8132009$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ciZ8Y.ErrorBoundary), {
        id: "async.jira.new-issue-create-trigger",
        packageName: "jiraNewIssueCreateTrigger"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "new-issue-create-trigger",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($11a0e42ee8132009$var$NewIssueCreateTrigger, null)));

});
parcelRegister("54D6s", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('8e0Dk');
        const value = parcelRequire('5bBud');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("8e0Dk").then(()=>parcelRequire('5bBud'));
}

});


parcelRegister("1oCC5", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c23ef2d42e42531$export$2e2bcd8739ae039);

var $2k89Y = parcelRequire("2k89Y");
var $7c23ef2d42e42531$export$2e2bcd8739ae039 = (0, $2k89Y.default);

});
parcelRegister("2k89Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $70ae92cbad0da713$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7rh0R = parcelRequire("7rh0R");

var $f7cA2 = parcelRequire("f7cA2");

var $jWuk1 = parcelRequire("jWuk1");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $4Bees = parcelRequire("4Bees");

var $aR8n6 = parcelRequire("aR8n6");

var $1ybV0 = parcelRequire("1ybV0");

var $7LFzI = parcelRequire("7LFzI");
var $5JgJ2 = parcelRequire("5JgJ2");

var $gGtKh = parcelRequire("gGtKh");

var $dYnI4 = parcelRequire("dYnI4");


var $26yXe = parcelRequire("26yXe");

var $kgHxg = parcelRequire("kgHxg");
const $70ae92cbad0da713$var$CrossIconMedium = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jWuk1))), {
        size: "medium",
        label: formatMessage((0, $kgHxg.default).close)
    });
};

const $70ae92cbad0da713$export$3039dc74ce32c9c8 = (0, $7rh0R.lazy)(()=>{
    (0, $dYnI4.monitor).startTask((0, $87a0abe4cc67502d$export$9a977208af30ffae));
    return (parcelRequire("8uuRQ")).then((module)=>module.default);
}, {
    ssr: false,
    moduleId: "./src/packages/portfolio-3/create-new-plan-wizard-drawer/src/ui/old-content/index.tsx"
});

const $70ae92cbad0da713$export$d7c17b78c88cc2fc = (0, $7rh0R.lazy)(()=>{
    (0, $dYnI4.monitor).startTask((0, $87a0abe4cc67502d$export$9a977208af30ffae));
    return (parcelRequire("31Z6M")).then((module)=>module.default);
}, {
    ssr: false,
    moduleId: "./src/packages/portfolio-3/create-new-plan-wizard-drawer/src/ui/content/index.tsx"
});
const $70ae92cbad0da713$var$CreateNewPlanWizardDrawer = ()=>{
    const [{ isOpen: isOpen, plan: plan }, { closeDrawer: closeDrawer }] = (0, $26yXe.useCreateNewPlanWizardDrawer)();
    const { loading: loading, intlMessages: intlMessages, locale: locale } = (0, $26yXe.useImportedMessagesForLocale)();
    const keepMounted = (0, $eUqFw.useRef)(false);
    if (!keepMounted.current && !isOpen) return null;
    // Keep mounted to Drawer close animation works
    if (!keepMounted.current) keepMounted.current = true;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const handleRequestClose = (e)=>{
        if (e.key === 'Escape') return;
        closeDrawer();
    };
    const spinner = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($70ae92cbad0da713$var$Center, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), {
        size: "xlarge"
    }));
    // Wrapping the AsyncPlanWizard component directly in Placeholder results the Drawer
    // flickering when it is opened immediately after the /plans page loads - either through
    // the create-plan=true query param, or by quickly clicking the top RHS Create plan
    // button. Wrapping the parent Drawer in Placeholder resolves this issue.
    const content = (()=>{
        if (loading) return spinner;
        if (!intlMessages) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($70ae92cbad0da713$export$3039dc74ce32c9c8, {
            plan: plan
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7LFzI.IntlProvider), {
            messages: intlMessages,
            locale: locale
        }, (0, $1ybV0.ff)('sploverview-create-experience') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($70ae92cbad0da713$export$d7c17b78c88cc2fc, {
            plan: plan
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($70ae92cbad0da713$export$3039dc74ce32c9c8, {
            plan: plan
        }));
    })();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "create-new-plan-wizard",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $f7cA2.default), {
        isOpen: isOpen,
        width: "full",
        onClose: handleRequestClose,
        icon: $70ae92cbad0da713$var$CrossIconMedium
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $70ae92cbad0da713$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aR8n6.default), {
        id: (0, $87a0abe4cc67502d$export$b8b9d90f9e5bd72b),
        packageName: (0, $87a0abe4cc67502d$export$b8b9d90f9e5bd72b),
        teamName: (0, $87a0abe4cc67502d$export$cfeee2ee86ead336),
        sendToPrivacyUnsafeSplunk: true
    }, content))));
};
var $70ae92cbad0da713$export$2e2bcd8739ae039 = $70ae92cbad0da713$var$CreateNewPlanWizardDrawer;
const $70ae92cbad0da713$var$containerStyles = (0, $1ZAYh.xcss)({
    marginTop: 'space.300'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $70ae92cbad0da713$var$Center = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _4t3id81e _c71l1w2c",
            __cmplp.className
        ])
    });
});

});
parcelRegister("f7cA2", function(module, exports) {

$parcel$export(module.exports, "default", () => $b01144a46d3facbb$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $eUqFw = parcelRequire("eUqFw");

var $kQ44K = parcelRequire("kQ44K");

var $hM7RE = parcelRequire("hM7RE");
var $1ngde = parcelRequire("1ngde");
var $2jDha = parcelRequire("2jDha");

var $gmZvv = parcelRequire("gmZvv");

var $pcrEK = parcelRequire("pcrEK");

var $3GGfx = parcelRequire("3GGfx");

var $55qpt = parcelRequire("55qpt");
const $b01144a46d3facbb$var$packageName = "@atlaskit/drawer";
const $b01144a46d3facbb$var$packageVersion = "7.11.0";
const $b01144a46d3facbb$var$createAndFireEventOnAtlaskit = (0, $hM7RE.default)('atlaskit');
const $b01144a46d3facbb$var$createAndFireOnClick = (createAnalyticsEvent, trigger)=>$b01144a46d3facbb$var$createAndFireEventOnAtlaskit({
        action: 'dismissed',
        actionSubject: 'drawer',
        attributes: {
            componentName: 'drawer',
            packageName: $b01144a46d3facbb$var$packageName,
            packageVersion: $b01144a46d3facbb$var$packageVersion,
            trigger: trigger
        }
    })(createAnalyticsEvent);
class $b01144a46d3facbb$export$b66bc6457778cdcb extends (0, $eUqFw.Component) {
    constructor(...args){
        super(...args);
        (0, $5zQU9.default)(this, "state", {
            renderPortal: false
        });
        (0, $5zQU9.default)(this, "body", (0, $kQ44K.canUseDOM) ? document.querySelector('body') : undefined);
        (0, $5zQU9.default)(this, "handleBlanketClick", (event)=>{
            this.handleClose(event, 'blanket');
        });
        (0, $5zQU9.default)(this, "handleBackButtonClick", (event)=>{
            this.handleClose(event, 'backButton');
        });
        (0, $5zQU9.default)(this, "handleClose", (event, trigger)=>{
            const { createAnalyticsEvent: createAnalyticsEvent, onClose: onClose } = this.props;
            const analyticsEvent = createAnalyticsEvent && $b01144a46d3facbb$var$createAndFireOnClick(createAnalyticsEvent, trigger);
            if (onClose) onClose(event, analyticsEvent);
        });
        (0, $5zQU9.default)(this, "handleKeyDown", (event)=>{
            const { isOpen: isOpen, onKeyDown: onKeyDown } = this.props;
            if (event.key === 'Escape' && isOpen) this.handleClose(event, 'escKey');
            if (onKeyDown) onKeyDown(event);
        });
    }
    componentDidMount() {
        const { isOpen: isOpen } = this.props;
        if (isOpen) window.addEventListener('keydown', this.handleKeyDown);
    }
    componentWillUnmount() {
        window.removeEventListener('keydown', this.handleKeyDown);
    }
    componentDidUpdate(prevProps) {
        const { isOpen: isOpen } = this.props;
        if (isOpen !== prevProps.isOpen) {
            if (isOpen) window.addEventListener('keydown', this.handleKeyDown);
            else window.removeEventListener('keydown', this.handleKeyDown);
        }
    }
    render() {
        if (!this.body) return null;
        const { testId: testId, isOpen: isOpen, children: children, icon: icon, closeLabel: closeLabel, scrollContentLabel: scrollContentLabel, width: width, shouldUnmountOnExit: shouldUnmountOnExit, onCloseComplete: onCloseComplete, onOpenComplete: onOpenComplete, autoFocusFirstElem: autoFocusFirstElem, isFocusLockEnabled: isFocusLockEnabled, shouldReturnFocus: shouldReturnFocus, overrides: overrides, zIndex: zIndex = 'unset', label: label, titleId: titleId } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gmZvv.default), {
            zIndex: zIndex
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3GGfx.default), {
            isOpen: isOpen,
            onBlanketClicked: this.handleBlanketClick,
            testId: testId && `${testId}--blanket`
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $55qpt.default), {
            testId: testId,
            icon: icon,
            closeLabel: closeLabel,
            in: isOpen,
            onClose: this.handleBackButtonClick,
            onCloseComplete: onCloseComplete,
            onOpenComplete: onOpenComplete,
            width: width,
            label: label,
            titleId: titleId,
            shouldUnmountOnExit: shouldUnmountOnExit,
            overrides: overrides,
            autoFocusFirstElem: autoFocusFirstElem,
            isFocusLockEnabled: isFocusLockEnabled,
            shouldReturnFocus: shouldReturnFocus,
            scrollContentLabel: scrollContentLabel
        }, children));
    }
}
(0, $5zQU9.default)($b01144a46d3facbb$export$b66bc6457778cdcb, "defaultProps", {
    width: 'narrow',
    ...(0, $pcrEK.defaultFocusLockSettings)
});
var $b01144a46d3facbb$export$2e2bcd8739ae039 = (0, $1ngde.default)({
    componentName: 'drawer',
    packageName: $b01144a46d3facbb$var$packageName,
    packageVersion: $b01144a46d3facbb$var$packageVersion
})((0, $2jDha.default)()($b01144a46d3facbb$export$b66bc6457778cdcb));

});
parcelRegister("pcrEK", function(module, exports) {

$parcel$export(module.exports, "transitionDurationMs", () => $04bbfd3ee965b452$export$614e920ab938d7a6);
$parcel$export(module.exports, "animationTimingFunction", () => $04bbfd3ee965b452$export$aa1acbd7fbaf45a2);
$parcel$export(module.exports, "defaultFocusLockSettings", () => $04bbfd3ee965b452$export$95a69bf7d3b83292);

const $04bbfd3ee965b452$export$3105270315df0e7 = '0.22s';
const $04bbfd3ee965b452$export$614e920ab938d7a6 = 220;
const $04bbfd3ee965b452$export$5cc90842f5a0bf76 = (0, $d58b680a02f4d6a4$export$57636bb43b1ccbb0);
const $04bbfd3ee965b452$export$790206ddaae8bb6a = [
    'narrow',
    'medium',
    'wide',
    'extended',
    'full'
];
const $04bbfd3ee965b452$export$aa1acbd7fbaf45a2 = ()=>(0, $d58b680a02f4d6a4$export$57636bb43b1ccbb0);
const $04bbfd3ee965b452$export$95a69bf7d3b83292 = {
    isFocusLockEnabled: true,
    shouldReturnFocus: true,
    autoFocusFirstElem: true
};

});
const $d58b680a02f4d6a4$export$c07234257a03d5e9 = 'cubic-bezier(0.15,1,0.3,1)';
const $d58b680a02f4d6a4$export$57636bb43b1ccbb0 = 'cubic-bezier(0.2,0,0,1)';
const $d58b680a02f4d6a4$export$929e5a82286172a6 = 'cubic-bezier(0.8,0,0,0.8)';


parcelRegister("3GGfx", function(module, exports) {

$parcel$export(module.exports, "default", () => $2af61141ad88993b$export$2e2bcd8739ae039);
/** @jsx jsx */ parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $51vNN = parcelRequire("51vNN");

var $lSV8Z = parcelRequire("lSV8Z");
var $hYDGa = parcelRequire("hYDGa");

var $pcrEK = parcelRequire("pcrEK");
const $2af61141ad88993b$var$blanketStyles = (0, $byn9U.css)({
    position: 'relative'
});
/**
 * A wrapper around `@atlaskit/blanket` that adds a fade in/out transition.
 */ const $2af61141ad88993b$var$Blanket = ({ isOpen: isOpen, onBlanketClicked: onBlanketClicked, testId: testId })=>{
    return (0, $byn9U.jsx)((0, $lSV8Z.default), {
        appear: true
    }, isOpen && (0, $byn9U.jsx)((0, $hYDGa.default), {
        duration: (0, $pcrEK.transitionDurationMs) * 2,
        animationTimingFunction: (0, $pcrEK.animationTimingFunction)
    }, ({ className: className })=>// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        (0, $byn9U.jsx)("div", {
            css: $2af61141ad88993b$var$blanketStyles,
            className: className
        }, (0, $byn9U.jsx)((0, $51vNN.default), {
            isTinted: true,
            onBlanketClicked: onBlanketClicked,
            testId: testId && testId
        }))));
};
var $2af61141ad88993b$export$2e2bcd8739ae039 = $2af61141ad88993b$var$Blanket;

});

parcelRegister("55qpt", function(module, exports) {

$parcel$export(module.exports, "default", () => $3b41e7d50c84cff7$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $j9fWg = parcelRequire("j9fWg");

var $gpZWO = parcelRequire("gpZWO");

var $lSV8Z = parcelRequire("lSV8Z");
var $2EVgw = parcelRequire("2EVgw");

var $pcrEK = parcelRequire("pcrEK");

var $tj6J9 = parcelRequire("tj6J9");

var $tbYSr = parcelRequire("tbYSr");

var $eVytO = parcelRequire("eVytO");

var $jwJeZ = parcelRequire("jwJeZ");

var $5Up2o = parcelRequire("5Up2o");
// Misc.
// ------------------------------
const $3b41e7d50c84cff7$var$defaults = {
    Sidebar: (0, $5Up2o.default),
    Content: (0, $tbYSr.default)
};
/**
 * This wrapper is used to specify separate durations for enter and exit.
 */ const $3b41e7d50c84cff7$var$CustomSlideIn = ({ children: children, onFinish: onFinish })=>{
    const { isExiting: isExiting } = (0, $lSV8Z.useExitingPersistence)();
    /**
   * The actual duration should be the same for both enter and exit,
   * but motion halves the passed duration for exit animations,
   * so we double it when exiting.
   */ const duration = isExiting ? (0, $pcrEK.transitionDurationMs) * 2 : (0, $pcrEK.transitionDurationMs);
    return (0, $byn9U.jsx)((0, $2EVgw.default), {
        animationTimingFunction: (0, $pcrEK.animationTimingFunction),
        duration: duration,
        enterFrom: "left",
        exitTo: "left",
        fade: "none",
        onFinish: onFinish
    }, children);
};
const $3b41e7d50c84cff7$var$DrawerPrimitive = ({ children: children, icon: Icon, closeLabel: closeLabel = 'Close drawer', scrollContentLabel: scrollContentLabel, onClose: onClose, onCloseComplete: onCloseComplete, onOpenComplete: onOpenComplete, overrides: overrides, testId: testId, in: isOpen, shouldReturnFocus: shouldReturnFocus, autoFocusFirstElem: autoFocusFirstElem, isFocusLockEnabled: isFocusLockEnabled, width: width, label: label, titleId: titleId })=>{
    const getOverrides = (0, $tj6J9.createExtender)($3b41e7d50c84cff7$var$defaults, overrides);
    const { component: Sidebar, ...sideBarOverrides } = getOverrides('Sidebar');
    const { component: Content, ...contentOverrides } = getOverrides('Content');
    /**
   * A ref to point to our wrapper, passed to `onCloseComplete` and `onOpenComplete` callbacks.
   */ const drawerRef = (0, $eUqFw.useRef)(null);
    const onFinish = (0, $eUqFw.useCallback)((state)=>{
        if (state === 'entering') onOpenComplete === null || onOpenComplete === void 0 || onOpenComplete(drawerRef.current);
        else if (state === 'exiting') onCloseComplete === null || onCloseComplete === void 0 || onCloseComplete(drawerRef.current);
    }, [
        onCloseComplete,
        onOpenComplete
    ]);
    return (0, $byn9U.jsx)((0, $lSV8Z.default), {
        appear: true
    }, isOpen && (0, $byn9U.jsx)($3b41e7d50c84cff7$var$CustomSlideIn, {
        onFinish: onFinish
    }, ({ className: className })=>(0, $byn9U.jsx)((0, $jwJeZ.default), {
            autoFocusFirstElem: autoFocusFirstElem,
            isFocusLockEnabled: isFocusLockEnabled,
            shouldReturnFocus: shouldReturnFocus
        }, (0, $byn9U.jsx)((0, $eVytO.default), {
            className: className,
            width: width,
            testId: testId,
            drawerRef: drawerRef,
            label: label,
            titleId: titleId
        }, (0, $byn9U.jsx)(Sidebar, sideBarOverrides, (0, $byn9U.jsx)((0, $j9fWg.default), {
            onClick: onClose,
            testId: testId && 'DrawerPrimitiveSidebarCloseButton',
            icon: Icon ? (iconProps)=>(0, $byn9U.jsx)(Icon, (0, $kU09D.default)({}, iconProps, {
                    size: "large"
                })) : (0, (/*@__PURE__*/$parcel$interopDefault($gpZWO))),
            label: closeLabel,
            shape: "circle",
            appearance: "subtle"
        })), (0, $byn9U.jsx)(Content, (0, $kU09D.default)({
            scrollContentLabel: scrollContentLabel
        }, contentOverrides), children)))));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$3b41e7d50c84cff7$export$2e2bcd8739ae039 = $3b41e7d50c84cff7$var$DrawerPrimitive;

});
parcelRegister("gpZWO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bf3f089e16becc19$var$_react = $bf3f089e16becc19$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $bf3f089e16becc19$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $bf3f089e16becc19$var$ArrowLeftIcon = (props)=>/*#__PURE__*/ $bf3f089e16becc19$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill-rule="evenodd" clip-rule="evenodd" d="M12.207 5.793a1 1 0 010 1.414L8.414 11H18a1 1 0 110 2H8.414l3.793 3.793a1 1 0 11-1.415 1.414l-5.499-5.5A.997.997 0 015 12.028v-.057a.996.996 0 01.293-.678l5.499-5.5a1 1 0 011.415 0z" fill="currentColor"/></svg>`
    }, props));
$bf3f089e16becc19$var$ArrowLeftIcon.displayName = 'ArrowLeftIcon';
var $bf3f089e16becc19$var$_default = $bf3f089e16becc19$var$ArrowLeftIcon;
module.exports.default = $bf3f089e16becc19$var$_default;

});

parcelRegister("tj6J9", function(module, exports) {

$parcel$export(module.exports, "createExtender", () => $058187e674ca8ea5$export$3f052dbd10b2d4da);
// eslint-disable-next-line @repo/internal/react/consistent-types-definitions
/**
 * @deprecated Please avoid using this function as we intend to remote it in a future release. See DSP-2673 for more information.
 */ const $058187e674ca8ea5$export$3f052dbd10b2d4da = function createExtender(defaults, /**
 * We're defaulting to an Object.create call here to circumvent
 *  the fact that {} can't be reconciled
 *  with a type that extends Record<string, any>
 *
 *  By doing this, we are intentionally disallowing users
 *  from nullifying a particular component in the tree.
 *  This can be reverted with additional logic,
 *  at such a time as this nullification becomes an actual usecase.
 */ overrides = Object.create(Object.prototype)) {
    if (!defaults) throw new Error('a default set of overrides *must* be passed in as the first argument');
    return function getOverrides(key) {
        const { cssFn: defaultCssFn, component: defaultComponent } = defaults[key];
        if (!overrides[key]) return {
            cssFn: defaultCssFn,
            component: defaultComponent
        };
        const { cssFn: customCssFn, component: customComponent } = overrides[key];
        const composedCssFn = (state)=>{
            return customCssFn(defaultCssFn(state), state);
        };
        return {
            cssFn: customCssFn ? composedCssFn : defaultCssFn,
            component: customComponent || defaultComponent
        };
    };
};

});

parcelRegister("tbYSr", function(module, exports) {

$parcel$export(module.exports, "default", () => $057c00b3fac7ab27$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");
const $057c00b3fac7ab27$var$defaultStyles = {
    flex: 1,
    overflow: 'auto',
    marginTop: "var(--ds-space-300, 24px)"
};
const $057c00b3fac7ab27$var$contentCSS = ()=>$057c00b3fac7ab27$var$defaultStyles;
const $057c00b3fac7ab27$var$Content = ({ cssFn: cssFn, scrollContentLabel: scrollContentLabel = 'Scrollable content', ...props })=>{
    const [showContentFocus, setContentFocus] = (0, $eUqFw.useState)(false);
    const scrollableRef = (0, $eUqFw.useRef)(null);
    (0, $eUqFw.useEffect)(()=>{
        const setLazyContentFocus = ()=>{
            const target = scrollableRef.current;
            target && setContentFocus(target.scrollHeight > target.clientHeight);
        };
        setLazyContentFocus();
    }, []);
    /**
   * I noticed the implementation at @atlaskit/checkbox would send the props to cssFn rather
   * than the defaultStyles as the overrides guide suggests. I went with what the overrides
   * guide suggested as it made more sense as a transformer of the current styles rather than
   * a complete override with no chance of partially changing styles.
   */ return (0, $byn9U.jsx)("div", (0, $kU09D.default)({
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        css: (0, $byn9U.css)(cssFn($057c00b3fac7ab27$var$defaultStyles)),
        ref: scrollableRef,
        tabIndex: showContentFocus ? 0 : undefined,
        role: showContentFocus ? 'region' : undefined,
        "aria-label": showContentFocus ? scrollContentLabel : undefined,
        "data-testId": "drawer-contents"
    }, props));
};
var $057c00b3fac7ab27$export$2e2bcd8739ae039 = {
    component: $057c00b3fac7ab27$var$Content,
    cssFn: $057c00b3fac7ab27$var$contentCSS
};

});

parcelRegister("eVytO", function(module, exports) {

$parcel$export(module.exports, "default", () => $ade1228b49ca6a77$export$2e2bcd8739ae039);
/** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $kkWA2 = parcelRequire("kkWA2");

var $PdmhA = parcelRequire("PdmhA");

var $kyri3 = parcelRequire("kyri3");

var $4CLHB = parcelRequire("4CLHB");
const $ade1228b49ca6a77$export$f693ac40d0904cc2 = {
    full: {
        width: '100vw'
    },
    extended: {
        width: '95vw'
    },
    narrow: {
        width: 360
    },
    medium: {
        width: 480
    },
    wide: {
        width: 600
    }
};
const $ade1228b49ca6a77$var$wrapperStyles = (0, $byn9U.css)({
    display: 'flex',
    height: '100vh',
    position: 'fixed',
    zIndex: 500,
    backgroundColor: `var(--ds-surface-overlay, ${(0, $PdmhA.N0)})`,
    [(0, $kyri3.CURRENT_SURFACE_CSS_VAR)]: `var(--ds-surface-overlay, ${(0, $PdmhA.N0)})`,
    insetBlockStart: 0,
    insetInlineStart: 0,
    overflow: 'hidden'
});
/**
 * A wrapper that controls the styling of the drawer with a few hacks with refs to get our Touch±Scroll locks working.
 */ const $ade1228b49ca6a77$var$DrawerWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ children: children, className: className, width: width = 'narrow', testId: testId, drawerRef: drawerRef, label: label, titleId: titleId }, scrollRef)=>{
    /**
   * We use a callback ref to assign the `<Content />` component to the forwarded `scrollRef`.
   * This ref comes from `react-scrolllock` to allow touch scrolling, eg.: `<ScrollLock><TouchScrollable>{children}</TouchScrollable><ScrollLock>`
   *
   * This is because we do not control the `<Content />` component in order to forward a ref to it (given it can be overriden via `DrawerPrimitiveProps['overrides']['Content']['component']`).
   * Additionally, we target the last child because with `props.overrides.Sidebar.component = () => null` you only have one child.
   * If both `Sidebar.component` and `Content.component` return null you will have no children and this will throw an error, but that doesn't seem valid.
   */ const assignSecondChildRef = (0, $eUqFw.useCallback)((node)=>{
        var _node$children;
        if (node !== null && node !== void 0 && (_node$children = node.children) !== null && _node$children !== void 0 && _node$children.length && typeof scrollRef === 'function') scrollRef(node.children[node.children.length - 1]);
    }, [
        scrollRef
    ]);
    const ref = (0, $kkWA2.useMergeRefs)([
        drawerRef,
        assignSecondChildRef
    ]);
    (0, $4CLHB.default)();
    return (0, $byn9U.jsx)("div", {
        css: $ade1228b49ca6a77$var$wrapperStyles,
        style: $ade1228b49ca6a77$export$f693ac40d0904cc2[width],
        className: className,
        "data-testid": testId,
        ref: ref,
        "aria-modal": true,
        role: "dialog",
        "aria-label": label,
        "aria-labelledby": titleId
    }, children);
});
var $ade1228b49ca6a77$export$2e2bcd8739ae039 = $ade1228b49ca6a77$var$DrawerWrapper;

});
parcelRegister("4CLHB", function(module, exports) {

$parcel$export(module.exports, "default", () => $35dfb6b737f264b7$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $74BVL = parcelRequire("74BVL");
/**
 * Returns how far the body is scrolled from the top of the viewport.
 *
 * ⚠️ This is copied from `packages/design-system/modal-dialog/src/internal/hooks/use-prevent-programmatic-scroll.tsx`
 *
 *   ____
 * ||____|| <-- overflow
 *  |    |  <-- viewport
 *  |____|
 *
 * Scroll distance is the height of overflow outside the viewport.
 */ function $35dfb6b737f264b7$var$getScrollDistance() {
    var _document$documentEle, _document$body;
    return window.pageYOffset || ((_document$documentEle = document.documentElement) === null || _document$documentEle === void 0 ? void 0 : _document$documentEle.scrollTop) || ((_document$body = document.body) === null || _document$body === void 0 ? void 0 : _document$body.scrollTop) || 0;
}
function $35dfb6b737f264b7$export$2e2bcd8739ae039() {
    const [scrollTopOffset, setScrollTopOffset] = (0, $eUqFw.useState)(0);
    (0, $eUqFw.useLayoutEffect)(()=>{
        setScrollTopOffset($35dfb6b737f264b7$var$getScrollDistance());
    }, []);
    const onWindowScroll = (0, $eUqFw.useCallback)(()=>{
        if ($35dfb6b737f264b7$var$getScrollDistance() !== scrollTopOffset) window.scrollTo(window.pageXOffset, scrollTopOffset);
    }, [
        scrollTopOffset
    ]);
    (0, $eUqFw.useEffect)(()=>{
        return (0, $74BVL.bind)(window, {
            type: 'scroll',
            listener: onWindowScroll
        });
    }, [
        onWindowScroll
    ]);
    return scrollTopOffset;
}

});


parcelRegister("jwJeZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $e37419560e3e64ab$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $eUqFw = parcelRequire("eUqFw");

var $6Pq2D = parcelRequire("6Pq2D");

var $8MHxr = parcelRequire("8MHxr");
parcelRequire("8ynlC");

var $pcrEK = parcelRequire("pcrEK");

var $2fFJv = parcelRequire("2fFJv");
class $e37419560e3e64ab$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    constructor(...args){
        super(...args);
        (0, $5zQU9.default)(this, "getFocusTarget", ()=>{
            const { shouldReturnFocus: shouldReturnFocus } = this.props;
            if (typeof shouldReturnFocus === 'boolean') return shouldReturnFocus;
            return false;
        });
        (0, $5zQU9.default)(this, "onDeactivation", ()=>{
            const { shouldReturnFocus: shouldReturnFocus } = this.props;
            if (typeof shouldReturnFocus !== 'boolean') window.setTimeout(()=>{
                var _shouldReturnFocus$cu;
                shouldReturnFocus === null || shouldReturnFocus === void 0 || (_shouldReturnFocus$cu = shouldReturnFocus.current) === null || _shouldReturnFocus$cu === void 0 || _shouldReturnFocus$cu.focus();
            }, 0);
        });
    }
    componentDidMount() {
        const { isFocusLockEnabled: isFocusLockEnabled, autoFocusFirstElem: autoFocusFirstElem } = this.props;
        typeof $2fFJv;
        if (typeof autoFocusFirstElem === 'function' && isFocusLockEnabled) {
            const elem = autoFocusFirstElem();
            if (elem && elem.focus) elem.focus();
        }
    }
    render() {
        const { isFocusLockEnabled: isFocusLockEnabled, autoFocusFirstElem: autoFocusFirstElem, children: children } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6Pq2D.default), {
            disabled: !isFocusLockEnabled,
            autoFocus: !!autoFocusFirstElem,
            returnFocus: this.getFocusTarget(),
            onDeactivation: this.onDeactivation
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8MHxr))), null, children));
    }
}
(0, $5zQU9.default)($e37419560e3e64ab$export$2e2bcd8739ae039, "defaultProps", {
    ...(0, $pcrEK.defaultFocusLockSettings)
});

});

parcelRegister("5Up2o", function(module, exports) {

$parcel$export(module.exports, "default", () => $44d59aa63f4af666$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");

var $byn9U = parcelRequire("byn9U");

var $PdmhA = parcelRequire("PdmhA");
const $44d59aa63f4af666$var$defaultStyle = {
    alignItems: 'center',
    boxSizing: 'border-box',
    color: `var(--ds-text-subtle, ${(0, $PdmhA.N500)})`,
    display: 'flex',
    flexShrink: 0,
    flexDirection: 'column',
    height: '100vh',
    paddingBottom: "var(--ds-space-200, 16px)",
    paddingTop: "var(--ds-space-300, 24px)",
    width: "var(--ds-space-800, 64px)"
};
const $44d59aa63f4af666$var$sidebarCSS = ()=>$44d59aa63f4af666$var$defaultStyle;
const $44d59aa63f4af666$var$Sidebar = ({ cssFn: cssFn, ...props })=>{
    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @repo/internal/react/no-unsafe-spread-props
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({
        css: (0, $byn9U.css)(cssFn($44d59aa63f4af666$var$defaultStyle))
    }, props));
};
var $44d59aa63f4af666$export$2e2bcd8739ae039 = {
    component: $44d59aa63f4af666$var$Sidebar,
    cssFn: $44d59aa63f4af666$var$sidebarCSS
};

});



parcelRegister("dYnI4", function(module, exports) {

$parcel$export(module.exports, "SPA_APP_NAME", () => $0dd50ffde9ec4111$export$3121747bb6e73d1c);
$parcel$export(module.exports, "TTI_SLO", () => $0dd50ffde9ec4111$export$748427380a6493b0);
$parcel$export(module.exports, "ARJ_EARLY_PRELOAD_PREFIX", () => $0dd50ffde9ec4111$export$1b60784a15ad91a9);
$parcel$export(module.exports, "monitor", () => $0dd50ffde9ec4111$export$ec5b303098bc4b7f);

var $3tabS = parcelRequire("3tabS");
var $lEpcX = parcelRequire("lEpcX");

var $6M8Uw = parcelRequire("6M8Uw");
var $2B87Z = parcelRequire("2B87Z");

var $1QVWH = parcelRequire("1QVWH");

var $j2Yjr = parcelRequire("j2Yjr");

var $fVaJL = parcelRequire("fVaJL");

var $dtKCx = parcelRequire("dtKCx");

var $j3szT = parcelRequire("j3szT");
const $0dd50ffde9ec4111$export$3121747bb6e73d1c = 'advanced-roadmaps';
const $0dd50ffde9ec4111$export$748427380a6493b0 = 4000;
const $0dd50ffde9ec4111$export$2a97570d48bcd64d = 1000;
const $0dd50ffde9ec4111$export$1b60784a15ad91a9 = 'jira.fe-spa.advanced-roadmaps.early-preload';
const $0dd50ffde9ec4111$var$INTERACTION_PREFIX = $0dd50ffde9ec4111$export$3121747bb6e73d1c;
const $0dd50ffde9ec4111$var$ARJ_EARLY_PRELOAD = 'arj-early-preload';
const $0dd50ffde9ec4111$var$PRODUCT_PREFIX = 'jira.fe-spa.advanced-roadmaps.product';
const $0dd50ffde9ec4111$var$taskKeyToInteractionKey = (taskKey)=>`${$0dd50ffde9ec4111$var$INTERACTION_PREFIX}.${taskKey.toLowerCase()}`;
const $0dd50ffde9ec4111$var$INITIAL_RENDER_TASK_KEY = '__initial_render__';
const $0dd50ffde9ec4111$var$MAX_ENTRIES_PER_MARK = 5;
class $0dd50ffde9ec4111$export$3de16b9a4e4a99f4 {
    constructor(options){
        this.featureFlags = [];
        this.profiles = new Map();
        this.timings = [];
        this.tasks = new Map();
        this.contextualAnalyticsData = {
            planId: '',
            scenarioId: ''
        };
        this.browserMetrics = (options || {}).browserMetrics || (0, $3tabS.browserMetrics);
        this.metrics = (options || {}).metrics || (0, $lEpcX.metrics);
        this.resetInitialRenderTask();
        (0, $dtKCx.injectCallbackIntoGetBooleanFeatureFlag)((flag)=>{
            this.registerBooleanFeatureFlag(flag);
        });
    }
    initializeContextualAnalyticsData(data) {
        this.contextualAnalyticsData = {
            ...data
        };
    }
    addContextualAnalyticsData(newData) {
        this.contextualAnalyticsData = {
            ...this.contextualAnalyticsData,
            ...newData
        };
    }
    /**
	 * Report when the initial render of the page has been finished.
	 *
	 */ finishInitialRender(pageKey, options) {
        const task = this.tasks.get($0dd50ffde9ec4111$var$INITIAL_RENDER_TASK_KEY);
        if (!task) return;
        this.recordEarlyPreloadTimings();
        const advancedRoadmapsPageLoad = this.metrics.pageLoad({
            key: `${$0dd50ffde9ec4111$export$3121747bb6e73d1c}.${pageKey}`,
            featureFlags: this.featureFlags,
            slo: {
                tti: {
                    initial: {
                        threshold: $0dd50ffde9ec4111$export$748427380a6493b0
                    },
                    transition: {
                        threshold: $0dd50ffde9ec4111$export$748427380a6493b0
                    }
                }
            },
            timings: this.timings.map(({ key: key })=>({
                    key: key,
                    startMark: `${key}:start`,
                    endMark: `${key}:end`
                }))
        });
        (0, $2B87Z.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $6M8Uw.PRODUCT_START_MARK), true);
        this.timings.forEach(({ key: key, startTime: startTime, endTime: endTime })=>{
            advancedRoadmapsPageLoad.mark(`${key}:start`, startTime);
            advancedRoadmapsPageLoad.mark(`${key}:end`, endTime);
        });
        const { scalingFactors: scalingFactors } = options;
        const customData = this.collectCustomData({
            scalingFactors: scalingFactors
        }, task.executionTimes, task.marks);
        (0, $j2Yjr.addBM3TimingsToUFO)(advancedRoadmapsPageLoad.getData()?.marks, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        advancedRoadmapsPageLoad.getData()?.config?.timings);
        (0, $1QVWH.addUFOCustomData)(customData);
        (0, $fVaJL.addApdexToAll)({
            key: advancedRoadmapsPageLoad.key,
            stopTime: performance.now()
        });
        this.resetInitialRenderTask();
    }
    /**
	 * Start measuring the task and timed functions within.
	 *
	 * Task is a single report unit. Always pair `startTask` with `finishTask`, or the corresponding
	 * analytics event will not be sent. Tasks are re-entrant, starting the same task before it's
	 * finished has no effect, the monitor just continues to collect data. However, people looking
	 * at the data would most likely imply 1:1 start/finish correspondence, so please don't abuse
	 * re-entrance property.
	 *
	 * When timed function is executed within a task its timing is added to task's extra attributes,
	 * as well as provided scaleFactors and registered perf feature flags. Tasks support nesting,
	 * timed functions are reported for all running tasks.
	 *
	 * We track function timing in `executionTimes` instead of using `BrowserMetrics.setMark` as it
	 * gets ugly fast due to the need to keep track of start and end of multiple invocations encoded
	 * in mark keys.
	 *
	 * At the moment all the tasks are reported as `custom` metrics as it's a majority of our use-cases
	 * but we must add support for `interaction` metrics.
	 */ startTask(taskKey, options, customStartTime) {
        if (this.tasks.has(taskKey)) return;
        const interaction = this.metrics.custom({
            key: $0dd50ffde9ec4111$var$taskKeyToInteractionKey(taskKey),
            featureFlags: this.featureFlags,
            slo: {
                threshold: $0dd50ffde9ec4111$export$2a97570d48bcd64d
            }
        });
        customStartTime !== undefined ? interaction.start({
            startTime: customStartTime
        }) : interaction.start();
        const justOptions = options || {
            scalingFactors: {}
        };
        const executionTimes = new Map();
        const marks = new Set();
        const task = {
            interaction: interaction,
            options: justOptions,
            executionTimes: executionTimes,
            marks: marks
        };
        this.tasks.set(taskKey, task);
        this.setMark(`${taskKey}_start`);
    }
    /**
	 * Finish measuring the task, prepare and send corresponding analytics event.
	 */ finishTask(taskKey, options) {
        const task = this.tasks.get(taskKey);
        if (!task) return;
        const { sloSuccessThreshold: sloSuccessThreshold = $0dd50ffde9ec4111$export$2a97570d48bcd64d, scalingFactors: scalingFactors } = options || {};
        // NOTE BM3 doesn't support setting SLO after interaction instantiation.
        // We violate its contract and set private field directly from here.
        // We do it only for the sake of Monitor's API backward compatibility.
        // We must move SLO into startTask ASAP and remove this abomination.
        if (typeof task.interaction.config !== 'undefined') task.interaction.config.slo.threshold = sloSuccessThreshold;
        if (scalingFactors) // @ts-expect-error No overload matches this call.
        Object.assign(task.options.scalingFactors, scalingFactors);
        const customData = this.collectCustomData(task.options, task.executionTimes, task.marks);
        task.interaction.stop({
            customData: customData
        });
        this.tasks.delete(taskKey);
        this.setMark(`${taskKey}_end`);
    }
    /**
	 * Decorate a function as a task, synchronously (task is finished as soon as the function returns).
	 */ timeTask(task, taskKey, options) {
        return (...args)=>{
            this.startTask(taskKey, options);
            const result = task(...args);
            this.finishTask(taskKey);
            return result;
        };
    }
    /**
	 * Mark a synchronous function as a timed one.
	 *
	 * When the function is executed in the presence of running tasks, its timing is reported to all of them.
	 *
	 * TODO Have a register of timed functions to warn on name clashes.
	 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    timeFunction(fn, fnKey) {
        return (...args)=>{
            this.startProfile(fnKey);
            const result = fn(...args);
            this.finishProfile(fnKey);
            return result;
        };
    }
    /**
	 * Start measuring execution time from the current point to the corresponding `finishProfile` call.
	 *
	 * When the profile is finished in the presence of running tasks, its timing is reported to all of them.
	 * *Do not* use it if the same profile could be potentially started concurrently,
	 * use `startProfileConcurrent` instead.
	 */ startProfile(profileKey) {
        if (this.profiles.has(profileKey)) return;
        this.profiles.set(profileKey, {
            start: performance.now()
        });
    }
    /**
	 * Finish profile and record its execution time to all running tasks.
	 *
	 * Use it only together with `startProfile`.
	 * To finish profile started by `startProfileConcurrent` use the returned function instead.
	 */ finishProfile(profileKey) {
        const profile = this.profiles.get(profileKey);
        if (!profile) return;
        this.recordProfile(profileKey, profile);
        this.profiles.delete(profileKey);
    }
    /**
	 * Start measuring execution time from the current point to the call of the returned function.
	 *
	 * When the profile is finish in the presence of running tasks, its timing is reported to all of them.
	 * This method is safe for the potentially concurrent multiple entries by the cost of the need
	 * to pass finish function down to the profile finish point.
	 * *Do not* use `finishProfile` method for the profile started by `startProfileConcurrent`.
	 */ startProfileConcurrent(profileKey) {
        const profile = {
            start: performance.now()
        };
        return ()=>this.recordProfile(profileKey, profile);
    }
    /**
	 * Register a boolean flag to be added as an extra attribute to emitted events.
	 */ registerBooleanFeatureFlag(flag) {
        this.featureFlags.push(flag);
    }
    /**
	 * Register a mark to be reported to all tasks running at that moment.
	 */ setMark(markKey) {
        if (!performance.mark) return;
        performance.mark(markKey);
        for (const { marks: marks } of this.tasks.values())marks.add(markKey);
    }
    // Private.
    /**
	 * Create a fake task to track initial render info
	 */ resetInitialRenderTask() {
        const executionTimes = new Map();
        const marks = new Set();
        const task = {
            interaction: {},
            options: {
                scalingFactors: {}
            },
            executionTimes: executionTimes,
            marks: marks
        };
        this.tasks.set($0dd50ffde9ec4111$var$INITIAL_RENDER_TASK_KEY, task);
    }
    /**
	 * Record profile execution time to all running tasks.
	 */ recordProfile(profileKey, profile) {
        const profileEnd = performance.now();
        const measurement = {
            start: profile.start,
            end: profileEnd
        };
        for (const { executionTimes: executionTimes } of this.tasks.values()){
            const times = executionTimes.get(profileKey);
            if (times) times.push(measurement);
            else executionTimes.set(profileKey, [
                measurement
            ]);
        }
    }
    /**
	 * Record custom profile execution time to all running tasks
	 */ recordCustomProfile(profileKey, customProfile) {
        const measurement = {
            ...customProfile
        };
        for (const { executionTimes: executionTimes } of this.tasks.values()){
            const times = executionTimes.get(profileKey);
            if (times) times.push(measurement);
            else executionTimes.set(profileKey, [
                measurement
            ]);
        }
    }
    /**
	 * Records the timing for preload requests
	 */ recordEarlyPreloadTimings() {
        const resources = [
            '',
            'backlog',
            'info-metadata',
            'initial-checks-for-report',
            'plan-info-for-report'
        ];
        this.timings.push(...resources.map((resource)=>{
            /**
				 * Recording the performance information of the API before returning
				 * the response.
				 */ const start = Math.floor((0, $j3szT.extractStartTime)(`${$0dd50ffde9ec4111$export$1b60784a15ad91a9}${resource ? `.${resource}` : ''}:start`));
            const end = Math.ceil((0, $j3szT.extractStartTime)(`${$0dd50ffde9ec4111$export$1b60784a15ad91a9}${resource ? `.${resource}` : ''}:end`));
            return {
                key: resource ? `${$0dd50ffde9ec4111$var$ARJ_EARLY_PRELOAD}/${resource}` : $0dd50ffde9ec4111$var$ARJ_EARLY_PRELOAD,
                startTime: start,
                endTime: end
            };
        }));
    }
    recordProductTimings() {
        const resources = [
            'parse-json'
        ];
        this.timings.push(...resources.map((resource)=>{
            /**
				 * Recording the performance information for preprocessing product data
				 */ const start = Math.floor((0, $j3szT.extractStartTime)(`${$0dd50ffde9ec4111$var$PRODUCT_PREFIX}.${resource}:start`));
            const end = Math.ceil((0, $j3szT.extractStartTime)(`${$0dd50ffde9ec4111$var$PRODUCT_PREFIX}.${resource}:end`));
            return {
                key: `product/${resource}`,
                startTime: start,
                endTime: end
            };
        }));
    }
    /**
	 * Enrich task report with feature flags, scaling factors, and execution time stats.
	 *
	 * Reported stats: min, max, mean, standard deviation, number of runs.
	 *
	 * Note that dots in feature flag names (and any other attributes) will be replaced by underscores in Splunk.
	 * (TODO confirm if this is still true in BM3 case)
	 */ collectCustomData(options, executionTimes, marks) {
        const pageStart = this.pageStart();
        const report = {
            ...this.contextualAnalyticsData,
            scalingFactors: {},
            executionTimes: {},
            marks: {}
        };
        const scalingFactors = options.scalingFactors || {};
        for (const factor of Object.keys(scalingFactors))report.scalingFactors[factor] = scalingFactors[factor];
        for (const [fnKey, allTimes] of executionTimes){
            // Skip leftovers from the previous route.
            const times = allTimes.filter(({ start: start })=>start >= pageStart);
            const n = times.length;
            if (n > 0) {
                const start = times[0].start;
                let lastEnd = start;
                let min = Infinity;
                let max = -Infinity;
                let sum = 0;
                // eslint-disable-next-line @typescript-eslint/no-shadow
                for (const { start: start, end: end } of times){
                    const duration = end - start;
                    sum += duration;
                    min = Math.min(min, duration);
                    max = Math.max(max, duration);
                    lastEnd = Math.max(lastEnd, end);
                }
                const mean = sum / n;
                let devSum = 0;
                // eslint-disable-next-line @typescript-eslint/no-shadow
                for (const { start: start, end: end } of times){
                    const dev = end - start - mean;
                    devSum += dev * dev;
                }
                const stddev = n > 1 ? Math.sqrt(devSum / (n - 1)) : 0;
                report.executionTimes[fnKey] = {
                    start: start - pageStart,
                    end: lastEnd - pageStart,
                    min: min,
                    max: max,
                    mean: mean,
                    stddev: stddev,
                    count: n,
                    sum: sum
                };
            }
        }
        if (performance.getEntriesByName) for (const mark of marks){
            let i = 0;
            for (const m of performance.getEntriesByName(mark) || []){
                if (i > $0dd50ffde9ec4111$var$MAX_ENTRIES_PER_MARK) break;
                const start = m.startTime - pageStart;
                // Skip leftovers from the previous route.
                if (start >= 0) {
                    report.marks[`${mark}_${i}`] = start;
                    i++;
                }
            }
        }
        return report;
    }
    /** When the most recent page transition started.
	 *
	 * It will be 0 on initial load.
	 */ pageStart() {
        return this.browserMetrics.getPageLoadMetric()?.startTime || 0;
    }
}
const $0dd50ffde9ec4111$export$ec5b303098bc4b7f = new $0dd50ffde9ec4111$export$3de16b9a4e4a99f4();

});
parcelRegister("6M8Uw", function(module, exports) {

$parcel$export(module.exports, "PRODUCT_START_MARK", () => $e57b25b6033962a3$export$8e54fca0a680fdfd);
$parcel$export(module.exports, "MarkProductStart", () => $e57b25b6033962a3$export$2a999c5f84501025);

var $6iz4v = parcelRequire("6iz4v");
const $e57b25b6033962a3$export$8e54fca0a680fdfd = 'PRODUCT_START';
const $e57b25b6033962a3$export$2a999c5f84501025 = ()=>{
    performance.clearMarks($e57b25b6033962a3$export$8e54fca0a680fdfd);
    (0, $6iz4v.setMark)($e57b25b6033962a3$export$8e54fca0a680fdfd);
    return null;
};

});

parcelRegister("1QVWH", function(module, exports) {

$parcel$export(module.exports, "default", () => $a4fbf7a0879450da$export$2e2bcd8739ae039);
$parcel$export(module.exports, "addUFOCustomData", () => $a4fbf7a0879450da$export$d12f56a472cdbe6c);

var $eUqFw = parcelRequire("eUqFw");

var $5iuyH = parcelRequire("5iuyH");

var $gnIbC = parcelRequire("gnIbC");

var $fVaJL = parcelRequire("fVaJL");
function $a4fbf7a0879450da$export$2e2bcd8739ae039({ data: data }) {
    const interactionContext = (0, $eUqFw.useContext)((0, $5iuyH.default));
    (0, $eUqFw.useMemo)(()=>{
        if (!interactionContext) return;
        interactionContext.addCustomData(data);
    }, [
        data,
        interactionContext
    ]);
    return null;
}
function $a4fbf7a0879450da$export$d12f56a472cdbe6c(data) {
    const interactionId = (0, $gnIbC.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    (0, $fVaJL.addCustomData)(currentInteractionId, [], data);
}

});

parcelRegister("j2Yjr", function(module, exports) {

$parcel$export(module.exports, "getBm3Timings", () => $9cfce24b860b88bd$export$f02972da195a43bb);
$parcel$export(module.exports, "UFOBM3TimingsToUFO", () => $9cfce24b860b88bd$export$30f0b5e5acd268bf);
$parcel$export(module.exports, "addBM3TimingsToUFO", () => $9cfce24b860b88bd$export$d93d677ef2f33c5c);

var $eUqFw = parcelRequire("eUqFw");

var $5iuyH = parcelRequire("5iuyH");

var $gnIbC = parcelRequire("gnIbC");

var $fVaJL = parcelRequire("fVaJL");
function $9cfce24b860b88bd$export$f02972da195a43bb(marks, timingConfigs) {
    const bm3Timings = {};
    if (!marks || !timingConfigs) return bm3Timings;
    timingConfigs.forEach((item)=>{
        if (!item.startMark || !item.endMark) return;
        const startTime = marks[item.startMark];
        if (!startTime) return;
        const endTime = marks[item.endMark];
        if (!endTime) return;
        bm3Timings[item.key] = {
            startTime: startTime,
            endTime: endTime
        };
    });
    return bm3Timings;
}
function $9cfce24b860b88bd$export$30f0b5e5acd268bf({ marks: marks, timings: timings }) {
    const interactionContext = (0, $eUqFw.useContext)((0, $5iuyH.default));
    const interactionId = (0, $gnIbC.getInteractionId)().current;
    (0, $eUqFw.useMemo)(()=>{
        if (interactionContext != null && interactionId != null && marks != null && timings != null) {
            const interactionType = (0, $fVaJL.getCurrentInteractionType)(interactionId);
            if (interactionType === 'press') return;
            const bm3Timings = $9cfce24b860b88bd$export$f02972da195a43bb(marks, timings);
            interactionContext.addCustomTimings(bm3Timings);
        }
    }, [
        interactionContext,
        interactionId,
        marks,
        timings
    ]);
    return null;
}
function $9cfce24b860b88bd$export$d93d677ef2f33c5c(marks, timingsConfig) {
    const interactionId = (0, $gnIbC.getInteractionId)().current;
    if (interactionId) {
        const interactionType = (0, $fVaJL.getCurrentInteractionType)(interactionId);
        if (interactionType === 'press') return;
        const bm3Timings = $9cfce24b860b88bd$export$f02972da195a43bb(marks, timingsConfig);
        (0, $fVaJL.addCustomTiming)(interactionId, [], bm3Timings);
    }
}

});

parcelRegister("dtKCx", function(module, exports) {

$parcel$export(module.exports, "injectCallbackIntoGetBooleanFeatureFlag", () => $42058a3266f06a4b$export$fe8eedb8c1059343);
$parcel$export(module.exports, "getBooleanFeatureFlag", () => $42058a3266f06a4b$export$a4658325ccb88f03);

var $1ybV0 = parcelRequire("1ybV0");
const $42058a3266f06a4b$var$callbacks = [];
const $42058a3266f06a4b$export$fe8eedb8c1059343 = (callback)=>{
    $42058a3266f06a4b$var$callbacks.push(callback);
};
const $42058a3266f06a4b$export$d930a8564fce9bcd = (flag)=>{
    const urlParams = new URLSearchParams(window.location.search);
    const ffOverrides = urlParams.get('ffOverrides');
    if (ffOverrides === undefined || ffOverrides === null) return null;
    // eslint-disable-next-line @typescript-eslint/no-shadow
    const item = ffOverrides.split(',').find((item)=>item.startsWith(`${flag}:`));
    return item !== undefined && item.split(':')[1] || null;
};
const $42058a3266f06a4b$export$a4658325ccb88f03 = (flag, defaultValue = false, storybookDefault = true)=>{
    for (const cb of $42058a3266f06a4b$var$callbacks)cb(flag, defaultValue, storybookDefault);
    if (window?.STORYBOOK_ENV) {
        const overrideValue = $42058a3266f06a4b$export$d930a8564fce9bcd(flag);
        if (overrideValue !== null) return overrideValue === 'true';
        return storybookDefault;
    }
    return (0, $1ybV0.ff)(flag, defaultValue);
};
const $42058a3266f06a4b$export$757bc67afadef4a0 = (featureFlagName, defaultValue, possibleValues = [], storybookDefault)=>{
    if (window?.STORYBOOK_ENV) {
        const overrideValue = $42058a3266f06a4b$export$d930a8564fce9bcd(featureFlagName);
        if (overrideValue !== null) return overrideValue;
        return typeof storybookDefault === 'string' ? storybookDefault : defaultValue;
    }
    return (0, $1ybV0.getMultivariateFeatureFlag)(featureFlagName, defaultValue, possibleValues);
};

});

parcelRegister("j3szT", function(module, exports) {

$parcel$export(module.exports, "extractStartTime", () => $f7e9a101130fcdb5$export$97ed9769a496ce6e);
const $f7e9a101130fcdb5$export$97ed9769a496ce6e = (markName)=>(performance.getEntriesByName(markName, 'mark')[0] || {
        startTime: 0
    }).startTime;

});


const $87a0abe4cc67502d$export$b8b9d90f9e5bd72b = 'jiraPortfolio3CreateNewPlanWizardDrawer';
const $87a0abe4cc67502d$export$cfeee2ee86ead336 = 'advanced-roadmaps';
const $87a0abe4cc67502d$export$f27a837467ec20e5 = 'planWizard';
const $87a0abe4cc67502d$export$6afdd25b4da87159 = 30;
const $87a0abe4cc67502d$export$9a977208af30ffae = 'create-plan-wizard.load-time';
const $87a0abe4cc67502d$export$a8e537ef0c1e2586 = 'Days';
const $87a0abe4cc67502d$export$2a59d0fbc784e5c1 = '1';
const $87a0abe4cc67502d$export$7288711b5316ff78 = 'YYYY-MM-DD';
const $87a0abe4cc67502d$export$14ae725d0cc7daa1 = 'DD/MMM/YY';

parcelRegister("26yXe", function(module, exports) {

$parcel$export(module.exports, "useCreateNewPlanWizardDrawer", () => $fce0b5f5d60fb0be$export$f3e7d3fc94eda89a);
$parcel$export(module.exports, "useImportedMessagesForLocale", () => $fce0b5f5d60fb0be$export$52303468eeac3ad0);

var $eUqFw = parcelRequire("eUqFw");

var $heB5U = parcelRequire("heB5U");
var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");

var $5JgJ2 = parcelRequire("5JgJ2");
const $fce0b5f5d60fb0be$var$CONTROLLER_NAME = 'create-new-plan-wizard-drawer';
const $fce0b5f5d60fb0be$var$initialState = {
    isOpen: false,
    plan: undefined
};
const $fce0b5f5d60fb0be$var$Store = (0, $a61MH.createStore)({
    name: $fce0b5f5d60fb0be$var$CONTROLLER_NAME,
    initialState: $fce0b5f5d60fb0be$var$initialState,
    actions: {
        openDrawer: (plan)=>({ setState: setState })=>setState({
                    isOpen: true,
                    plan: plan
                }),
        closeDrawer: ()=>({ setState: setState })=>setState({
                    isOpen: false,
                    plan: undefined
                })
    }
});
const $fce0b5f5d60fb0be$export$f3e7d3fc94eda89a = (0, $ggKAj.createHook)($fce0b5f5d60fb0be$var$Store);
const $fce0b5f5d60fb0be$export$9ec7b5762fb72de2 = (0, $heB5U.createContainer)($fce0b5f5d60fb0be$var$Store, {
    onInit: ()=>({ setState: setState }, { isOpen: isOpen, plan: plan })=>{
            setState({
                isOpen: isOpen,
                plan: plan
            });
        }
});
const $fce0b5f5d60fb0be$var$EXCLUDED_I18N_FILES = [
    'index',
    'languages',
    'en'
];
const $fce0b5f5d60fb0be$var$FALLBACK_INTL_MESSAGES = Object.freeze({});

const $fce0b5f5d60fb0be$export$19442c17ab279a67 = async (rawlocale = 'en')=>{
    // Filter out country code as the AFE i18n does not use them e.g en => en-US
    const locale = rawlocale.split('-')[0];
    if (!locale || $fce0b5f5d60fb0be$var$EXCLUDED_I18N_FILES.includes(locale)) return {
        default: $fce0b5f5d60fb0be$var$FALLBACK_INTL_MESSAGES
    };
    try {
        {
            // eslint-disable-next-line jira/import/webpack-magic-comment-entries
            const i18nModule = await (parcelRequire("53Fqr"));
            const result = i18nModule[locale]();
            return result;
        }
        // eslint-disable-next-line jira/import/webpack-magic-comment-entries
        const result = await import(`@atlassian/jira-portfolio-plan-wizard/dist/cjs/i18n/${locale}`);
        return result;
    } catch  {
        return {
            default: $fce0b5f5d60fb0be$var$FALLBACK_INTL_MESSAGES
        };
    }
};
const $fce0b5f5d60fb0be$export$52303468eeac3ad0 = ()=>{
    const { locale: locale } = (0, $5JgJ2.default)();
    const [state, setState] = (0, $eUqFw.useState)({
        locale: locale,
        loading: true,
        intlMessages: undefined
    });
    (0, $eUqFw.useEffect)(()=>{
        let mounted = true;
        const load = async ()=>{
            // eslint-disable-next-line @typescript-eslint/no-shadow
            setState((state)=>({
                    ...state,
                    loading: true
                }));
            const { default: intlMessages } = await $fce0b5f5d60fb0be$export$19442c17ab279a67(locale);
            if (!mounted) return;
            // eslint-disable-next-line @typescript-eslint/no-shadow
            setState((state)=>({
                    ...state,
                    loading: false,
                    intlMessages: intlMessages
                }));
        };
        load();
        return ()=>{
            mounted = false;
        };
    }, [
        locale
    ]);
    return state;
};

});
parcelRegister("53Fqr", function(module, exports) {





























module.exports = {
    "cs": ()=>(parcelRequire("eFmkU")),
    "da": ()=>(parcelRequire("aEFmq")),
    "de": ()=>(parcelRequire("f4Rfm")),
    "en": ()=>(parcelRequire("3BmuK")),
    "en_GB": ()=>(parcelRequire("3gBUP")),
    "en_ZZ": ()=>(parcelRequire("8BiyF")),
    "es": ()=>(parcelRequire("6KQkB")),
    "et": ()=>(parcelRequire("dfaVb")),
    "fi": ()=>(parcelRequire("2E8nL")),
    "fr": ()=>(parcelRequire("fsFMx")),
    "hu": ()=>(parcelRequire("9hbjO")),
    "index": ()=>(parcelRequire("kuu7W")),
    "it": ()=>(parcelRequire("4CUSn")),
    "ja": ()=>(parcelRequire("fdQTx")),
    "ko": ()=>(parcelRequire("7SQkf")),
    "nb": ()=>(parcelRequire("22Sk0")),
    "nl": ()=>(parcelRequire("kqSqy")),
    "pl": ()=>(parcelRequire("jCMQU")),
    "pt_BR": ()=>(parcelRequire("8D2Xp")),
    "pt_PT": ()=>(parcelRequire("fPcDY")),
    "ru": ()=>(parcelRequire("d6yed")),
    "sk": ()=>(parcelRequire("7iofy")),
    "sv": ()=>(parcelRequire("7VgvA")),
    "th": ()=>(parcelRequire("etzfE")),
    "tr": ()=>(parcelRequire("ci51z")),
    "uk": ()=>(parcelRequire("ekdeh")),
    "vi": ()=>(parcelRequire("1TQvd")),
    "zh": ()=>(parcelRequire("cppWZ")),
    "zh_TW": ()=>(parcelRequire("iXdxU"))
};

});
parcelRegister("eFmkU", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('9tv1u');
        const value = parcelRequire('lqTPC');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("9tv1u").then(()=>parcelRequire('lqTPC'));
}

});

parcelRegister("aEFmq", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('41WiB');
        const value = parcelRequire('32QVI');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("41WiB").then(()=>parcelRequire('32QVI'));
}

});

parcelRegister("f4Rfm", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('3lhic');
        const value = parcelRequire('aB89D');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("3lhic").then(()=>parcelRequire('aB89D'));
}

});

parcelRegister("3BmuK", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('NBDoQ');
        const value = parcelRequire('9pxG8');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("NBDoQ").then(()=>parcelRequire('9pxG8'));
}

});

parcelRegister("3gBUP", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('7JR60');
        const value = parcelRequire('fnbVL');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("7JR60").then(()=>parcelRequire('fnbVL'));
}

});

parcelRegister("8BiyF", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('65yXC');
        const value = parcelRequire('hUj2m');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("65yXC").then(()=>parcelRequire('hUj2m'));
}

});

parcelRegister("6KQkB", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('77oCJ');
        const value = parcelRequire('92W6x');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("77oCJ").then(()=>parcelRequire('92W6x'));
}

});

parcelRegister("dfaVb", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('lKGxV');
        const value = parcelRequire('9E31n');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("lKGxV").then(()=>parcelRequire('9E31n'));
}

});

parcelRegister("2E8nL", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('agx5N');
        const value = parcelRequire('kaavJ');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("agx5N").then(()=>parcelRequire('kaavJ'));
}

});

parcelRegister("fsFMx", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('dfyUB');
        const value = parcelRequire('6EUBT');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("dfyUB").then(()=>parcelRequire('6EUBT'));
}

});

parcelRegister("9hbjO", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('6aH8S');
        const value = parcelRequire('gZ8jY');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("6aH8S").then(()=>parcelRequire('gZ8jY'));
}

});

parcelRegister("kuu7W", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('d81ex');
        const value = parcelRequire('k09M8');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("d81ex").then(()=>parcelRequire('k09M8'));
}

});

parcelRegister("4CUSn", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('aWcSy');
        const value = parcelRequire('6F9T8');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("aWcSy").then(()=>parcelRequire('6F9T8'));
}

});

parcelRegister("fdQTx", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('e9v4f');
        const value = parcelRequire('dSmG3');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("e9v4f").then(()=>parcelRequire('dSmG3'));
}

});

parcelRegister("7SQkf", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('20XTj');
        const value = parcelRequire('yw66G');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("20XTj").then(()=>parcelRequire('yw66G'));
}

});

parcelRegister("22Sk0", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('eNhvA');
        const value = parcelRequire('8OwBj');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("eNhvA").then(()=>parcelRequire('8OwBj'));
}

});

parcelRegister("kqSqy", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('8FAxg');
        const value = parcelRequire('1T59O');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("8FAxg").then(()=>parcelRequire('1T59O'));
}

});

parcelRegister("jCMQU", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('iLjoa');
        const value = parcelRequire('aXeFZ');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("iLjoa").then(()=>parcelRequire('aXeFZ'));
}

});

parcelRegister("8D2Xp", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('kkZND');
        const value = parcelRequire('aDKUs');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("kkZND").then(()=>parcelRequire('aDKUs'));
}

});

parcelRegister("fPcDY", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('7QgZX');
        const value = parcelRequire('eQLSp');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("7QgZX").then(()=>parcelRequire('eQLSp'));
}

});

parcelRegister("d6yed", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('gAcw4');
        const value = parcelRequire('1L44x');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("gAcw4").then(()=>parcelRequire('1L44x'));
}

});

parcelRegister("7iofy", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('dPPse');
        const value = parcelRequire('dV3qs');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("dPPse").then(()=>parcelRequire('dV3qs'));
}

});

parcelRegister("7VgvA", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('92pUw');
        const value = parcelRequire('iDizf');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("92pUw").then(()=>parcelRequire('iDizf'));
}

});

parcelRegister("etzfE", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('5zoIv');
        const value = parcelRequire('cYgvK');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("5zoIv").then(()=>parcelRequire('cYgvK'));
}

});

parcelRegister("ci51z", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('6s1f7');
        const value = parcelRequire('lEcod');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("6s1f7").then(()=>parcelRequire('lEcod'));
}

});

parcelRegister("ekdeh", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('a4W17');
        const value = parcelRequire('aVenR');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("a4W17").then(()=>parcelRequire('aVenR'));
}

});

parcelRegister("1TQvd", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('h0vCu');
        const value = parcelRequire('e8anb');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("h0vCu").then(()=>parcelRequire('e8anb'));
}

});

parcelRegister("cppWZ", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('9V5oj');
        const value = parcelRequire('fUEWQ');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("9V5oj").then(()=>parcelRequire('fUEWQ'));
}

});

parcelRegister("iXdxU", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('5uAbP');
        const value = parcelRequire('Q6VFJ');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("5uAbP").then(()=>parcelRequire('Q6VFJ'));
}

});



parcelRegister("kgHxg", function(module, exports) {

$parcel$export(module.exports, "default", () => $326da00bf5b36204$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $326da00bf5b36204$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    close: {
        "id": "portfolio-3-create-new-plan-wizard-drawer.ui.close",
        "defaultMessage": "Close"
    }
});

});

parcelRegister("8uuRQ", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('h2MrD'),
            load('bYT2S'),
            load('hPzOn'),
            load('5OT3q')
        ]);
        const value = parcelRequire('6k9TN');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("h2MrD"),
        load("bYT2S"),
        load("hPzOn"),
        load("5OT3q")
    ]).then(()=>parcelRequire('6k9TN'));
}

});

parcelRegister("31Z6M", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('h2MrD'),
            load('bYT2S'),
            load('hPzOn'),
            load('kvJuj')
        ]);
        const value = parcelRequire('8R5zS');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("h2MrD"),
        load("bYT2S"),
        load("hPzOn"),
        load("kvJuj")
    ]).then(()=>parcelRequire('8R5zS'));
}

});



parcelRegister("bsgBu", function(module, exports) {

$parcel$export(module.exports, "default", () => $8e873e1c606c5a51$export$2e2bcd8739ae039);

var $dddYR = parcelRequire("dddYR");
var $8e873e1c606c5a51$export$2e2bcd8739ae039 = (0, $dddYR.default);

});
parcelRegister("dddYR", function(module, exports) {

$parcel$export(module.exports, "default", () => $abb8d8e5e5f00042$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $dxopF = parcelRequire("dxopF");

var $aR8n6 = parcelRequire("aR8n6");

var $k8Qyf = parcelRequire("k8Qyf");

var $gGtKh = parcelRequire("gGtKh");

var $hzcvF = parcelRequire("hzcvF");

var $cWiVr = parcelRequire("cWiVr");

var $kJlBc = parcelRequire("kJlBc");

var $iG4Rs = parcelRequire("iG4Rs");

var $d0QLq = parcelRequire("d0QLq");

var $bF8PW = parcelRequire("bF8PW");
const $abb8d8e5e5f00042$var$CreateSamplePlan = ()=>{
    const [{ isOpen: isOpen }, { close: close }] = (0, $d0QLq.useCreateSamplePlan)();
    const [{ location: location }] = (0, $kJlBc.useRouter)();
    const initialLocation = (0, $hzcvF.usePrevious)(location);
    // When the route changes we should close the modal
    (0, $eUqFw.useEffect)(()=>{
        if (initialLocation && initialLocation !== location) close();
    }, [
        close,
        initialLocation,
        location
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dxopF.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "create-sample-plan",
        fallback: null
    }, isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bF8PW.default), null)));
};
const $abb8d8e5e5f00042$var$CreateSamplePlanContainer = ({ isOpen: isOpen = false })=>{
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagsService)();
    const { push: push } = (0, $kJlBc.useRouterActions)();
    const { data: { user: currentUser } } = (0, $cWiVr.useCurrentUser)();
    const redirectToPlan = (0, $eUqFw.useCallback)((planId)=>{
        push(`/jira/plans/${planId}`);
    }, [
        push
    ]);
    if (!currentUser.accountId) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d0QLq.CreateSamplePlanProvider), {
        isGlobal: true,
        isOpen: isOpen,
        showFlag: showFlag,
        redirectToPlan: redirectToPlan,
        leadAccountId: currentUser.accountId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aR8n6.default), {
        id: (0, $iG4Rs.ERROR_REPORTING_PACKAGE),
        packageName: (0, $iG4Rs.ERROR_REPORTING_PACKAGE),
        teamName: (0, $iG4Rs.ERROR_REPORTING_TEAM),
        sendToPrivacyUnsafeSplunk: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($abb8d8e5e5f00042$var$CreateSamplePlan, null)));
};
var $abb8d8e5e5f00042$export$2e2bcd8739ae039 = $abb8d8e5e5f00042$var$CreateSamplePlanContainer;

});
parcelRegister("iG4Rs", function(module, exports) {

$parcel$export(module.exports, "ERROR_REPORTING_PACKAGE", () => $849ca60c037bd134$export$f27a837467ec20e5);
$parcel$export(module.exports, "ERROR_REPORTING_TEAM", () => $849ca60c037bd134$export$cfeee2ee86ead336);
$parcel$export(module.exports, "MAX_PLAN_NAME_LENGTH", () => $849ca60c037bd134$export$62da4a2465b3b309);
$parcel$export(module.exports, "CREATE_SUCCESS_FLAG_ID", () => $849ca60c037bd134$export$d526356745046017);
$parcel$export(module.exports, "CREATE_ERROR_FLAG_ID", () => $849ca60c037bd134$export$abd17266df221a92);
$parcel$export(module.exports, "UNKNOWN_EXCEPTION", () => $849ca60c037bd134$export$cfba07bc71f884c1);
$parcel$export(module.exports, "USER_SETTINGS_ERRORS", () => $849ca60c037bd134$export$4a3e779cd3c10125);
$parcel$export(module.exports, "ERROR_CODE_TITLE_MAPPING", () => $849ca60c037bd134$export$91ec80863c2c2030);
$parcel$export(module.exports, "ERROR_CODE_TITLE_MAPPING_OLD", () => $849ca60c037bd134$export$ac9380d5cd254833);
$parcel$export(module.exports, "ERROR_CODE_DESCRIPTION_MAPPING", () => $849ca60c037bd134$export$c43e20911e13ca0);
$parcel$export(module.exports, "ERROR_CODE_DESCRIPTION_MAPPING_OLD", () => $849ca60c037bd134$export$dd6b1d0682cc49d0);
$parcel$export(module.exports, "ERROR_LINK_MAPPING", () => $849ca60c037bd134$export$2c5a783ab3215ce1);
$parcel$export(module.exports, "ERROR_LINK_MAPPING_OLD", () => $849ca60c037bd134$export$3c3f70484d1d8acd);

var $2mX4j = parcelRequire("2mX4j");
const $849ca60c037bd134$export$f27a837467ec20e5 = 'jiraPortfolio3CreateSamplePlan';
const $849ca60c037bd134$export$cfeee2ee86ead336 = 'advanced-roadmaps';
const $849ca60c037bd134$export$2c16bd1d8b68b11f = 'https://support.atlassian.com/contact';
const $849ca60c037bd134$export$af6d68522cb370b8 = 'https://support.atlassian.com/jira-software-cloud/docs/view-a-sample-advanced-roadmaps-plan/';
const $849ca60c037bd134$export$62da4a2465b3b309 = 255;
const $849ca60c037bd134$export$d526356745046017 = 'samplePlanCreatedSuccessfully';
const $849ca60c037bd134$export$abd17266df221a92 = 'samplePlanError';
const $849ca60c037bd134$export$e6515d2009b1dba7 = 'REQUIRED_FIELDS_CONFIGURED_ON_ISSUE';
const $849ca60c037bd134$export$80ecb4d853a9f09b = 'EMPTY_ISSUE_LINKS';
const $849ca60c037bd134$export$f31def2c4daaefc0 = 'NO_BROWSE_PROJECTS_PERMISSION';
const $849ca60c037bd134$export$530d46555d7ccbb = 'NO_CREATE_ISSUES_PERMISSION';
const $849ca60c037bd134$export$8c852ea52ca9ebe = 'NO_TRANSITION_ISSUES_PERMISSION';
const $849ca60c037bd134$export$855d898b7009ad1c = 'NO_EDIT_ISSUES_PERMISSION';
const $849ca60c037bd134$export$5c8703f47a29c462 = 'WATCHING_DISABLED';
const $849ca60c037bd134$export$cfba07bc71f884c1 = 'UNKNOWN_EXCEPTION';
const $849ca60c037bd134$export$4a3e779cd3c10125 = [
    $849ca60c037bd134$export$e6515d2009b1dba7,
    $849ca60c037bd134$export$80ecb4d853a9f09b,
    $849ca60c037bd134$export$f31def2c4daaefc0,
    $849ca60c037bd134$export$530d46555d7ccbb,
    $849ca60c037bd134$export$8c852ea52ca9ebe,
    $849ca60c037bd134$export$855d898b7009ad1c,
    $849ca60c037bd134$export$5c8703f47a29c462
];
const $849ca60c037bd134$export$91ec80863c2c2030 = {
    [$849ca60c037bd134$export$e6515d2009b1dba7]: (0, $2mX4j.default).configurationErrorTitle,
    [$849ca60c037bd134$export$80ecb4d853a9f09b]: (0, $2mX4j.default).configurationErrorTitle,
    [$849ca60c037bd134$export$f31def2c4daaefc0]: (0, $2mX4j.default).permissionErrorTitle,
    [$849ca60c037bd134$export$530d46555d7ccbb]: (0, $2mX4j.default).permissionErrorTitle,
    [$849ca60c037bd134$export$8c852ea52ca9ebe]: (0, $2mX4j.default).permissionErrorTitle,
    [$849ca60c037bd134$export$855d898b7009ad1c]: (0, $2mX4j.default).permissionErrorTitle,
    [$849ca60c037bd134$export$5c8703f47a29c462]: (0, $2mX4j.default).configurationErrorTitle,
    [$849ca60c037bd134$export$cfba07bc71f884c1]: (0, $2mX4j.default).tryAgainErrorTitle
};
const $849ca60c037bd134$export$ac9380d5cd254833 = {
    [$849ca60c037bd134$export$e6515d2009b1dba7]: (0, $2mX4j.default).configurationErrorTitleOld,
    [$849ca60c037bd134$export$80ecb4d853a9f09b]: (0, $2mX4j.default).configurationErrorTitleOld,
    [$849ca60c037bd134$export$f31def2c4daaefc0]: (0, $2mX4j.default).permissionErrorTitleOld,
    [$849ca60c037bd134$export$530d46555d7ccbb]: (0, $2mX4j.default).permissionErrorTitleOld,
    [$849ca60c037bd134$export$8c852ea52ca9ebe]: (0, $2mX4j.default).permissionErrorTitleOld,
    [$849ca60c037bd134$export$855d898b7009ad1c]: (0, $2mX4j.default).permissionErrorTitleOld,
    [$849ca60c037bd134$export$5c8703f47a29c462]: (0, $2mX4j.default).configurationErrorTitleOld,
    [$849ca60c037bd134$export$cfba07bc71f884c1]: (0, $2mX4j.default).tryAgainErrorTitleOld
};
const $849ca60c037bd134$export$c43e20911e13ca0 = {
    [$849ca60c037bd134$export$e6515d2009b1dba7]: (0, $2mX4j.default).requiredFieldsConfiguredOnIssueError,
    [$849ca60c037bd134$export$80ecb4d853a9f09b]: (0, $2mX4j.default).emptyIssueLinksError,
    [$849ca60c037bd134$export$f31def2c4daaefc0]: (0, $2mX4j.default).noBrowseProjectsPermissionError,
    [$849ca60c037bd134$export$530d46555d7ccbb]: (0, $2mX4j.default).noCreateIssuesPermissionError,
    [$849ca60c037bd134$export$8c852ea52ca9ebe]: (0, $2mX4j.default).noTransitionIssuesPermissionError,
    [$849ca60c037bd134$export$855d898b7009ad1c]: (0, $2mX4j.default).noEditIssuesPermissionError,
    [$849ca60c037bd134$export$5c8703f47a29c462]: (0, $2mX4j.default).watchingDisabledError,
    [$849ca60c037bd134$export$cfba07bc71f884c1]: (0, $2mX4j.default).unknownExceptionError
};
const $849ca60c037bd134$export$dd6b1d0682cc49d0 = {
    [$849ca60c037bd134$export$e6515d2009b1dba7]: (0, $2mX4j.default).requiredFieldsConfiguredOnIssueErrorOld,
    [$849ca60c037bd134$export$80ecb4d853a9f09b]: (0, $2mX4j.default).emptyIssueLinksErrorOld,
    [$849ca60c037bd134$export$f31def2c4daaefc0]: (0, $2mX4j.default).noBrowseProjectsPermissionErrorOld,
    [$849ca60c037bd134$export$530d46555d7ccbb]: (0, $2mX4j.default).noCreateIssuesPermissionErrorOld,
    [$849ca60c037bd134$export$8c852ea52ca9ebe]: (0, $2mX4j.default).noTransitionIssuesPermissionErrorOld,
    [$849ca60c037bd134$export$855d898b7009ad1c]: (0, $2mX4j.default).noEditIssuesPermissionErrorOld,
    [$849ca60c037bd134$export$5c8703f47a29c462]: (0, $2mX4j.default).watchingDisabledErrorOld,
    [$849ca60c037bd134$export$cfba07bc71f884c1]: (0, $2mX4j.default).unknownExceptionErrorOld
};
const $849ca60c037bd134$export$2c5a783ab3215ce1 = {
    [$849ca60c037bd134$export$e6515d2009b1dba7]: {
        text: (0, $2mX4j.default).learnMore,
        href: $849ca60c037bd134$export$af6d68522cb370b8
    },
    [$849ca60c037bd134$export$80ecb4d853a9f09b]: {
        text: (0, $2mX4j.default).learnMore,
        href: $849ca60c037bd134$export$af6d68522cb370b8
    },
    [$849ca60c037bd134$export$f31def2c4daaefc0]: {
        text: (0, $2mX4j.default).learnMore,
        href: $849ca60c037bd134$export$af6d68522cb370b8
    },
    [$849ca60c037bd134$export$530d46555d7ccbb]: {
        text: (0, $2mX4j.default).learnMore,
        href: $849ca60c037bd134$export$af6d68522cb370b8
    },
    [$849ca60c037bd134$export$8c852ea52ca9ebe]: {
        text: (0, $2mX4j.default).learnMore,
        href: $849ca60c037bd134$export$af6d68522cb370b8
    },
    [$849ca60c037bd134$export$855d898b7009ad1c]: {
        text: (0, $2mX4j.default).learnMore,
        href: $849ca60c037bd134$export$af6d68522cb370b8
    },
    [$849ca60c037bd134$export$5c8703f47a29c462]: {
        text: (0, $2mX4j.default).learnMore,
        href: $849ca60c037bd134$export$af6d68522cb370b8
    },
    [$849ca60c037bd134$export$cfba07bc71f884c1]: {
        text: (0, $2mX4j.default).contactSupport,
        href: $849ca60c037bd134$export$2c16bd1d8b68b11f
    }
};
const $849ca60c037bd134$export$3c3f70484d1d8acd = {
    [$849ca60c037bd134$export$e6515d2009b1dba7]: {
        text: (0, $2mX4j.default).learnMore,
        href: $849ca60c037bd134$export$af6d68522cb370b8
    },
    [$849ca60c037bd134$export$80ecb4d853a9f09b]: {
        text: (0, $2mX4j.default).learnMore,
        href: $849ca60c037bd134$export$af6d68522cb370b8
    },
    [$849ca60c037bd134$export$f31def2c4daaefc0]: {
        text: (0, $2mX4j.default).learnMore,
        href: $849ca60c037bd134$export$af6d68522cb370b8
    },
    [$849ca60c037bd134$export$530d46555d7ccbb]: {
        text: (0, $2mX4j.default).learnMore,
        href: $849ca60c037bd134$export$af6d68522cb370b8
    },
    [$849ca60c037bd134$export$8c852ea52ca9ebe]: {
        text: (0, $2mX4j.default).learnMore,
        href: $849ca60c037bd134$export$af6d68522cb370b8
    },
    [$849ca60c037bd134$export$855d898b7009ad1c]: {
        text: (0, $2mX4j.default).learnMore,
        href: $849ca60c037bd134$export$af6d68522cb370b8
    },
    [$849ca60c037bd134$export$5c8703f47a29c462]: {
        text: (0, $2mX4j.default).learnMore,
        href: $849ca60c037bd134$export$af6d68522cb370b8
    },
    [$849ca60c037bd134$export$cfba07bc71f884c1]: {
        text: (0, $2mX4j.default).contactSupport,
        href: $849ca60c037bd134$export$2c16bd1d8b68b11f
    }
};

});
parcelRegister("2mX4j", function(module, exports) {

$parcel$export(module.exports, "default", () => $80fbe5208791cbaa$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $80fbe5208791cbaa$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    configurationErrorTitle: {
        "id": "portfolio-3-create-sample-plan.common.configuration-error-title",
        "defaultMessage": "Your demo plan couldn't be created because of a configuration error"
    },
    configurationErrorTitleOld: {
        "id": "portfolio-3-create-sample-plan.common.configuration-error-title-old",
        "defaultMessage": "Your sample plan couldn't be created because of a configuration error"
    },
    permissionErrorTitle: {
        "id": "portfolio-3-create-sample-plan.common.permission-error-title",
        "defaultMessage": "Your demo plan couldn't be created because you\u2019re missing a required permission"
    },
    permissionErrorTitleOld: {
        "id": "portfolio-3-create-sample-plan.common.permission-error-title-old",
        "defaultMessage": "Your sample plan couldn't be created because you\u2019re missing a required permission"
    },
    tryAgainErrorTitle: {
        "id": "portfolio-3-create-sample-plan.common.try-again-error-title",
        "defaultMessage": "Try to create your demo plan again"
    },
    tryAgainErrorTitleOld: {
        "id": "portfolio-3-create-sample-plan.common.try-again-error-title-old",
        "defaultMessage": "Try to create your sample plan again"
    },
    requiredFieldsConfiguredOnIssueError: {
        "id": "portfolio-3-create-sample-plan.common.required-fields-configured-on-issue-error",
        "defaultMessage": "Your issues have required fields which blocked your demo plan from being created. {readMoreLink}"
    },
    requiredFieldsConfiguredOnIssueErrorOld: {
        "id": "portfolio-3-create-sample-plan.common.required-fields-configured-on-issue-error-old",
        "defaultMessage": "Your issues have required fields which blocked your sample plan from being created. {readMoreLink}"
    },
    emptyIssueLinksError: {
        "id": "portfolio-3-create-sample-plan.common.empty-issue-links-error",
        "defaultMessage": "Your site doesn't have issue links configured, which are required to create a demo plan. {readMoreLink}"
    },
    emptyIssueLinksErrorOld: {
        "id": "portfolio-3-create-sample-plan.common.empty-issue-links-error-old",
        "defaultMessage": "Your site doesn't have issue links configured, which are required to create a sample plan. {readMoreLink}"
    },
    noBrowseProjectsPermissionError: {
        "id": "portfolio-3-create-sample-plan.common.no-browse-projects-permission-error",
        "defaultMessage": "Your demo plan couldn't be created because you don\u2019t have the <permission-type>Browse Projects</permission-type> permission. {readMoreLink}"
    },
    noBrowseProjectsPermissionErrorOld: {
        "id": "portfolio-3-create-sample-plan.common.no-browse-projects-permission-error-old",
        "defaultMessage": "Your sample plan couldn't be created because you don\u2019t have the <permission-type>Browse Projects</permission-type> permission. {readMoreLink}"
    },
    noCreateIssuesPermissionError: {
        "id": "portfolio-3-create-sample-plan.common.no-create-issues-permission-error",
        "defaultMessage": "Your demo plan couldn't be created because you don\u2019t have the <permission-type>Create Issues</permission-type> permission. {readMoreLink}"
    },
    noCreateIssuesPermissionErrorOld: {
        "id": "portfolio-3-create-sample-plan.common.no-create-issues-permission-error-old",
        "defaultMessage": "Your sample plan couldn't be created because you don\u2019t have the <permission-type>Create Issues</permission-type> permission. {readMoreLink}"
    },
    noTransitionIssuesPermissionError: {
        "id": "portfolio-3-create-sample-plan.common.no-transition-issues-permission-error",
        "defaultMessage": "Your demo plan couldn't be created because you don\u2019t have the <permission-type>Transition Issues</permission-type> permission. {readMoreLink}"
    },
    noTransitionIssuesPermissionErrorOld: {
        "id": "portfolio-3-create-sample-plan.common.no-transition-issues-permission-error-old",
        "defaultMessage": "Your sample plan couldn't be created because you don\u2019t have the <permission-type>Transition Issues</permission-type> permission. {readMoreLink}"
    },
    noEditIssuesPermissionError: {
        "id": "portfolio-3-create-sample-plan.common.no-edit-issues-permission-error",
        "defaultMessage": "Your demo plan couldn't be created because you don\u2019t have the <permission-type>Edit Issues</permission-type> permission. {readMoreLink}"
    },
    noEditIssuesPermissionErrorOld: {
        "id": "portfolio-3-create-sample-plan.common.no-edit-issues-permission-error-old",
        "defaultMessage": "Your sample plan couldn't be created because you don\u2019t have the <permission-type>Edit Issues</permission-type> permission. {readMoreLink}"
    },
    watchingDisabledError: {
        "id": "portfolio-3-create-sample-plan.common.watching-disabled-error",
        "defaultMessage": "Your demo plan couldn't be created because you have issue watching disabled. {readMoreLink}"
    },
    watchingDisabledErrorOld: {
        "id": "portfolio-3-create-sample-plan.common.watching-disabled-error-old",
        "defaultMessage": "Your sample plan couldn't be created because you have issue watching disabled. {readMoreLink}"
    },
    unknownExceptionError: {
        "id": "portfolio-3-create-sample-plan.common.unknown-exception-error",
        "defaultMessage": "Your demo plan couldn't be created, but we\u2019re not sure why. If the problem persists, contact Atlassian support. {readMoreLink}"
    },
    unknownExceptionErrorOld: {
        "id": "portfolio-3-create-sample-plan.common.unknown-exception-error-old",
        "defaultMessage": "Your sample plan couldn't be created, but we\u2019re not sure why. If the problem persists, contact Atlassian support. {readMoreLink}"
    },
    learnMore: {
        "id": "portfolio-3-create-sample-plan.common.learn-more",
        "defaultMessage": "Learn more"
    },
    contactSupport: {
        "id": "portfolio-3-create-sample-plan.common.contact-support",
        "defaultMessage": "Contact Atlassian support"
    }
});

});


parcelRegister("d0QLq", function(module, exports) {

$parcel$export(module.exports, "useCreateSamplePlan", () => $941848b62f4a3507$export$53d6fde96f096b86);
$parcel$export(module.exports, "CreateSamplePlanProvider", () => $941848b62f4a3507$export$88b99aa46c223622);

var $eUqFw = parcelRequire("eUqFw");

var $heB5U = parcelRequire("heB5U");
var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");

var $guiFP = parcelRequire("guiFP");

var $iG4Rs = parcelRequire("iG4Rs");

var $crTvr = parcelRequire("crTvr");
const $941848b62f4a3507$var$CONTROLLER_NAME = 'create-sample-plan';
const $941848b62f4a3507$var$initialState = {
    /**
	 * This field controls modal dismissible status
	 */ isOpen: false,
    /**
	 * This field is only used to redirect the user to plan page if the modal is not closed.
	 */ planId: null,
    /**
	 * This field is used to detect the correct redirection creation session,
	 * without this field, we don't know which creation session needs to be redirected
	 * e.g. the user started multiple sample creation and stays on the last one - in this case,
	 * only the last creation needs to be redirected.
	 */ taskId: null,
    /**
	 * Progress of the ongoing task
	 */ progressPercentage: null,
    /**
	 * Once this field has been set to `true`, we'll know we can call the actions returned
	 * by our useCreateSamplePlan hook.
	 */ hasBeenInitialised: false
};
const $941848b62f4a3507$var$actions = {
    open: ()=>({ setState: setState })=>{
            setState({
                isOpen: true
            });
        },
    close: ()=>({ setState: setState })=>{
            const nextState = (({ hasBeenInitialised: hasBeenInitialised, ...rest })=>rest)($941848b62f4a3507$var$initialState);
            setState(nextState);
        },
    setPlanId: (planId)=>({ setState: setState })=>{
            setState({
                planId: planId
            });
        },
    setTaskId: (taskId)=>({ setState: setState })=>{
            setState({
                taskId: taskId
            });
        },
    setProgressPercentage: (progressPercentage)=>({ setState: setState })=>{
            setState({
                progressPercentage: progressPercentage
            });
        },
    submitSamplePlan: ({ planName: planName, flags: { success: SuccessFlag, error: ErrorFlag } })=>async ({ setState: setState, getState: getState, dispatch: dispatch }, { showFlag: showFlag, redirectToPlan: redirectToPlan, leadAccountId: leadAccountId })=>{
            try {
                const taskId = await (0, $crTvr.createSamplePlanAsync)({
                    body: JSON.stringify({
                        title: planName,
                        leadAccountId: leadAccountId
                    })
                });
                setState({
                    taskId: taskId
                });
                const response = await (0, $crTvr.pollCreateSamplePlan)(taskId, (progressPercentage)=>{
                    const { taskId: latestTaskId } = getState();
                    // progressPercentage should reflect the progress of the most recent taskId
                    // If they don't match, skip updating
                    if (taskId !== latestTaskId) return;
                    setState({
                        progressPercentage: progressPercentage
                    });
                });
                const { plan: plan } = response.samplePlan;
                const currentState = getState();
                // We only want to redirect them if the taskId for the current modal is the same as the one for this request
                // Else it might belong to a previous modal
                if (currentState.isOpen && taskId === currentState.taskId) {
                    redirectToPlan(plan.id);
                    dispatch($941848b62f4a3507$var$actions.close());
                } else {
                    const flagId = (0, $iG4Rs.CREATE_SUCCESS_FLAG_ID) + plan.id;
                    showFlag({
                        id: flagId,
                        render: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(SuccessFlag, {
                                id: flagId,
                                planName: plan.name,
                                planId: plan.id
                            })
                    });
                }
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (err) {
                // we only want to track errors unrelated to user settings
                if (!(0, $iG4Rs.USER_SETTINGS_ERRORS).includes(err.message)) (0, $guiFP.default)({
                    error: err,
                    meta: {
                        id: `${(0, $iG4Rs.ERROR_REPORTING_PACKAGE)}SubmitFailed`,
                        packageName: (0, $iG4Rs.ERROR_REPORTING_PACKAGE),
                        teamName: (0, $iG4Rs.ERROR_REPORTING_TEAM)
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
                const props = {
                    id: (0, $iG4Rs.CREATE_ERROR_FLAG_ID),
                    errorCode: err.message
                };
                showFlag({
                    id: (0, $iG4Rs.CREATE_ERROR_FLAG_ID),
                    render: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ErrorFlag, props)
                });
                dispatch($941848b62f4a3507$var$actions.close());
            }
        }
};
const $941848b62f4a3507$var$Store = (0, $a61MH.createStore)({
    name: $941848b62f4a3507$var$CONTROLLER_NAME,
    initialState: $941848b62f4a3507$var$initialState,
    actions: $941848b62f4a3507$var$actions
});
const $941848b62f4a3507$export$53d6fde96f096b86 = (0, $ggKAj.createHook)($941848b62f4a3507$var$Store);
const $941848b62f4a3507$export$88b99aa46c223622 = (0, $heB5U.createContainer)($941848b62f4a3507$var$Store, {
    onInit: ()=>({ setState: setState }, { isOpen: isOpen = false })=>{
            setState({
                isOpen: isOpen,
                hasBeenInitialised: true
            });
        }
});

});
parcelRegister("crTvr", function(module, exports) {

$parcel$export(module.exports, "createSamplePlanAsync", () => $35743bfccad6aca6$export$fed9130b90cf6213);
$parcel$export(module.exports, "pollCreateSamplePlan", () => $35743bfccad6aca6$export$5d240a69af545c0d);
/**
 * Consider moving into service
 */ 
var $guiFP = parcelRequire("guiFP");

var $7byHA = parcelRequire("7byHA");
var $lRmyA = parcelRequire("lRmyA");

var $88Osm = parcelRequire("88Osm");

var $iG4Rs = parcelRequire("iG4Rs");
const $35743bfccad6aca6$var$throwIfNotOk = async (response)=>{
    if (response.ok) return response;
    if (response.status === 500) throw new (0, $7byHA.default)(response.status, (0, $iG4Rs.UNKNOWN_EXCEPTION), response.headers.get((0, $88Osm.TRACE_ID_HEADER)) ?? undefined, response);
};
const $35743bfccad6aca6$var$throwIfFailed = (result)=>{
    if (result.samplePlan && !result.samplePlan.success) throw new Error(result.samplePlan.error);
};
const $35743bfccad6aca6$var$delay = (ms = 3000)=>new Promise((res)=>setTimeout(res, ms));
const $35743bfccad6aca6$export$fed9130b90cf6213 = async (data)=>{
    const response = await (0, $lRmyA.performPostRequest)('/rest/jpo/1.0/plans/sampleplan/async', data);
    const { taskId: taskId } = response;
    if (!taskId) throw new Error('Invalid response from createSamplePlan');
    return taskId;
};
const $35743bfccad6aca6$export$5d240a69af545c0d = async (taskId, onUpdate)=>{
    const url = `/rest/jpo/1.0/plans/sampleplan/async/${taskId}`;
    try {
        const response = await fetch(url);
        await $35743bfccad6aca6$var$throwIfNotOk(response);
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const raw = await response.json();
        $35743bfccad6aca6$var$throwIfFailed(raw);
        onUpdate(raw.progressPercent);
        if (raw.done) return raw;
        await $35743bfccad6aca6$var$delay();
        return $35743bfccad6aca6$export$5d240a69af545c0d(taskId, onUpdate);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        // we only want to track errors unrelated to user settings
        if (!(0, $iG4Rs.USER_SETTINGS_ERRORS).includes(error.message)) (0, $guiFP.default)({
            meta: {
                id: `${(0, $iG4Rs.ERROR_REPORTING_PACKAGE)}PollingFailed`,
                packageName: (0, $iG4Rs.ERROR_REPORTING_PACKAGE),
                teamName: (0, $iG4Rs.ERROR_REPORTING_TEAM)
            },
            attributes: {
                message: 'Polling create sample plan failed'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
        throw error;
    }
};

});


parcelRegister("bF8PW", function(module, exports) {

$parcel$export(module.exports, "default", () => $addbede4c63974df$export$2e2bcd8739ae039);

var $7rh0R = parcelRequire("7rh0R");

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $addbede4c63974df$var$CreateSamplePlanContent = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("dWc1D")).then((module)=>module.default), {
    moduleId: "./src/packages/portfolio-3/create-sample-plan/src/ui/content/index.tsx"
});
var $addbede4c63974df$export$2e2bcd8739ae039 = $addbede4c63974df$var$CreateSamplePlanContent;

});
parcelRegister("dWc1D", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('hPzOn'),
            load('4Ud00')
        ]);
        const value = parcelRequire('jBXsS');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("hPzOn"),
        load("4Ud00")
    ]).then(()=>parcelRequire('jBXsS'));
}

});




parcelRegister("9GDXZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $8bf49dd378c5d4da$export$2e2bcd8739ae039);

var $8un0w = parcelRequire("8un0w");

var $knPb9 = parcelRequire("knPb9");

var $bAQOb = parcelRequire("bAQOb");

var $lbttE = parcelRequire("lbttE");

var $bQPcp = parcelRequire("bQPcp");

var $8nNbW = parcelRequire("8nNbW");

var $aIshW = parcelRequire("aIshW");
const $8bf49dd378c5d4da$var$ProjectCreate = (0, $bAQOb.componentWithFF)('project-create-retooling-enabled-hix-3234', (0, $bQPcp.default), (0, $8nNbW.default));
var $8bf49dd378c5d4da$export$2e2bcd8739ae039 = (0, $8un0w.default)({
    onClose: ({ screen: screen, canCreateClassicProject: canCreateClassicProject, canCreateNextGenProject: canCreateNextGenProject, isAdmin: isAdmin, projectComparisonScreen: projectComparisonScreen })=>({
            name: 'projectCreate',
            screen: screen,
            canCreateClassic: canCreateClassicProject,
            canCreateNextGen: canCreateNextGenProject,
            isAdmin: isAdmin,
            projectComparisonScreen: projectComparisonScreen
        })
})((0, $knPb9.default)((0, $aIshW.default), {
    Consumer: (0, $lbttE.ProjectCreateDrawerConsumer),
    ProjectCreate: $8bf49dd378c5d4da$var$ProjectCreate
}));

});
parcelRegister("8un0w", function(module, exports) {

$parcel$export(module.exports, "default", () => $da3e17e369dbbaa5$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $etqm0 = parcelRequire("etqm0");
/**
 * Adds analytics events to the given callbacks without altering the original behavior
 * Callback is expected to have analyticsEvent as a last argument
 * @example
 * ```tsx
 *  // will fire "select" event when onSelect is called
 *  fileWithUIAnalytics({ onSelect: 'select' })
 *
 *  // will fire "select" event with extra attributes
 *  fileWithUIAnalytics({ onSelect: (value) => ({ name: 'select', value: value}) }
 *  ```
 */ const $da3e17e369dbbaa5$var$fireWithUIAnalytics = (ConnectedProps)=>{
    // sort the keys so we can set the deps of useMemo
    const providedKeys = Object.keys(ConnectedProps).sort();
    /**
	 * We implement a custom caching mechanism rather than memoizeOne. We got
	 * more ops/sec this way and we only need to bust the changing props cache
	 * instead of destroying all references on a single prop change.
	 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const cachedMappedProps = {}; /*    the actual prop value */ 
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const cachedConnectedProps = {}; /* the connected prop value (the callback) */ 
    const getStateFromMappedProps = (mapped)=>{
        providedKeys.forEach((key, index)=>{
            // firstly check the cache if the prop has changed before creating
            // any new connected props
            const prop = mapped[index];
            if (key in cachedMappedProps && cachedMappedProps[key] === prop) return;
            cachedMappedProps[key] = prop;
            // @ts-expect-error - TS7019 - Rest parameter 'attrs' implicitly has an 'any[]' type.
            cachedConnectedProps[key] = (...attrs)=>{
                // assume that analytics event is always the last one (it should be by convention)
                const analyticsEvent = attrs[attrs.length - 1].clone();
                const connectedProp = ConnectedProps[key];
                // example: { onSelect: 'select' }
                if (typeof ConnectedProps[key] === 'string') analyticsEvent.update({
                    name: connectedProp,
                    analyticsType: (0, $etqm0.UI_EVENT_TYPE)
                }).fire();
                else if (typeof connectedProp === 'function') {
                    const update = connectedProp(...attrs);
                    analyticsEvent.update({
                        ...update,
                        analyticsType: (0, $etqm0.UI_EVENT_TYPE)
                    }).fire();
                }
                if (typeof prop === 'function') prop(...attrs);
            };
        });
        return cachedConnectedProps;
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (WrappedComponent)=>// eslint-disable-next-line jira/react/no-class-components, @typescript-eslint/no-explicit-any,@typescript-eslint/consistent-type-assertions
        class WithAnalytics extends (0, $eUqFw.Component) {
            static{
                // Note: This seems to render weirdly in the chrome debugger. May need to change the string formatting to work around it
                this.displayName = `WithAnalytics(${WrappedComponent.displayName || WrappedComponent.name || 'UnnamedComponent'}`;
            }
            render() {
                const newMappedProps = getStateFromMappedProps(providedKeys.map((key)=>this.props[key]));
                // @ts-expect-error TS2322: Type {} is not assignable to type
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, {
                    ...this.props,
                    ...newMappedProps
                });
            }
        }; // eslint-disable-line @typescript-eslint/no-explicit-any
};
var $da3e17e369dbbaa5$export$2e2bcd8739ae039 = $da3e17e369dbbaa5$var$fireWithUIAnalytics;

});

parcelRegister("bQPcp", function(module, exports) {

$parcel$export(module.exports, "default", () => $032f4cd0e274e4ee$export$2e2bcd8739ae039);
/* async.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7rh0R = parcelRequire("7rh0R");

var $4Bees = parcelRequire("4Bees");

var $0cdA8 = parcelRequire("0cdA8");

var $gGtKh = parcelRequire("gGtKh");

const $032f4cd0e274e4ee$export$cb6ba161267f8f0c = ()=>(parcelRequire("hAnKU"));

/* eslint-disable-next-line jira/import/webpack-magic-comment-entries, jira/deprecations/no-rll-client-async-experiences */ const $032f4cd0e274e4ee$var$LazyComponent = (0, $7rh0R.lazy)(()=>(parcelRequire("hAnKU")), {
    moduleId: "./src/packages/project-create/main/src/index.tsx"
});
const $032f4cd0e274e4ee$export$b283b23d37290b6a = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "bundle-async-project-create",
        fallback: "flag",
        packageName: "jira-project-create-main"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "project-create",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($032f4cd0e274e4ee$var$Center, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), {
            size: "large"
        }))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($032f4cd0e274e4ee$var$LazyComponent, props)));
var $032f4cd0e274e4ee$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $032f4cd0e274e4ee$export$b283b23d37290b6a;
const $032f4cd0e274e4ee$var$Center = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _4t3i1kxc",
            __cmplp.className
        ])
    });
});

});
parcelRegister("hAnKU", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('hPzOn'),
            load('2hmUs'),
            load('bCeK4'),
            load('3F8ry')
        ]);
        const value = parcelRequire('i1XOq');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("hPzOn"),
        load("2hmUs"),
        load("bCeK4"),
        load("3F8ry")
    ]).then(()=>parcelRequire('i1XOq'));
}

});


parcelRegister("8nNbW", function(module, exports) {

$parcel$export(module.exports, "loadProjectCreateBundle", () => $180e818162e16f78$export$cb6ba161267f8f0c);
$parcel$export(module.exports, "AsyncProjectCreate", () => $180e818162e16f78$export$b283b23d37290b6a);
$parcel$export(module.exports, "default", () => $180e818162e16f78$export$2e2bcd8739ae039);
/* async.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7rh0R = parcelRequire("7rh0R");

var $4Bees = parcelRequire("4Bees");

var $0cdA8 = parcelRequire("0cdA8");

var $gGtKh = parcelRequire("gGtKh");


const $180e818162e16f78$export$cb6ba161267f8f0c = ()=>(parcelRequire("bdgbp"));

/* eslint-disable-next-line jira/import/webpack-magic-comment-entries, jira/deprecations/no-rll-client-async-experiences */ const $180e818162e16f78$var$LazyComponent = (0, $7rh0R.lazy)(()=>(parcelRequire("bdgbp")), {
    moduleId: "./src/packages/project-create-old/src/index.tsx"
});
const $180e818162e16f78$export$b283b23d37290b6a = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "bundle-async-project-create",
        fallback: "flag",
        packageName: "jira-project-create",
        teamName: "helix"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "project-create",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($180e818162e16f78$var$Center, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), {
            size: "large"
        }))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($180e818162e16f78$var$LazyComponent, props)));
var $180e818162e16f78$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $180e818162e16f78$export$b283b23d37290b6a;
const $180e818162e16f78$var$Center = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _4t3i1kxc",
            __cmplp.className
        ])
    });
});

});
const $10d4a12524bf3792$export$59fe870bc818978d = 'PROJECT_CREATE_LOAD_START_MARK_KEY';
const $10d4a12524bf3792$export$c31bdc8313c39f72 = 'PROJECT_CREATE_LOAD_END_MARK_KEY';
const $10d4a12524bf3792$export$5dc4f809336ac7c3 = 'PROJECT_CREATE_READY_MARK_KEY';
const $10d4a12524bf3792$export$8f0c4426531e762 = 'project-create';
const $10d4a12524bf3792$export$def2f343237303e5 = 'projectCreateJwmOnboarding';

parcelRegister("bdgbp", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('dsiAd'),
            load('9vNc4'),
            load('4ogRW'),
            load('2hmUs'),
            load('bCeK4'),
            load('hPzOn'),
            load('h2MrD'),
            load('bYT2S'),
            load('4vXEb')
        ]);
        const value = parcelRequire('eZMr7');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("dsiAd"),
        load("9vNc4"),
        load("4ogRW"),
        load("2hmUs"),
        load("bCeK4"),
        load("hPzOn"),
        load("h2MrD"),
        load("bYT2S"),
        load("4vXEb")
    ]).then(()=>parcelRequire('eZMr7'));
}

});


parcelRegister("aIshW", function(module, exports) {

$parcel$export(module.exports, "default", () => $f824b2dfee99d8c5$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $hFmdR = parcelRequire("hFmdR");

var $6iz4v = parcelRequire("6iz4v");

var $6U1dF = parcelRequire("6U1dF");



var $l2C7j = parcelRequire("l2C7j");
const $f824b2dfee99d8c5$var$PreloadAsyncProjectCreateDrawer = ()=>{
    (0, $eUqFw.useEffect)(()=>{
        (0, $l2C7j.preloadAsyncProjectCreateDrawer)();
    }, []);
    return null;
};
// eslint-disable-next-line jira/react/no-class-components
const $f824b2dfee99d8c5$var$View = class ProjectCreateDrawer extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            isAdmin: false,
            isOnboarding: false
        };
    }
    render() {
        const { Consumer: Consumer } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, Consumer ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Consumer, null, ({ data: data, methods: methods })=>data.shouldRenderDrawer ? this.renderContent(data, methods) : null) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6U1dF.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f824b2dfee99d8c5$var$PreloadAsyncProjectCreateDrawer, null)));
    }
    constructor(...args){
        super(...args);
        this.onScreenChange = (screen)=>{
            this.screen = screen;
        };
        this.onPermissionsFetched = ({ canCreateClassicProject: canCreateClassicProject, canCreateNextGenProject: canCreateNextGenProject })=>{
            this.permissions = {
                canCreateClassicProject: canCreateClassicProject,
                canCreateNextGenProject: canCreateNextGenProject
            };
        };
        this.screen = '';
        this.permissions = {
            canCreateClassicProject: null,
            canCreateNextGenProject: null
        };
        this.renderContent = (data, methods)=>{
            const { isAdmin: isAdmin, baseUrl: baseUrl, locale: locale, isOnboarding: isOnboarding, appEditions: appEditions, ProjectCreate: ProjectCreate } = this.props;
            if (data.isOpen) (0, $6iz4v.setMark)((0, $10d4a12524bf3792$export$59fe870bc818978d));
            const onClose = (e, analyticsEvent)=>{
                methods.close();
                this.props.onClose && this.props.onClose({
                    screen: this.screen,
                    isAdmin: this.props.isAdmin,
                    canCreateClassicProject: this.permissions.canCreateClassicProject,
                    canCreateNextGenProject: this.permissions.canCreateNextGenProject
                }, analyticsEvent);
            };
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $l2C7j.AsyncProjectCreateDrawerContent), {
                onClose: onClose,
                baseUrl: baseUrl,
                isAdmin: isAdmin,
                isOnboarding: isOnboarding,
                data: data,
                methods: methods,
                locale: locale,
                appEditions: appEditions,
                onScreenChange: this.onScreenChange,
                onPermissionsFetched: this.onPermissionsFetched,
                ProjectCreate: ProjectCreate
            });
        };
    }
};
var $f824b2dfee99d8c5$export$2e2bcd8739ae039 = (0, $hFmdR.AnalyticsSource)('ProjectCreate', (0, $41ea3621645e2acc$export$9d2de6eebf7462b5))($f824b2dfee99d8c5$var$View);

});
parcelRegister("6U1dF", function(module, exports) {

$parcel$export(module.exports, "NonCritical", () => $7c939f739e44c405$export$20fd89b1bf707b1a);
$parcel$export(module.exports, "default", () => $7c939f739e44c405$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $0cdA8 = parcelRequire("0cdA8");

var $h3mHU = parcelRequire("h3mHU");
const $7c939f739e44c405$export$83d969795398ec56 = ({ children: children, timerThreshold: timerThreshold })=>{
    const [{ isReady: isReady }] = (0, $h3mHU.useSpaStatePageReady)();
    const [isFirstRun, setFirstRun] = (0, $eUqFw.useState)(true);
    const [hasThresholdTimerExpired, setHasThresholdTimerExpired] = (0, $eUqFw.useState)(false);
    (0, $eUqFw.useEffect)(()=>{
        if (timerThreshold != null) setTimeout(()=>{
            setHasThresholdTimerExpired(true);
        }, timerThreshold);
    }, [
        timerThreshold
    ]);
    if (!isFirstRun || isReady || hasThresholdTimerExpired) {
        isFirstRun && setFirstRun(false);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children);
    }
    return null;
};
const $7c939f739e44c405$export$5b2f4b62d18632 = ({ id: id = 'non-critical-with-timer', teamName: teamName, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: id,
        teamName: teamName,
        packageName: "jiraPlatformNonCritical",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7c939f739e44c405$export$83d969795398ec56, props));
/**
 * Delays rendering its children until the page is deemed ready, optimizing for a smoother initial load. Suitable for content that is not immediately necessary.
 */ const $7c939f739e44c405$var$NonCriticalComponent = (props)=>{
    const [{ isReady: isReady }] = (0, $h3mHU.useSpaStatePageReady)();
    const [isFirstRun, setFirstRun] = (0, $eUqFw.useState)(true);
    if (!isFirstRun || isReady) {
        isFirstRun && setFirstRun(false);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, props.children);
    }
    return null;
};
const $7c939f739e44c405$export$20fd89b1bf707b1a = ({ id: id = 'non-critical', teamName: teamName, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: id,
        teamName: teamName,
        packageName: "jiraPlatformNonCritical",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7c939f739e44c405$var$NonCriticalComponent, props));
var $7c939f739e44c405$export$2e2bcd8739ae039 = $7c939f739e44c405$var$NonCriticalComponent;

});

parcelRegister("l2C7j", function(module, exports) {

$parcel$export(module.exports, "preloadAsyncProjectCreateDrawer", () => $935c7210450a66fa$export$bf40786982237798);
$parcel$export(module.exports, "AsyncProjectCreateDrawerContent", () => $935c7210450a66fa$export$975ae959df433581);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $51vNN = parcelRequire("51vNN");

var $0cdA8 = parcelRequire("0cdA8");

var $gGtKh = parcelRequire("gGtKh");

const $935c7210450a66fa$export$bf40786982237798 = ()=>(parcelRequire("1n9d5"));

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $935c7210450a66fa$var$LazyComponent = (0, $7rh0R.lazy)(()=>// eslint-disable-next-line jira/import/webpack-magic-comment-entries
    (parcelRequire("1n9d5")), {
    moduleId: "./src/packages/navigation-apps/project-create-drawer/src/view/index.tsx"
});
const $935c7210450a66fa$var$newComponent = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "bundle-async-project-create-drawer",
        fallback: "flag",
        packageName: "jira-project-create-drawer",
        teamName: "helix"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "async-project-create-drawer",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $51vNN.default), {
            isTinted: true
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($935c7210450a66fa$var$LazyComponent, props)));
const $935c7210450a66fa$export$975ae959df433581 = $935c7210450a66fa$var$newComponent;

});
parcelRegister("1n9d5", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('9YSUX');
        const value = parcelRequire('1R4BF');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("9YSUX").then(()=>parcelRequire('1R4BF'));
}

});




parcelRegister("28VqH", function(module, exports) {

$parcel$export(module.exports, "default", () => $4e1773b25886a8b4$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $0cdA8 = parcelRequire("0cdA8");

var $gGtKh = parcelRequire("gGtKh");

var $7uVYl = parcelRequire("7uVYl");


// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $4e1773b25886a8b4$var$ShortcutsDialogLazy = (0, $7rh0R.lazy)(()=>(parcelRequire("g4kvy")), {
    ssr: false,
    moduleId: "./src/packages/shortcuts-dialog/src/ui/main.tsx"
});
const $4e1773b25886a8b4$var$ShortcutsDialog = ()=>{
    const [{ isShortcutsDialogVisible: isShortcutsDialogVisible }] = (0, $7uVYl.useShortcuts)();
    return isShortcutsDialogVisible ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "shortcuts-dialog",
        packageName: "jira-shortcuts-dialog",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "atlassian-jira-shortcuts-dialog",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4e1773b25886a8b4$var$ShortcutsDialogLazy, null))) : null;
};
var $4e1773b25886a8b4$export$2e2bcd8739ae039 = $4e1773b25886a8b4$var$ShortcutsDialog;

});
parcelRegister("7uVYl", function(module, exports) {

$parcel$export(module.exports, "useShortcuts", () => $76686ee3e3d6a06c$export$a1ca853c6e4bb6fb);
$parcel$export(module.exports, "useShortcutsActions", () => $76686ee3e3d6a06c$export$b331ee6e87b9104c);

var $fvC6Z = parcelRequire("fvC6Z");
const $76686ee3e3d6a06c$export$a1ca853c6e4bb6fb = ()=>(0, $fvC6Z.useShortcutsStore)();
const $76686ee3e3d6a06c$export$b331ee6e87b9104c = ()=>{
    const [, actions] = (0, $fvC6Z.useShortcutsActionsStore)();
    return [
        undefined,
        actions
    ];
};

});
parcelRegister("fvC6Z", function(module, exports) {

$parcel$export(module.exports, "useShortcutsStore", () => $896347e3151ace81$export$a14646bfc7ba8d81);
$parcel$export(module.exports, "useShortcutsActionsStore", () => $896347e3151ace81$export$1a29bfef7fa09838);

var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");

var $4Dsz6 = parcelRequire("4Dsz6");
const $896347e3151ace81$export$d4c72bab9d6cc13a = {
    shortcuts: {
        admin: {
            key: 'admin',
            label: 'ADMIN',
            options: [],
            isLoaded: false
        }
    },
    isShortcutsDialogVisible: false,
    isShortcutsLoading: false,
    hasError: false,
    isAdminLoading: false,
    selectedItemKey: null,
    header: null,
    title: undefined
};
const $896347e3151ace81$export$6f57813fe9f31bf9 = (0, $a61MH.createStore)({
    name: 'shortcuts',
    initialState: // @ts-expect-error - TS2322 - Type '{ readonly shortcuts: { readonly admin: { readonly key: "admin"; readonly label: "ADMIN"; readonly options: readonly []; readonly isLoaded: false; }; }; readonly isShortcutsDialogVisible: false; readonly isShortcutsLoading: false; ... 4 more ...; readonly title: undefined; }' is not assignable to type 'State'.
    $896347e3151ace81$export$d4c72bab9d6cc13a,
    actions: $4Dsz6
});
const $896347e3151ace81$export$a14646bfc7ba8d81 = (0, $ggKAj.createHook)($896347e3151ace81$export$6f57813fe9f31bf9);
const $896347e3151ace81$export$1a29bfef7fa09838 = (0, $ggKAj.createHook)($896347e3151ace81$export$6f57813fe9f31bf9, {
    selector: null
});

});
parcelRegister("4Dsz6", function(module, exports) {

$parcel$export(module.exports, "registerShortcuts", () => $9eb9f475a5856f0f$export$598ec0e6047cbdca);
$parcel$export(module.exports, "setShortcutsDialogVisibility", () => $9eb9f475a5856f0f$export$80ab1e79e32c3021);
$parcel$export(module.exports, "setShortcutsLoading", () => $9eb9f475a5856f0f$export$7ed2ac8328423043);
$parcel$export(module.exports, "setHasError", () => $9eb9f475a5856f0f$export$645a7c7453685186);
$parcel$export(module.exports, "setHeader", () => $9eb9f475a5856f0f$export$604ed74fb893f0e2);
$parcel$export(module.exports, "fetchAdminSections", () => $9eb9f475a5856f0f$export$aec87c8c9bde62e6);
$parcel$export(module.exports, "setSelectedItemKey", () => $9eb9f475a5856f0f$export$249c9d5b49cd9712);
$parcel$export(module.exports, "dropShortcutsByKeys", () => $9eb9f475a5856f0f$export$9cf39adf0dec984);

var $iVIEg = parcelRequire("iVIEg");

var $6QsdI = parcelRequire("6QsdI");

var $kh3b8 = parcelRequire("kh3b8");
const $9eb9f475a5856f0f$export$598ec0e6047cbdca = (shortcuts)=>({ getState: getState, setState: setState })=>{
        const currentState = getState();
        const newShortcuts = shortcuts.reduce((acc, current)=>{
            acc[current.key] = current;
            return acc;
        }, {
            ...currentState.shortcuts
        });
        setState({
            ...currentState,
            shortcuts: newShortcuts,
            isShortcutsLoading: false
        });
    };
const $9eb9f475a5856f0f$export$80ab1e79e32c3021 = (isVisible)=>({ getState: getState, setState: setState })=>{
        setState({
            ...getState(),
            isShortcutsDialogVisible: isVisible
        });
    };
const $9eb9f475a5856f0f$export$7ed2ac8328423043 = (isLoading)=>({ getState: getState, setState: setState })=>{
        setState({
            ...getState(),
            isShortcutsLoading: isLoading
        });
    };
const $9eb9f475a5856f0f$export$645a7c7453685186 = (hasError)=>({ getState: getState, setState: setState })=>{
        const currentState = getState();
        setState({
            ...currentState,
            hasError: hasError
        });
    };
const $9eb9f475a5856f0f$export$604ed74fb893f0e2 = (header, title)=>({ getState: getState, setState: setState })=>{
        const currentState = getState();
        setState({
            ...currentState,
            header: header,
            title: title
        });
    };
const $9eb9f475a5856f0f$export$aec87c8c9bde62e6 = ()=>async ({ setState: setState, getState: getState })=>{
        const currentState = getState();
        setState({
            ...currentState,
            isAdminLoading: true
        });
        const result = await (0, $6QsdI.default)();
        const shortcuts = result ? (0, $kh3b8.buildAdminSections)(result) : [];
        const newState = getState();
        setState({
            ...newState,
            shortcuts: {
                ...newState.shortcuts,
                admin: {
                    ...newState.shortcuts.admin,
                    key: 'admin',
                    options: shortcuts,
                    isLoaded: true
                }
            },
            hasError: currentState.hasError || !result,
            isAdminLoading: false
        });
    };
const $9eb9f475a5856f0f$export$249c9d5b49cd9712 = (item)=>({ setState: setState, getState: getState })=>{
        setState({
            ...getState(),
            selectedItemKey: item
        });
    };
const $9eb9f475a5856f0f$export$9cf39adf0dec984 = (keys)=>({ getState: getState, setState: setState })=>{
        if (!keys.length) return;
        const { shortcuts: shortcuts, ...rest } = getState();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const newShortcuts = (0, (/*@__PURE__*/$parcel$interopDefault($iVIEg)))(Object.keys(shortcuts), keys).reduce((acc, key)=>{
            acc[key] = shortcuts[key];
            return acc;
        }, {});
        setState({
            ...rest,
            shortcuts: newShortcuts,
            isShortcutsLoading: false
        });
    };

});
parcelRegister("iVIEg", function(module, exports) {

var $fa0Ox = parcelRequire("fa0Ox");

var $hKE3p = parcelRequire("hKE3p");

var $9eFtX = parcelRequire("9eFtX");

var $cRpul = parcelRequire("cRpul");
/**
 * Creates an array of `array` values not included in the other given arrays
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons. The order and references of result values are
 * determined by the first array.
 *
 * **Note:** Unlike `_.pullAll`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {...Array} [values] The values to exclude.
 * @returns {Array} Returns the new array of filtered values.
 * @see _.without, _.xor
 * @example
 *
 * _.difference([2, 1], [2, 3]);
 * // => [1]
 */ var $dc802f203e524f15$var$difference = $9eFtX(function(array, values) {
    return $cRpul(array) ? $fa0Ox(array, $hKE3p(values, 1, $cRpul, true)) : [];
});
module.exports = $dc802f203e524f15$var$difference;

});
parcelRegister("fa0Ox", function(module, exports) {

var $lYFvJ = parcelRequire("lYFvJ");

var $lqZWH = parcelRequire("lqZWH");

var $6v6uu = parcelRequire("6v6uu");

var $kJvGp = parcelRequire("kJvGp");

var $74vSq = parcelRequire("74vSq");

var $8AO5Q = parcelRequire("8AO5Q");
/** Used as the size to enable large array optimizations. */ var $b0986bd506ee8a3d$var$LARGE_ARRAY_SIZE = 200;
/**
 * The base implementation of methods like `_.difference` without support
 * for excluding multiple arrays or iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Array} values The values to exclude.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of filtered values.
 */ function $b0986bd506ee8a3d$var$baseDifference(array, values, iteratee, comparator) {
    var index = -1, includes = $lqZWH, isCommon = true, length = array.length, result = [], valuesLength = values.length;
    if (!length) return result;
    if (iteratee) values = $kJvGp(values, $74vSq(iteratee));
    if (comparator) {
        includes = $6v6uu;
        isCommon = false;
    } else if (values.length >= $b0986bd506ee8a3d$var$LARGE_ARRAY_SIZE) {
        includes = $8AO5Q;
        isCommon = false;
        values = new $lYFvJ(values);
    }
    outer: while(++index < length){
        var value = array[index], computed = iteratee == null ? value : iteratee(value);
        value = comparator || value !== 0 ? value : 0;
        if (isCommon && computed === computed) {
            var valuesIndex = valuesLength;
            while(valuesIndex--){
                if (values[valuesIndex] === computed) continue outer;
            }
            result.push(value);
        } else if (!includes(values, computed, comparator)) result.push(value);
    }
    return result;
}
module.exports = $b0986bd506ee8a3d$var$baseDifference;

});


parcelRegister("6QsdI", function(module, exports) {

$parcel$export(module.exports, "default", () => $dd5b36ae9a64aed1$export$2e2bcd8739ae039);

var $gUUjF = parcelRequire("gUUjF");

var $2OdyW = parcelRequire("2OdyW");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$dd5b36ae9a64aed1$export$2e2bcd8739ae039 = async ()=>{
    try {
        return await (0, $2OdyW.default)('/rest/adminquicksearch/latest/links/default');
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $gUUjF.default).safeErrorWithoutCustomerData('shortcuts-dialog.fetch-admin-links', error.toString());
        return null;
    }
};

});

parcelRegister("kh3b8", function(module, exports) {

$parcel$export(module.exports, "buildAdminSections", () => $978ed85a7f52065b$export$5f8c94ecd4c9eb76);
const $978ed85a7f52065b$export$5f8c94ecd4c9eb76 = (parent, result = [])=>{
    if (parent.sections && parent.sections.length) parent.sections.forEach((s)=>$978ed85a7f52065b$export$5f8c94ecd4c9eb76(s, result));
    if (parent.items && parent.items.length) parent.items.forEach((i)=>result.push({
            key: i.key,
            label: i.label,
            // @ts-expect-error - TS2322 - Type '() => void' is not assignable to type '(event?: Event | undefined) => Promise<undefined> | undefined'.
            onClick: ()=>{
                window.location.href = i.linkUrl;
            }
        }));
    return result;
};

});




parcelRegister("g4kvy", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('daSWN')
        ]);
        const value = parcelRequire('fnOgj');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("daSWN")
    ]).then(()=>parcelRequire('fnOgj'));
}

});


parcelRegister("jM9bW", function(module, exports) {

$parcel$export(module.exports, "FlagIssueWithCommentModal", () => $83d3a873c1c0fb0a$export$dc5402e0014db7d2);

var $eUqFw = parcelRequire("eUqFw");

var $hTLlD = parcelRequire("hTLlD");

var $eZmml = parcelRequire("eZmml");

var $6j4bv = parcelRequire("6j4bv");

var $3q7Yq = parcelRequire("3q7Yq");

var $0cdA8 = parcelRequire("0cdA8");

var $guiFP = parcelRequire("guiFP");

var $k8Qyf = parcelRequire("k8Qyf");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $8DoMP = parcelRequire("8DoMP");

var $doiEd = parcelRequire("doiEd");

var $48XBC = parcelRequire("48XBC");

var $evlR1 = parcelRequire("evlR1");
const $83d3a873c1c0fb0a$var$entryPointParams = {};
const $83d3a873c1c0fb0a$var$FlagIssueWithCommentModalBase = ()=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $6j4bv.useEntryPoint)((0, $8DoMP.asyncFlagWithCommentModal), $83d3a873c1c0fb0a$var$entryPointParams);
    const [initialized, setInitialized] = (0, $eUqFw.useState)(false);
    const [{ flagAction: flagAction, issues: issues, forcePreload: forcePreload, callback: callback, analyticsArgs: analyticsArgs }, { close: close }] = (0, $doiEd.useFlagIssueModal)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagsService)();
    (0, $eUqFw.useEffect)(()=>{
        if (forcePreload && !initialized) {
            setInitialized(true);
            entryPointActions.preload();
        }
    }, [
        entryPointActions,
        forcePreload,
        initialized
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (flagAction !== undefined) {
            entryPointActions.load();
            if (!initialized) setInitialized(true);
        } else if (initialized) entryPointActions.unload();
    }, [
        flagAction,
        initialized,
        entryPointActions
    ]);
    const issueIds = (0, $eUqFw.useMemo)(()=>issues.map(({ issueId: issueId })=>issueId), [
        issues
    ]);
    // Not using issueIds from modal because it is number[] where they should be IssueId[]
    const handleSaveWithComment = (0, $eUqFw.useCallback)(async (_, flag, comment)=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        });
        const extendedAnalyticsArgs = {
            hasComment: !(0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))(comment, (0, $eZmml.getEmptyADF)()),
            ...analyticsArgs
        };
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'confirmButton', extendedAnalyticsArgs);
        close();
        try {
            await (0, $48XBC.saveFlagWithComment)(issueIds, flag, comment);
            analyticsEvent.update({
                action: 'flagged',
                actionSubject: 'cards'
            });
            (0, $jMP2a.fireTrackAnalytics)(analyticsEvent, 'cards flagged', {
                ...extendedAnalyticsArgs,
                numCards: issueIds.length,
                flagAction: flag ? 'added' : 'removed'
            });
            if (callback) callback({
                issueIds: issueIds,
                flag: flag,
                comment: comment
            });
        } catch (err) {
            const error = err instanceof Error ? err : new Error('Unknown error');
            (0, $guiFP.default)({
                error: error,
                meta: {
                    id: 'jira.addCommentOnFlagSaveAction',
                    packageName: 'jiraSoftwareAddIssueFlagWithComment',
                    teamName: 'deliveroo'
                }
            });
            showFlag({
                key: 'flag-issue-with-comment-modal-error',
                type: 'error',
                title: flag ? (0, $evlR1.messages).addFlagFailedTitle : (0, $evlR1.messages).removeFlagFailedTitle,
                description: flag ? (0, $evlR1.messages).addFlagFailedDescription : (0, $evlR1.messages).removeFlagFailedDescription
            });
        }
    }, [
        createAnalyticsEvent,
        analyticsArgs,
        close,
        issueIds,
        callback,
        showFlag
    ]);
    const handleOnClose = ()=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        });
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'cancelButton', {
            ...analyticsArgs
        });
        close();
    };
    const modalProps = {
        flagAction: flagAction,
        cards: issues.map(({ issueId: issueId, issueKey: issueKey, summary: summary, type: type })=>({
                id: +issueId,
                key: issueKey,
                summary: summary ?? '',
                type: type
            })),
        onClose: handleOnClose,
        onFlagWithComment: handleSaveWithComment
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3q7Yq.ModalEntryPointContainer), {
        entryPointActions: entryPointActions,
        entryPointReferenceSubject: entryPointReferenceSubject,
        id: "flag-issue-with-comment-modal",
        packageName: "jira-software-add-issue-flag-with-comment",
        runtimeProps: modalProps
    });
};
const $83d3a873c1c0fb0a$export$dc5402e0014db7d2 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "jira-software-add-issue-flag-with-comment-entrypoint",
        packageName: "JiraSoftwareAddIssueFlagWithComment",
        fallback: "unmount",
        teamName: "deliveroo"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($83d3a873c1c0fb0a$var$FlagIssueWithCommentModalBase, null));

});
parcelRegister("eZmml", function(module, exports) {

$parcel$export(module.exports, "getEmptyADF", () => $ae981b4922a7f015$export$d109ab46c9575565);
// https://product-fabric.atlassian.net/wiki/spaces/ADF/pages/881362244/ADF+Change+42+Uniform+Empty+ADF+Representation
const $ae981b4922a7f015$export$d109ab46c9575565 = ()=>({
        type: 'doc',
        version: 1,
        content: []
    });

});

parcelRegister("8DoMP", function(module, exports) {

$parcel$export(module.exports, "asyncFlagWithCommentModal", () => $087058a8d2536a06$export$58c94fab0d44ad1);

var $1K77P = parcelRequire("1K77P");

var $7QhYz = parcelRequire("7QhYz");

const $087058a8d2536a06$export$58c94fab0d44ad1 = (0, $7QhYz.createEntryPoint)({
    root: (0, $1K77P.JSResourceForInteraction)(()=>(parcelRequire("6N4p0")).then((module)=>module.CommentOnFlaggingUnflaggingEntryPoint), {
        moduleId: "265517b7"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("6N4p0", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('h2MrD'),
            load('bYT2S'),
            load('hPzOn'),
            load('e6WdP')
        ]);
        const value = parcelRequire('a2oRV');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("h2MrD"),
        load("bYT2S"),
        load("hPzOn"),
        load("e6WdP")
    ]).then(()=>parcelRequire('a2oRV'));
}

});


parcelRegister("doiEd", function(module, exports) {

$parcel$export(module.exports, "useFlagIssueModal", () => $18793edf10a61216$export$db07b3fff1829cc2);
$parcel$export(module.exports, "useFlagIssueModalActions", () => $18793edf10a61216$export$9c426adea6bff2be);

var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");

var $iErtT = parcelRequire("iErtT");
const $18793edf10a61216$var$initialState = {
    forcePreload: false,
    issues: [],
    flagAction: undefined
};
const $18793edf10a61216$var$store = (0, $a61MH.createStore)({
    initialState: $18793edf10a61216$var$initialState,
    actions: $iErtT.actions,
    name: 'flagIssueModalStore'
});
const $18793edf10a61216$export$db07b3fff1829cc2 = (0, $ggKAj.createHook)($18793edf10a61216$var$store);
const $18793edf10a61216$export$9c426adea6bff2be = (0, $ggKAj.createActionsHook)($18793edf10a61216$var$store);

});
parcelRegister("iErtT", function(module, exports) {

$parcel$export(module.exports, "actions", () => $07b96f4ee722f2db$export$e324594224ef24da);
const $07b96f4ee722f2db$var$open = ({ issues: issues, flagAction: flagAction, callback: callback, source: source, analyticsArgs: analyticsArgs })=>({ setState: setState })=>{
        const newState = {
            issues: issues,
            flagAction: flagAction,
            callback: callback,
            analyticsArgs: {
                source: source,
                ...analyticsArgs
            }
        };
        setState(newState);
    };
const $07b96f4ee722f2db$var$close = ()=>({ setState: setState })=>{
        setState({
            issues: [],
            flagAction: undefined,
            callback: undefined,
            analyticsArgs: undefined
        });
    };
const $07b96f4ee722f2db$var$preload = ()=>({ setState: setState, getState: getState })=>{
        const { forcePreload: forcePreload } = getState();
        if (!forcePreload) setState({
            forcePreload: true
        });
    };
const $07b96f4ee722f2db$export$e324594224ef24da = {
    open: $07b96f4ee722f2db$var$open,
    close: $07b96f4ee722f2db$var$close,
    preload: $07b96f4ee722f2db$var$preload
};

});


parcelRegister("48XBC", function(module, exports) {

$parcel$export(module.exports, "saveFlagWithComment", () => $0f5777aa1a08beb8$export$59f88df61be59073);

var $7byHA = parcelRequire("7byHA");
var $jxATW = parcelRequire("jxATW");
const $0f5777aa1a08beb8$export$3ae968343ffb0d2b = '/rest/greenhopper/3/xboard/issue/flag/flag';
const $0f5777aa1a08beb8$var$noContentStatus = 204;
const $0f5777aa1a08beb8$export$59f88df61be59073 = (issueKeys, flag, comment)=>fetch($0f5777aa1a08beb8$export$3ae968343ffb0d2b, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            issueKeys: issueKeys,
            flag: flag,
            comment: comment,
            commentProperty: '',
            commentVisibility: ''
        })
    }).then((response)=>{
        if (!response.ok) {
            const { status: status } = response;
            const traceId = (0, $jxATW.getTraceId)(response);
            if (traceId != null && traceId !== '') throw new (0, $7byHA.default)(status, `Fetch call failed with status code: ${status}`, traceId);
            else throw new (0, $7byHA.default)(status);
        }
        if (response.status === $0f5777aa1a08beb8$var$noContentStatus) return null;
        return response.text().then((body)=>{
            const result = body ? JSON.parse(body) : null;
            if (result) {
                const errorMessage = result.errorMessages ? result.errorMessages.join(', ') : 'Unidentified error when saving flag with comment';
                throw new Error(errorMessage);
            }
            return null;
        });
    });

});

parcelRegister("evlR1", function(module, exports) {

$parcel$export(module.exports, "messages", () => $fd76d81e57818bd7$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $fd76d81e57818bd7$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    addFlagFailedTitle: {
        "id": "software-add-issue-flag-with-comment.add-flag-failed-title",
        "defaultMessage": "We couldn't flag this issue"
    },
    addFlagFailedDescription: {
        "id": "software-add-issue-flag-with-comment.add-flag-failed-description",
        "defaultMessage": "Check your connection and try adding the flag again."
    },
    removeFlagFailedTitle: {
        "id": "software-add-issue-flag-with-comment.remove-flag-failed-title",
        "defaultMessage": "We couldn't remove the flag from this issue"
    },
    removeFlagFailedDescription: {
        "id": "software-add-issue-flag-with-comment.remove-flag-failed-description",
        "defaultMessage": "Check your connection and try removing the flag again."
    }
});

});


parcelRegister("gYdvA", function(module, exports) {

$parcel$export(module.exports, "AsyncEnforceStorageLimitsModal", () => $1c74900207079a5d$export$319be76441a339a9);

var $eUqFw = parcelRequire("eUqFw");

var $3HPSR = parcelRequire("3HPSR");

var $6j4bv = parcelRequire("6j4bv");

var $3q7Yq = parcelRequire("3q7Yq");

var $1bSFW = parcelRequire("1bSFW");

var $dWLk9 = parcelRequire("dWLk9");
var $c7H0g = parcelRequire("c7H0g");


var $lXjME = parcelRequire("lXjME");


var $8FSSj = parcelRequire("8FSSj");

var $1cXLn = parcelRequire("1cXLn");
const $1c74900207079a5d$export$319be76441a339a9 = ()=>{
    // We can optimise and not show the modal if the user is not on the free edition
    const isFreeEdition = (0, $1bSFW.useIsJswFreeEdition)();
    const isAdmin = (0, $c7H0g.useIsAdmin)();
    const { canUpgradeAndPay: canUpgradeAndPay, loading: isBillingPermissionsLoading } = (0, $3HPSR.useCanUpgradeAndPayForJswFree)({
        caller: (0, $815b5650076b1618$export$b8b9d90f9e5bd72b),
        billingAdminCheckMethod: 'traits',
        skip: !isFreeEdition || !isAdmin
    });
    // Note this API call will fire for both experiment and control cohorts
    // since it defines the cohort for the user
    const { jswStorageRatio: jswStorageRatio, jswStorageLimit: jswStorageLimit } = (0, $1cXLn.useJswStorageUsage)({
        // API 403s for non-admins or without the manage billing permission
        skip: !isFreeEdition || !isAdmin || !canUpgradeAndPay
    });
    const hasReachedStorageRatioThreshold = jswStorageRatio && jswStorageRatio > (0, $507f82bdd90554d8$export$dada91eca2d214e9);
    if (!isFreeEdition || // usage limit & storage ratio are undefined if the request fails or not fetched yet
    !jswStorageLimit || !hasReachedStorageRatioThreshold || isBillingPermissionsLoading) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1c74900207079a5d$export$cfe1392b5c9b528f, {
        jswStorageRatio: jswStorageRatio,
        jswStorageLimit: jswStorageLimit,
        canUpgradeAndPay: Boolean(canUpgradeAndPay)
    });
};
const $1c74900207079a5d$export$cfe1392b5c9b528f = ({ jswStorageRatio: jswStorageRatio, jswStorageLimit: jswStorageLimit, canUpgradeAndPay: canUpgradeAndPay })=>{
    const cloudId = (0, $dWLk9.useCloudId)();
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $6j4bv.useEntryPoint)((0, $8FSSj.enforceStorageLimitsModalEntryPoint), {
        cloudId: cloudId,
        // JSW productKey (experiment is JSW only)
        productKey: 'jira-software.ondemand',
        // Default user to JSW Standard plan
        // JSW Standard offeringKey
        // @see: https://stash.atlassian.com/projects/CCP/repos/billing-console/browse/packages/bac/components/product-offerings/src/service/data/jira-software/index.ts#21
        offeringKey: 'a70b5cbb-1ae1-4003-8f4a-9001a4a50526'
    });
    const [{ isOpen: isOpen }, { setIsOpen: setIsOpen }] = (0, $lXjME.useEnforceStorageModal)();
    const enforceStorageLimitsModalProps = (0, $eUqFw.useMemo)(()=>({
            onClose: ()=>{
                setIsOpen({
                    isOpen: 'closed',
                    touchpoint: undefined
                });
            },
            jswStorageRatio: jswStorageRatio,
            jswStorageLimit: jswStorageLimit,
            canUpgradeAndPay: canUpgradeAndPay
        }), [
        jswStorageRatio,
        jswStorageLimit,
        canUpgradeAndPay,
        setIsOpen
    ]);
    (0, $eUqFw.useEffect)(()=>{
        // Note relay is smart enough not to re-fetch the chunk if it's already loaded
        // @todo: would be great if we didn't need isOpen and be able to load() directly from sweet state
        if (isOpen === 'open') entryPointActions.load();
    }, [
        entryPointActions,
        isOpen
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3q7Yq.ModalEntryPointContainer), {
        id: "async-enforce-storage-limits-modal",
        packageName: (0, $815b5650076b1618$export$b8b9d90f9e5bd72b),
        teamName: "jlove-makkuro",
        entryPointReferenceSubject: entryPointReferenceSubject,
        entryPointActions: entryPointActions,
        errorFallback: "unmount",
        runtimeProps: enforceStorageLimitsModalProps
    });
};

});
parcelRegister("3HPSR", function(module, exports) {

$parcel$export(module.exports, "useCanUpgradeAndPayForJswFree", () => $ec9ec1014fe81092$export$f4f07d855739fba1);
$parcel$export(module.exports, "useCanProductUserUpgradeAndPay", () => $ec9ec1014fe81092$export$53827a0ff095f14b);

var $eUqFw = parcelRequire("eUqFw");

var $5iWql = parcelRequire("5iWql");

var $3svxt = parcelRequire("3svxt");

var $1Iui1 = parcelRequire("1Iui1");

var $guiFP = parcelRequire("guiFP");

var $a6wc8 = parcelRequire("a6wc8");

var $79xbN = parcelRequire("79xbN");

var $lRmyA = parcelRequire("lRmyA");

var $jRj3P = parcelRequire("jRj3P");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");


var $dWlsy = parcelRequire("dWlsy");

var $1R3n5 = parcelRequire("1R3n5");
var $gd0Sp = parcelRequire("gd0Sp");


var $553IO = parcelRequire("553IO");
const $ec9ec1014fe81092$var$fetchEntitlementDetails = (entitlementId)=>(0, $lRmyA.performGetRequest)(`/gateway/api/ccp/api/v1/entitlements/${entitlementId}/details`, {
        headers: {
            'Content-Type': 'application/json'
        }
    });
const $ec9ec1014fe81092$var$fetchBillingAdmins = (transactionAccountId)=>(0, $lRmyA.performGetRequest)('/gateway/api/ccp/api/v1/billing-admins', {
        headers: {
            'Content-Type': 'application/json',
            'X-transaction-account': transactionAccountId
        }
    });
const $ec9ec1014fe81092$export$2abcbc88aea6e581 = (0, $5iWql.default)($ec9ec1014fe81092$var$fetchEntitlementDetails);
const $ec9ec1014fe81092$export$294eed4c864e0f71 = (0, $5iWql.default)($ec9ec1014fe81092$var$fetchBillingAdmins);
const $ec9ec1014fe81092$export$f4f07d855739fba1 = ({ caller: caller, skip: skip = false, billingAdminCheckMethod: billingAdminCheckMethod = 'traits' })=>{
    const [canUpgradeAndPay, setCanUpgradeAndPay] = (0, $eUqFw.useState)(undefined);
    const [loading, setLoading] = (0, $eUqFw.useState)(false);
    const [error, setError] = (0, $eUqFw.useState)(undefined);
    const [ineligibilityReason, setIneligibilityReason] = (0, $eUqFw.useState)(undefined);
    const { isSiteAdmin: isSiteAdmin, cloudId: cloudId, atlassianAccountId: atlassianAccountId, productEntitlementDetails: productEntitlementDetails } = (0, $gd0Sp.useTenantContext)();
    const { fetch: fetch, error: personalizationApiError } = (0, $jRj3P.useSiteUserPersonalization)();
    const isBillingSystemCcp = productEntitlementDetails?.[0, $2edfd53057852e41$export$1346c9aa3cbb477d]?.billingSourceSystem === 'CCP';
    const entitlementId = productEntitlementDetails?.[0, $2edfd53057852e41$export$1346c9aa3cbb477d]?.entitlementId;
    const checkIsCcpBillingAdmin = (0, $eUqFw.useCallback)(async ()=>{
        if (!entitlementId) throw new Error('Empty entitlementId');
        if (!atlassianAccountId) throw new Error('Empty atlassianAccountId');
        // CCP API approach
        if (billingAdminCheckMethod === 'ccpApi') {
            const entitlementDetails = await $ec9ec1014fe81092$export$2abcbc88aea6e581(entitlementId);
            const transactionAccountId = entitlementDetails?.transactionAccountId;
            const billingAdminsResponse = await $ec9ec1014fe81092$export$294eed4c864e0f71(transactionAccountId);
            const isBillingAdmin = !!billingAdminsResponse?.data?.find(({ id: id = null })=>id === atlassianAccountId);
            return isBillingAdmin;
        }
        // Traits approach
        const personalizationData = await fetch({
            cloudId: cloudId,
            userId: atlassianAccountId
        });
        if (!personalizationData) return undefined;
        const isBillingAdmin = personalizationData.find((trait)=>trait.name === (0, $87ce2dbad94f3492$export$3aad3de2cc377789) && trait.value === true) !== undefined;
        return isBillingAdmin;
    }, [
        atlassianAccountId,
        billingAdminCheckMethod,
        cloudId,
        entitlementId,
        fetch
    ]);
    /**
	 * This `useEffect` performs the permission checks.
	 */ (0, $eUqFw.useEffect)(()=>{
        if (skip) return;
        setLoading(true);
        // Only logged in site admins can upgrade
        if (isSiteAdmin) {
            if (isBillingSystemCcp) // On CCP, only billing admins can manage billing
            checkIsCcpBillingAdmin().then((isBillingAdmin)=>{
                setCanUpgradeAndPay(isBillingAdmin);
                // Empty ineligibilityReason marks that the requisites were checked
                setIneligibilityReason(isBillingAdmin ? '' : 'not a billing admin');
            }).catch((e)=>{
                setError(e);
                setIneligibilityReason('error checking eligibility');
            }).finally(()=>{
                setLoading(false);
            });
            else {
                // On HAMS, site admins can also manage billing
                setCanUpgradeAndPay(true);
                setLoading(false);
                // Empty ineligibilityReason marks that the requisites were checked
                setIneligibilityReason('');
            }
        } else {
            setCanUpgradeAndPay(false);
            setLoading(false);
            setIneligibilityReason('not a site admin');
        }
    }, [
        atlassianAccountId,
        caller,
        checkIsCcpBillingAdmin,
        isBillingSystemCcp,
        isSiteAdmin,
        skip
    ]);
    /**
	 * Errors from the Traits API are not thrown. Instead, they are stored in the `error` field from `useSiteUserPersonalization`.
	 * Since we can't catch those errors, we need to listen for changes to that `error` field and update our own "error" state accordingly.
	 */ (0, $eUqFw.useEffect)(()=>{
        if (personalizationApiError) setError(personalizationApiError);
    }, [
        personalizationApiError
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (error) (0, $guiFP.default)({
            error: error,
            meta: {
                id: 'useCanUpgradeAndPayForJswFree',
                packageName: (0, $87ce2dbad94f3492$export$b8b9d90f9e5bd72b),
                teamName: 'flywheel-tako'
            },
            attributes: {
                billingSourceSystem: isBillingSystemCcp ? 'CCP' : 'HAMS',
                caller: caller,
                billingAdminCheckMethod: billingAdminCheckMethod
            },
            sendToPrivacyUnsafeSplunk: true
        });
    }, [
        error,
        isBillingSystemCcp,
        caller,
        billingAdminCheckMethod
    ]);
    return {
        canUpgradeAndPay: canUpgradeAndPay,
        loading: loading,
        error: error,
        ineligibilityReason: ineligibilityReason
    };
};
const $ec9ec1014fe81092$export$2e34435b19772971 = ({ caller: caller, skip: skip = false })=>{
    const [canUpgradeAndPay, setCanUpgradeAndPay] = (0, $eUqFw.useState)(undefined);
    const [loading, setLoading] = (0, $eUqFw.useState)(false);
    const [error, setError] = (0, $eUqFw.useState)(undefined);
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    const subProduct = (0, $dWlsy.useSubProduct)();
    const explicitlyLicensedProducts = (0, $3svxt.default)(tenantContext);
    const applicationKey = (0, $a6wc8.getProductKey)(subProduct, explicitlyLicensedProducts);
    (0, $eUqFw.useEffect)(()=>{
        if (skip) return;
        if (!applicationKey) {
            setError(new Error('Empty applicationKey'));
            return;
        }
        const isBillingSystemCcp = tenantContext.productEntitlementDetails?.[applicationKey]?.billingSourceSystem === 'CCP';
        const entitlementId = tenantContext.productEntitlementDetails?.[applicationKey]?.entitlementId;
        const checkIsCcpBillingAdmin = async ()=>{
            if (!entitlementId) throw new Error('Empty entitlementId');
            if (!tenantContext.atlassianAccountId) throw new Error('Empty atlassianAccountId');
            const entitlementDetails = await $ec9ec1014fe81092$export$2abcbc88aea6e581(entitlementId);
            const transactionAccountId = entitlementDetails?.transactionAccountId;
            const billingAdminsResponse = await $ec9ec1014fe81092$export$294eed4c864e0f71(transactionAccountId);
            const isBillingAdmin = billingAdminsResponse?.data?.some(({ id: id = null })=>id === tenantContext.atlassianAccountId) ?? false;
            return isBillingAdmin;
        };
        setLoading(true);
        // Only logged in site admins can upgrade
        if (tenantContext.isSiteAdmin && tenantContext.atlassianAccountId) {
            if (isBillingSystemCcp) // On CCP, only billing admins can manage billing
            checkIsCcpBillingAdmin().then((isBillingAdmin)=>{
                setCanUpgradeAndPay(isBillingAdmin);
            }).catch((e)=>{
                setError(e);
                (0, $guiFP.default)({
                    error: e,
                    meta: {
                        id: 'useCanUpgradeAndPayForCurrentProduct',
                        packageName: (0, $87ce2dbad94f3492$export$b8b9d90f9e5bd72b),
                        teamName: 'flywheel-tako'
                    },
                    attributes: {
                        billingSourceSystem: isBillingSystemCcp ? 'CCP' : 'HAMS',
                        caller: caller,
                        subProduct: subProduct,
                        applicationKey: applicationKey,
                        licensedProducts: tenantContext.licensedProducts,
                        productEntitlementDetails: tenantContext.productEntitlementDetails
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
            }).finally(()=>{
                setLoading(false);
            });
            else {
                // On HAMS, site admins can also manage billing
                setCanUpgradeAndPay(true);
                setLoading(false);
            }
        } else {
            setCanUpgradeAndPay(false);
            setLoading(false);
        }
    }, [
        applicationKey,
        caller,
        skip,
        subProduct,
        tenantContext.atlassianAccountId,
        tenantContext.isSiteAdmin,
        tenantContext.licensedProducts,
        tenantContext.productEntitlementDetails
    ]);
    return {
        canUpgradeAndPay: canUpgradeAndPay,
        loading: loading,
        error: error
    };
};
const $ec9ec1014fe81092$export$422d9ad995b055f = ({ caller: caller, onError: onError })=>{
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    const subProduct = (0, $dWlsy.useSubProduct)();
    const explicitlyLicensedProducts = (0, $3svxt.default)(tenantContext);
    const applicationKey = (0, $a6wc8.getProductKey)(subProduct, explicitlyLicensedProducts);
    const checkIsCcpBillingAdmin = (0, $eUqFw.useCallback)(async (entitlementId)=>{
        if (!entitlementId) throw new Error('Empty entitlementId');
        if (!tenantContext.atlassianAccountId) throw new Error('Empty atlassianAccountId');
        const entitlementDetails = await $ec9ec1014fe81092$export$2abcbc88aea6e581(entitlementId);
        const transactionAccountId = entitlementDetails?.transactionAccountId;
        const billingAdminsResponse = await $ec9ec1014fe81092$export$294eed4c864e0f71(transactionAccountId);
        const isBillingAdmin = billingAdminsResponse?.data?.some(({ id: id = null })=>id === tenantContext.atlassianAccountId) ?? false;
        return isBillingAdmin;
    }, [
        tenantContext.atlassianAccountId
    ]);
    /**
	 * Checks whether the user has upgrade and billing permission (i.e. is site and billing admin).
	 * Returns `true` if the user has permission for both, `false` if they don't, and `null` if the check failed.
	 */ const hasUpgradeAndBillingPermission = (0, $eUqFw.useCallback)(async ()=>{
        if (!applicationKey) {
            const error = new Error('Empty applicationKey');
            const analyticsAttributes = {
                caller: caller,
                subProduct: subProduct,
                applicationKey: applicationKey,
                licensedProducts: tenantContext.licensedProducts,
                productEntitlementDetails: tenantContext.productEntitlementDetails
            };
            onError?.(error, analyticsAttributes);
            return null;
        }
        // Site admin is required for upgrading products
        if (!tenantContext.isSiteAdmin || !tenantContext.atlassianAccountId) return false;
        const isBillingSystemCcp = tenantContext.productEntitlementDetails?.[applicationKey]?.billingSourceSystem === 'CCP';
        // On CCP, only billing admins can manage billing
        if (isBillingSystemCcp) {
            const entitlementId = tenantContext.productEntitlementDetails?.[applicationKey]?.entitlementId;
            return checkIsCcpBillingAdmin(entitlementId).then((isBillingAdmin)=>isBillingAdmin).catch((e)=>{
                const analyticsAttributes = {
                    billingSourceSystem: isBillingSystemCcp ? 'CCP' : 'HAMS',
                    caller: caller,
                    subProduct: subProduct,
                    applicationKey: applicationKey,
                    licensedProducts: tenantContext.licensedProducts,
                    productEntitlementDetails: tenantContext.productEntitlementDetails
                };
                onError?.(e, analyticsAttributes);
                return null;
            });
        }
        // On HAMS, site admins can manage billing
        return true;
    }, [
        applicationKey,
        caller,
        checkIsCcpBillingAdmin,
        onError,
        subProduct,
        tenantContext.atlassianAccountId,
        tenantContext.isSiteAdmin,
        tenantContext.licensedProducts,
        tenantContext.productEntitlementDetails
    ]);
    return {
        hasUpgradeAndBillingPermission: hasUpgradeAndBillingPermission
    };
};
function $ec9ec1014fe81092$export$53827a0ff095f14b(props) {
    const { skip: skip, productKey: productKey, edition: edition } = props;
    const [canProductUserUpgradeAndPay, setCanProductUserUpgradeAndPay] = (0, $eUqFw.useState)();
    const [isProductUserBillingAdmin, setIsProductUserBillingAdmin] = (0, $eUqFw.useState)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const isSiteAdmin = (0, $1R3n5.useIsSiteAdmin)();
    // Lazy query that we can call conditionally
    const { data: data, isLoading: isLoading, error: error, fetch: fetchCanProductUserUpgradeAndPay } = (0, $553IO.useCanProductUserUpgradeAndPayQuery)();
    const fireExperimentExposureEvent = (0, $eUqFw.useCallback)((cohort, isCurrentUserBillingAdmin)=>{
        (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'feature exposed', 'editionAwarenessPill', {
            flagKey: 'more_user_products_can_upgrade_and_pay_in_product',
            cohort: cohort,
            isSiteAdmin: isSiteAdmin,
            edition: edition,
            isBillingAdmin: isCurrentUserBillingAdmin
        });
    }, [
        createAnalyticsEvent,
        edition,
        isSiteAdmin
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (!skip) {
            if (productKey) {
                const [expConfig] = (0, $79xbN.UNSAFE_noExposureExp)('more_user_products_can_upgrade_and_pay_in_product');
                const experimentCohort = expConfig.get('cohort', (0, $1Iui1.NOT_ENROLLED));
                // Only perform network checks once we know the user is enrolled.
                if (experimentCohort !== (0, $1Iui1.NOT_ENROLLED)) fetchCanProductUserUpgradeAndPay(productKey);
            }
        }
    }, [
        fetchCanProductUserUpgradeAndPay,
        productKey,
        skip
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (data !== undefined) {
            setIsProductUserBillingAdmin(data.isBillingAdmin);
            if (data.canProductUserUpgradeAndPay) {
                // Only product users who can upgrade and pay are eligible for our experiment
                const experimentCohort = (0, $79xbN.expVal)('more_user_products_can_upgrade_and_pay_in_product', 'cohort', 'not-enrolled');
                if (experimentCohort !== (0, $1Iui1.NOT_ENROLLED)) fireExperimentExposureEvent(experimentCohort, data.isBillingAdmin);
                // If the user is in treatment for experiment,  use the result of the permissions query
                if (experimentCohort === (0, $1Iui1.VARIATION)) setCanProductUserUpgradeAndPay(data.canProductUserUpgradeAndPay);
                else setCanProductUserUpgradeAndPay(false);
            } else setCanProductUserUpgradeAndPay(false);
        }
    }, [
        data,
        fireExperimentExposureEvent
    ]);
    return {
        isProductUserBillingAdmin: isProductUserBillingAdmin,
        canProductUserUpgradeAndPay: canProductUserUpgradeAndPay,
        isLoading: isLoading,
        error: error
    };
}

});
parcelRegister("3svxt", function(module, exports) {

$parcel$export(module.exports, "default", () => $1e55bb6ee669ca6d$export$2e2bcd8739ae039);

var // eslint-disable-next-line jira/import/no-anonymous-default-export
$1e55bb6ee669ca6d$export$2e2bcd8739ae039 = (tenantContext)=>{
    const { licensedProducts: licensedProducts } = tenantContext;
    const result = [];
    licensedProducts[0, $2edfd53057852e41$export$db515c8cec1e6f79] && result.push((0, $2edfd53057852e41$export$db515c8cec1e6f79));
    licensedProducts[0, $2edfd53057852e41$export$c8c1c8c3f8ddba61] && result.push((0, $2edfd53057852e41$export$c8c1c8c3f8ddba61));
    licensedProducts[0, $2edfd53057852e41$export$1346c9aa3cbb477d] && result.push((0, $2edfd53057852e41$export$1346c9aa3cbb477d));
    licensedProducts[0, $2edfd53057852e41$export$202f50ee62667e32] && result.push((0, $2edfd53057852e41$export$202f50ee62667e32));
    return result;
};

});
const $2edfd53057852e41$export$c8c1c8c3f8ddba61 = 'jira-servicedesk';
const $2edfd53057852e41$export$1346c9aa3cbb477d = 'jira-software';
const $2edfd53057852e41$export$202f50ee62667e32 = 'jira-product-discovery';
const $2edfd53057852e41$export$db515c8cec1e6f79 = 'jira-core';
const $2edfd53057852e41$export$c811f21c9ad05dc2 = 'confluence';
const $2edfd53057852e41$export$961148c98d198270 = 'opsgenie';


parcelRegister("a6wc8", function(module, exports) {

$parcel$export(module.exports, "getProductKey", () => $9e20cc650e9eaa2c$export$d0b7f02493f85477);

const $9e20cc650e9eaa2c$export$d0b7f02493f85477 = (subProduct, explicitlyLicensedProducts)=>{
    if (subProduct === 'software') return 0, $2edfd53057852e41$export$1346c9aa3cbb477d;
    if (subProduct === 'serviceDesk') return 0, $2edfd53057852e41$export$c8c1c8c3f8ddba61;
    // useSubProduct currently doesn't support polaris
    // JPD's subproduct currently falls under to 'software'
    // https://hello.atlassian.net/wiki/spaces/STAR/pages/2940457206/Detach+from+JSW+analytics+subproduct
    if (subProduct === 'polaris') return 0, $2edfd53057852e41$export$202f50ee62667e32;
    if (subProduct === 'core') return 0, $2edfd53057852e41$export$db515c8cec1e6f79;
    // If subProduct is null, we may be on a product-agnostic page e.g. "Your Work".
    // If there is only one licensed product, we can infer what the user is using.
    if (explicitlyLicensedProducts.length === 1) return explicitlyLicensedProducts[0];
    return null;
};

});

parcelRegister("jRj3P", function(module, exports) {

$parcel$export(module.exports, "memoizedFetchSiteUserPersonalization", () => $4441cad18cc93774$export$de93ec54b11be450);
$parcel$export(module.exports, "useSiteUserPersonalization", () => $4441cad18cc93774$export$8dc79ff315095801);

var $5iWql = parcelRequire("5iWql");

var $eEzyV = parcelRequire("eEzyV");

var $2OdyW = parcelRequire("2OdyW");
const $4441cad18cc93774$var$getPersonalizationSiteUserTraitsUrl = (cloudId, userId)=>`/gateway/api/tap-delivery/api/v3/personalization/site/${cloudId}/user/${userId}`;
const $4441cad18cc93774$export$8f40704723ec6690 = async ({ cloudId: cloudId, userId: userId })=>{
    if (!cloudId) throw new Error('empty cloudId');
    if (!userId) throw new Error('empty userId');
    const { attributes: attributes } = await (0, $2OdyW.default)($4441cad18cc93774$var$getPersonalizationSiteUserTraitsUrl(cloudId, userId), {
        method: 'GET',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'x-atlassian-mau-ignore': 'true'
        }
    });
    return attributes;
};
const $4441cad18cc93774$export$de93ec54b11be450 = (0, $5iWql.default)($4441cad18cc93774$export$8f40704723ec6690, ([{ cloudId: newCloudId, userId: newUserId }], [{ cloudId: lastCloudId, userId: lastUserId }])=>newCloudId === lastCloudId && newUserId === lastUserId);
const $4441cad18cc93774$export$8dc79ff315095801 = ()=>(0, $eEzyV.useService)($4441cad18cc93774$export$de93ec54b11be450);

});
parcelRegister("eEzyV", function(module, exports) {

$parcel$export(module.exports, "useService", () => $cbb15d4da2e9ab10$export$6de4685a6c88b4e9);
$parcel$export(module.exports, "useLoadingStatusService", () => $cbb15d4da2e9ab10$export$c963713a27525aaf);

var $eUqFw = parcelRequire("eUqFw");
const $cbb15d4da2e9ab10$export$6de4685a6c88b4e9 = (request, initialState = {})=>{
    const [state, setState] = (0, $eUqFw.useState)({
        loading: false,
        data: undefined,
        error: undefined,
        ...initialState
    });
    const fetch = (0, $eUqFw.useCallback)(async (requestData)=>{
        setState({
            loading: true,
            error: undefined,
            data: undefined
        });
        try {
            const data = await request(requestData);
            setState({
                loading: false,
                error: undefined,
                data: data
            });
            return data;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                loading: false,
                error: error,
                data: undefined
            });
            return undefined;
        }
    }, [
        request
    ]);
    return {
        ...state,
        fetch: fetch
    };
};
const $cbb15d4da2e9ab10$export$c963713a27525aaf = (request, initialState = {})=>{
    const [loadingStatus, setLoadingStatus] = (0, $eUqFw.useState)('idle');
    const { data: data, loading: loading, error: error, fetch: fetch } = $cbb15d4da2e9ab10$export$6de4685a6c88b4e9(request, initialState);
    (0, $eUqFw.useEffect)(()=>{
        if (loading) setLoadingStatus('started');
        else if (error) setLoadingStatus('error');
        else if (data) setLoadingStatus('success');
    }, [
        data,
        loading,
        error
    ]);
    return {
        data: data,
        loadingStatus: loadingStatus,
        error: error,
        fetch: fetch
    };
};

});


const $87ce2dbad94f3492$export$3aad3de2cc377789 = 'jira_software_free_is_ccp_billing_admins';
const $87ce2dbad94f3492$export$b8b9d90f9e5bd72b = 'jiraBilling';

parcelRegister("553IO", function(module, exports) {

$parcel$export(module.exports, "useCanProductUserUpgradeAndPayQuery", () => $05b6ff197bac8a57$export$44d5ccfd376c6700);

var $1nR1W = parcelRequire("1nR1W");

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $dWLk9 = parcelRequire("dWLk9");
const $05b6ff197bac8a57$export$62297b13309008b2 = (0, $1nR1W.default);
const $05b6ff197bac8a57$export$44d5ccfd376c6700 = ()=>{
    const cloudId = (0, $dWLk9.useCloudId)();
    const relayEnvironment = (0, $iWLL0.useRelayEnvironment)();
    const [data, setData] = (0, $eUqFw.useState)(undefined);
    const [isLoading, setIsLoading] = (0, $eUqFw.useState)(false);
    const [error, setError] = (0, $eUqFw.useState)(null);
    const fetch = (0, $eUqFw.useCallback)((productKey)=>{
        setIsLoading(true);
        const variables = {
            cloudId: cloudId,
            productKey: productKey
        };
        (0, $iWLL0.fetchQuery)(relayEnvironment, $05b6ff197bac8a57$export$62297b13309008b2, variables, {
            fetchPolicy: 'store-or-network'
        }).subscribe({
            complete: ()=>{
                setIsLoading(false);
            },
            next: (response)=>{
                // Endpoint takes in an array of cloudIds, but we never call this with more than one cloudId
                const entitlement = response?.tenantContexts?.[0]?.entitlementInfo?.entitlement;
                const canPay = entitlement?.transactionAccount?.experienceCapabilities?.addPaymentMethodV2?.isAvailableToUser;
                const canUpgrade = entitlement?.experienceCapabilities?.changeOfferingV2?.isAvailableToUser;
                const isCurrentUserBillingAdmin = entitlement?.transactionAccount?.isCurrentUserBillingAdmin;
                const canUpgradeAndPay = canUpgrade && canPay;
                setData({
                    canProductUserUpgradeAndPay: canUpgradeAndPay ?? false,
                    isBillingAdmin: isCurrentUserBillingAdmin ?? false
                });
            },
            error: (fetchError)=>{
                setIsLoading(false);
                setError(fetchError);
            }
        });
    }, [
        cloudId,
        relayEnvironment
    ]);
    return {
        fetch: fetch,
        data: data,
        isLoading: isLoading,
        error: error
    };
};

});
parcelRegister("1nR1W", function(module, exports) {

$parcel$export(module.exports, "default", () => $e1fefb3ae3cd7b75$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<8d940d3469c4fac7a5777668b0741358>>
 * @relayHash ea92179dc2519e0969d4281dd79d396f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9308b51a7dfc7d956d54b611c603679c467cba651b645e963aac170dd0f5ba0b
const $e1fefb3ae3cd7b75$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "productKey"
        }
    ], v1 = [
        {
            "items": [
                {
                    "kind": "Variable",
                    "name": "cloudIds.0",
                    "variableName": "cloudId"
                }
            ],
            "kind": "ListValue",
            "name": "cloudIds"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "hamsProductKey",
            "variableName": "productKey"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "isCurrentUserBillingAdmin"
    }, v4 = {
        "kind": "ScalarField",
        "name": "isAvailableToUser"
    }, v5 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v6 = [
        v5 /*: any*/ ,
        v4 /*: any*/ 
    ], v7 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "canProductUserUpgradeAndPayQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "transactionAccount",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "RequiredField",
                                                    "field": v3 /*: any*/ ,
                                                    "action": "THROW",
                                                    "path": "tenantContexts.entitlementInfo.entitlement.transactionAccount.isCurrentUserBillingAdmin"
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "experienceCapabilities",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "addPaymentMethodV2",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v4 /*: any*/ ,
                                                                    "action": "THROW",
                                                                    "path": "tenantContexts.entitlementInfo.entitlement.transactionAccount.experienceCapabilities.addPaymentMethodV2.isAvailableToUser"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "experienceCapabilities",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "changeOfferingV2",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "RequiredField",
                                                            "field": v4 /*: any*/ ,
                                                            "action": "THROW",
                                                            "path": "tenantContexts.entitlementInfo.entitlement.experienceCapabilities.changeOfferingV2.isAvailableToUser"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "canProductUserUpgradeAndPayQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                v5 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "transactionAccount",
                                            "plural": false,
                                            "selections": [
                                                v5 /*: any*/ ,
                                                v3 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "experienceCapabilities",
                                                    "plural": false,
                                                    "selections": [
                                                        v5 /*: any*/ ,
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "addPaymentMethodV2",
                                                            "plural": false,
                                                            "selections": v6 /*: any*/ 
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v7 /*: any*/ 
                                                    ],
                                                    "type": "CcpTransactionAccount"
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "experienceCapabilities",
                                            "plural": false,
                                            "selections": [
                                                v5 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "changeOfferingV2",
                                                    "plural": false,
                                                    "selections": v6 /*: any*/ 
                                                }
                                            ]
                                        },
                                        v7 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "9308b51a7dfc7d956d54b611c603679c467cba651b645e963aac170dd0f5ba0b",
            "metadata": {},
            "name": "canProductUserUpgradeAndPayQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$e1fefb3ae3cd7b75$var$node.hash = "018980114a88416ec612e7565b16db6c";
var $e1fefb3ae3cd7b75$export$2e2bcd8739ae039 = $e1fefb3ae3cd7b75$var$node;

});



parcelRegister("1bSFW", function(module, exports) {

$parcel$export(module.exports, "useIsJswFreeEdition", () => $ee14c6cae824e3c4$export$caad10020a17bf56);

var $eUqFw = parcelRequire("eUqFw");

var $6WXNs = parcelRequire("6WXNs");

var $ab6rA = parcelRequire("ab6rA");
const $ee14c6cae824e3c4$export$caad10020a17bf56 = ()=>{
    const appEditions = (0, $ab6rA.useAppEditions)();
    return (0, $eUqFw.useMemo)(()=>appEditions.software === (0, $6WXNs.FREE_EDITION), [
        appEditions
    ]);
};

});
parcelRegister("ab6rA", function(module, exports) {

$parcel$export(module.exports, "useAppEditions", () => $75e408c194026ea5$export$92ed15881fc090d7);

var $gd0Sp = parcelRequire("gd0Sp");
const $75e408c194026ea5$export$92ed15881fc090d7 = ()=>{
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    return tenantContext && tenantContext.appEditions;
};

});


const $815b5650076b1618$export$b8b9d90f9e5bd72b = 'jira-enforce-storage-limits';
const $815b5650076b1618$export$8f56a4ad6e1486ea = 10;
const $815b5650076b1618$export$ed785d2382d0101d = 'lastStorageEnforcement';

parcelRegister("lXjME", function(module, exports) {

$parcel$export(module.exports, "useEnforceStorageModal", () => $2d9caf4f19990d1a$export$56beb4c2629d6615);

var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");

var $erKBL = parcelRequire("erKBL");
const $2d9caf4f19990d1a$var$initialState = {
    isOpen: 'closed',
    touchpoint: undefined
};
const $2d9caf4f19990d1a$var$store = (0, $a61MH.createStore)({
    name: 'jsw-enforce-storage-limit-modal',
    initialState: $2d9caf4f19990d1a$var$initialState,
    actions: $erKBL.actions
});
const $2d9caf4f19990d1a$export$56beb4c2629d6615 = (0, $ggKAj.createHook)($2d9caf4f19990d1a$var$store);

});
parcelRegister("erKBL", function(module, exports) {

$parcel$export(module.exports, "actions", () => $31c22c176c15a4e6$export$e324594224ef24da);

var $fvtbN = parcelRequire("fvtbN");
const $31c22c176c15a4e6$export$e324594224ef24da = {
    setIsOpen: $fvtbN.setIsOpen
};

});
parcelRegister("fvtbN", function(module, exports) {

$parcel$export(module.exports, "setIsOpen", () => $9702937a09b78fa4$export$dcf23146e0a40195);
const $9702937a09b78fa4$export$dcf23146e0a40195 = (newState)=>({ setState: setState })=>{
        setState(newState);
    };

});



const $507f82bdd90554d8$export$dada91eca2d214e9 = 1;

parcelRegister("8FSSj", function(module, exports) {

$parcel$export(module.exports, "enforceStorageLimitsModalEntryPoint", () => $04648ce763684e89$export$9dc1f3d91d81486);

var $dDuVh = parcelRequire("dDuVh");

var $1K77P = parcelRequire("1K77P");

var $7QhYz = parcelRequire("7QhYz");

const $04648ce763684e89$export$9dc1f3d91d81486 = (0, $7QhYz.createEntryPoint)({
    root: (0, $1K77P.JSResourceForInteraction)(()=>(parcelRequire("jraTA")), {
        moduleId: "0c63b578"
    }),
    getPreloadProps: ({ cloudId: cloudId, productKey: productKey, offeringKey: offeringKey })=>({
            queries: {
                changeOffering: {
                    parameters: $dDuVh.default,
                    variables: {
                        cloudId: cloudId,
                        productKey: productKey,
                        offeringKey: offeringKey
                    }
                }
            }
        })
});

});
parcelRegister("dDuVh", function(module, exports) {

$parcel$export(module.exports, "default", () => $0d04bdd96e1e0cf9$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<a29b09783fe9aa5dbaca0efd5e16bec0>>
 * @relayHash d476d150df3ed5244b896179176af3cf
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ea8945a70156b0e6ef8bae1986c4a0b7fa509f9e2517d04cd635ce03b865cbd3
const $0d04bdd96e1e0cf9$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "ea8945a70156b0e6ef8bae1986c4a0b7fa509f9e2517d04cd635ce03b865cbd3",
        "metadata": {},
        "name": "modal_EnforceStorageLimitQuery",
        "operationKind": "query",
        "text": null
    }
};
var $0d04bdd96e1e0cf9$export$2e2bcd8739ae039 = $0d04bdd96e1e0cf9$var$node;

});

parcelRegister("jraTA", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('hPzOn'),
            load('7MBe5')
        ]);
        const value = parcelRequire('bxoMW');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("hPzOn"),
        load("7MBe5")
    ]).then(()=>parcelRequire('bxoMW'));
}

});


parcelRegister("1cXLn", function(module, exports) {

$parcel$export(module.exports, "useJswStorageUsage", () => $41d4022d7e079ced$export$3821ffee6c560867);

var $33240 = parcelRequire("33240");


function $41d4022d7e079ced$var$getJswStorageLimit(response) {
    return response?.limits.find((limit)=>limit.product.startsWith('ari:cloud:jira-software'));
}
function $41d4022d7e079ced$var$getStorageRatio(usageLimit) {
    return usageLimit && !usageLimit.total.unlimited ? usageLimit.total.used / usageLimit.total.allowed : undefined;
}
function $41d4022d7e079ced$export$3821ffee6c560867({ skip: skip }) {
    const cachedUsageLimit = $41d4022d7e079ced$var$getJswStorageLimit((0, $33240.getCachedDataUsage)());
    const storageRatioFromCachedUsageLimit = $41d4022d7e079ced$var$getStorageRatio(cachedUsageLimit);
    const shouldUseCache = storageRatioFromCachedUsageLimit !== undefined && storageRatioFromCachedUsageLimit < (0, $507f82bdd90554d8$export$dada91eca2d214e9);
    const { data: data } = (0, $33240.useDataUsage)({
        skip: skip,
        shouldUseCache: shouldUseCache,
        caller: (0, $815b5650076b1618$export$b8b9d90f9e5bd72b),
        teamName: 'jlove-makkuro'
    });
    const jswStorageLimit = $41d4022d7e079ced$var$getJswStorageLimit(data);
    const jswStorageRatio = $41d4022d7e079ced$var$getStorageRatio(jswStorageLimit);
    return {
        jswStorageRatio: jswStorageRatio,
        jswStorageLimit: jswStorageLimit
    };
}

});
parcelRegister("33240", function(module, exports) {

$parcel$export(module.exports, "getCachedDataUsage", () => $e74e014b30f6d9d5$export$d1376b56df53b988);
$parcel$export(module.exports, "setCachedDataUsage", () => $e74e014b30f6d9d5$export$e564699c183fe85c);
$parcel$export(module.exports, "useDataUsage", () => $e74e014b30f6d9d5$export$fca2d9fe3d20784e);
$parcel$export(module.exports, "getJswDataLimits", () => $e74e014b30f6d9d5$export$312c2f14ff342ea);

var $eUqFw = parcelRequire("eUqFw");

var $guiFP = parcelRequire("guiFP");

var $1ybV0 = parcelRequire("1ybV0");

var $8LJqN = parcelRequire("8LJqN");


var $dWLk9 = parcelRequire("dWLk9");

var $cweuT = parcelRequire("cweuT");

var $3r3Eg = parcelRequire("3r3Eg");

var $fbVH2 = parcelRequire("fbVH2");
function $e74e014b30f6d9d5$export$d1376b56df53b988() {
    try {
        const cachedValue = (0, $3r3Eg.usageLimitsStorage).get((0, $cweuT.STORAGE_KEY));
        if (cachedValue?.limits !== undefined) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return cachedValue;
        return undefined;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $guiFP.default)({
            error: error,
            meta: {
                id: 'getCachedDataUsage',
                packageName: (0, $cweuT.PACKAGE_NAME),
                teamName: 'flywheel-tako'
            },
            sendToPrivacyUnsafeSplunk: true
        });
    }
}
function $e74e014b30f6d9d5$export$e564699c183fe85c(response) {
    try {
        (0, $3r3Eg.usageLimitsStorage).set((0, $cweuT.STORAGE_KEY), response, Date.now() + (0, $cweuT.USAGE_LIMITS_EXPIRY_MS));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $guiFP.default)({
            error: error,
            meta: {
                id: 'setCachedDataUsage',
                packageName: (0, $cweuT.PACKAGE_NAME),
                teamName: 'flywheel-tako'
            },
            sendToPrivacyUnsafeSplunk: true
        });
    }
}
const $e74e014b30f6d9d5$export$aa1c24efae08daa1 = ({ skip: skip = false, caller: caller, shouldUseCache: shouldUseCache = false, productType: productType = (0, $2edfd53057852e41$export$1346c9aa3cbb477d), teamName: teamName = 'flywheel-tako' })=>{
    const cloudId = (0, $dWLk9.useCloudId)();
    const [storageLimitDataForProduct, { fetchStorageLimitDataForProduct: fetchStorageLimitDataForProduct }] = (0, $fbVH2.useJswEditionAwarenessStorageLimitData)();
    const [data, setData] = (0, $eUqFw.useState)(null);
    (0, $eUqFw.useEffect)(()=>{
        if (skip) return;
        if (shouldUseCache) {
            const cachedResponse = $e74e014b30f6d9d5$export$d1376b56df53b988();
            if (cachedResponse) {
                setData(cachedResponse);
                return;
            }
        }
        // We want to be caching the data in the store to avoid risk/rate limiting.
        // Note this is different to the caching in the local storage layer,
        // which should have the same behaviour as before for any consumers wanting to use that cache
        fetchStorageLimitDataForProduct({
            caller: caller,
            analyticsMetaId: 'useDataUsage',
            analyticsTeamName: teamName,
            productType: productType,
            cloudId: cloudId
        });
    }, [
        caller,
        cloudId,
        productType,
        shouldUseCache,
        skip,
        fetchStorageLimitDataForProduct,
        teamName
    ]);
    const dataForProductFromStore = storageLimitDataForProduct[productType];
    // if the cache is empty, the data is fetched from the store so we can use it
    // TODO: move cache logic to sweet state store
    const dataToReturn = shouldUseCache && data ? data : dataForProductFromStore?.data;
    return {
        data: dataToReturn || null,
        loading: dataForProductFromStore?.isFetching || false,
        error: dataForProductFromStore?.error || null
    };
};
const $e74e014b30f6d9d5$export$4810ecf341f9ae2c = ({ skip: skip = false, caller: caller, productType: productType = (0, $2edfd53057852e41$export$1346c9aa3cbb477d), shouldUseCache: shouldUseCache = false, maxAge: // default to one day in ms
maxAge = 86400000, teamName: teamName = 'flywheel-tako' })=>{
    const [data, setData] = (0, $eUqFw.useState)(null);
    const [loading, setLoading] = (0, $eUqFw.useState)(true);
    const [error, setError] = (0, $eUqFw.useState)(null);
    const [hasTriggeredFetch, setHasTriggeredFetch] = (0, $eUqFw.useState)(false);
    const cloudId = (0, $dWLk9.useCloudId)();
    const [storageLimitDataForProduct, { fetchStorageLimitDataForProductWithTimestamp: fetchStorageLimitDataForProductWithTimestamp }] = (0, $fbVH2.useJswEditionAwarenessStorageLimitData)();
    // only run once initially, any updates to the memory from any global fetch calls will cause a re-run and update the data
    (0, $eUqFw.useEffect)(()=>{
        if (skip) {
            setData(null);
            setLoading(false);
            setError(null);
            return;
        }
        if (shouldUseCache) {
            // if data in memory is valid
            const memoryData = storageLimitDataForProduct?.[productType];
            if (memoryData?.data && // timestamp hasn't expired
            (memoryData.data.fetchTimestamp ?? 0) + maxAge > Date.now()) {
                setData(memoryData.data);
                setLoading(memoryData.isFetching);
                setError(memoryData.error);
                return;
            }
            // else try to use local storage
            const localStorageData = (0, $3r3Eg.getUsageLimitsByProductFromLocalStorage)(teamName);
            const productLocalStorageData = localStorageData?.[productType];
            if (productLocalStorageData && // timestamp hasn't expired
            (productLocalStorageData.fetchTimestamp ?? 0) + maxAge > Date.now()) {
                setData(productLocalStorageData);
                setLoading(false);
                setError(null);
                return;
            }
        // else fetch new data and update the data in memory and local storage, triggering a re-render and returning refreshed data
        }
        // only allow to fetch once
        if (!hasTriggeredFetch) {
            // refresh the memory and local storage with fresh data
            fetchStorageLimitDataForProductWithTimestamp({
                caller: caller,
                analyticsMetaId: 'useDataUsage',
                analyticsTeamName: teamName,
                productType: productType,
                cloudId: cloudId
            });
            setHasTriggeredFetch(true);
        }
        // return the data from memory which will be updated from the fetch call
        const memoryData = storageLimitDataForProduct[productType];
        setData(memoryData?.data ?? null);
        setLoading(memoryData?.isFetching ?? false);
        setError(memoryData?.error ?? null);
    }, [
        caller,
        cloudId,
        fetchStorageLimitDataForProductWithTimestamp,
        hasTriggeredFetch,
        maxAge,
        productType,
        shouldUseCache,
        skip,
        storageLimitDataForProduct,
        teamName
    ]);
    return {
        data: data,
        loading: loading,
        error: error
    };
};
const $e74e014b30f6d9d5$export$fca2d9fe3d20784e = (0, $8LJqN.functionWithCondition)(()=>(0, $1ybV0.ff)('consolidate-usedatausage_bcc0a'), $e74e014b30f6d9d5$export$4810ecf341f9ae2c, $e74e014b30f6d9d5$export$aa1c24efae08daa1);
const $e74e014b30f6d9d5$export$312c2f14ff342ea = (data, cloudId)=>data?.limits.find((limit)=>limit.product === `ari:cloud:jira-software::site/${cloudId}`);

});
parcelRegister("cweuT", function(module, exports) {

$parcel$export(module.exports, "PACKAGE_NAME", () => $d7291708f6a6221d$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "STORAGE_KEY", () => $d7291708f6a6221d$export$86880b4b2e1a2384);
$parcel$export(module.exports, "USAGE_LIMITS_BY_PRODUCT_CACHE_KEY", () => $d7291708f6a6221d$export$e5cb394dbfa5e3ac);
$parcel$export(module.exports, "USAGE_LIMITS_EXPIRY_MS", () => $d7291708f6a6221d$export$2a41463d750f61d2);
const $d7291708f6a6221d$export$b8b9d90f9e5bd72b = 'jiraNavigationAppsSidebarEditionAwarenessUtils';
const $d7291708f6a6221d$export$86880b4b2e1a2384 = 'storageCache';
const $d7291708f6a6221d$export$e5cb394dbfa5e3ac = 'usageLimitsByProductCache';
const $d7291708f6a6221d$export$2a41463d750f61d2 = 86400000; // One day

});

parcelRegister("3r3Eg", function(module, exports) {

$parcel$export(module.exports, "usageLimitsStorage", () => $6b22ab7602d25355$export$ddaa6b16788078b3);
$parcel$export(module.exports, "isUsageLimitsResponse", () => $6b22ab7602d25355$export$d6788bc133e83fa8);
$parcel$export(module.exports, "getUsageLimitsByProductFromLocalStorage", () => $6b22ab7602d25355$export$95c96af568708408);
$parcel$export(module.exports, "setUsageLimitsForProductInLocalStorage", () => $6b22ab7602d25355$export$5738d08921b5dbfd);

var $aZaPn = parcelRequire("aZaPn");

var $guiFP = parcelRequire("guiFP");


var $cweuT = parcelRequire("cweuT");
const $6b22ab7602d25355$export$ddaa6b16788078b3 = (0, $aZaPn.createLocalExpirableStorageProvider)('usage-limits');
const $6b22ab7602d25355$export$2282e65cbf97fe14 = (0, $aZaPn.createLocalExpirableStorageProvider)('usage-limits-by-product');
const $6b22ab7602d25355$var$isApplicationKey = (key)=>{
    const supportedApplications = [
        (0, $2edfd53057852e41$export$c8c1c8c3f8ddba61),
        (0, $2edfd53057852e41$export$1346c9aa3cbb477d),
        (0, $2edfd53057852e41$export$202f50ee62667e32),
        (0, $2edfd53057852e41$export$db515c8cec1e6f79)
    ];
    return supportedApplications.some((application)=>application === key);
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $6b22ab7602d25355$var$isUsageLimit = (limit)=>{
    if (limit == null || typeof limit !== 'object') return false;
    if (limit.product == null || typeof limit.product !== 'string') return false;
    if (limit.edition == null || typeof limit.edition !== 'string') return false;
    if (limit.total == null || typeof limit.total !== 'object') return false;
    if (limit.total.allowed == null || typeof limit.total.allowed !== 'number') return false;
    if (limit.total.used == null || typeof limit.total.used !== 'number') return false;
    if (limit.total.unlimited == null || typeof limit.total.unlimited !== 'boolean') return false;
    return true;
};
const $6b22ab7602d25355$export$d6788bc133e83fa8 = (data)=>{
    if (data == null || typeof data !== 'object') return false;
    // Check if limits exists and is a non-empty array
    if (!Array.isArray(data.limits) || data.limits.length === 0) return false;
    // Check every limit isUsageLimit
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    if (!data.limits.every((limit)=>$6b22ab7602d25355$var$isUsageLimit(limit))) return false;
    return true;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $6b22ab7602d25355$var$isUsageLimitsData = (data)=>{
    if (data == null || typeof data !== 'object') return false;
    if (!$6b22ab7602d25355$export$d6788bc133e83fa8(data)) return false;
    // Optionally check fetchTimestamp if it exists
    if ('fetchTimestamp' in data && typeof data.fetchTimestamp !== 'number') return false;
    return true;
};
const $6b22ab7602d25355$export$608bf2db99125ec2 = (obj)=>{
    // Check if obj is an object
    if (obj == null || typeof obj !== 'object') return false;
    // Check each key and value in the object
    for (const [key, value] of Object.entries(obj)){
        // Check if key is one of the ApplicationKeys
        if (!$6b22ab7602d25355$var$isApplicationKey(key)) return false;
        // Check if value matches UsageLimitsData structure
        if (!$6b22ab7602d25355$var$isUsageLimitsData(value)) return false;
    }
    // If all checks pass, return true
    return true;
};
function $6b22ab7602d25355$export$95c96af568708408(teamName) {
    try {
        const cachedValue = $6b22ab7602d25355$export$2282e65cbf97fe14.get((0, $cweuT.USAGE_LIMITS_BY_PRODUCT_CACHE_KEY));
        if ($6b22ab7602d25355$export$608bf2db99125ec2(cachedValue)) return cachedValue;
        return undefined;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $guiFP.default)({
            error: error,
            meta: {
                id: 'getUsageLimitsForProductFromLocalStorage',
                packageName: (0, $cweuT.PACKAGE_NAME),
                teamName: teamName
            },
            sendToPrivacyUnsafeSplunk: true
        });
    }
}
function $6b22ab7602d25355$export$5738d08921b5dbfd(product, response, teamName) {
    const prevCache = $6b22ab7602d25355$export$95c96af568708408(teamName);
    const newCache = {
        ...prevCache,
        [product]: response
    };
    $6b22ab7602d25355$export$2282e65cbf97fe14.set((0, $cweuT.USAGE_LIMITS_BY_PRODUCT_CACHE_KEY), newCache, Date.now() + (0, $cweuT.USAGE_LIMITS_EXPIRY_MS));
}

});

parcelRegister("fbVH2", function(module, exports) {

$parcel$export(module.exports, "useJswEditionAwarenessStorageLimitData", () => $9c45e94ae0aac2fd$export$695955c72ce78aa9);

var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");

var $45KjS = parcelRequire("45KjS");
const $9c45e94ae0aac2fd$export$d4c72bab9d6cc13a = {};
const $9c45e94ae0aac2fd$var$store = (0, $a61MH.createStore)({
    name: 'jsw-edition-awareness-storage-limit-data',
    initialState: $9c45e94ae0aac2fd$export$d4c72bab9d6cc13a,
    actions: $45KjS.actions
});
const $9c45e94ae0aac2fd$export$695955c72ce78aa9 = (0, $ggKAj.createHook)($9c45e94ae0aac2fd$var$store);

});
parcelRegister("45KjS", function(module, exports) {

$parcel$export(module.exports, "actions", () => $db351573db54f467$export$e324594224ef24da);

var $9QiwJ = parcelRequire("9QiwJ");
const $db351573db54f467$export$e324594224ef24da = {
    fetchStorageLimitDataForProduct: $9QiwJ.fetchStorageLimitDataForProduct,
    fetchStorageLimitDataForProductWithTimestamp: $9QiwJ.fetchStorageLimitDataForProductWithTimestamp
};

});
parcelRegister("9QiwJ", function(module, exports) {

$parcel$export(module.exports, "fetchStorageLimitDataForProduct", () => $5e6af884daabe5ef$export$a9501746fabb151c);
$parcel$export(module.exports, "fetchStorageLimitDataForProductWithTimestamp", () => $5e6af884daabe5ef$export$8455538f79b2f2ea);

var $guiFP = parcelRequire("guiFP");

var $2OdyW = parcelRequire("2OdyW");

var $cweuT = parcelRequire("cweuT");

var $3r3Eg = parcelRequire("3r3Eg");
function $5e6af884daabe5ef$var$setCachedDataUsage(response) {
    (0, $3r3Eg.usageLimitsStorage).set((0, $cweuT.STORAGE_KEY), response, Date.now() + (0, $cweuT.USAGE_LIMITS_EXPIRY_MS));
}
const $5e6af884daabe5ef$export$a9501746fabb151c = ({ caller: caller, analyticsMetaId: analyticsMetaId, productType: productType, cloudId: cloudId, analyticsTeamName: analyticsTeamName })=>async ({ getState: getState, setState: setState })=>{
        const currentState = getState();
        const dataForProductAlreadyInStore = currentState[productType]?.data;
        // If data from API is already there, use it
        if (dataForProductAlreadyInStore != null) return;
        // If fetch in progress, bail out.
        if (currentState[productType]?.isFetching === true) return;
        setState({
            [productType]: {
                ...getState()[productType],
                isFetching: true,
                error: null
            }
        });
        (0, $2OdyW.default)(`/gateway/api/media/admin/usage/limits?cloudId=${cloudId}&products=${productType}`).then((response)=>{
            if (response?.limits === undefined) throw Error(`Invalid storage limit response: ${JSON.stringify(response)}`);
            setState({
                [productType]: {
                    ...getState()[productType],
                    data: response
                }
            });
            $5e6af884daabe5ef$var$setCachedDataUsage(response);
        }).catch((e)=>{
            setState({
                [productType]: {
                    ...getState()[productType],
                    error: e
                }
            });
            (0, $guiFP.default)({
                error: e,
                meta: {
                    id: analyticsMetaId,
                    packageName: (0, $cweuT.PACKAGE_NAME),
                    teamName: analyticsTeamName
                },
                attributes: {
                    caller: caller,
                    fetchTraceId: e.traceId,
                    productType: productType
                },
                sendToPrivacyUnsafeSplunk: true
            });
        }).finally(()=>{
            setState({
                [productType]: {
                    ...getState()[productType],
                    isFetching: false
                }
            });
        });
    };
const $5e6af884daabe5ef$export$8455538f79b2f2ea = ({ caller: caller, analyticsMetaId: analyticsMetaId, productType: productType, cloudId: cloudId, analyticsTeamName: analyticsTeamName })=>async ({ getState: getState, setState: setState })=>{
        // if fetch is in progress from another call, exit early and rely on the other call to update it in memory
        if (getState()[productType]?.isFetching === true) return;
        // initiate fetch
        setState({
            [productType]: {
                ...getState()[productType],
                isFetching: true,
                error: null
            }
        });
        return (0, $2OdyW.default)(`/gateway/api/media/admin/usage/limits?cloudId=${cloudId}&products=${productType}`).then((response)=>{
            if (!(0, $3r3Eg.isUsageLimitsResponse)(response)) throw Error('Invalid storage limit response', {
                cause: JSON.stringify(response)
            });
            const fetchTimestamp = Date.now();
            const usageLimitsWithTimestamp = {
                ...response,
                fetchTimestamp: fetchTimestamp
            };
            // set the data in memory
            setState({
                [productType]: {
                    ...getState()[productType],
                    data: usageLimitsWithTimestamp
                }
            });
            // set the data in local storage
            (0, $3r3Eg.setUsageLimitsForProductInLocalStorage)(productType, usageLimitsWithTimestamp, analyticsTeamName);
        }).catch((e)=>{
            setState({
                [productType]: {
                    ...getState()[productType],
                    error: e
                }
            });
            (0, $guiFP.default)({
                error: e,
                meta: {
                    id: analyticsMetaId,
                    packageName: (0, $cweuT.PACKAGE_NAME),
                    teamName: analyticsTeamName
                },
                attributes: {
                    caller: caller,
                    fetchTraceId: e.traceId,
                    productType: productType
                },
                sendToPrivacyUnsafeSplunk: true
            });
        }).finally(()=>{
            setState({
                [productType]: {
                    ...getState()[productType],
                    isFetching: false
                }
            });
        });
    };

});






const $2ac6e3dbd6c2a0c4$export$bfef7353718d9887 = 'shared-layout.ui.global.command-palette-container';
const $2ac6e3dbd6c2a0c4$export$7138a6fa3d695a2e = 'darktheme-benefits-modal.ui.modal';



//# sourceMappingURL=async-global-global-components.9eab0a02.js.map
